
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6bb0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6bb0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aVTSq", function(module, exports) {
"use strict";
module.exports = "3.24.1";

});

parcelRegister("hwIuZ", function(module, exports) {
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ var $cc27f16397c057b3$var$Hogan = {};
(function(Hogan) {
    Hogan.Template = function(codeObj, text, compiler, options) {
        codeObj = codeObj || {};
        this.r = codeObj.code || this.r;
        this.c = compiler;
        this.options = options || {};
        this.text = text || "";
        this.partials = codeObj.partials || {};
        this.subs = codeObj.subs || {};
        this.buf = "";
    };
    Hogan.Template.prototype = {
        // render: replaced by generated code.
        r: function(context, partials, indent) {
            return "";
        },
        // variable escaping
        v: hoganEscape,
        // triple stache
        t: coerceToString,
        render: function render(context, partials, indent) {
            return this.ri([
                context
            ], partials || {}, indent);
        },
        // render internal -- a hook for overrides that catches partials too
        ri: function(context, partials, indent) {
            return this.r(context, partials, indent);
        },
        // ensurePartial
        ep: function(symbol, partials) {
            var partial = this.partials[symbol];
            // check to see that if we've instantiated this partial before
            var template = partials[partial.name];
            if (partial.instance && partial.base == template) return partial.instance;
            if (typeof template == "string") {
                if (!this.c) throw new Error("No compiler available.");
                template = this.c.compile(template, this.options);
            }
            if (!template) return null;
            // We use this to check whether the partials dictionary has changed
            this.partials[symbol].base = template;
            if (partial.subs) {
                // Make sure we consider parent template now
                if (!partials.stackText) partials.stackText = {};
                for(key in partial.subs)if (!partials.stackText[key]) partials.stackText[key] = this.activeSub !== undefined && partials.stackText[this.activeSub] ? partials.stackText[this.activeSub] : this.text;
                template = createSpecializedPartial(template, partial.subs, partial.partials, this.stackSubs, this.stackPartials, partials.stackText);
            }
            this.partials[symbol].instance = template;
            return template;
        },
        // tries to find a partial in the current scope and render it
        rp: function(symbol, context, partials, indent) {
            var partial = this.ep(symbol, partials);
            if (!partial) return "";
            return partial.ri(context, partials, indent);
        },
        // render a section
        rs: function(context, partials, section) {
            var tail = context[context.length - 1];
            if (!isArray(tail)) {
                section(context, partials, this);
                return;
            }
            for(var i = 0; i < tail.length; i++){
                context.push(tail[i]);
                section(context, partials, this);
                context.pop();
            }
        },
        // maybe start a section
        s: function(val, ctx, partials, inverted, start, end, tags) {
            var pass;
            if (isArray(val) && val.length === 0) return false;
            if (typeof val == "function") val = this.ms(val, ctx, partials, inverted, start, end, tags);
            pass = !!val;
            if (!inverted && pass && ctx) ctx.push(typeof val == "object" ? val : ctx[ctx.length - 1]);
            return pass;
        },
        // find values with dotted names
        d: function(key1, ctx, partials, returnFound) {
            var found, names = key1.split("."), val = this.f(names[0], ctx, partials, returnFound), doModelGet = this.options.modelGet, cx = null;
            if (key1 === "." && isArray(ctx[ctx.length - 2])) val = ctx[ctx.length - 1];
            else for(var i = 1; i < names.length; i++){
                found = findInScope(names[i], val, doModelGet);
                if (found !== undefined) {
                    cx = val;
                    val = found;
                } else val = "";
            }
            if (returnFound && !val) return false;
            if (!returnFound && typeof val == "function") {
                ctx.push(cx);
                val = this.mv(val, ctx, partials);
                ctx.pop();
            }
            return val;
        },
        // find values with normal names
        f: function(key1, ctx, partials, returnFound) {
            var val = false, v = null, found = false, doModelGet = this.options.modelGet;
            for(var i = ctx.length - 1; i >= 0; i--){
                v = ctx[i];
                val = findInScope(key1, v, doModelGet);
                if (val !== undefined) {
                    found = true;
                    break;
                }
            }
            if (!found) return returnFound ? false : "";
            if (!returnFound && typeof val == "function") val = this.mv(val, ctx, partials);
            return val;
        },
        // higher order templates
        ls: function(func, cx, partials, text, tags) {
            var oldTags = this.options.delimiters;
            this.options.delimiters = tags;
            this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
            this.options.delimiters = oldTags;
            return false;
        },
        // compile text
        ct: function(text, cx, partials) {
            if (this.options.disableLambda) throw new Error("Lambda features disabled.");
            return this.c.compile(text, this.options).render(cx, partials);
        },
        // template result buffering
        b: function(s) {
            this.buf += s;
        },
        fl: function() {
            var r = this.buf;
            this.buf = "";
            return r;
        },
        // method replace section
        ms: function(func, ctx, partials, inverted, start, end, tags) {
            var textSource, cx = ctx[ctx.length - 1], result = func.call(cx);
            if (typeof result == "function") {
                if (inverted) return true;
                else {
                    textSource = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text;
                    return this.ls(result, cx, partials, textSource.substring(start, end), tags);
                }
            }
            return result;
        },
        // method replace variable
        mv: function(func, ctx, partials) {
            var cx = ctx[ctx.length - 1];
            var result = func.call(cx);
            if (typeof result == "function") return this.ct(coerceToString(result.call(cx)), cx, partials);
            return result;
        },
        sub: function(name, context, partials, indent) {
            var f = this.subs[name];
            if (f) {
                this.activeSub = name;
                f(context, partials, this, indent);
                this.activeSub = false;
            }
        }
    };
    //Find a key in an object
    function findInScope(key1, scope, doModelGet) {
        var val;
        if (scope && typeof scope == "object") {
            if (scope[key1] !== undefined) val = scope[key1];
            else if (doModelGet && scope.get && typeof scope.get == "function") val = scope.get(key1);
        }
        return val;
    }
    function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
        function PartialTemplate() {}
        PartialTemplate.prototype = instance;
        function Substitutions() {}
        Substitutions.prototype = instance.subs;
        var key1;
        var partial = new PartialTemplate();
        partial.subs = new Substitutions();
        partial.subsText = {}; //hehe. substext.
        partial.buf = "";
        stackSubs = stackSubs || {};
        partial.stackSubs = stackSubs;
        partial.subsText = stackText;
        for(key1 in subs)if (!stackSubs[key1]) stackSubs[key1] = subs[key1];
        for(key1 in stackSubs)partial.subs[key1] = stackSubs[key1];
        stackPartials = stackPartials || {};
        partial.stackPartials = stackPartials;
        for(key1 in partials)if (!stackPartials[key1]) stackPartials[key1] = partials[key1];
        for(key1 in stackPartials)partial.partials[key1] = stackPartials[key1];
        return partial;
    }
    var rAmp = /&/g, rLt = /</g, rGt = />/g, rApos = /\'/g, rQuot = /\"/g, hChars = /[&<>\"\']/;
    function coerceToString(val) {
        return String(val === null || val === undefined ? "" : val);
    }
    function hoganEscape(str) {
        str = coerceToString(str);
        return hChars.test(str) ? str.replace(rAmp, "&amp;").replace(rLt, "&lt;").replace(rGt, "&gt;").replace(rApos, "&#39;").replace(rQuot, "&quot;") : str;
    }
    var isArray = Array.isArray || function(a) {
        return Object.prototype.toString.call(a) === "[object Array]";
    };
})(module.exports);

});

function $ef6ec48844ba4a28$var$createAuth(appId, apiKey, authMode = "WithinHeaders") {
    const credentials = {
        "x-algolia-api-key": apiKey,
        "x-algolia-application-id": appId
    };
    return {
        headers () {
            return authMode === "WithinHeaders" ? credentials : {};
        },
        queryParameters () {
            return authMode === "WithinQueryParameters" ? credentials : {};
        }
    };
}
function $ef6ec48844ba4a28$var$createBrowserLocalStorageCache(options) {
    let storage;
    // We've changed the namespace to avoid conflicts with v4, as this version is a huge breaking change
    const namespaceKey = `algolia-client-js-${options.key}`;
    function getStorage() {
        if (storage === undefined) storage = options.localStorage || window.localStorage;
        return storage;
    }
    function getNamespace() {
        return JSON.parse(getStorage().getItem(namespaceKey) || "{}");
    }
    function setNamespace(namespace) {
        getStorage().setItem(namespaceKey, JSON.stringify(namespace));
    }
    function removeOutdatedCacheItems() {
        const timeToLive = options.timeToLive ? options.timeToLive * 1000 : null;
        const namespace = getNamespace();
        const filteredNamespaceWithoutOldFormattedCacheItems = Object.fromEntries(Object.entries(namespace).filter(([, cacheItem])=>{
            return cacheItem.timestamp !== undefined;
        }));
        setNamespace(filteredNamespaceWithoutOldFormattedCacheItems);
        if (!timeToLive) return;
        const filteredNamespaceWithoutExpiredItems = Object.fromEntries(Object.entries(filteredNamespaceWithoutOldFormattedCacheItems).filter(([, cacheItem])=>{
            const currentTimestamp = new Date().getTime();
            const isExpired = cacheItem.timestamp + timeToLive < currentTimestamp;
            return !isExpired;
        }));
        setNamespace(filteredNamespaceWithoutExpiredItems);
    }
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            return Promise.resolve().then(()=>{
                removeOutdatedCacheItems();
                return getNamespace()[JSON.stringify(key)];
            }).then((value)=>{
                return Promise.all([
                    value ? value.value : defaultValue(),
                    value !== undefined
                ]);
            }).then(([value, exists])=>{
                return Promise.all([
                    value,
                    exists || events.miss(value)
                ]);
            }).then(([value])=>value);
        },
        set (key, value) {
            return Promise.resolve().then(()=>{
                const namespace = getNamespace();
                namespace[JSON.stringify(key)] = {
                    timestamp: new Date().getTime(),
                    value: value
                };
                getStorage().setItem(namespaceKey, JSON.stringify(namespace));
                return value;
            });
        },
        delete (key) {
            return Promise.resolve().then(()=>{
                const namespace = getNamespace();
                delete namespace[JSON.stringify(key)];
                getStorage().setItem(namespaceKey, JSON.stringify(namespace));
            });
        },
        clear () {
            return Promise.resolve().then(()=>{
                getStorage().removeItem(namespaceKey);
            });
        }
    };
}
function $ef6ec48844ba4a28$var$createNullCache() {
    return {
        get (_key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            const value = defaultValue();
            return value.then((result)=>Promise.all([
                    result,
                    events.miss(result)
                ])).then(([result])=>result);
        },
        set (_key, value) {
            return Promise.resolve(value);
        },
        delete (_key) {
            return Promise.resolve();
        },
        clear () {
            return Promise.resolve();
        }
    };
}
function $ef6ec48844ba4a28$var$createFallbackableCache(options) {
    const caches = [
        ...options.caches
    ];
    const current = caches.shift();
    if (current === undefined) return $ef6ec48844ba4a28$var$createNullCache();
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            return current.get(key, defaultValue, events).catch(()=>{
                return $ef6ec48844ba4a28$var$createFallbackableCache({
                    caches: caches
                }).get(key, defaultValue, events);
            });
        },
        set (key, value) {
            return current.set(key, value).catch(()=>{
                return $ef6ec48844ba4a28$var$createFallbackableCache({
                    caches: caches
                }).set(key, value);
            });
        },
        delete (key) {
            return current.delete(key).catch(()=>{
                return $ef6ec48844ba4a28$var$createFallbackableCache({
                    caches: caches
                }).delete(key);
            });
        },
        clear () {
            return current.clear().catch(()=>{
                return $ef6ec48844ba4a28$var$createFallbackableCache({
                    caches: caches
                }).clear();
            });
        }
    };
}
function $ef6ec48844ba4a28$var$createMemoryCache(options = {
    serializable: true
}) {
    let cache = {};
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            const keyAsString = JSON.stringify(key);
            if (keyAsString in cache) return Promise.resolve(options.serializable ? JSON.parse(cache[keyAsString]) : cache[keyAsString]);
            const promise = defaultValue();
            return promise.then((value)=>events.miss(value)).then(()=>promise);
        },
        set (key, value) {
            cache[JSON.stringify(key)] = options.serializable ? JSON.stringify(value) : value;
            return Promise.resolve(value);
        },
        delete (key) {
            delete cache[JSON.stringify(key)];
            return Promise.resolve();
        },
        clear () {
            cache = {};
            return Promise.resolve();
        }
    };
}
// By default, API Clients at Algolia have expiration delay of 5 mins.
// In the JavaScript client, we have 2 mins.
const $ef6ec48844ba4a28$var$EXPIRATION_DELAY = 120000;
function $ef6ec48844ba4a28$var$createStatefulHost(host, status = "up") {
    const lastUpdate = Date.now();
    function isUp() {
        return status === "up" || Date.now() - lastUpdate > $ef6ec48844ba4a28$var$EXPIRATION_DELAY;
    }
    function isTimedOut() {
        return status === "timed out" && Date.now() - lastUpdate <= $ef6ec48844ba4a28$var$EXPIRATION_DELAY;
    }
    return {
        ...host,
        status: status,
        lastUpdate: lastUpdate,
        isUp: isUp,
        isTimedOut: isTimedOut
    };
}
function $ef6ec48844ba4a28$var$_defineProperty(e, r, t) {
    return (r = $ef6ec48844ba4a28$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ef6ec48844ba4a28$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ef6ec48844ba4a28$var$_toPropertyKey(t) {
    var i = $ef6ec48844ba4a28$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
class $ef6ec48844ba4a28$var$AlgoliaError extends Error {
    constructor(message, name){
        super(message);
        $ef6ec48844ba4a28$var$_defineProperty(this, "name", "AlgoliaError");
        if (name) this.name = name;
    }
}
class $ef6ec48844ba4a28$var$ErrorWithStackTrace extends $ef6ec48844ba4a28$var$AlgoliaError {
    constructor(message, stackTrace, name){
        super(message, name);
        // the array and object should be frozen to reflect the stackTrace at the time of the error
        $ef6ec48844ba4a28$var$_defineProperty(this, "stackTrace", void 0);
        this.stackTrace = stackTrace;
    }
}
class $ef6ec48844ba4a28$var$RetryError extends $ef6ec48844ba4a28$var$ErrorWithStackTrace {
    constructor(stackTrace){
        super("Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support.", stackTrace, "RetryError");
    }
}
class $ef6ec48844ba4a28$var$ApiError extends $ef6ec48844ba4a28$var$ErrorWithStackTrace {
    constructor(message, status, stackTrace, name = "ApiError"){
        super(message, stackTrace, name);
        $ef6ec48844ba4a28$var$_defineProperty(this, "status", void 0);
        this.status = status;
    }
}
class $ef6ec48844ba4a28$var$DeserializationError extends $ef6ec48844ba4a28$var$AlgoliaError {
    constructor(message, response){
        super(message, "DeserializationError");
        $ef6ec48844ba4a28$var$_defineProperty(this, "response", void 0);
        this.response = response;
    }
}
// DetailedApiError is only used by the ingestion client to return more informative error, other clients will use ApiClient.
class $ef6ec48844ba4a28$var$DetailedApiError extends $ef6ec48844ba4a28$var$ApiError {
    constructor(message, status, error, stackTrace){
        super(message, status, stackTrace, "DetailedApiError");
        $ef6ec48844ba4a28$var$_defineProperty(this, "error", void 0);
        this.error = error;
    }
}
function $ef6ec48844ba4a28$var$shuffle(array) {
    const shuffledArray = array;
    for(let c = array.length - 1; c > 0; c--){
        const b = Math.floor(Math.random() * (c + 1));
        const a = array[c];
        shuffledArray[c] = array[b];
        shuffledArray[b] = a;
    }
    return shuffledArray;
}
function $ef6ec48844ba4a28$var$serializeUrl(host, path, queryParameters) {
    const queryParametersAsString = $ef6ec48844ba4a28$var$serializeQueryParameters(queryParameters);
    let url = `${host.protocol}://${host.url}${host.port ? `:${host.port}` : ""}/${path.charAt(0) === "/" ? path.substring(1) : path}`;
    if (queryParametersAsString.length) url += `?${queryParametersAsString}`;
    return url;
}
function $ef6ec48844ba4a28$var$serializeQueryParameters(parameters) {
    return Object.keys(parameters).filter((key)=>parameters[key] !== undefined).sort().map((key)=>`${key}=${encodeURIComponent(Object.prototype.toString.call(parameters[key]) === "[object Array]" ? parameters[key].join(",") : parameters[key]).replaceAll("+", "%20")}`).join("&");
}
function $ef6ec48844ba4a28$var$serializeData(request, requestOptions) {
    if (request.method === "GET" || request.data === undefined && requestOptions.data === undefined) return undefined;
    const data = Array.isArray(request.data) ? request.data : {
        ...request.data,
        ...requestOptions.data
    };
    return JSON.stringify(data);
}
function $ef6ec48844ba4a28$var$serializeHeaders(baseHeaders, requestHeaders, requestOptionsHeaders) {
    const headers = {
        Accept: "application/json",
        ...baseHeaders,
        ...requestHeaders,
        ...requestOptionsHeaders
    };
    const serializedHeaders = {};
    Object.keys(headers).forEach((header)=>{
        const value = headers[header];
        serializedHeaders[header.toLowerCase()] = value;
    });
    return serializedHeaders;
}
function $ef6ec48844ba4a28$var$deserializeSuccess(response) {
    try {
        return JSON.parse(response.content);
    } catch (e) {
        throw new $ef6ec48844ba4a28$var$DeserializationError(e.message, response);
    }
}
function $ef6ec48844ba4a28$var$deserializeFailure({ content: content, status: status }, stackFrame) {
    try {
        const parsed = JSON.parse(content);
        if ("error" in parsed) return new $ef6ec48844ba4a28$var$DetailedApiError(parsed.message, status, parsed.error, stackFrame);
        return new $ef6ec48844ba4a28$var$ApiError(parsed.message, status, stackFrame);
    } catch (e) {
    // ..
    }
    return new $ef6ec48844ba4a28$var$ApiError(content, status, stackFrame);
}
function $ef6ec48844ba4a28$var$isNetworkError({ isTimedOut: isTimedOut, status: status }) {
    return !isTimedOut && ~~status === 0;
}
function $ef6ec48844ba4a28$var$isRetryable({ isTimedOut: isTimedOut, status: status }) {
    return isTimedOut || $ef6ec48844ba4a28$var$isNetworkError({
        isTimedOut: isTimedOut,
        status: status
    }) || ~~(status / 100) !== 2 && ~~(status / 100) !== 4;
}
function $ef6ec48844ba4a28$var$isSuccess({ status: status }) {
    return ~~(status / 100) === 2;
}
function $ef6ec48844ba4a28$var$stackTraceWithoutCredentials(stackTrace) {
    return stackTrace.map((stackFrame)=>$ef6ec48844ba4a28$var$stackFrameWithoutCredentials(stackFrame));
}
function $ef6ec48844ba4a28$var$stackFrameWithoutCredentials(stackFrame) {
    const modifiedHeaders = stackFrame.request.headers["x-algolia-api-key"] ? {
        "x-algolia-api-key": "*****"
    } : {};
    return {
        ...stackFrame,
        request: {
            ...stackFrame.request,
            headers: {
                ...stackFrame.request.headers,
                ...modifiedHeaders
            }
        }
    };
}
function $ef6ec48844ba4a28$var$createTransporter({ hosts: hosts, hostsCache: hostsCache, baseHeaders: baseHeaders, baseQueryParameters: baseQueryParameters, algoliaAgent: algoliaAgent, timeouts: timeouts, requester: requester, requestsCache: requestsCache, responsesCache: responsesCache }) {
    async function createRetryableOptions(compatibleHosts) {
        const statefulHosts = await Promise.all(compatibleHosts.map((compatibleHost)=>{
            return hostsCache.get(compatibleHost, ()=>{
                return Promise.resolve($ef6ec48844ba4a28$var$createStatefulHost(compatibleHost));
            });
        }));
        const hostsUp = statefulHosts.filter((host)=>host.isUp());
        const hostsTimedOut = statefulHosts.filter((host)=>host.isTimedOut());
        // Note, we put the hosts that previously timed out on the end of the list.
        const hostsAvailable = [
            ...hostsUp,
            ...hostsTimedOut
        ];
        const compatibleHostsAvailable = hostsAvailable.length > 0 ? hostsAvailable : compatibleHosts;
        return {
            hosts: compatibleHostsAvailable,
            getTimeout (timeoutsCount, baseTimeout) {
                /**
         * Imagine that you have 4 hosts, if timeouts will increase
         * on the following way: 1 (timed out) > 4 (timed out) > 5 (200).
         *
         * Note that, the very next request, we start from the previous timeout.
         *
         *  5 (timed out) > 6 (timed out) > 7 ...
         *
         * This strategy may need to be reviewed, but is the strategy on the our
         * current v3 version.
         */ const timeoutMultiplier = hostsTimedOut.length === 0 && timeoutsCount === 0 ? 1 : hostsTimedOut.length + 3 + timeoutsCount;
                return timeoutMultiplier * baseTimeout;
            }
        };
    }
    async function retryableRequest(request, requestOptions, isRead = true) {
        const stackTrace = [];
        /**
     * First we prepare the payload that do not depend from hosts.
     */ const data = $ef6ec48844ba4a28$var$serializeData(request, requestOptions);
        const headers = $ef6ec48844ba4a28$var$serializeHeaders(baseHeaders, request.headers, requestOptions.headers);
        // On `GET`, the data is proxied to query parameters.
        const dataQueryParameters = request.method === "GET" ? {
            ...request.data,
            ...requestOptions.data
        } : {};
        const queryParameters = {
            ...baseQueryParameters,
            ...request.queryParameters,
            ...dataQueryParameters
        };
        if (algoliaAgent.value) queryParameters["x-algolia-agent"] = algoliaAgent.value;
        if (requestOptions && requestOptions.queryParameters) {
            for (const key of Object.keys(requestOptions.queryParameters))// We want to keep `undefined` and `null` values,
            // but also avoid stringifying `object`s, as they are
            // handled in the `serializeUrl` step right after.
            if (!requestOptions.queryParameters[key] || Object.prototype.toString.call(requestOptions.queryParameters[key]) === "[object Object]") queryParameters[key] = requestOptions.queryParameters[key];
            else queryParameters[key] = requestOptions.queryParameters[key].toString();
        }
        let timeoutsCount = 0;
        const retry = async (retryableHosts, getTimeout)=>{
            /**
       * We iterate on each host, until there is no host left.
       */ const host = retryableHosts.pop();
            if (host === undefined) throw new $ef6ec48844ba4a28$var$RetryError($ef6ec48844ba4a28$var$stackTraceWithoutCredentials(stackTrace));
            let responseTimeout = isRead ? requestOptions.timeouts?.read || timeouts.read : requestOptions.timeouts?.write || timeouts.write;
            const payload = {
                data: data,
                headers: headers,
                method: request.method,
                url: $ef6ec48844ba4a28$var$serializeUrl(host, request.path, queryParameters),
                connectTimeout: getTimeout(timeoutsCount, requestOptions.timeouts?.connect || timeouts.connect),
                responseTimeout: getTimeout(timeoutsCount, responseTimeout)
            };
            /**
       * The stackFrame is pushed to the stackTrace so we
       * can have information about onRetry and onFailure
       * decisions.
       */ const pushToStackTrace = (response)=>{
                const stackFrame = {
                    request: payload,
                    response: response,
                    host: host,
                    triesLeft: retryableHosts.length
                };
                stackTrace.push(stackFrame);
                return stackFrame;
            };
            const response = await requester.send(payload);
            if ($ef6ec48844ba4a28$var$isRetryable(response)) {
                const stackFrame = pushToStackTrace(response);
                // If response is a timeout, we increase the number of timeouts so we can increase the timeout later.
                if (response.isTimedOut) timeoutsCount++;
                /**
         * Failures are individually sent to the logger, allowing
         * the end user to debug / store stack frames even
         * when a retry error does not happen.
         */ // eslint-disable-next-line no-console -- this will be fixed by exposing a `logger` to the transporter
                console.log("Retryable failure", $ef6ec48844ba4a28$var$stackFrameWithoutCredentials(stackFrame));
                /**
         * We also store the state of the host in failure cases. If the host, is
         * down it will remain down for the next 2 minutes. In a timeout situation,
         * this host will be added end of the list of hosts on the next request.
         */ await hostsCache.set(host, $ef6ec48844ba4a28$var$createStatefulHost(host, response.isTimedOut ? "timed out" : "down"));
                return retry(retryableHosts, getTimeout);
            }
            if ($ef6ec48844ba4a28$var$isSuccess(response)) return $ef6ec48844ba4a28$var$deserializeSuccess(response);
            pushToStackTrace(response);
            throw $ef6ec48844ba4a28$var$deserializeFailure(response, stackTrace);
        };
        /**
     * Finally, for each retryable host perform request until we got a non
     * retryable response. Some notes here:
     *
     * 1. The reverse here is applied so we can apply a `pop` later on => more performant.
     * 2. We also get from the retryable options a timeout multiplier that is tailored
     * for the current context.
     */ const compatibleHosts = hosts.filter((host)=>host.accept === "readWrite" || (isRead ? host.accept === "read" : host.accept === "write"));
        const options = await createRetryableOptions(compatibleHosts);
        return retry([
            ...options.hosts
        ].reverse(), options.getTimeout);
    }
    function createRequest(request, requestOptions = {}) {
        /**
     * A read request is either a `GET` request, or a request that we make
     * via the `read` transporter (e.g. `search`).
     */ const isRead = request.useReadTransporter || request.method === "GET";
        if (!isRead) /**
       * On write requests, no cache mechanisms are applied, and we
       * proxy the request immediately to the requester.
       */ return retryableRequest(request, requestOptions, isRead);
        const createRetryableRequest = ()=>{
            /**
       * Then, we prepare a function factory that contains the construction of
       * the retryable request. At this point, we may *not* perform the actual
       * request. But we want to have the function factory ready.
       */ return retryableRequest(request, requestOptions);
        };
        /**
     * Once we have the function factory ready, we need to determine of the
     * request is "cacheable" - should be cached. Note that, once again,
     * the user can force this option.
     */ const cacheable = requestOptions.cacheable || request.cacheable;
        /**
     * If is not "cacheable", we immediately trigger the retryable request, no
     * need to check cache implementations.
     */ if (cacheable !== true) return createRetryableRequest();
        /**
     * If the request is "cacheable", we need to first compute the key to ask
     * the cache implementations if this request is on progress or if the
     * response already exists on the cache.
     */ const key = {
            request: request,
            requestOptions: requestOptions,
            transporter: {
                queryParameters: baseQueryParameters,
                headers: baseHeaders
            }
        };
        /**
     * With the computed key, we first ask the responses cache
     * implementation if this request was been resolved before.
     */ return responsesCache.get(key, ()=>{
            /**
       * If the request has never resolved before, we actually ask if there
       * is a current request with the same key on progress.
       */ return requestsCache.get(key, ()=>/**
       * Finally, if there is no request in progress with the same key,
       * this `createRetryableRequest()` will actually trigger the
       * retryable request.
       */ requestsCache.set(key, createRetryableRequest()).then((response)=>Promise.all([
                        requestsCache.delete(key),
                        response
                    ]), (err)=>Promise.all([
                        requestsCache.delete(key),
                        Promise.reject(err)
                    ])).then(([_, response])=>response));
        }, {
            /**
       * Of course, once we get this response back from the server, we
       * tell response cache to actually store the received response
       * to be used later.
       */ miss: (response)=>responsesCache.set(key, response)
        });
    }
    return {
        hostsCache: hostsCache,
        requester: requester,
        timeouts: timeouts,
        algoliaAgent: algoliaAgent,
        baseHeaders: baseHeaders,
        baseQueryParameters: baseQueryParameters,
        hosts: hosts,
        request: createRequest,
        requestsCache: requestsCache,
        responsesCache: responsesCache
    };
}
function $ef6ec48844ba4a28$var$createAlgoliaAgent(version) {
    const algoliaAgent = {
        value: `Algolia for JavaScript (${version})`,
        add (options) {
            const addedAlgoliaAgent = `; ${options.segment}${options.version !== undefined ? ` (${options.version})` : ""}`;
            if (algoliaAgent.value.indexOf(addedAlgoliaAgent) === -1) algoliaAgent.value = `${algoliaAgent.value}${addedAlgoliaAgent}`;
            return algoliaAgent;
        }
    };
    return algoliaAgent;
}
function $ef6ec48844ba4a28$var$getAlgoliaAgent({ algoliaAgents: algoliaAgents, client: client, version: version }) {
    const defaultAlgoliaAgent = $ef6ec48844ba4a28$var$createAlgoliaAgent(version).add({
        segment: client,
        version: version
    });
    algoliaAgents.forEach((algoliaAgent)=>defaultAlgoliaAgent.add(algoliaAgent));
    return defaultAlgoliaAgent;
}
const $ef6ec48844ba4a28$var$DEFAULT_CONNECT_TIMEOUT_BROWSER = 1000;
const $ef6ec48844ba4a28$var$DEFAULT_READ_TIMEOUT_BROWSER = 2000;
const $ef6ec48844ba4a28$var$DEFAULT_WRITE_TIMEOUT_BROWSER = 30000;
function $ef6ec48844ba4a28$var$createXhrRequester() {
    function send(request) {
        return new Promise((resolve)=>{
            const baseRequester = new XMLHttpRequest();
            baseRequester.open(request.method, request.url, true);
            Object.keys(request.headers).forEach((key)=>baseRequester.setRequestHeader(key, request.headers[key]));
            const createTimeout = (timeout, content)=>{
                return setTimeout(()=>{
                    baseRequester.abort();
                    resolve({
                        status: 0,
                        content: content,
                        isTimedOut: true
                    });
                }, timeout);
            };
            const connectTimeout = createTimeout(request.connectTimeout, "Connection timeout");
            let responseTimeout;
            baseRequester.onreadystatechange = ()=>{
                if (baseRequester.readyState > baseRequester.OPENED && responseTimeout === undefined) {
                    clearTimeout(connectTimeout);
                    responseTimeout = createTimeout(request.responseTimeout, "Socket timeout");
                }
            };
            baseRequester.onerror = ()=>{
                // istanbul ignore next
                if (baseRequester.status === 0) {
                    clearTimeout(connectTimeout);
                    clearTimeout(responseTimeout);
                    resolve({
                        content: baseRequester.responseText || "Network request failed",
                        status: baseRequester.status,
                        isTimedOut: false
                    });
                }
            };
            baseRequester.onload = ()=>{
                clearTimeout(connectTimeout);
                clearTimeout(responseTimeout);
                resolve({
                    content: baseRequester.responseText,
                    status: baseRequester.status,
                    isTimedOut: false
                });
            };
            baseRequester.send(request.data);
        });
    }
    return {
        send: send
    };
}
// Code generated by OpenAPI Generator (https://openapi-generator.tech), manual changes will be lost - read more on https://github.com/algolia/api-clients-automation. DO NOT EDIT.
const $ef6ec48844ba4a28$export$ad1dfbed11feb646 = "5.1.1";
function $ef6ec48844ba4a28$var$getDefaultHosts(appId) {
    return [
        {
            url: `${appId}-dsn.algolia.net`,
            accept: "read",
            protocol: "https"
        },
        {
            url: `${appId}.algolia.net`,
            accept: "write",
            protocol: "https"
        }
    ].concat($ef6ec48844ba4a28$var$shuffle([
        {
            url: `${appId}-1.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        },
        {
            url: `${appId}-2.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        },
        {
            url: `${appId}-3.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        }
    ]));
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function $ef6ec48844ba4a28$var$createLiteClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, ...options }) {
    const auth = $ef6ec48844ba4a28$var$createAuth(appIdOption, apiKeyOption, authMode);
    const transporter = $ef6ec48844ba4a28$var$createTransporter({
        hosts: $ef6ec48844ba4a28$var$getDefaultHosts(appIdOption),
        ...options,
        algoliaAgent: $ef6ec48844ba4a28$var$getAlgoliaAgent({
            algoliaAgents: algoliaAgents,
            client: "Lite",
            version: $ef6ec48844ba4a28$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
         * The `appId` currently in use.
         */ appId: appIdOption,
        /**
         * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
         */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>undefined);
        },
        /**
         * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
         */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
         * Adds a `segment` to the `x-algolia-agent` sent with every requests.
         *
         * @param segment - The algolia agent (user-agent) segment to add.
         * @param version - The version of the agent.
         */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
         * Helper: calls the `search` method but with certainty that we will only request Algolia records (hits) and not facets.
         * Disclaimer: We don't assert that the parameters you pass to this method only contains `hits` requests to prevent impacting search performances, this helper is purely for typing purposes.
         *
         * @summary Search multiple indices for `hits`.
         * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
         * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
         */ searchForHits (searchMethodParams, requestOptions) {
            return this.search(searchMethodParams, requestOptions);
        },
        /**
         * Helper: calls the `search` method but with certainty that we will only request Algolia facets and not records (hits).
         * Disclaimer: We don't assert that the parameters you pass to this method only contains `facets` requests to prevent impacting search performances, this helper is purely for typing purposes.
         *
         * @summary Search multiple indices for `facets`.
         * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
         * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
         */ searchForFacets (searchMethodParams, requestOptions) {
            return this.search(searchMethodParams, requestOptions);
        },
        /**
         * This method allow you to send requests to the Algolia REST API.
         *
         * @param customPost - The customPost object.
         * @param customPost.path - Path of the endpoint, anything after \"/1\" must be specified.
         * @param customPost.parameters - Query parameters to apply to the current query.
         * @param customPost.body - Parameters to send with the custom request.
         * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
         */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
         * Retrieves recommendations from selected AI models.
         *
         * Required API Key ACLs:
         * - search.
         *
         * @param getRecommendationsParams - The getRecommendationsParams object.
         * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
         */ getRecommendations (getRecommendationsParams, requestOptions) {
            if (getRecommendationsParams && Array.isArray(getRecommendationsParams)) {
                const newSignatureRequest = {
                    requests: getRecommendationsParams
                };
                // eslint-disable-next-line no-param-reassign
                getRecommendationsParams = newSignatureRequest;
            }
            if (!getRecommendationsParams) throw new Error("Parameter `getRecommendationsParams` is required when calling `getRecommendations`.");
            if (!getRecommendationsParams.requests) throw new Error("Parameter `getRecommendationsParams.requests` is required when calling `getRecommendations`.");
            const requestPath = "/1/indexes/*/recommendations";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: getRecommendationsParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
         * Sends multiple search request to one or more indices.  This can be useful in these cases:  - Different indices for different purposes, such as, one index for products, another one for marketing content. - Multiple searches to the same index—for example, with different filters.
         *
         * Required API Key ACLs:
         * - search.
         *
         * @param searchMethodParams - Muli-search request body. Results are returned in the same order as the requests.
         * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
         */ search (searchMethodParams, requestOptions) {
            if (searchMethodParams && Array.isArray(searchMethodParams)) {
                const newSignatureRequest = {
                    requests: searchMethodParams.map(({ params: params, ...legacyRequest })=>{
                        if (legacyRequest.type === "facet") return {
                            ...legacyRequest,
                            ...params,
                            type: "facet"
                        };
                        return {
                            ...legacyRequest,
                            ...params,
                            facet: undefined,
                            maxFacetHits: undefined,
                            facetQuery: undefined
                        };
                    })
                };
                // eslint-disable-next-line no-param-reassign
                searchMethodParams = newSignatureRequest;
            }
            if (!searchMethodParams) throw new Error("Parameter `searchMethodParams` is required when calling `search`.");
            if (!searchMethodParams.requests) throw new Error("Parameter `searchMethodParams.requests` is required when calling `search`.");
            const requestPath = "/1/indexes/*/queries";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchMethodParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// Code generated by OpenAPI Generator (https://openapi-generator.tech), manual changes will be lost - read more on https://github.com/algolia/api-clients-automation. DO NOT EDIT.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function $ef6ec48844ba4a28$export$f33d1b811c3510b4(appId, apiKey, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    return $ef6ec48844ba4a28$var$createLiteClient({
        appId: appId,
        apiKey: apiKey,
        timeouts: {
            connect: $ef6ec48844ba4a28$var$DEFAULT_CONNECT_TIMEOUT_BROWSER,
            read: $ef6ec48844ba4a28$var$DEFAULT_READ_TIMEOUT_BROWSER,
            write: $ef6ec48844ba4a28$var$DEFAULT_WRITE_TIMEOUT_BROWSER
        },
        requester: $ef6ec48844ba4a28$var$createXhrRequester(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: $ef6ec48844ba4a28$var$createMemoryCache(),
        requestsCache: $ef6ec48844ba4a28$var$createMemoryCache({
            serializable: false
        }),
        hostsCache: $ef6ec48844ba4a28$var$createFallbackableCache({
            caches: [
                $ef6ec48844ba4a28$var$createBrowserLocalStorageCache({
                    key: `${$ef6ec48844ba4a28$export$ad1dfbed11feb646}-${appId}`
                }),
                $ef6ec48844ba4a28$var$createMemoryCache()
            ]
        }),
        ...options
    });
}



function $62e320c3ff1379b2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $62e320c3ff1379b2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $62e320c3ff1379b2$var$_typeof(o);
}
var $62e320c3ff1379b2$export$d900da7fa9a86f36 = "_ALGOLIA";
function $62e320c3ff1379b2$var$getCookie(name) {
    if ((typeof document === "undefined" ? "undefined" : $62e320c3ff1379b2$var$_typeof(document)) !== "object" || typeof document.cookie !== "string") return undefined;
    var prefix = "".concat(name, "=");
    var cookies = document.cookie.split(";");
    for(var i = 0; i < cookies.length; i++){
        var cookie = cookies[i];
        while(cookie.charAt(0) === " ")cookie = cookie.substring(1);
        if (cookie.indexOf(prefix) === 0) return cookie.substring(prefix.length, cookie.length);
    }
    return undefined;
}
function $62e320c3ff1379b2$export$61f1c6e9cd2ed687() {
    return $62e320c3ff1379b2$var$getCookie($62e320c3ff1379b2$export$d900da7fa9a86f36);
}
function $62e320c3ff1379b2$export$2e2bcd8739ae039() {
    return $62e320c3ff1379b2$export$61f1c6e9cd2ed687();
}

var $23fceae7dc9dc95c$var$NAMESPACE = "ais";
var $23fceae7dc9dc95c$export$d8556a2a8f973135 = function component(componentName) {
    return function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, descendantName = _ref.descendantName, modifierName = _ref.modifierName;
        var descendent = descendantName ? "-".concat(descendantName) : "";
        var modifier = modifierName ? "--".concat(modifierName) : "";
        return "".concat($23fceae7dc9dc95c$var$NAMESPACE, "-").concat(componentName).concat(descendent).concat(modifier);
    };
};


function $b4f0c35eb9590d0c$export$d14846335956eefa(object, path) {
    var parts = Array.isArray(path) ? path : path.split(".");
    return parts.reduce(function(current, key) {
        return current && current[key];
    }, object);
}

/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/escape.js
 */ // Used to map characters to HTML entities.
var $272444c6ab685d67$var$htmlEntities = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
// Used to match HTML entities and HTML characters.
var $272444c6ab685d67$var$regexUnescapedHtml = /[&<>"']/g;
var $272444c6ab685d67$var$regexHasUnescapedHtml = RegExp($272444c6ab685d67$var$regexUnescapedHtml.source);
function $272444c6ab685d67$export$4e7f196112fea3c5(value) {
    return value && $272444c6ab685d67$var$regexHasUnescapedHtml.test(value) ? value.replace($272444c6ab685d67$var$regexUnescapedHtml, function(character) {
        return $272444c6ab685d67$var$htmlEntities[character];
    }) : value;
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/unescape.js
 */ // Used to map HTML entities to characters.
var $272444c6ab685d67$var$htmlCharacters = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
};
// Used to match HTML entities and HTML characters.
var $272444c6ab685d67$var$regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var $272444c6ab685d67$var$regexHasEscapedHtml = RegExp($272444c6ab685d67$var$regexEscapedHtml.source);
function $272444c6ab685d67$export$e8bacd2802a88316(value) {
    return value && $272444c6ab685d67$var$regexHasEscapedHtml.test(value) ? value.replace($272444c6ab685d67$var$regexEscapedHtml, function(character) {
        return $272444c6ab685d67$var$htmlCharacters[character];
    }) : value;
}


function $2024d8874034c7cb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2024d8874034c7cb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2024d8874034c7cb$var$_typeof(o);
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/master/isPlainObject.js
 */ function $2024d8874034c7cb$var$getTag(value) {
    if (value === null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
function $2024d8874034c7cb$var$isObjectLike(value) {
    return $2024d8874034c7cb$var$_typeof(value) === "object" && value !== null;
}
function $2024d8874034c7cb$export$53b83ca8eaab0383(value) {
    if (!$2024d8874034c7cb$var$isObjectLike(value) || $2024d8874034c7cb$var$getTag(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    var proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}


function $ffe8c7f6cc3688f1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ffe8c7f6cc3688f1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ffe8c7f6cc3688f1$var$_typeof(o);
}
function $ffe8c7f6cc3688f1$var$_objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $ffe8c7f6cc3688f1$var$_extends() {
    $ffe8c7f6cc3688f1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ffe8c7f6cc3688f1$var$_extends.apply(this, arguments);
}
function $ffe8c7f6cc3688f1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ffe8c7f6cc3688f1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ffe8c7f6cc3688f1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ffe8c7f6cc3688f1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ffe8c7f6cc3688f1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ffe8c7f6cc3688f1$var$_defineProperty(obj, key, value) {
    key = $ffe8c7f6cc3688f1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ffe8c7f6cc3688f1$var$_toPropertyKey(t) {
    var i = $ffe8c7f6cc3688f1$var$_toPrimitive(t, "string");
    return "symbol" == $ffe8c7f6cc3688f1$var$_typeof(i) ? i : String(i);
}
function $ffe8c7f6cc3688f1$var$_toPrimitive(t, r) {
    if ("object" != $ffe8c7f6cc3688f1$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ffe8c7f6cc3688f1$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ffe8c7f6cc3688f1$export$1e7338a8952eaf35 = {
    highlightPreTag: "__ais-highlight__",
    highlightPostTag: "__/ais-highlight__"
};
var $ffe8c7f6cc3688f1$export$62e796b7905e8e6b = {
    highlightPreTag: "<mark>",
    highlightPostTag: "</mark>"
};
// @MAJOR: in the future, this should only escape, not replace
function $ffe8c7f6cc3688f1$var$replaceTagsAndEscape(value) {
    return (0, $272444c6ab685d67$export$4e7f196112fea3c5)(value).replace(new RegExp($ffe8c7f6cc3688f1$export$1e7338a8952eaf35.highlightPreTag, "g"), $ffe8c7f6cc3688f1$export$62e796b7905e8e6b.highlightPreTag).replace(new RegExp($ffe8c7f6cc3688f1$export$1e7338a8952eaf35.highlightPostTag, "g"), $ffe8c7f6cc3688f1$export$62e796b7905e8e6b.highlightPostTag);
}
function $ffe8c7f6cc3688f1$var$recursiveEscape(input) {
    if ((0, $2024d8874034c7cb$export$53b83ca8eaab0383)(input) && typeof input.value !== "string") return Object.keys(input).reduce(function(acc, key) {
        return $ffe8c7f6cc3688f1$var$_objectSpread($ffe8c7f6cc3688f1$var$_objectSpread({}, acc), {}, $ffe8c7f6cc3688f1$var$_defineProperty({}, key, $ffe8c7f6cc3688f1$var$recursiveEscape(input[key])));
    }, {});
    if (Array.isArray(input)) return input.map($ffe8c7f6cc3688f1$var$recursiveEscape);
    return $ffe8c7f6cc3688f1$var$_objectSpread($ffe8c7f6cc3688f1$var$_objectSpread({}, input), {}, {
        value: $ffe8c7f6cc3688f1$var$replaceTagsAndEscape(input.value)
    });
}
function $ffe8c7f6cc3688f1$export$9adb036445aab889(hits) {
    if (hits.__escaped === undefined) {
        // We don't override the value on hit because it will mutate the raw results
        // instead we make a shallow copy and we assign the escaped values on it.
        hits = hits.map(function(_ref) {
            var hit = $ffe8c7f6cc3688f1$var$_extends({}, ($ffe8c7f6cc3688f1$var$_objectDestructuringEmpty(_ref), _ref));
            if (hit._highlightResult) hit._highlightResult = $ffe8c7f6cc3688f1$var$recursiveEscape(hit._highlightResult);
            if (hit._snippetResult) hit._snippetResult = $ffe8c7f6cc3688f1$var$recursiveEscape(hit._snippetResult);
            return hit;
        });
        hits.__escaped = true;
    }
    return hits;
}
function $ffe8c7f6cc3688f1$export$9ae2e822836b2e1a(facetHits) {
    return facetHits.map(function(h) {
        return $ffe8c7f6cc3688f1$var$_objectSpread($ffe8c7f6cc3688f1$var$_objectSpread({}, h), {}, {
            highlighted: $ffe8c7f6cc3688f1$var$replaceTagsAndEscape(h.highlighted)
        });
    });
}


var $7406f687e3aa4bbe$var$suit = (0, $23fceae7dc9dc95c$export$d8556a2a8f973135)("Highlight");
function $7406f687e3aa4bbe$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $b4f0c35eb9590d0c$export$d14846335956eefa)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $7406f687e3aa4bbe$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}

function $9e862a34ed7cbcee$export$44b4521aa38272f2(payload) {
    return btoa(encodeURIComponent(JSON.stringify(payload)));
}
function $9e862a34ed7cbcee$export$706ea24b0964bee9(serialized) {
    return JSON.parse(decodeURIComponent(atob(serialized)));
}


function $0960a378c85a0fdc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0960a378c85a0fdc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0960a378c85a0fdc$var$_typeof(o);
}
function $0960a378c85a0fdc$export$cbcfede36ce7ab2e(domElement) {
    var method = domElement.getAttribute("data-insights-method");
    var serializedPayload = domElement.getAttribute("data-insights-payload");
    if (typeof serializedPayload !== "string") throw new Error("The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.");
    try {
        var payload = (0, $9e862a34ed7cbcee$export$706ea24b0964bee9)(serializedPayload);
        return {
            method: method,
            payload: payload
        };
    } catch (error) {
        throw new Error("The insights helper was unable to parse `data-insights-payload`.");
    }
}
function $0960a378c85a0fdc$export$a3453cc0ced8b97c(_ref) {
    var method = _ref.method, payload = _ref.payload;
    if ($0960a378c85a0fdc$var$_typeof(payload) !== "object") throw new Error("The insights helper expects the payload to be an object.");
    var serializedPayload;
    try {
        serializedPayload = (0, $9e862a34ed7cbcee$export$44b4521aa38272f2)(payload);
    } catch (error) {
        throw new Error("Could not JSON serialize the payload object.");
    }
    return 'data-insights-method="'.concat(method, '" data-insights-payload="').concat(serializedPayload, '"');
}
function $0960a378c85a0fdc$export$2e2bcd8739ae039(method, payload) {
    return $0960a378c85a0fdc$export$a3453cc0ced8b97c({
        method: method,
        payload: payload
    });
}



function $8fb298909229fbd4$export$a34fe2fceda1929e(parts) {
    var highlightPreTag = (0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPreTag, highlightPostTag = (0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPostTag;
    return parts.map(function(part) {
        return part.isHighlighted ? highlightPreTag + part.value + highlightPostTag : part.value;
    }).join("");
}


function $40278fc744783199$export$e04d28e65b830ebf(highlightedValue) {
    // @MAJOR: this should use TAG_PLACEHOLDER
    var highlightPostTag = (0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPostTag, highlightPreTag = (0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPreTag;
    var splitByPreTag = highlightedValue.split(highlightPreTag);
    var firstValue = splitByPreTag.shift();
    var elements = !firstValue ? [] : [
        {
            value: firstValue,
            isHighlighted: false
        }
    ];
    splitByPreTag.forEach(function(split) {
        var splitByPostTag = split.split(highlightPostTag);
        elements.push({
            value: splitByPostTag[0],
            isHighlighted: true
        });
        if (splitByPostTag[1] !== "") elements.push({
            value: splitByPostTag[1],
            isHighlighted: false
        });
    });
    return elements;
}


var $4a16cda6e2e49219$var$hasAlphanumeric = new RegExp(/\w/i);
function $4a16cda6e2e49219$export$60c97785b669d08a(parts, i) {
    var _parts, _parts2;
    var current = parts[i];
    var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
    var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;
    if (!$4a16cda6e2e49219$var$hasAlphanumeric.test((0, $272444c6ab685d67$export$e8bacd2802a88316)(current.value)) && isPreviousHighlighted === isNextHighlighted) return isPreviousHighlighted;
    return current.isHighlighted;
}


function $cd0fcf71c417640e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cd0fcf71c417640e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cd0fcf71c417640e$var$_typeof(o);
}
function $cd0fcf71c417640e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd0fcf71c417640e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd0fcf71c417640e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cd0fcf71c417640e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd0fcf71c417640e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cd0fcf71c417640e$var$_defineProperty(obj, key, value) {
    key = $cd0fcf71c417640e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cd0fcf71c417640e$var$_toPropertyKey(t) {
    var i = $cd0fcf71c417640e$var$_toPrimitive(t, "string");
    return "symbol" == $cd0fcf71c417640e$var$_typeof(i) ? i : String(i);
}
function $cd0fcf71c417640e$var$_toPrimitive(t, r) {
    if ("object" != $cd0fcf71c417640e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cd0fcf71c417640e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cd0fcf71c417640e$export$8d1202a2cf66e93(parts) {
    if (!parts.some(function(part) {
        return part.isHighlighted;
    })) return parts.map(function(part) {
        return $cd0fcf71c417640e$var$_objectSpread($cd0fcf71c417640e$var$_objectSpread({}, part), {}, {
            isHighlighted: false
        });
    });
    return parts.map(function(part, i) {
        return $cd0fcf71c417640e$var$_objectSpread($cd0fcf71c417640e$var$_objectSpread({}, part), {}, {
            isHighlighted: !(0, $4a16cda6e2e49219$export$60c97785b669d08a)(parts, i)
        });
    });
}


var $252f56918a3355b2$var$suit = (0, $23fceae7dc9dc95c$export$d8556a2a8f973135)("ReverseHighlight");
function $252f56918a3355b2$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $b4f0c35eb9590d0c$export$d14846335956eefa)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $252f56918a3355b2$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $8fb298909229fbd4$export$a34fe2fceda1929e)((0, $cd0fcf71c417640e$export$8d1202a2cf66e93)((0, $40278fc744783199$export$e04d28e65b830ebf)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



var $6a226ae052dfdaa0$var$suit = (0, $23fceae7dc9dc95c$export$d8556a2a8f973135)("ReverseSnippet");
function $6a226ae052dfdaa0$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $b4f0c35eb9590d0c$export$d14846335956eefa)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $6a226ae052dfdaa0$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $8fb298909229fbd4$export$a34fe2fceda1929e)((0, $cd0fcf71c417640e$export$8d1202a2cf66e93)((0, $40278fc744783199$export$e04d28e65b830ebf)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



var $e443915becc5e204$var$suit = (0, $23fceae7dc9dc95c$export$d8556a2a8f973135)("Snippet");
function $e443915becc5e204$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $b4f0c35eb9590d0c$export$d14846335956eefa)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $e443915becc5e204$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}


function $522688c948998c6d$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $522688c948998c6d$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($522688c948998c6d$var$isPrimitive(first) || $522688c948998c6d$var$isPrimitive(second) || typeof first === "function" || typeof second === "function") return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    // @TODO avoid for..of because of the large polyfill
    // eslint-disable-next-line no-restricted-syntax
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$522688c948998c6d$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}

// eslint-disable-next-line no-restricted-globals
/**
 * Runs code on browser environments safely.
 */ function $746e4e2d1e96d95f$export$39f19eed34acd2f1(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        fallback: function fallback() {
            return undefined;
        }
    }, fallback = _ref.fallback;
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === "undefined") return fallback();
    // eslint-disable-next-line no-restricted-globals
    return callback({
        window: window
    });
}


var $bed699150dce830c$var$_excluded = [
    "page"
];
function $bed699150dce830c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bed699150dce830c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bed699150dce830c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bed699150dce830c$var$getStateWithoutPage(state) {
    var _ref = state || {}, page = _ref.page, rest = $bed699150dce830c$var$_objectWithoutProperties(_ref, $bed699150dce830c$var$_excluded);
    return rest;
}
function $bed699150dce830c$export$2e2bcd8739ae039() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, key = _ref2.key;
    var KEY = [
        "ais.infiniteHits",
        key
    ].filter(Boolean).join(":");
    return {
        read: function read(_ref3) {
            var state = _ref3.state;
            var sessionStorage = (0, $746e4e2d1e96d95f$export$39f19eed34acd2f1)(function(_ref4) {
                var window = _ref4.window;
                return window.sessionStorage;
            });
            if (!sessionStorage) return null;
            try {
                var cache = JSON.parse(// @ts-expect-error JSON.parse() requires a string, but it actually accepts null, too.
                sessionStorage.getItem(KEY));
                return cache && (0, $522688c948998c6d$export$248d38f6296296c5)(cache.state, $bed699150dce830c$var$getStateWithoutPage(state)) ? cache.hits : null;
            } catch (error) {
                if (error instanceof SyntaxError) try {
                    sessionStorage.removeItem(KEY);
                } catch (err) {
                // do nothing
                }
                return null;
            }
        },
        write: function write(_ref5) {
            var state = _ref5.state, hits = _ref5.hits;
            var sessionStorage = (0, $746e4e2d1e96d95f$export$39f19eed34acd2f1)(function(_ref6) {
                var window = _ref6.window;
                return window.sessionStorage;
            });
            if (!sessionStorage) return;
            try {
                sessionStorage.setItem(KEY, JSON.stringify({
                    state: $bed699150dce830c$var$getStateWithoutPage(state),
                    hits: hits
                }));
            } catch (error) {
            // do nothing
            }
        }
    };
}


var $b40ee84aff520977$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $b40ee84aff520977$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
$b40ee84aff520977$exports = $b40ee84aff520977$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$b40ee84aff520977$var$EventEmitter.prototype._events = undefined;
$b40ee84aff520977$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$b40ee84aff520977$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$b40ee84aff520977$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$b40ee84aff520977$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError("n must be a positive number");
    this._maxListeners = n;
    return this;
};
$b40ee84aff520977$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === "error") {
        if (!this._events.error || $b40ee84aff520977$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($b40ee84aff520977$var$isUndefined(handler)) return false;
    if ($b40ee84aff520977$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($b40ee84aff520977$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$b40ee84aff520977$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$b40ee84aff520977$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit("newListener", type, $b40ee84aff520977$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($b40ee84aff520977$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($b40ee84aff520977$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$b40ee84aff520977$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $b40ee84aff520977$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === "function") // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$b40ee84aff520977$var$EventEmitter.prototype.on = $b40ee84aff520977$var$EventEmitter.prototype.addListener;
$b40ee84aff520977$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$b40ee84aff520977$var$isFunction(listener)) throw TypeError("listener must be a function");
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$b40ee84aff520977$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$b40ee84aff520977$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $b40ee84aff520977$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    } else if ($b40ee84aff520977$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    }
    return this;
};
$b40ee84aff520977$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($b40ee84aff520977$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$b40ee84aff520977$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($b40ee84aff520977$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$b40ee84aff520977$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($b40ee84aff520977$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$b40ee84aff520977$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $b40ee84aff520977$var$isFunction(arg) {
    return typeof arg === "function";
}
function $b40ee84aff520977$var$isNumber(arg) {
    return typeof arg === "number";
}
function $b40ee84aff520977$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $b40ee84aff520977$var$isUndefined(arg) {
    return arg === void 0;
}


var $74e7126a05d3520a$exports = {};
"use strict";
var $5bde2a95cbd04999$exports = {};
"use strict";

var $cb8145b447143402$exports = {};
"use strict";

var $1cf73c71c9995bf7$exports = {};
"use strict";
function $1cf73c71c9995bf7$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
$1cf73c71c9995bf7$exports = $1cf73c71c9995bf7$var$inherits;


/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state for search
 * @param {function} recommendFn the function to create the derived state for recommendations
 */ function $cb8145b447143402$var$DerivedHelper(mainHelper, fn, recommendFn) {
    this.main = mainHelper;
    this.fn = fn;
    this.recommendFn = recommendFn;
    this.lastResults = null;
    this.lastRecommendResults = null;
}
$1cf73c71c9995bf7$exports($cb8145b447143402$var$DerivedHelper, $b40ee84aff520977$exports);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $cb8145b447143402$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$cb8145b447143402$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$cb8145b447143402$var$DerivedHelper.prototype.getModifiedRecommendState = function(parameters) {
    return this.recommendFn(parameters);
};
$cb8145b447143402$exports = $cb8145b447143402$var$DerivedHelper;


var $d8f72dc053825475$exports = {};
"use strict";
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $d8f72dc053825475$var$escapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return String(value).replace(/^-/, "\\-");
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $d8f72dc053825475$var$unescapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return value.replace(/^\\-/, "-");
}
$d8f72dc053825475$exports = {
    escapeFacetValue: $d8f72dc053825475$var$escapeFacetValue,
    unescapeFacetValue: $d8f72dc053825475$var$unescapeFacetValue
};


var $5bde2a95cbd04999$require$escapeFacetValue = $d8f72dc053825475$exports.escapeFacetValue;

var $f004d531f4e0bd66$exports = {};
"use strict";
function $f004d531f4e0bd66$var$clone(value) {
    if (typeof value === "object" && value !== null) return $f004d531f4e0bd66$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $f004d531f4e0bd66$var$isObjectOrArrayOrFunction(value) {
    return typeof value === "function" || Array.isArray(value) || Object.prototype.toString.call(value) === "[object Object]";
}
function $f004d531f4e0bd66$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === "__proto__" || key === "constructor") continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== "undefined" && typeof sourceVal === "undefined") continue;
        if ($f004d531f4e0bd66$var$isObjectOrArrayOrFunction(targetVal) && $f004d531f4e0bd66$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $f004d531f4e0bd66$var$_merge(targetVal, sourceVal);
        else target[key] = $f004d531f4e0bd66$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $f004d531f4e0bd66$var$merge(target) {
    if (!$f004d531f4e0bd66$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($f004d531f4e0bd66$var$isObjectOrArrayOrFunction(source)) $f004d531f4e0bd66$var$_merge(target, source);
    }
    return target;
}
$f004d531f4e0bd66$exports = $f004d531f4e0bd66$var$merge;


var $48298581434a39e5$exports = {};
"use strict";
function $48298581434a39e5$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
$48298581434a39e5$exports = $48298581434a39e5$var$objectHasKeys;


var $6f0ae6fc93c19c5a$exports = {};
"use strict";
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $6f0ae6fc93c19c5a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$6f0ae6fc93c19c5a$exports = $6f0ae6fc93c19c5a$var$_objectWithoutPropertiesLoose;


var $e18128f64498c208$exports = {};
"use strict";
/**
 * RecommendParameters is the data structure that contains all the information
 * usable for getting recommendations from the Algolia API. It doesn't do the
 * search itself, nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It
 * will be provided when needed.
 * @constructor
 * @classdesc contains all the parameters for recommendations
 * @param {RecommendParametersOptions} opts the options to create the object
 */ function $e18128f64498c208$var$RecommendParameters(opts) {
    opts = opts || {};
    this.params = opts.params || [];
}
$e18128f64498c208$var$RecommendParameters.prototype = {
    constructor: $e18128f64498c208$var$RecommendParameters,
    addParams: function(params) {
        var newParams = this.params.slice();
        newParams.push(params);
        return new $e18128f64498c208$var$RecommendParameters({
            params: newParams
        });
    },
    removeParams: function(id) {
        return new $e18128f64498c208$var$RecommendParameters({
            params: this.params.filter(function(param) {
                return param.$$id !== id;
            })
        });
    },
    addFrequentlyBoughtTogether: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "bought-together"
        }));
    },
    addRelatedProducts: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "related-products"
        }));
    },
    addTrendingItems: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-items"
        }));
    },
    addTrendingFacets: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-facets"
        }));
    },
    addLookingSimilar: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "looking-similar"
        }));
    },
    _buildQueries: function(indexName, cache) {
        return this.params.filter(function(params) {
            return cache[params.$$id] === undefined;
        }).map(function(params) {
            var query = Object.assign({}, params, {
                indexName: indexName,
                // @TODO: remove this if it ever gets handled by the API
                threshold: params.threshold || 0
            });
            delete query.$$id;
            return query;
        });
    }
};
$e18128f64498c208$exports = $e18128f64498c208$var$RecommendParameters;


var $eb196a44d10ad5b6$exports = {};
"use strict";
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {RecommendParameters} state state that led to the response
 * @param {Record<string,RecommendResultItem>} results the results from algolia client
 **/ function $eb196a44d10ad5b6$var$RecommendResults(state, results) {
    this._state = state;
    this._rawResults = {};
    // eslint-disable-next-line consistent-this
    var self = this;
    state.params.forEach(function(param) {
        var id = param.$$id;
        self[id] = results[id];
        self._rawResults[id] = results[id];
    });
}
$eb196a44d10ad5b6$var$RecommendResults.prototype = {
    constructor: $eb196a44d10ad5b6$var$RecommendResults
};
$eb196a44d10ad5b6$exports = $eb196a44d10ad5b6$var$RecommendResults;


var $9af5b091c69af1ae$exports = {};
"use strict";

function $9af5b091c69af1ae$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $9af5b091c69af1ae$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $9af5b091c69af1ae$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $9af5b091c69af1ae$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $9af5b091c69af1ae$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(":")[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === "string" && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ":" + parent.value);
                    else if (filteredFacetFilters.length > 0) params.facetFilters = filteredFacetFilters;
                    else delete params.facetFilters;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getCompositionQueries: function getQueries(state) {
        return [
            {
                compositionID: state.index,
                requestBody: {
                    params: $9af5b091c69af1ae$var$requestBuilder._getCompositionHitsSearchParams(state)
                }
            }
        ];
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($9af5b091c69af1ae$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $9af5b091c69af1ae$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $9af5b091c69af1ae$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $9af5b091c69af1ae$var$requestBuilder._getTagFilters(state);
        var additionalParams = {};
        if (facets.length > 0) additionalParams.facets = facets.indexOf("*") > -1 ? [
            "*"
        ] : facets;
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $9af5b091c69af1ae$var$sortObject($f004d531f4e0bd66$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getCompositionHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets.map(function(value) {
            return "disjunctive(" + value + ")";
        })).concat($9af5b091c69af1ae$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $9af5b091c69af1ae$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $9af5b091c69af1ae$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $9af5b091c69af1ae$var$requestBuilder._getTagFilters(state);
        var additionalParams = {};
        if (facets.length > 0) additionalParams.facets = facets.indexOf("*") > -1 ? [
            "*"
        ] : facets;
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        var params = state.getQueryParams();
        delete params.highlightPreTag;
        delete params.highlightPostTag;
        // not a valid search parameter, it is handled in _getCompositionQueries
        delete params.index;
        return $9af5b091c69af1ae$var$sortObject($f004d531f4e0bd66$exports({}, params, additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $9af5b091c69af1ae$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $9af5b091c69af1ae$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $9af5b091c69af1ae$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $9af5b091c69af1ae$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $9af5b091c69af1ae$var$sortObject($f004d531f4e0bd66$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(",");
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.slice().sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":" + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":-" + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.slice().sort().forEach(function(facetValue) {
                orFilters.push(facetName + ":" + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ":" + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || "";
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === "number") searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $9af5b091c69af1ae$var$sortObject($f004d531f4e0bd66$exports({}, $9af5b091c69af1ae$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
$9af5b091c69af1ae$exports = $9af5b091c69af1ae$var$requestBuilder;


var $e7fac303ca53f9e0$exports = {};
"use strict";
var $ff4409fbffa58207$exports = {};
"use strict";
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
$ff4409fbffa58207$exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};


var $7c0c84abd35a1bd7$exports = {};
"use strict";
// @MAJOR can be replaced by native Array#find when we change support
$7c0c84abd35a1bd7$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};


var $b1e9bb7496d4a529$exports = {};
"use strict";
function $b1e9bb7496d4a529$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
$b1e9bb7496d4a529$exports = $b1e9bb7496d4a529$var$intersection;





var $38a5dc578766bd21$exports = {};
"use strict";
function $38a5dc578766bd21$var$valToNumber(v) {
    if (typeof v === "number") return v;
    else if (typeof v === "string") return parseFloat(v);
    else if (Array.isArray(v)) return v.map($38a5dc578766bd21$var$valToNumber);
    throw new Error("The value should be a number, a parsable string or an array of those.");
}
$38a5dc578766bd21$exports = $38a5dc578766bd21$var$valToNumber;


var $f7db4060be5e004d$exports = {};
"use strict";
$f7db4060be5e004d$exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};


var $e43ba9c651044c16$exports = {};
"use strict";



var $e43ba9c651044c16$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($e43ba9c651044c16$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = "" + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $ff4409fbffa58207$exports(mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $e43ba9c651044c16$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = "" + value;
        return $e43ba9c651044c16$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error("toggleRefinement should be used with a value");
        if ($e43ba9c651044c16$var$lib.isRefined(refinementList, attribute, value)) return $e43ba9c651044c16$var$lib.removeRefinement(refinementList, attribute, value);
        return $e43ba9c651044c16$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$48298581434a39e5$exports(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === "string") return $6f0ae6fc93c19c5a$exports(refinementList, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = "" + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
$e43ba9c651044c16$exports = $e43ba9c651044c16$var$lib;


/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $e7fac303ca53f9e0$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $e7fac303ca53f9e0$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $e7fac303ca53f9e0$var$findArray(array, searchedValue) {
    return $7c0c84abd35a1bd7$exports(array, function(currentValue) {
        return $e7fac303ca53f9e0$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $e7fac303ca53f9e0$var$SearchParameters(newParameters) {
    var params = newParameters ? $e7fac303ca53f9e0$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$f7db4060be5e004d$exports(params.userToken)) // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}");
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $e7fac303ca53f9e0$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $e7fac303ca53f9e0$var$SearchParameters.PARAMETERS = Object.keys(new $e7fac303ca53f9e0$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $e7fac303ca53f9e0$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $e7fac303ca53f9e0$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        "aroundPrecision",
        "aroundRadius",
        "getRankingInfo",
        "minWordSizefor2Typos",
        "minWordSizefor1Typo",
        "page",
        "maxValuesPerFacet",
        "distinct",
        "minimumAroundRadius",
        "hitsPerPage",
        "minProximity"
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === "string") {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === "string") return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === "string") return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $f004d531f4e0bd66$exports(partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $e7fac303ca53f9e0$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $e7fac303ca53f9e0$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $e7fac303ca53f9e0$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $48298581434a39e5$exports(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($48298581434a39e5$exports(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$e7fac303ca53f9e0$var$SearchParameters.prototype = {
    constructor: $e7fac303ca53f9e0$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $e43ba9c651044c16$exports.clearRefinement(this.facetsRefinements, attribute, "conjunctiveFacet"),
            facetsExcludes: $e43ba9c651044c16$exports.clearRefinement(this.facetsExcludes, attribute, "exclude"),
            disjunctiveFacetsRefinements: $e43ba9c651044c16$exports.clearRefinement(this.disjunctiveFacetsRefinements, attribute, "disjunctiveFacet"),
            hierarchicalFacetsRefinements: $e43ba9c651044c16$exports.clearRefinement(this.hierarchicalFacetsRefinements, attribute, "hierarchicalFacet")
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, value) {
        var val = $38a5dc578766bd21$exports(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $f004d531f4e0bd66$exports({}, this.numericRefinements);
        mod[attribute] = $f004d531f4e0bd66$exports({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $e7fac303ca53f9e0$var$isEqualNumericRefinement(value.val, $38a5dc578766bd21$exports(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$48298581434a39e5$exports(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === "string") return $6f0ae6fc93c19c5a$exports(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, "numeric");
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + hierarchicalFacet.name + "`");
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($e43ba9c651044c16$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $e43ba9c651044c16$exports.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($e43ba9c651044c16$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $e43ba9c651044c16$exports.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if ($e43ba9c651044c16$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $e43ba9c651044c16$exports.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$e43ba9c651044c16$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $e43ba9c651044c16$exports.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$e43ba9c651044c16$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $e43ba9c651044c16$exports.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if (!$e43ba9c651044c16$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $e43ba9c651044c16$exports.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error("Cannot refine the undeclared facet " + facet + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsRefinements: $e43ba9c651044c16$exports.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsExcludes: $e43ba9c651044c16$exports.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $e43ba9c651044c16$exports.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration");
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $ff4409fbffa58207$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + " is already refined.");
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $ff4409fbffa58207$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $ff4409fbffa58207$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $e43ba9c651044c16$exports.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $e43ba9c651044c16$exports.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $e43ba9c651044c16$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $38a5dc578766bd21$exports(value);
        var isAttributeValueDefined = $e7fac303ca53f9e0$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $b1e9bb7496d4a529$exports(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $b1e9bb7496d4a529$exports(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        "index",
        "facets",
        "disjunctiveFacets",
        "facetsRefinements",
        "hierarchicalFacets",
        "facetsExcludes",
        "disjunctiveFacetsRefinements",
        "numericRefinements",
        "tagRefinements",
        "hierarchicalFacetsRefinements"
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $e7fac303ca53f9e0$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $e7fac303ca53f9e0$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $6f0ae6fc93c19c5a$exports(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            "isRefined:desc",
            "name:asc"
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || " > ";
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === "boolean") return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $7c0c84abd35a1bd7$exports(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ $e7fac303ca53f9e0$exports = $e7fac303ca53f9e0$var$SearchParameters;


var $e21bfd2819a87d9e$exports = {};
"use strict";
var $610b3650bbb70cba$exports = {};
"use strict";
$610b3650bbb70cba$exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};





var $76d6359f261c4b84$exports = {};
"use strict";
// @MAJOR can be replaced by native Array#findIndex when we change support
$76d6359f261c4b84$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};


var $5cc03421fdd2140e$exports = {};
"use strict";

/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ $5cc03421fdd2140e$exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(":");
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(":");
        var matchingDefault = $7c0c84abd35a1bd7$exports(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};


var $fe6ce808b001f93f$exports = {};
"use strict";
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order and keep the highest numeric value
function $fe6ce808b001f93f$var$mergeNumericMax() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            var accValue = typeof acc[key] === "number" ? acc[key] : 0;
            var sourceValue = source[key];
            if (sourceValue === undefined) return;
            if (sourceValue >= accValue) {
                if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
                delete acc[key];
                acc[key] = sourceValue;
            }
        });
        return acc;
    }, {});
}
$fe6ce808b001f93f$exports = $fe6ce808b001f93f$var$mergeNumericMax;


var $04b18e8062dc0a37$exports = {};
"use strict";
function $04b18e8062dc0a37$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $04b18e8062dc0a37$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $04b18e8062dc0a37$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === "desc") return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
$04b18e8062dc0a37$exports = $04b18e8062dc0a37$var$orderBy;


var $e21bfd2819a87d9e$var$escapeFacetValue = $d8f72dc053825475$exports.escapeFacetValue;
var $e21bfd2819a87d9e$var$unescapeFacetValue = $d8f72dc053825475$exports.unescapeFacetValue;
var $8028f8777b9c1c92$exports = {};
"use strict";
$8028f8777b9c1c92$exports = $8028f8777b9c1c92$var$generateTrees;




var $8028f8777b9c1c92$var$escapeFacetValue = $d8f72dc053825475$exports.escapeFacetValue;
var $8028f8777b9c1c92$var$unescapeFacetValue = $d8f72dc053825475$exports.unescapeFacetValue;
function $8028f8777b9c1c92$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || "";
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $5cc03421fdd2140e$exports(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $8028f8777b9c1c92$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $8028f8777b9c1c92$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $7c0c84abd35a1bd7$exports(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $8028f8777b9c1c92$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $04b18e8062dc0a37$exports(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $8028f8777b9c1c92$var$format(facetCount, facetValue, hierarchicalSeparator, $8028f8777b9c1c92$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $8028f8777b9c1c92$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $8028f8777b9c1c92$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $8028f8777b9c1c92$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}


/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $e21bfd2819a87d9e$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $e21bfd2819a87d9e$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $e21bfd2819a87d9e$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $7c0c84abd35a1bd7$exports(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @param {object} options options to control results content
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $e21bfd2819a87d9e$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0] || {};
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    var opts = $ff4409fbffa58207$exports(options, {
        persistHierarchicalRootCount: false
    });
    Object.keys(opts).forEach(function(key) {
        self[key] = opts[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $e21bfd2819a87d9e$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $e21bfd2819a87d9e$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $e21bfd2819a87d9e$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $76d6359f261c4b84$exports(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $e21bfd2819a87d9e$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $e21bfd2819a87d9e$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $610b3650bbb70cba$exports(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $76d6359f261c4b84$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $76d6359f261c4b84$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = self.persistHierarchicalRootCount ? $fe6ce808b001f93f$exports(self.hierarchicalFacets[position][attributeIndex].data, facetResults) : $ff4409fbffa58207$exports(facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $fe6ce808b001f93f$exports(dataFromMainRequest, facetResults),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $e21bfd2819a87d9e$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($e21bfd2819a87d9e$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $76d6359f261c4b84$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $76d6359f261c4b84$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                // @MAJOR: remove this legacy behaviour in next major version
                var defaultData = {};
                if (currentRefinement.length > 0 && !self.persistHierarchicalRootCount) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $ff4409fbffa58207$exports(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($8028f8777b9c1c92$exports(state));
    /**
   * @type {Array}
   */ this.facets = $610b3650bbb70cba$exports(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $610b3650bbb70cba$exports(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $e21bfd2819a87d9e$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $7c0c84abd35a1bd7$exports(this.facets, predicate) || $7c0c84abd35a1bd7$exports(this.disjunctiveFacets, predicate) || $7c0c84abd35a1bd7$exports(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $e21bfd2819a87d9e$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $7c0c84abd35a1bd7$exports(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $e21bfd2819a87d9e$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $7c0c84abd35a1bd7$exports(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $e21bfd2819a87d9e$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $7c0c84abd35a1bd7$exports(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $e21bfd2819a87d9e$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || "");
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, "");
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $e21bfd2819a87d9e$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $e21bfd2819a87d9e$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === (currentRefinement[depth] && currentRefinement[depth].trim());
    if (item.data) item.data.forEach(function(child) {
        $e21bfd2819a87d9e$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $e21bfd2819a87d9e$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $e21bfd2819a87d9e$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $ff4409fbffa58207$exports({
        data: sortedChildren
    }, node);
    return newNode;
}
$e21bfd2819a87d9e$var$SearchResults.DEFAULT_SORT = [
    "isRefined:desc",
    "count:desc",
    "name:asc"
];
function $e21bfd2819a87d9e$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $e21bfd2819a87d9e$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var hide = facetOrdering.hide || [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        var hidden = hide.indexOf(name) > -1;
        if (!hidden && reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else if (!hidden) remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === "hidden") return orderedFacets;
    else if (sortRemainingBy === "alpha") ordering = [
        [
            "path",
            "name"
        ],
        [
            "asc",
            "asc"
        ]
    ];
    else ordering = [
        [
            "count"
        ],
        [
            "desc"
        ]
    ];
    return orderedFacets.concat($04b18e8062dc0a37$exports(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $e21bfd2819a87d9e$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $e21bfd2819a87d9e$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $e21bfd2819a87d9e$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $ff4409fbffa58207$exports(opts, {
        sortBy: $e21bfd2819a87d9e$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $e21bfd2819a87d9e$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $e21bfd2819a87d9e$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $e21bfd2819a87d9e$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $5cc03421fdd2140e$exports(options.sortBy, $e21bfd2819a87d9e$var$SearchResults.DEFAULT_SORT);
            return $04b18e8062dc0a37$exports(data, order[0], order[1]);
        } else if (typeof options.sortBy === "function") return $e21bfd2819a87d9e$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $e21bfd2819a87d9e$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $e21bfd2819a87d9e$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $e21bfd2819a87d9e$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $e21bfd2819a87d9e$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $7c0c84abd35a1bd7$exports(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $e21bfd2819a87d9e$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($e21bfd2819a87d9e$var$getRefinement(state, "facet", attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($e21bfd2819a87d9e$var$getRefinement(state, "exclude", attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($e21bfd2819a87d9e$var$getRefinement(state, "disjunctive", attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($e21bfd2819a87d9e$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: "numeric",
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: "tag",
            attributeName: "_tags",
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $e21bfd2819a87d9e$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $7c0c84abd35a1bd7$exports(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $e21bfd2819a87d9e$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $7c0c84abd35a1bd7$exports(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $7c0c84abd35a1bd7$exports(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || "";
    return {
        type: "hierarchical",
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
$e21bfd2819a87d9e$exports = $e21bfd2819a87d9e$var$SearchResults;


var $0ce959ddfc992e35$exports = {};
"use strict";

var $e776f8918504f9b2$exports = {};
// @MAJOR: remove this function and use Array.prototype.flat
$e776f8918504f9b2$exports = function flat(arr) {
    return arr.reduce(function(acc, val) {
        return acc.concat(val);
    }, []);
};


function $0ce959ddfc992e35$var$getAverageIndices(indexTracker, nrOfObjs) {
    var avgIndices = [];
    Object.keys(indexTracker).forEach(function(key) {
        if (indexTracker[key].count < 2) indexTracker[key].indexSum += 100;
        avgIndices.push({
            objectID: key,
            avgOfIndices: indexTracker[key].indexSum / nrOfObjs
        });
    });
    return avgIndices.sort(function(a, b) {
        return a.avgOfIndices > b.avgOfIndices ? 1 : -1;
    });
}
function $0ce959ddfc992e35$var$sortAndMergeRecommendations(results) {
    var indexTracker = {};
    results.forEach(function(hits) {
        hits.forEach(function(hit, index) {
            if (!indexTracker[hit.objectID]) indexTracker[hit.objectID] = {
                indexSum: index,
                count: 1
            };
            else indexTracker[hit.objectID] = {
                indexSum: indexTracker[hit.objectID].indexSum + index,
                count: indexTracker[hit.objectID].count + 1
            };
        });
    });
    var sortedAverageIndices = $0ce959ddfc992e35$var$getAverageIndices(indexTracker, results.length);
    var finalOrder = sortedAverageIndices.reduce(function(orderedHits, avgIndexRef) {
        var result = $7c0c84abd35a1bd7$exports($e776f8918504f9b2$exports(results), function(hit) {
            return hit.objectID === avgIndexRef.objectID;
        });
        return result ? orderedHits.concat(result) : orderedHits;
    }, []);
    return finalOrder;
}
$0ce959ddfc992e35$exports = $0ce959ddfc992e35$var$sortAndMergeRecommendations;



var $aVTSq = parcelRequire("aVTSq");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 */ function $5bde2a95cbd04999$var$AlgoliaSearchHelper(client, index, options, searchResultsOptions) {
    if (typeof client.addAlgoliaAgent === "function") client.addAlgoliaAgent("JS Helper (" + $aVTSq + ")");
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $e7fac303ca53f9e0$exports.make(opts);
    this.recommendState = new $e18128f64498c208$exports({
        params: opts.recommendState
    });
    this.lastResults = null;
    this.lastRecommendResults = null;
    this._queryId = 0;
    this._recommendQueryId = 0;
    this._lastQueryIdReceived = -1;
    this._lastRecommendQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
    this._currentNbRecommendQueries = 0;
    this._searchResultsOptions = searchResultsOptions;
    this._recommendCache = {};
}
$1cf73c71c9995bf7$exports($5bde2a95cbd04999$var$AlgoliaSearchHelper, $b40ee84aff520977$exports);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
$5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.searchWithComposition = function() {
    this._runComposition({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Sends the recommendation queries set in the state. When the method is
 * called, it triggers a `fetch` event. The results will be available through
 * the `result` event. If an error occurs, an `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires fetch
 * @fires result
 * @fires error
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.recommend = function() {
    this._recommend();
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $9af5b091c69af1ae$exports._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $9af5b091c69af1ae$exports._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit("searchOnce", {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(null, new $e21bfd2819a87d9e$exports(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        return {
            content: new $e21bfd2819a87d9e$exports(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] answers is no longer supported");
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $f004d531f4e0bd66$exports({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $6f0ae6fc93c19c5a$exports($9af5b091c69af1ae$exports._getHitsSearchParams(derivedState), [
            "attributesToSnippet",
            "hitsPerPage",
            "restrictSearchableAttributes",
            "snippetEllipsisText"
        ])
    });
    var errorMessage = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
    if (typeof this.client.initIndex !== "function") throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== "function") throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === "function" && // v5 has a wrong sffv signature
    typeof this.client.searchForFacets !== "function";
    var clientHasInitIndex = typeof this.client.initIndex === "function";
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== "function") throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $9af5b091c69af1ae$exports.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: "facet",
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit("searchForFacetValues", {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $5bde2a95cbd04999$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Search for facet values using the Composition API & based on a query and the name of a faceted attribute.
 * This triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.searchForCompositionFacetValues = function(facet, query, maxFacetHits, userState) {
    if (typeof this.client.searchForFacetValues !== "function") throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues");
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    searchForFacetValuesPromise = this.client.searchForFacetValues({
        compositionID: state.index,
        facetName: facet,
        searchForFacetValuesRequest: {
            params: {
                query: query,
                maxFacetHits: maxFacetHits,
                searchQuery: $9af5b091c69af1ae$exports._getCompositionHitsSearchParams(state)
            }
        }
    });
    this.emit("searchForFacetValues", {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        content = content.results[0];
        content.facetHits.forEach(function(f) {
            f.escapedValue = $5bde2a95cbd04999$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a "frequently bought together" recommendation query.
 *
 * @param {FrequentlyBoughtTogetherQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addFrequentlyBoughtTogether = function(params) {
    this._recommendChange({
        state: this.recommendState.addFrequentlyBoughtTogether(params)
    });
    return this;
};
/**
 * Adds a "related products" recommendation query.
 *
 * @param {RelatedProductsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addRelatedProducts = function(params) {
    this._recommendChange({
        state: this.recommendState.addRelatedProducts(params)
    });
    return this;
};
/**
 * Adds a "trending items" recommendation query.
 *
 * @param {TrendingItemsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addTrendingItems = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingItems(params)
    });
    return this;
};
/**
 * Adds a "trending facets" recommendation query.
 *
 * @param {TrendingFacetsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addTrendingFacets = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingFacets(params)
    });
    return this;
};
/**
 * Adds a "looking similar" recommendation query.
 *
 * @param {LookingSimilarQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.addLookingSimilar = function(params) {
    this._recommendChange({
        state: this.recommendState.addLookingSimilar(params)
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a "frequently bought together" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeFrequentlyBoughtTogether = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "related products" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeRelatedProducts = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending items" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeTrendingItems = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending facets" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeTrendingFacets = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "looking similar" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.removeLookingSimilar = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $5bde2a95cbd04999$var$setCurrentPage(page) {
    if (page < 0) throw new Error("Page requested below 0.");
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.setCurrentPage = $5bde2a95cbd04999$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.setPage = $5bde2a95cbd04999$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $e7fac303ca53f9e0$exports.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $e7fac303ca53f9e0$exports(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($48298581434a39e5$exports(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $5bde2a95cbd04999$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.getCurrentPage = $5bde2a95cbd04999$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.getPage = $5bde2a95cbd04999$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "conjunctive"
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "exclude"
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "disjunctive"
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: "numeric"
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $9af5b091c69af1ae$exports._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit("search", {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $9af5b091c69af1ae$exports._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit("search", {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return undefined;
};
/**
 * Perform the underlying queries
 * @private
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype._runComposition = function() {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = $9af5b091c69af1ae$exports._getCompositionQueries(derivedState);
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit("search", {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    if (queries.length > 1) throw new Error("Only one query is allowed when using a composition.");
    var query = queries[0];
    try {
        this.client.search(query).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return undefined;
};
$5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype._recommend = function() {
    var searchState = this.state;
    var recommendState = this.recommendState;
    var index = this.getIndex();
    var states = [
        {
            state: recommendState,
            index: index,
            helper: this
        }
    ];
    var ids = recommendState.params.map(function(param) {
        return param.$$id;
    });
    this.emit("fetch", {
        recommend: {
            state: recommendState,
            results: this.lastRecommendResults
        }
    });
    var cache = this._recommendCache;
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedIndex = derivedHelper.getModifiedState(searchState).index;
        if (!derivedIndex) return [];
        // Contrary to what is done when deriving the search state, we don't want to
        // provide the current recommend state to the derived helper, as it would
        // inherit unwanted queries. We instead provide an empty recommend state.
        var derivedState = derivedHelper.getModifiedRecommendState(new $e18128f64498c208$exports());
        states.push({
            state: derivedState,
            index: derivedIndex,
            helper: derivedHelper
        });
        ids = Array.prototype.concat.apply(ids, derivedState.params.map(function(param) {
            return param.$$id;
        }));
        derivedHelper.emit("fetch", {
            recommend: {
                state: derivedState,
                results: derivedHelper.lastRecommendResults
            }
        });
        return derivedState._buildQueries(derivedIndex, cache);
    });
    var queries = Array.prototype.concat.apply(this.recommendState._buildQueries(index, cache), derivedQueries);
    if (queries.length === 0) return;
    if (queries.length > 0 && typeof this.client.getRecommendations === "undefined") {
        // eslint-disable-next-line no-console
        console.warn("Please update algoliasearch/lite to the latest version in order to use recommend widgets.");
        return;
    }
    var queryId = this._recommendQueryId++;
    this._currentNbRecommendQueries++;
    try {
        this.client.getRecommendations(queries).then(this._dispatchRecommendResponse.bind(this, queryId, states, ids)).catch(this._dispatchRecommendError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // eslint-disable-next-line consistent-this
    var self = this;
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
    var results = content.results.slice();
    var rawContent = Object.keys(content).reduce(function(value, key) {
        if (key !== "results") value[key] = content[key];
        return value;
    }, {});
    if (Object.keys(rawContent).length <= 0) rawContent = undefined;
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit("result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $e21bfd2819a87d9e$exports(state, specificResults, self._searchResultsOptions);
        if (rawContent !== undefined) helper.lastResults._rawContent = rawContent;
        helper.emit("result", {
            results: helper.lastResults,
            state: state
        });
    });
};
$5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype._dispatchRecommendResponse = function(queryId, states, ids, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
    var cache = this._recommendCache;
    var idsMap = {};
    ids.filter(function(id) {
        return cache[id] === undefined;
    }).forEach(function(id, index) {
        if (!idsMap[id]) idsMap[id] = [];
        idsMap[id].push(index);
    });
    Object.keys(idsMap).forEach(function(id) {
        var indices = idsMap[id];
        var firstResult = content.results[indices[0]];
        if (indices.length === 1) {
            cache[id] = firstResult;
            return;
        }
        cache[id] = Object.assign({}, firstResult, {
            hits: $0ce959ddfc992e35$exports(indices.map(function(idx) {
                return content.results[idx].hits;
            }))
        });
    });
    var results = {};
    ids.forEach(function(id) {
        results[id] = cache[id];
    });
    states.forEach(function(s) {
        var state = s.state;
        var helper = s.helper;
        if (!s.index) {
            // eslint-disable-next-line no-warning-comments
            // TODO: emit "result" event when events for Recommend are implemented
            helper.emit("recommend:result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastRecommendResults = new $eb196a44d10ad5b6$exports(state, results);
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "result" event when events for Recommend are implemented
        helper.emit("recommend:result", {
            recommend: {
                results: helper.lastRecommendResults,
                state: state
            }
        });
    });
};
$5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
};
$5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype._dispatchRecommendError = function(queryId, error) {
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
};
$5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit("change", {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
$5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype._recommendChange = function(event) {
    var state = event.state;
    if (state !== this.recommendState) {
        this.recommendState = state;
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "change" event when events for Recommend are implemented
        this.emit("recommend:change", {
            search: {
                results: this.lastResults,
                state: this.state
            },
            recommend: {
                results: this.lastRecommendResults,
                state: this.recommendState
            }
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === "function") newClient.addAlgoliaAgent("JS Helper (" + $aVTSq + ")");
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @param {function} recommendFn RecommendParameters -> RecommendParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.derive = function(fn, recommendFn) {
    var derivedHelper = new $cb8145b447143402$exports(this, fn, recommendFn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error("Derived helper already detached");
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $5bde2a95cbd04999$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ $5bde2a95cbd04999$exports = $5bde2a95cbd04999$var$AlgoliaSearchHelper;






/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $74e7126a05d3520a$var$algoliasearchHelper(client, index, opts, searchResultsOptions) {
    return new $5bde2a95cbd04999$exports(client, index, opts, searchResultsOptions);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $74e7126a05d3520a$var$algoliasearchHelper.version = (parcelRequire("aVTSq"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $74e7126a05d3520a$var$algoliasearchHelper.AlgoliaSearchHelper = $5bde2a95cbd04999$exports;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $74e7126a05d3520a$var$algoliasearchHelper.SearchParameters = $e7fac303ca53f9e0$exports;
/**
 * Constructor for the object containing all the parameters for Recommend.
 * @member module:algoliasearchHelper.RecommendParameters
 * @type {RecommendParameters}
 */ $74e7126a05d3520a$var$algoliasearchHelper.RecommendParameters = $e18128f64498c208$exports;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $74e7126a05d3520a$var$algoliasearchHelper.SearchResults = $e21bfd2819a87d9e$exports;
/**
 * Constructor for the object containing the results for Recommend.
 * @member module:algoliasearchHelper.RecommendResults
 * @type {RecommendResults}
 */ $74e7126a05d3520a$var$algoliasearchHelper.RecommendResults = $eb196a44d10ad5b6$exports;
$74e7126a05d3520a$exports = $74e7126a05d3520a$var$algoliasearchHelper;



// We aren't using the native `Array.prototype.find` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `find` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.find` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
function $6233c69c2fe30ad7$export$71aa6c912b956294(items, predicate) {
    var value;
    for(var i = 0; i < items.length; i++){
        value = items[i];
        // inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
        if (predicate(value, i, items)) return value;
    }
    return undefined;
}

// typed as any, since it accepts the _real_ js clients, not the interface we otherwise expect
function $d91642b47df847fb$export$58f35ab8a1251bc0(searchClient) {
    if (searchClient.appId && searchClient.apiKey) // searchClient v5
    return [
        searchClient.appId,
        searchClient.apiKey
    ];
    else if (searchClient.transporter) {
        // searchClient v4 or v5
        var transporter = searchClient.transporter;
        var headers = transporter.headers || transporter.baseHeaders;
        var queryParameters = transporter.queryParameters || transporter.baseQueryParameters;
        var APP_ID = "x-algolia-application-id";
        var API_KEY = "x-algolia-api-key";
        var appId = headers[APP_ID] || queryParameters[APP_ID];
        var apiKey = headers[API_KEY] || queryParameters[API_KEY];
        return [
            appId,
            apiKey
        ];
    } else // searchClient v3
    return [
        searchClient.applicationID,
        searchClient.apiKey
    ];
}

function $846d3432ff405e8b$export$8793edee2d425525() {}


/**
 * Create UUID according to
 * https://www.ietf.org/rfc/rfc4122.txt.
 *
 * @returns Generated UUID.
 */ function $9e4c97cff1dedaa7$export$5dbf9a24b655dde4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        /* eslint-disable no-bitwise */ var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 0x3 | 0x8;
        /* eslint-enable */ return v.toString(16);
    });
}


function $d0531431952f7f4f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d0531431952f7f4f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d0531431952f7f4f$var$_typeof(o);
}
function $d0531431952f7f4f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d0531431952f7f4f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d0531431952f7f4f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d0531431952f7f4f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d0531431952f7f4f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d0531431952f7f4f$var$_defineProperty(obj, key, value) {
    key = $d0531431952f7f4f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d0531431952f7f4f$var$_toPropertyKey(t) {
    var i = $d0531431952f7f4f$var$_toPrimitive(t, "string");
    return "symbol" == $d0531431952f7f4f$var$_typeof(i) ? i : String(i);
}
function $d0531431952f7f4f$var$_toPrimitive(t, r) {
    if ("object" != $d0531431952f7f4f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d0531431952f7f4f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d0531431952f7f4f$var$_slicedToArray(arr, i) {
    return $d0531431952f7f4f$var$_arrayWithHoles(arr) || $d0531431952f7f4f$var$_iterableToArrayLimit(arr, i) || $d0531431952f7f4f$var$_unsupportedIterableToArray(arr, i) || $d0531431952f7f4f$var$_nonIterableRest();
}
function $d0531431952f7f4f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d0531431952f7f4f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d0531431952f7f4f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d0531431952f7f4f$var$_toConsumableArray(arr) {
    return $d0531431952f7f4f$var$_arrayWithoutHoles(arr) || $d0531431952f7f4f$var$_iterableToArray(arr) || $d0531431952f7f4f$var$_unsupportedIterableToArray(arr) || $d0531431952f7f4f$var$_nonIterableSpread();
}
function $d0531431952f7f4f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d0531431952f7f4f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d0531431952f7f4f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d0531431952f7f4f$var$_arrayLikeToArray(o, minLen);
}
function $d0531431952f7f4f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d0531431952f7f4f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d0531431952f7f4f$var$_arrayLikeToArray(arr);
}
function $d0531431952f7f4f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $d0531431952f7f4f$var$ALGOLIA_INSIGHTS_VERSION = "2.17.2";
var $d0531431952f7f4f$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($d0531431952f7f4f$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
function $d0531431952f7f4f$export$91e0bf09562e2c44() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _insightsClient = props.insightsClient, insightsInitParams = props.insightsInitParams, onEvent = props.onEvent, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal, _props$$$automatic = props.$$automatic, $$automatic = _props$$$automatic === void 0 ? false : _props$$$automatic;
    var potentialInsightsClient = _insightsClient;
    if (!_insightsClient && _insightsClient !== null) (0, $746e4e2d1e96d95f$export$39f19eed34acd2f1)(function(_ref) {
        var window = _ref.window;
        var pointer = window.AlgoliaAnalyticsObject || "aa";
        if (typeof pointer === "string") potentialInsightsClient = window[pointer];
        if (!potentialInsightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) {
                window[pointer] = function() {
                    if (!window[pointer].queue) window[pointer].queue = [];
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    window[pointer].queue.push(args);
                };
                window[pointer].version = $d0531431952f7f4f$var$ALGOLIA_INSIGHTS_VERSION;
                window[pointer].shouldAddScript = true;
            }
            potentialInsightsClient = window[pointer];
        }
    });
    // if still no insightsClient was found, we use a noop
    var insightsClient = potentialInsightsClient || (0, $846d3432ff405e8b$export$8793edee2d425525);
    return function(_ref2) {
        var instantSearchInstance = _ref2.instantSearchInstance;
        // remove existing default insights middleware
        // user-provided insights middleware takes precedence
        var existingInsightsMiddlewares = instantSearchInstance.middleware.filter(function(m) {
            return m.instance.$$type === "ais.insights" && m.instance.$$internal;
        }).map(function(m) {
            return m.creator;
        });
        instantSearchInstance.unuse.apply(instantSearchInstance, $d0531431952f7f4f$var$_toConsumableArray(existingInsightsMiddlewares));
        var _getAppIdAndApiKey = (0, $d91642b47df847fb$export$58f35ab8a1251bc0)(instantSearchInstance.client), _getAppIdAndApiKey2 = $d0531431952f7f4f$var$_slicedToArray(_getAppIdAndApiKey, 2), appId = _getAppIdAndApiKey2[0], apiKey = _getAppIdAndApiKey2[1];
        var queuedInitParams = undefined;
        var queuedUserToken = undefined;
        var userTokenBeforeInit = undefined;
        var queue = insightsClient.queue;
        if (Array.isArray(queue)) {
            // Context: The umd build of search-insights is asynchronously loaded by the snippet.
            //
            // When user calls `aa('setUserToken', 'my-user-token')` before `search-insights` is loaded,
            // ['setUserToken', 'my-user-token'] gets stored in `aa.queue`.
            // Whenever `search-insights` is finally loaded, it will process the queue.
            //
            // But here's the reason why we handle it here:
            // At this point, even though `search-insights` is not loaded yet,
            // we still want to read the token from the queue.
            // Otherwise, the first search call will be fired without the token.
            var _map = [
                "setUserToken",
                "init"
            ].map(function(key) {
                var _ref3 = (0, $6233c69c2fe30ad7$export$71aa6c912b956294)(queue.slice().reverse(), function(_ref5) {
                    var _ref6 = $d0531431952f7f4f$var$_slicedToArray(_ref5, 1), method = _ref6[0];
                    return method === key;
                }) || [], _ref4 = $d0531431952f7f4f$var$_slicedToArray(_ref3, 2), value = _ref4[1];
                return value;
            });
            var _map2 = $d0531431952f7f4f$var$_slicedToArray(_map, 2);
            queuedUserToken = _map2[0];
            queuedInitParams = _map2[1];
        }
        // If user called `aa('setUserToken')` before creating the Insights middleware,
        // we temporarily store the token and set it later on.
        //
        // Otherwise, the `init` call might override them with anonymous user token.
        insightsClient("getUserToken", null, function(_error, userToken) {
            userTokenBeforeInit = $d0531431952f7f4f$var$normalizeUserToken(userToken);
        });
        // Only `init` if the `insightsInitParams` option is passed or
        // if the `insightsClient` version doesn't supports optional `init` calling.
        if (insightsInitParams || !$d0531431952f7f4f$var$isModernInsightsClient(insightsClient)) insightsClient("init", $d0531431952f7f4f$var$_objectSpread({
            appId: appId,
            apiKey: apiKey,
            partial: true
        }, insightsInitParams));
        var initialParameters;
        var helper;
        return {
            $$type: "ais.insights",
            $$internal: $$internal,
            $$automatic: $$automatic,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                if (!insightsClient.shouldAddScript) return;
                var errorMessage = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
                try {
                    var script = document.createElement("script");
                    script.async = true;
                    script.src = $d0531431952f7f4f$var$ALGOLIA_INSIGHTS_SRC;
                    script.onerror = function() {
                        instantSearchInstance.emit("error", new Error(errorMessage));
                    };
                    document.body.appendChild(script);
                    insightsClient.shouldAddScript = false;
                } catch (cause) {
                    insightsClient.shouldAddScript = false;
                    instantSearchInstance.emit("error", new Error(errorMessage));
                }
            },
            started: function started() {
                insightsClient("addAlgoliaAgent", "insights-middleware");
                helper = instantSearchInstance.mainHelper;
                var queueAtStart = insightsClient.queue;
                if (Array.isArray(queueAtStart)) {
                    var _map3 = [
                        "setUserToken",
                        "init"
                    ].map(function(key) {
                        var _ref7 = (0, $6233c69c2fe30ad7$export$71aa6c912b956294)(queueAtStart.slice().reverse(), function(_ref9) {
                            var _ref10 = $d0531431952f7f4f$var$_slicedToArray(_ref9, 1), method = _ref10[0];
                            return method === key;
                        }) || [], _ref8 = $d0531431952f7f4f$var$_slicedToArray(_ref7, 2), value = _ref8[1];
                        return value;
                    });
                    var _map4 = $d0531431952f7f4f$var$_slicedToArray(_map3, 2);
                    queuedUserToken = _map4[0];
                    queuedInitParams = _map4[1];
                }
                initialParameters = $d0531431952f7f4f$var$getInitialParameters(instantSearchInstance);
                // We don't want to force clickAnalytics when the insights is enabled from the search response.
                // This means we don't enable insights for indices that don't opt in
                if (!$$automatic) helper.overrideStateWithoutTriggeringChangeEvent($d0531431952f7f4f$var$_objectSpread($d0531431952f7f4f$var$_objectSpread({}, helper.state), {}, {
                    clickAnalytics: true
                }));
                if (!$$internal) instantSearchInstance.scheduleSearch();
                var setUserTokenToSearch = function setUserTokenToSearch(userToken) {
                    var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var normalizedUserToken = $d0531431952f7f4f$var$normalizeUserToken(userToken);
                    if (!normalizedUserToken) return;
                    var existingToken = helper.state.userToken;
                    function applyToken() {
                        helper.overrideStateWithoutTriggeringChangeEvent($d0531431952f7f4f$var$_objectSpread($d0531431952f7f4f$var$_objectSpread({}, helper.state), {}, {
                            userToken: normalizedUserToken
                        }));
                        if (existingToken && existingToken !== userToken) instantSearchInstance.scheduleSearch();
                    }
                    // Delay the token application to the next render cycle
                    if (!immediate) setTimeout(applyToken, 0);
                    else applyToken();
                };
                function setUserToken(token) {
                    setUserTokenToSearch(token, true);
                    insightsClient("setUserToken", token);
                }
                var anonymousUserToken = undefined;
                var anonymousTokenFromInsights = (0, $62e320c3ff1379b2$export$61f1c6e9cd2ed687)();
                if (anonymousTokenFromInsights) // When `aa('init', { ... })` is called, it creates an anonymous user token in cookie.
                // We can set it as userToken on instantsearch and insights. If it's not set as an insights
                // userToken before a sendEvent, insights automatically generates a new anonymous token,
                // causing a state change and an unnecessary query on instantsearch.
                anonymousUserToken = anonymousTokenFromInsights;
                else {
                    var token = "anonymous-".concat((0, $9e4c97cff1dedaa7$export$5dbf9a24b655dde4)());
                    anonymousUserToken = token;
                }
                var userTokenFromInit;
                // With SSR, the token could be be set on the state. We make sure
                // that insights is in sync with that token since, there is no
                // insights lib on the server.
                var tokenFromSearchParameters = initialParameters.userToken;
                // When the first query is sent, the token is possibly not yet set by
                // the insights onChange callbacks (if insights isn't yet loaded).
                // It is explicitly being set here so that the first query has the
                // initial tokens set and ensure a second query isn't automatically
                // made when the onChange callback actually changes the state.
                if (insightsInitParams !== null && insightsInitParams !== void 0 && insightsInitParams.userToken) userTokenFromInit = insightsInitParams.userToken;
                if (userTokenFromInit) setUserToken(userTokenFromInit);
                else if (tokenFromSearchParameters) setUserToken(tokenFromSearchParameters);
                else if (userTokenBeforeInit) setUserToken(userTokenBeforeInit);
                else if (queuedUserToken) setUserToken(queuedUserToken);
                else if (anonymousUserToken) {
                    var _queuedInitParams;
                    setUserToken(anonymousUserToken);
                    if (insightsInitParams !== null && insightsInitParams !== void 0 && insightsInitParams.useCookie || (_queuedInitParams = queuedInitParams) !== null && _queuedInitParams !== void 0 && _queuedInitParams.useCookie) {
                        var _queuedInitParams2;
                        $d0531431952f7f4f$var$saveTokenAsCookie(anonymousUserToken, (insightsInitParams === null || insightsInitParams === void 0 ? void 0 : insightsInitParams.cookieDuration) || ((_queuedInitParams2 = queuedInitParams) === null || _queuedInitParams2 === void 0 ? void 0 : _queuedInitParams2.cookieDuration));
                    }
                }
                // This updates userToken which is set explicitly by `aa('setUserToken', userToken)`
                insightsClient("onUserTokenChange", function(token) {
                    return setUserTokenToSearch(token, true);
                }, {
                    immediate: true
                });
                var insightsClientWithLocalCredentials = insightsClient;
                if ($d0531431952f7f4f$var$isModernInsightsClient(insightsClient)) insightsClientWithLocalCredentials = function insightsClientWithLocalCredentials(method, payload) {
                    var extraParams = {
                        headers: {
                            "X-Algolia-Application-Id": appId,
                            "X-Algolia-API-Key": apiKey
                        }
                    };
                    // @ts-ignore we are calling this only when we know that the client actually is correct
                    return insightsClient(method, payload, extraParams);
                };
                var viewedObjectIDs = new Set();
                var lastQueryId;
                instantSearchInstance.mainHelper.derivedHelpers[0].on("result", function(_ref11) {
                    var results = _ref11.results;
                    if (results && (!results.queryID || results.queryID !== lastQueryId)) {
                        lastQueryId = results.queryID;
                        viewedObjectIDs.clear();
                    }
                });
                instantSearchInstance.sendEventToInsights = function(event) {
                    if (onEvent) onEvent(event, insightsClientWithLocalCredentials);
                    else if (event.insightsMethod) {
                        if (event.insightsMethod === "viewedObjectIDs") {
                            var _payload = event.payload;
                            var difference = _payload.objectIDs.filter(function(objectID) {
                                return !viewedObjectIDs.has(objectID);
                            });
                            if (difference.length === 0) return;
                            difference.forEach(function(objectID) {
                                return viewedObjectIDs.add(objectID);
                            });
                            _payload.objectIDs = difference;
                        }
                        // Source is used to differentiate events sent by instantsearch from those sent manually.
                        event.payload.algoliaSource = [
                            "instantsearch"
                        ];
                        if ($$automatic) event.payload.algoliaSource.push("instantsearch-automatic");
                        if (event.eventModifier === "internal") event.payload.algoliaSource.push("instantsearch-internal");
                        insightsClientWithLocalCredentials(event.insightsMethod, event.payload);
                    }
                };
            },
            unsubscribe: function unsubscribe() {
                insightsClient("onUserTokenChange", undefined);
                instantSearchInstance.sendEventToInsights = (0, $846d3432ff405e8b$export$8793edee2d425525);
                if (helper && initialParameters) {
                    helper.overrideStateWithoutTriggeringChangeEvent($d0531431952f7f4f$var$_objectSpread($d0531431952f7f4f$var$_objectSpread({}, helper.state), initialParameters));
                    instantSearchInstance.scheduleSearch();
                }
            }
        };
    };
}
function $d0531431952f7f4f$var$getInitialParameters(instantSearchInstance) {
    var _instantSearchInstanc, _instantSearchInstanc2;
    // in SSR, the initial state we use in this domain is set on the main index
    var stateFromInitialResults = ((_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : (_instantSearchInstanc2 = _instantSearchInstanc[instantSearchInstance.indexName]) === null || _instantSearchInstanc2 === void 0 ? void 0 : _instantSearchInstanc2.state) || {};
    var stateFromHelper = instantSearchInstance.mainHelper.state;
    return {
        userToken: stateFromInitialResults.userToken || stateFromHelper.userToken,
        clickAnalytics: stateFromInitialResults.clickAnalytics || stateFromHelper.clickAnalytics
    };
}
function $d0531431952f7f4f$var$saveTokenAsCookie(token, cookieDuration) {
    var MONTH = 2592000000;
    var d = new Date();
    d.setTime(d.getTime() + (cookieDuration || MONTH * 6));
    var expires = "expires=".concat(d.toUTCString());
    document.cookie = "_ALGOLIA=".concat(token, ";").concat(expires, ";path=/");
}
/**
 * Determines if a given insights `client` supports the optional call to `init`
 * and the ability to set credentials via extra parameters when sending events.
 */ function $d0531431952f7f4f$var$isModernInsightsClient(client) {
    var _split$map = (client.version || "").split(".").map(Number), _split$map2 = $d0531431952f7f4f$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/naming-convention */ var v3 = major >= 3;
    var v2_6 = major === 2 && minor >= 6;
    var v1_10 = major === 1 && minor >= 10;
    /* eslint-enable @typescript-eslint/naming-convention */ return v3 || v2_6 || v1_10;
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $d0531431952f7f4f$var$normalizeUserToken(userToken) {
    if (!userToken) return undefined;
    return typeof userToken === "number" ? userToken.toString() : userToken;
}


function $0aa2606e7b9711cf$export$dbf1227de6c1fbc6(instantSearchInstance, parent, uiState) {
    var helper = parent.getHelper();
    return {
        uiState: uiState,
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        state: helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        scopedResults: [],
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === "stalled"
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}
function $0aa2606e7b9711cf$export$c3ba97e79c76dd38(instantSearchInstance, parent, widget) {
    var results = parent.getResultsForWidget(widget);
    var helper = parent.getHelper();
    return {
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        results: results,
        scopedResults: parent.getScopedResults(),
        state: results && "_state" in results ? results._state : helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === "stalled"
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}


function $44d0263adf33480c$var$extractWidgetPayload(widgets, instantSearchInstance, payload) {
    var initOptions = (0, $0aa2606e7b9711cf$export$dbf1227de6c1fbc6)(instantSearchInstance, instantSearchInstance.mainIndex, instantSearchInstance._initialUiState);
    widgets.forEach(function(widget) {
        var widgetParams = {};
        if (widget.getWidgetRenderState) {
            var renderState = widget.getWidgetRenderState(initOptions);
            if (renderState && renderState.widgetParams) // casting, as we just earlier checked widgetParams exists, and thus an object
            widgetParams = renderState.widgetParams;
        }
        // since we destructure in all widgets, the parameters with defaults are set to "undefined"
        var params = Object.keys(widgetParams).filter(function(key) {
            return widgetParams[key] !== undefined;
        });
        payload.widgets.push({
            type: widget.$$type,
            widgetType: widget.$$widgetType,
            params: params
        });
        if (widget.$$type === "ais.index") $44d0263adf33480c$var$extractWidgetPayload(widget.getWidgets(), instantSearchInstance, payload);
    });
}
function $44d0263adf33480c$export$4b4254890acf93e7() {
    return (0, $746e4e2d1e96d95f$export$39f19eed34acd2f1)(function(_ref) {
        var _window$navigator, _window$navigator$use;
        var window = _ref.window;
        return ((_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$use = _window$navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.indexOf("Algolia Crawler")) > -1;
    }, {
        fallback: function fallback() {
            return false;
        }
    });
}
function $44d0263adf33480c$export$8ee9d2447935ed96() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$$$internal = _ref2.$$internal, $$internal = _ref2$$$internal === void 0 ? false : _ref2$$$internal;
    return function(_ref3) {
        var instantSearchInstance = _ref3.instantSearchInstance;
        var payload = {
            widgets: []
        };
        var payloadContainer = document.createElement("meta");
        var refNode = document.querySelector("head");
        payloadContainer.name = "instantsearch:widgets";
        return {
            $$type: "ais.metadata",
            $$internal: $$internal,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                // using setTimeout here to delay extraction until widgets have been added in a tick (e.g. Vue)
                setTimeout(function() {
                    var client = instantSearchInstance.client;
                    payload.ua = client.transporter && client.transporter.userAgent ? client.transporter.userAgent.value : client._ua;
                    $44d0263adf33480c$var$extractWidgetPayload(instantSearchInstance.mainIndex.getWidgets(), instantSearchInstance, payload);
                    instantSearchInstance.middleware.forEach(function(middleware) {
                        return payload.widgets.push({
                            middleware: true,
                            type: middleware.instance.$$type,
                            internal: middleware.instance.$$internal
                        });
                    });
                    payloadContainer.content = JSON.stringify(payload);
                    refNode.appendChild(payloadContainer);
                }, 0);
            },
            started: function started() {},
            unsubscribe: function unsubscribe() {
                payloadContainer.remove();
            }
        };
    };
}


var $63616b162b581232$exports = {};
"use strict";
var $27bcaa98db5678a8$exports = {};
"use strict";
var $632d7ada879e7621$exports = {};
"use strict";
var $d8ca2467da63da6f$exports = {};
"use strict";
var $d8ca2467da63da6f$var$replace = String.prototype.replace;
var $d8ca2467da63da6f$var$percentTwenties = /%20/g;
var $d8ca2467da63da6f$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$d8ca2467da63da6f$exports = {
    "default": $d8ca2467da63da6f$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d8ca2467da63da6f$var$replace.call(value, $d8ca2467da63da6f$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d8ca2467da63da6f$var$Format.RFC1738,
    RFC3986: $d8ca2467da63da6f$var$Format.RFC3986
};


var $632d7ada879e7621$var$has = Object.prototype.hasOwnProperty;
var $632d7ada879e7621$var$isArray = Array.isArray;
var $632d7ada879e7621$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $632d7ada879e7621$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($632d7ada879e7621$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $632d7ada879e7621$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $632d7ada879e7621$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($632d7ada879e7621$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$632d7ada879e7621$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($632d7ada879e7621$var$isArray(target) && !$632d7ada879e7621$var$isArray(source)) mergeTarget = $632d7ada879e7621$var$arrayToObject(target, options);
    if ($632d7ada879e7621$var$isArray(target) && $632d7ada879e7621$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($632d7ada879e7621$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($632d7ada879e7621$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $632d7ada879e7621$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $632d7ada879e7621$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $632d7ada879e7621$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $d8ca2467da63da6f$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $632d7ada879e7621$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($632d7ada879e7621$var$hexTable[0xC0 | c >> 6] + $632d7ada879e7621$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($632d7ada879e7621$var$hexTable[0xE0 | c >> 12] + $632d7ada879e7621$var$hexTable[0x80 | c >> 6 & 0x3F] + $632d7ada879e7621$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $632d7ada879e7621$var$hexTable[0xF0 | c >> 18] + $632d7ada879e7621$var$hexTable[0x80 | c >> 12 & 0x3F] + $632d7ada879e7621$var$hexTable[0x80 | c >> 6 & 0x3F] + $632d7ada879e7621$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $632d7ada879e7621$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $632d7ada879e7621$var$compactQueue(queue);
    return value;
};
var $632d7ada879e7621$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $632d7ada879e7621$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $632d7ada879e7621$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $632d7ada879e7621$var$maybeMap = function maybeMap(val, fn) {
    if ($632d7ada879e7621$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$632d7ada879e7621$exports = {
    arrayToObject: $632d7ada879e7621$var$arrayToObject,
    assign: $632d7ada879e7621$var$assign,
    combine: $632d7ada879e7621$var$combine,
    compact: $632d7ada879e7621$var$compact,
    decode: $632d7ada879e7621$var$decode,
    encode: $632d7ada879e7621$var$encode,
    isBuffer: $632d7ada879e7621$var$isBuffer,
    isRegExp: $632d7ada879e7621$var$isRegExp,
    maybeMap: $632d7ada879e7621$var$maybeMap,
    merge: $632d7ada879e7621$var$merge
};



var $27bcaa98db5678a8$var$has = Object.prototype.hasOwnProperty;
var $27bcaa98db5678a8$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $27bcaa98db5678a8$var$isArray = Array.isArray;
var $27bcaa98db5678a8$var$split = String.prototype.split;
var $27bcaa98db5678a8$var$push = Array.prototype.push;
var $27bcaa98db5678a8$var$pushToArray = function(arr, valueOrArray) {
    $27bcaa98db5678a8$var$push.apply(arr, $27bcaa98db5678a8$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $27bcaa98db5678a8$var$toISO = Date.prototype.toISOString;
var $27bcaa98db5678a8$var$defaultFormat = $d8ca2467da63da6f$exports.default;
var $27bcaa98db5678a8$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $632d7ada879e7621$exports.encode,
    encodeValuesOnly: false,
    format: $27bcaa98db5678a8$var$defaultFormat,
    formatter: $d8ca2467da63da6f$exports.formatters[$27bcaa98db5678a8$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $27bcaa98db5678a8$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $27bcaa98db5678a8$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $27bcaa98db5678a8$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset) {
    var obj = object;
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $27bcaa98db5678a8$var$isArray(obj)) obj = $632d7ada879e7621$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $27bcaa98db5678a8$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($27bcaa98db5678a8$var$isNonNullishPrimitive(obj) || $632d7ada879e7621$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $27bcaa98db5678a8$var$defaults.encoder, charset, "key", format);
            if (generateArrayPrefix === "comma" && encodeValuesOnly) {
                var valuesArray = $27bcaa98db5678a8$var$split.call(String(obj), ",");
                var valuesJoined = "";
                for(var i = 0; i < valuesArray.length; ++i)valuesJoined += (i === 0 ? "" : ",") + formatter(encoder(valuesArray[i], $27bcaa98db5678a8$var$defaults.encoder, charset, "value", format));
                return [
                    formatter(keyValue) + "=" + valuesJoined
                ];
            }
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $27bcaa98db5678a8$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $27bcaa98db5678a8$var$isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : void 0
        }
    ];
    else if ($27bcaa98db5678a8$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $27bcaa98db5678a8$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
        $27bcaa98db5678a8$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset));
    }
    return values;
};
var $27bcaa98db5678a8$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $27bcaa98db5678a8$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $27bcaa98db5678a8$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $d8ca2467da63da6f$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$27bcaa98db5678a8$var$has.call($d8ca2467da63da6f$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $d8ca2467da63da6f$exports.formatters[format];
    var filter = $27bcaa98db5678a8$var$defaults.filter;
    if (typeof opts.filter === "function" || $27bcaa98db5678a8$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $27bcaa98db5678a8$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $27bcaa98db5678a8$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $27bcaa98db5678a8$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $27bcaa98db5678a8$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $27bcaa98db5678a8$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $27bcaa98db5678a8$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $27bcaa98db5678a8$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $27bcaa98db5678a8$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $27bcaa98db5678a8$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $27bcaa98db5678a8$var$defaults.strictNullHandling
    };
};
$27bcaa98db5678a8$exports = function(object, opts) {
    var obj = object;
    var options = $27bcaa98db5678a8$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($27bcaa98db5678a8$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $27bcaa98db5678a8$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $27bcaa98db5678a8$var$arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $27bcaa98db5678a8$var$pushToArray(keys, $27bcaa98db5678a8$var$stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $9a181781940bbd7c$exports = {};
"use strict";

var $9a181781940bbd7c$var$has = Object.prototype.hasOwnProperty;
var $9a181781940bbd7c$var$isArray = Array.isArray;
var $9a181781940bbd7c$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $632d7ada879e7621$exports.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $9a181781940bbd7c$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $9a181781940bbd7c$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $9a181781940bbd7c$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $9a181781940bbd7c$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $9a181781940bbd7c$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $9a181781940bbd7c$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $9a181781940bbd7c$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $9a181781940bbd7c$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $9a181781940bbd7c$var$defaults.decoder, charset, "key");
            val = $632d7ada879e7621$exports.maybeMap($9a181781940bbd7c$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $9a181781940bbd7c$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $9a181781940bbd7c$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $9a181781940bbd7c$var$isArray(val) ? [
            val
        ] : val;
        if ($9a181781940bbd7c$var$has.call(obj, key)) obj[key] = $632d7ada879e7621$exports.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $9a181781940bbd7c$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $9a181781940bbd7c$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $9a181781940bbd7c$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $9a181781940bbd7c$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $9a181781940bbd7c$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $9a181781940bbd7c$var$parseObject(keys, val, options, valuesParsed);
};
var $9a181781940bbd7c$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $9a181781940bbd7c$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $9a181781940bbd7c$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $9a181781940bbd7c$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $9a181781940bbd7c$var$defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $9a181781940bbd7c$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $9a181781940bbd7c$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $9a181781940bbd7c$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $9a181781940bbd7c$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $632d7ada879e7621$exports.isRegExp(opts.delimiter) ? opts.delimiter : $9a181781940bbd7c$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $9a181781940bbd7c$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $9a181781940bbd7c$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $9a181781940bbd7c$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $9a181781940bbd7c$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $9a181781940bbd7c$var$defaults.strictNullHandling
    };
};
$9a181781940bbd7c$exports = function(str, opts) {
    var options = $9a181781940bbd7c$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $9a181781940bbd7c$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $9a181781940bbd7c$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $632d7ada879e7621$exports.merge(obj, newObj, options);
    }
    return $632d7ada879e7621$exports.compact(obj);
};



$63616b162b581232$exports = {
    formats: $d8ca2467da63da6f$exports,
    parse: $9a181781940bbd7c$exports,
    stringify: $27bcaa98db5678a8$exports
};



function $f1d49a31ef4240b0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f1d49a31ef4240b0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f1d49a31ef4240b0$var$_typeof(o);
}
function $f1d49a31ef4240b0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f1d49a31ef4240b0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f1d49a31ef4240b0$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f1d49a31ef4240b0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f1d49a31ef4240b0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f1d49a31ef4240b0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f1d49a31ef4240b0$var$_defineProperty(obj, key, value) {
    key = $f1d49a31ef4240b0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f1d49a31ef4240b0$var$_toPropertyKey(t) {
    var i = $f1d49a31ef4240b0$var$_toPrimitive(t, "string");
    return "symbol" == $f1d49a31ef4240b0$var$_typeof(i) ? i : String(i);
}
function $f1d49a31ef4240b0$var$_toPrimitive(t, r) {
    if ("object" != $f1d49a31ef4240b0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f1d49a31ef4240b0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f1d49a31ef4240b0$var$setWindowTitle = function setWindowTitle(title) {
    if (title) // This function is only executed on browsers so we can disable this check.
    // eslint-disable-next-line no-restricted-globals
    window.document.title = title;
};
var $f1d49a31ef4240b0$var$BrowserHistory = /*#__PURE__*/ function() {
    /**
   * Initializes a new storage provider that syncs the search state to the URL
   * using web APIs (`window.location.pushState` and `onpopstate` event).
   */ function BrowserHistory(_ref) {
        var _this = this;
        var windowTitle = _ref.windowTitle, _ref$writeDelay = _ref.writeDelay, writeDelay = _ref$writeDelay === void 0 ? 400 : _ref$writeDelay, createURL = _ref.createURL, parseURL = _ref.parseURL, getLocation = _ref.getLocation, start = _ref.start, dispose = _ref.dispose, push = _ref.push, cleanUrlOnDispose = _ref.cleanUrlOnDispose;
        $f1d49a31ef4240b0$var$_classCallCheck(this, BrowserHistory);
        $f1d49a31ef4240b0$var$_defineProperty(this, "$$type", "ais.browser");
        /**
     * Transforms a UI state into a title for the page.
     */ $f1d49a31ef4240b0$var$_defineProperty(this, "windowTitle", void 0);
        /**
     * Time in milliseconds before performing a write in the history.
     * It prevents from adding too many entries in the history and
     * makes the back button more usable.
     *
     * @default 400
     */ $f1d49a31ef4240b0$var$_defineProperty(this, "writeDelay", void 0);
        /**
     * Creates a full URL based on the route state.
     * The storage adaptor maps all syncable keys to the query string of the URL.
     */ $f1d49a31ef4240b0$var$_defineProperty(this, "_createURL", void 0);
        /**
     * Parses the URL into a route state.
     * It should be symmetrical to `createURL`.
     */ $f1d49a31ef4240b0$var$_defineProperty(this, "parseURL", void 0);
        /**
     * Returns the location to store in the history.
     * @default () => window.location
     */ $f1d49a31ef4240b0$var$_defineProperty(this, "getLocation", void 0);
        $f1d49a31ef4240b0$var$_defineProperty(this, "writeTimer", void 0);
        $f1d49a31ef4240b0$var$_defineProperty(this, "_onPopState", void 0);
        /**
     * Indicates if last action was back/forward in the browser.
     */ $f1d49a31ef4240b0$var$_defineProperty(this, "inPopState", false);
        /**
     * Indicates whether the history router is disposed or not.
     */ $f1d49a31ef4240b0$var$_defineProperty(this, "isDisposed", false);
        /**
     * Indicates the window.history.length before the last call to
     * window.history.pushState (called in `write`).
     * It allows to determine if a `pushState` has been triggered elsewhere,
     * and thus to prevent the `write` method from calling `pushState`.
     */ $f1d49a31ef4240b0$var$_defineProperty(this, "latestAcknowledgedHistory", 0);
        $f1d49a31ef4240b0$var$_defineProperty(this, "_start", void 0);
        $f1d49a31ef4240b0$var$_defineProperty(this, "_dispose", void 0);
        $f1d49a31ef4240b0$var$_defineProperty(this, "_push", void 0);
        $f1d49a31ef4240b0$var$_defineProperty(this, "_cleanUrlOnDispose", void 0);
        this.windowTitle = windowTitle;
        this.writeTimer = undefined;
        this.writeDelay = writeDelay;
        this._createURL = createURL;
        this.parseURL = parseURL;
        this.getLocation = getLocation;
        this._start = start;
        this._dispose = dispose;
        this._push = push;
        this._cleanUrlOnDispose = typeof cleanUrlOnDispose === "undefined" ? true : cleanUrlOnDispose;
        (0, $746e4e2d1e96d95f$export$39f19eed34acd2f1)(function(_ref2) {
            var window1 = _ref2.window;
            var title = _this.windowTitle && _this.windowTitle(_this.read());
            $f1d49a31ef4240b0$var$setWindowTitle(title);
            _this.latestAcknowledgedHistory = window1.history.length;
        });
    }
    /**
   * Reads the URL and returns a syncable UI search state.
   */ $f1d49a31ef4240b0$var$_createClass(BrowserHistory, [
        {
            key: "read",
            value: function read() {
                return this.parseURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($63616b162b581232$exports))),
                    location: this.getLocation()
                });
            }
        },
        {
            key: "write",
            value: function write(routeState) {
                var _this2 = this;
                (0, $746e4e2d1e96d95f$export$39f19eed34acd2f1)(function(_ref3) {
                    var window1 = _ref3.window;
                    var url = _this2.createURL(routeState);
                    var title = _this2.windowTitle && _this2.windowTitle(routeState);
                    if (_this2.writeTimer) clearTimeout(_this2.writeTimer);
                    _this2.writeTimer = setTimeout(function() {
                        $f1d49a31ef4240b0$var$setWindowTitle(title);
                        if (_this2.shouldWrite(url)) {
                            if (_this2._push) _this2._push(url);
                            else window1.history.pushState(routeState, title || "", url);
                            _this2.latestAcknowledgedHistory = window1.history.length;
                        }
                        _this2.inPopState = false;
                        _this2.writeTimer = undefined;
                    }, _this2.writeDelay);
                });
            }
        },
        {
            key: "onUpdate",
            value: function onUpdate(callback) {
                var _this3 = this;
                if (this._start) this._start(function() {
                    callback(_this3.read());
                });
                this._onPopState = function() {
                    if (_this3.writeTimer) {
                        clearTimeout(_this3.writeTimer);
                        _this3.writeTimer = undefined;
                    }
                    _this3.inPopState = true;
                    // We always read the state from the URL because the state of the history
                    // can be incorect in some cases (e.g. using React Router).
                    callback(_this3.read());
                };
                (0, $746e4e2d1e96d95f$export$39f19eed34acd2f1)(function(_ref4) {
                    var window1 = _ref4.window;
                    window1.addEventListener("popstate", _this3._onPopState);
                });
            }
        },
        {
            key: "createURL",
            value: function createURL(routeState) {
                var url = this._createURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($63616b162b581232$exports))),
                    routeState: routeState,
                    location: this.getLocation()
                });
                var e;
                return url;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this4 = this;
                if (this._dispose) this._dispose();
                this.isDisposed = true;
                (0, $746e4e2d1e96d95f$export$39f19eed34acd2f1)(function(_ref5) {
                    var window1 = _ref5.window;
                    if (_this4._onPopState) window1.removeEventListener("popstate", _this4._onPopState);
                });
                if (this.writeTimer) clearTimeout(this.writeTimer);
                if (this._cleanUrlOnDispose) this.write({});
            }
        },
        {
            key: "start",
            value: function start() {
                this.isDisposed = false;
            }
        },
        {
            key: "shouldWrite",
            value: function shouldWrite(url) {
                var _this5 = this;
                return (0, $746e4e2d1e96d95f$export$39f19eed34acd2f1)(function(_ref6) {
                    var window1 = _ref6.window;
                    // When disposed and the cleanUrlOnDispose is set to false, we do not want to write the URL.
                    if (_this5.isDisposed && !_this5._cleanUrlOnDispose) return false;
                    // We do want to `pushState` if:
                    // - the router is not disposed, IS.js needs to update the URL
                    // OR
                    // - the last write was from InstantSearch.js
                    // (unlike a SPA, where it would have last written)
                    var lastPushWasByISAfterDispose = !(_this5.isDisposed && _this5.latestAcknowledgedHistory !== window1.history.length);
                    return(// When the last state change was through popstate, the IS.js state changes,
                    // but that should not write the URL.
                    !_this5.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
                    lastPushWasByISAfterDispose && // When the URL is the same as the current one, we do not want to write it.
                    url !== window1.location.href);
                });
            }
        }
    ]);
    return BrowserHistory;
}();
function $f1d49a31ef4240b0$export$2e2bcd8739ae039() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$createURL = _ref7.createURL, createURL = _ref7$createURL === void 0 ? function(_ref8) {
        var qsModule = _ref8.qsModule, routeState = _ref8.routeState, location = _ref8.location;
        var protocol = location.protocol, hostname = location.hostname, _location$port = location.port, port = _location$port === void 0 ? "" : _location$port, pathname = location.pathname, hash = location.hash;
        var queryString = qsModule.stringify(routeState);
        var portWithPrefix = port === "" ? "" : ":".concat(port);
        // IE <= 11 has no proper `location.origin` so we cannot rely on it.
        if (!queryString) return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname).concat(hash);
        return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname, "?").concat(queryString).concat(hash);
    } : _ref7$createURL, _ref7$parseURL = _ref7.parseURL, parseURL = _ref7$parseURL === void 0 ? function(_ref9) {
        var qsModule = _ref9.qsModule, location = _ref9.location;
        // `qs` by default converts arrays with more than 20 items to an object.
        // We want to avoid this because the data structure manipulated can therefore vary.
        // Setting the limit to `100` seems a good number because the engine's default is 100
        // (it can go up to 1000 but it is very unlikely to select more than 100 items in the UI).
        //
        // Using an `arrayLimit` of `n` allows `n + 1` items.
        //
        // See:
        //   - https://github.com/ljharb/qs#parsing-arrays
        //   - https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/
        return qsModule.parse(location.search.slice(1), {
            arrayLimit: 99
        });
    } : _ref7$parseURL, _ref7$writeDelay = _ref7.writeDelay, writeDelay = _ref7$writeDelay === void 0 ? 400 : _ref7$writeDelay, windowTitle = _ref7.windowTitle, _ref7$getLocation = _ref7.getLocation, getLocation = _ref7$getLocation === void 0 ? function() {
        return (0, $746e4e2d1e96d95f$export$39f19eed34acd2f1)(function(_ref10) {
            var window1 = _ref10.window;
            return window1.location;
        }, {
            fallback: function fallback() {
                throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
            }
        });
    } : _ref7$getLocation, start = _ref7.start, dispose = _ref7.dispose, push = _ref7.push, cleanUrlOnDispose = _ref7.cleanUrlOnDispose;
    return new $f1d49a31ef4240b0$var$BrowserHistory({
        createURL: createURL,
        parseURL: parseURL,
        writeDelay: writeDelay,
        windowTitle: windowTitle,
        getLocation: getLocation,
        start: start,
        dispose: dispose,
        push: push,
        cleanUrlOnDispose: cleanUrlOnDispose
    });
}


function $e8abe01460e483f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e8abe01460e483f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e8abe01460e483f8$var$_typeof(o);
}
var $e8abe01460e483f8$var$_excluded = [
    "configure"
];
function $e8abe01460e483f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e8abe01460e483f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e8abe01460e483f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e8abe01460e483f8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e8abe01460e483f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e8abe01460e483f8$var$_defineProperty(obj, key, value) {
    key = $e8abe01460e483f8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e8abe01460e483f8$var$_toPropertyKey(t) {
    var i = $e8abe01460e483f8$var$_toPrimitive(t, "string");
    return "symbol" == $e8abe01460e483f8$var$_typeof(i) ? i : String(i);
}
function $e8abe01460e483f8$var$_toPrimitive(t, r) {
    if ("object" != $e8abe01460e483f8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e8abe01460e483f8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e8abe01460e483f8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e8abe01460e483f8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e8abe01460e483f8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e8abe01460e483f8$var$getIndexStateWithoutConfigure(uiState) {
    var configure = uiState.configure, trackedUiState = $e8abe01460e483f8$var$_objectWithoutProperties(uiState, $e8abe01460e483f8$var$_excluded);
    return trackedUiState;
}
function $e8abe01460e483f8$export$2e2bcd8739ae039() {
    return {
        $$type: "ais.simple",
        stateToRoute: function stateToRoute(uiState) {
            return Object.keys(uiState).reduce(function(state, indexId) {
                return $e8abe01460e483f8$var$_objectSpread($e8abe01460e483f8$var$_objectSpread({}, state), {}, $e8abe01460e483f8$var$_defineProperty({}, indexId, $e8abe01460e483f8$var$getIndexStateWithoutConfigure(uiState[indexId])));
            }, {});
        },
        routeToState: function routeToState() {
            var routeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return Object.keys(routeState).reduce(function(state, indexId) {
                return $e8abe01460e483f8$var$_objectSpread($e8abe01460e483f8$var$_objectSpread({}, state), {}, $e8abe01460e483f8$var$_defineProperty({}, indexId, $e8abe01460e483f8$var$getIndexStateWithoutConfigure(routeState[indexId])));
            }, {});
        }
    };
}



function $be4c23fbdfdd3f2f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $be4c23fbdfdd3f2f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $be4c23fbdfdd3f2f$var$_typeof(o);
}
function $be4c23fbdfdd3f2f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $be4c23fbdfdd3f2f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $be4c23fbdfdd3f2f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $be4c23fbdfdd3f2f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $be4c23fbdfdd3f2f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $be4c23fbdfdd3f2f$var$_defineProperty(obj, key, value) {
    key = $be4c23fbdfdd3f2f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $be4c23fbdfdd3f2f$var$_toPropertyKey(t) {
    var i = $be4c23fbdfdd3f2f$var$_toPrimitive(t, "string");
    return "symbol" == $be4c23fbdfdd3f2f$var$_typeof(i) ? i : String(i);
}
function $be4c23fbdfdd3f2f$var$_toPrimitive(t, r) {
    if ("object" != $be4c23fbdfdd3f2f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $be4c23fbdfdd3f2f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $be4c23fbdfdd3f2f$export$1fe5128387816284 = function createRouterMiddleware() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$router = props.router, router = _props$router === void 0 ? (0, $f1d49a31ef4240b0$export$2e2bcd8739ae039)() : _props$router, _props$stateMapping = props.stateMapping, stateMapping = _props$stateMapping === void 0 ? (0, $e8abe01460e483f8$export$2e2bcd8739ae039)() : _props$stateMapping, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal;
    return function(_ref) {
        var instantSearchInstance = _ref.instantSearchInstance;
        function topLevelCreateURL(nextState) {
            var previousUiState = // If only the mainIndex is initialized, we don't yet know what other
            // index widgets are used. Therefore we fall back to the initialUiState.
            // We can't indiscriminately use the initialUiState because then we
            // reintroduce state that was changed by the user.
            // When there are no widgets, we are sure the user can't yet have made
            // any changes.
            instantSearchInstance.mainIndex.getWidgets().length === 0 ? instantSearchInstance._initialUiState : instantSearchInstance.mainIndex.getWidgetUiState({});
            var uiState = Object.keys(nextState).reduce(function(acc, indexId) {
                return $be4c23fbdfdd3f2f$var$_objectSpread($be4c23fbdfdd3f2f$var$_objectSpread({}, acc), {}, $be4c23fbdfdd3f2f$var$_defineProperty({}, indexId, nextState[indexId]));
            }, previousUiState);
            var route = stateMapping.stateToRoute(uiState);
            return router.createURL(route);
        }
        // casting to UiState here to keep createURL unaware of custom UiState
        // (as long as it's an object, it's ok)
        instantSearchInstance._createURL = topLevelCreateURL;
        var lastRouteState = undefined;
        var initialUiState = instantSearchInstance._initialUiState;
        return {
            $$type: "ais.router({router:".concat(router.$$type || "__unknown__", ", stateMapping:").concat(stateMapping.$$type || "__unknown__", "})"),
            $$internal: $$internal,
            onStateChange: function onStateChange(_ref2) {
                var uiState = _ref2.uiState;
                var routeState = stateMapping.stateToRoute(uiState);
                if (lastRouteState === undefined || !(0, $522688c948998c6d$export$248d38f6296296c5)(lastRouteState, routeState)) {
                    router.write(routeState);
                    lastRouteState = routeState;
                }
            },
            subscribe: function subscribe() {
                instantSearchInstance._initialUiState = $be4c23fbdfdd3f2f$var$_objectSpread($be4c23fbdfdd3f2f$var$_objectSpread({}, initialUiState), stateMapping.routeToState(router.read()));
                router.onUpdate(function(route) {
                    if (instantSearchInstance.mainIndex.getWidgets().length > 0) instantSearchInstance.setUiState(stateMapping.routeToState(route));
                });
            },
            started: function started() {
                var _router$start;
                (_router$start = router.start) === null || _router$start === void 0 || _router$start.call(router);
            },
            unsubscribe: function unsubscribe() {
                router.dispose();
            }
        };
    };
};



function $c5ac68b3400622d0$export$110679b26359d23d(_ref) {
    var name = _ref.name, _ref$connector = _ref.connector, connector = _ref$connector === void 0 ? false : _ref$connector;
    return [
        "https://www.algolia.com/doc/api-reference/widgets/",
        name,
        "/js/",
        connector ? "#connector" : ""
    ].join("");
}
function $c5ac68b3400622d0$export$2fde5bffc340821e() {
    for(var _len = arguments.length, widgets = new Array(_len), _key = 0; _key < _len; _key++)widgets[_key] = arguments[_key];
    var links = widgets.map(function(widget) {
        return $c5ac68b3400622d0$export$110679b26359d23d(widget);
    }).join(", ");
    return function(message) {
        return [
            message,
            "See documentation: ".concat(links)
        ].filter(Boolean).join("\n\n");
    };
}

function $aa2e53e8f7f529f4$export$a9c9a0d43506297d(widget) {
    return widget.$$type === "ais.index";
}

// We aren't using the native `Array.prototype.findIndex` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `findIndex` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.findIndex` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
function $a570db022c3992f3$export$de3a4d4a0d731119(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
}


function $57b7a6525254cbcf$export$f70730c3d1fc524e(array) {
    return array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
}


function $24da987d0ad66cbb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $24da987d0ad66cbb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $24da987d0ad66cbb$var$_typeof(o);
}
var $24da987d0ad66cbb$var$_excluded = [
    "facets",
    "disjunctiveFacets",
    "facetsRefinements",
    "facetsExcludes",
    "disjunctiveFacetsRefinements",
    "numericRefinements",
    "tagRefinements",
    "hierarchicalFacets",
    "hierarchicalFacetsRefinements",
    "ruleContexts"
];
function $24da987d0ad66cbb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $24da987d0ad66cbb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $24da987d0ad66cbb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $24da987d0ad66cbb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $24da987d0ad66cbb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $24da987d0ad66cbb$var$_defineProperty(obj, key, value) {
    key = $24da987d0ad66cbb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $24da987d0ad66cbb$var$_toPropertyKey(t) {
    var i = $24da987d0ad66cbb$var$_toPrimitive(t, "string");
    return "symbol" == $24da987d0ad66cbb$var$_typeof(i) ? i : String(i);
}
function $24da987d0ad66cbb$var$_toPrimitive(t, r) {
    if ("object" != $24da987d0ad66cbb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $24da987d0ad66cbb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $24da987d0ad66cbb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $24da987d0ad66cbb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $24da987d0ad66cbb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $24da987d0ad66cbb$var$mergeWithRest = function mergeWithRest(left, right) {
    var facets = right.facets, disjunctiveFacets = right.disjunctiveFacets, facetsRefinements = right.facetsRefinements, facetsExcludes = right.facetsExcludes, disjunctiveFacetsRefinements = right.disjunctiveFacetsRefinements, numericRefinements = right.numericRefinements, tagRefinements = right.tagRefinements, hierarchicalFacets = right.hierarchicalFacets, hierarchicalFacetsRefinements = right.hierarchicalFacetsRefinements, ruleContexts = right.ruleContexts, rest = $24da987d0ad66cbb$var$_objectWithoutProperties(right, $24da987d0ad66cbb$var$_excluded);
    return left.setQueryParameters(rest);
};
// Merge facets
var $24da987d0ad66cbb$var$mergeFacets = function mergeFacets(left, right) {
    return right.facets.reduce(function(_, name) {
        return _.addFacet(name);
    }, left);
};
var $24da987d0ad66cbb$var$mergeDisjunctiveFacets = function mergeDisjunctiveFacets(left, right) {
    return right.disjunctiveFacets.reduce(function(_, name) {
        return _.addDisjunctiveFacet(name);
    }, left);
};
var $24da987d0ad66cbb$var$mergeHierarchicalFacets = function mergeHierarchicalFacets(left, right) {
    return left.setQueryParameters({
        hierarchicalFacets: right.hierarchicalFacets.reduce(function(facets, facet) {
            var index = (0, $a570db022c3992f3$export$de3a4d4a0d731119)(facets, function(_) {
                return _.name === facet.name;
            });
            if (index === -1) return facets.concat(facet);
            var nextFacets = facets.slice();
            nextFacets.splice(index, 1, facet);
            return nextFacets;
        }, left.hierarchicalFacets)
    });
};
// Merge facet refinements
var $24da987d0ad66cbb$var$mergeTagRefinements = function mergeTagRefinements(left, right) {
    return right.tagRefinements.reduce(function(_, value) {
        return _.addTagRefinement(value);
    }, left);
};
var $24da987d0ad66cbb$var$mergeFacetRefinements = function mergeFacetRefinements(left, right) {
    return left.setQueryParameters({
        facetsRefinements: $24da987d0ad66cbb$var$_objectSpread($24da987d0ad66cbb$var$_objectSpread({}, left.facetsRefinements), right.facetsRefinements)
    });
};
var $24da987d0ad66cbb$var$mergeFacetsExcludes = function mergeFacetsExcludes(left, right) {
    return left.setQueryParameters({
        facetsExcludes: $24da987d0ad66cbb$var$_objectSpread($24da987d0ad66cbb$var$_objectSpread({}, left.facetsExcludes), right.facetsExcludes)
    });
};
var $24da987d0ad66cbb$var$mergeDisjunctiveFacetsRefinements = function mergeDisjunctiveFacetsRefinements(left, right) {
    return left.setQueryParameters({
        disjunctiveFacetsRefinements: $24da987d0ad66cbb$var$_objectSpread($24da987d0ad66cbb$var$_objectSpread({}, left.disjunctiveFacetsRefinements), right.disjunctiveFacetsRefinements)
    });
};
var $24da987d0ad66cbb$var$mergeNumericRefinements = function mergeNumericRefinements(left, right) {
    return left.setQueryParameters({
        numericRefinements: $24da987d0ad66cbb$var$_objectSpread($24da987d0ad66cbb$var$_objectSpread({}, left.numericRefinements), right.numericRefinements)
    });
};
var $24da987d0ad66cbb$var$mergeHierarchicalFacetsRefinements = function mergeHierarchicalFacetsRefinements(left, right) {
    return left.setQueryParameters({
        hierarchicalFacetsRefinements: $24da987d0ad66cbb$var$_objectSpread($24da987d0ad66cbb$var$_objectSpread({}, left.hierarchicalFacetsRefinements), right.hierarchicalFacetsRefinements)
    });
};
var $24da987d0ad66cbb$var$mergeRuleContexts = function mergeRuleContexts(left, right) {
    var ruleContexts = (0, $57b7a6525254cbcf$export$f70730c3d1fc524e)([].concat(left.ruleContexts).concat(right.ruleContexts).filter(Boolean));
    if (ruleContexts.length > 0) return left.setQueryParameters({
        ruleContexts: ruleContexts
    });
    return left;
};
var $24da987d0ad66cbb$export$8049d91f25899769 = function mergeSearchParameters() {
    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++)parameters[_key] = arguments[_key];
    return parameters.reduce(function(left, right) {
        var hierarchicalFacetsRefinementsMerged = $24da987d0ad66cbb$var$mergeHierarchicalFacetsRefinements(left, right);
        var hierarchicalFacetsMerged = $24da987d0ad66cbb$var$mergeHierarchicalFacets(hierarchicalFacetsRefinementsMerged, right);
        var tagRefinementsMerged = $24da987d0ad66cbb$var$mergeTagRefinements(hierarchicalFacetsMerged, right);
        var numericRefinementsMerged = $24da987d0ad66cbb$var$mergeNumericRefinements(tagRefinementsMerged, right);
        var disjunctiveFacetsRefinementsMerged = $24da987d0ad66cbb$var$mergeDisjunctiveFacetsRefinements(numericRefinementsMerged, right);
        var facetsExcludesMerged = $24da987d0ad66cbb$var$mergeFacetsExcludes(disjunctiveFacetsRefinementsMerged, right);
        var facetRefinementsMerged = $24da987d0ad66cbb$var$mergeFacetRefinements(facetsExcludesMerged, right);
        var disjunctiveFacetsMerged = $24da987d0ad66cbb$var$mergeDisjunctiveFacets(facetRefinementsMerged, right);
        var ruleContextsMerged = $24da987d0ad66cbb$var$mergeRuleContexts(disjunctiveFacetsMerged, right);
        var facetsMerged = $24da987d0ad66cbb$var$mergeFacets(ruleContextsMerged, right);
        return $24da987d0ad66cbb$var$mergeWithRest(facetsMerged, right);
    });
};

function $48c9905b4086c284$export$1c33c9881dac6797(current) {
    var parent = current.getParent();
    var states = [
        current.getHelper().state
    ];
    while(parent !== null){
        states = [
            parent.getHelper().state
        ].concat(states);
        parent = parent.getParent();
    }
    return states;
}


var $4e377dc12d81017f$var$id = 0;
function $4e377dc12d81017f$export$50b3ac0e47148c0b(widget) {
    if (widget.dependsOn !== "recommend") return;
    widget.$$id = $4e377dc12d81017f$var$id++;
}
function $4e377dc12d81017f$export$13e2e3d76152aecf() {
    $4e377dc12d81017f$var$id = 0;
}


function $2f6f2e7746e4cc22$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2f6f2e7746e4cc22$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2f6f2e7746e4cc22$var$_typeof(o);
}
var $2f6f2e7746e4cc22$var$_excluded = [
    "initialSearchParameters"
], $2f6f2e7746e4cc22$var$_excluded2 = [
    "initialRecommendParameters"
];
function $2f6f2e7746e4cc22$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2f6f2e7746e4cc22$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2f6f2e7746e4cc22$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2f6f2e7746e4cc22$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2f6f2e7746e4cc22$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2f6f2e7746e4cc22$var$_defineProperty(obj, key, value) {
    key = $2f6f2e7746e4cc22$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2f6f2e7746e4cc22$var$_toPropertyKey(t) {
    var i = $2f6f2e7746e4cc22$var$_toPrimitive(t, "string");
    return "symbol" == $2f6f2e7746e4cc22$var$_typeof(i) ? i : String(i);
}
function $2f6f2e7746e4cc22$var$_toPrimitive(t, r) {
    if ("object" != $2f6f2e7746e4cc22$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2f6f2e7746e4cc22$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2f6f2e7746e4cc22$var$_toConsumableArray(arr) {
    return $2f6f2e7746e4cc22$var$_arrayWithoutHoles(arr) || $2f6f2e7746e4cc22$var$_iterableToArray(arr) || $2f6f2e7746e4cc22$var$_unsupportedIterableToArray(arr) || $2f6f2e7746e4cc22$var$_nonIterableSpread();
}
function $2f6f2e7746e4cc22$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2f6f2e7746e4cc22$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2f6f2e7746e4cc22$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2f6f2e7746e4cc22$var$_arrayLikeToArray(o, minLen);
}
function $2f6f2e7746e4cc22$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $2f6f2e7746e4cc22$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2f6f2e7746e4cc22$var$_arrayLikeToArray(arr);
}
function $2f6f2e7746e4cc22$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2f6f2e7746e4cc22$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2f6f2e7746e4cc22$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2f6f2e7746e4cc22$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2f6f2e7746e4cc22$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "index-widget"
});
/**
 * This is the same content as helper._change / setState, but allowing for extra
 * UiState to be synchronized.
 * see: https://github.com/algolia/algoliasearch-helper-js/blob/6b835ffd07742f2d6b314022cce6848f5cfecd4a/src/algoliasearch.helper.js#L1311-L1324
 */ function $2f6f2e7746e4cc22$var$privateHelperSetState(helper, _ref) {
    var state = _ref.state, recommendState = _ref.recommendState, isPageReset = _ref.isPageReset, _uiState = _ref._uiState;
    if (state !== helper.state) {
        helper.state = state;
        helper.emit("change", {
            state: helper.state,
            results: helper.lastResults,
            isPageReset: isPageReset,
            _uiState: _uiState
        });
    }
    if (recommendState !== helper.recommendState) helper.recommendState = recommendState;
}
function $2f6f2e7746e4cc22$var$getLocalWidgetsUiState(widgets, widgetStateOptions) {
    var initialUiState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return widgets.reduce(function(uiState, widget) {
        if ((0, $aa2e53e8f7f529f4$export$a9c9a0d43506297d)(widget)) return uiState;
        if (!widget.getWidgetUiState && !widget.getWidgetState) return uiState;
        if (widget.getWidgetUiState) return widget.getWidgetUiState(uiState, widgetStateOptions);
        return widget.getWidgetState(uiState, widgetStateOptions);
    }, initialUiState);
}
function $2f6f2e7746e4cc22$var$getLocalWidgetsSearchParameters(widgets, widgetSearchParametersOptions) {
    var initialSearchParameters = widgetSearchParametersOptions.initialSearchParameters, rest = $2f6f2e7746e4cc22$var$_objectWithoutProperties(widgetSearchParametersOptions, $2f6f2e7746e4cc22$var$_excluded);
    return widgets.reduce(function(state, widget) {
        if (!widget.getWidgetSearchParameters || (0, $aa2e53e8f7f529f4$export$a9c9a0d43506297d)(widget)) return state;
        if (widget.dependsOn === "search" && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return widget.getWidgetSearchParameters(state, rest);
    }, initialSearchParameters);
}
function $2f6f2e7746e4cc22$var$getLocalWidgetsRecommendParameters(widgets, widgetRecommendParametersOptions) {
    var initialRecommendParameters = widgetRecommendParametersOptions.initialRecommendParameters, rest = $2f6f2e7746e4cc22$var$_objectWithoutProperties(widgetRecommendParametersOptions, $2f6f2e7746e4cc22$var$_excluded2);
    return widgets.reduce(function(state, widget) {
        if (!(0, $aa2e53e8f7f529f4$export$a9c9a0d43506297d)(widget) && widget.dependsOn === "recommend" && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return state;
    }, initialRecommendParameters);
}
function $2f6f2e7746e4cc22$var$resetPageFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $aa2e53e8f7f529f4$export$a9c9a0d43506297d));
    if (indexWidgets.length === 0) return;
    indexWidgets.forEach(function(widget) {
        var widgetHelper = widget.getHelper();
        $2f6f2e7746e4cc22$var$privateHelperSetState(widgetHelper, {
            state: widgetHelper.state.resetPage(),
            recommendState: widgetHelper.recommendState,
            isPageReset: true
        });
        $2f6f2e7746e4cc22$var$resetPageFromWidgets(widget.getWidgets());
    });
}
function $2f6f2e7746e4cc22$var$resolveScopedResultsFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $aa2e53e8f7f529f4$export$a9c9a0d43506297d));
    return indexWidgets.reduce(function(scopedResults, current) {
        return scopedResults.concat.apply(scopedResults, [
            {
                indexId: current.getIndexId(),
                results: current.getResults(),
                helper: current.getHelper()
            }
        ].concat($2f6f2e7746e4cc22$var$_toConsumableArray($2f6f2e7746e4cc22$var$resolveScopedResultsFromWidgets(current.getWidgets()))));
    }, []);
}
var $2f6f2e7746e4cc22$var$index = function index(widgetParams) {
    if (widgetParams === undefined || widgetParams.indexName === undefined) throw new Error($2f6f2e7746e4cc22$var$withUsage("The `indexName` option is required."));
    var indexName = widgetParams.indexName, _widgetParams$indexId = widgetParams.indexId, indexId = _widgetParams$indexId === void 0 ? indexName : _widgetParams$indexId;
    var localWidgets = [];
    var localUiState = {};
    var localInstantSearchInstance = null;
    var localParent = null;
    var helper = null;
    var derivedHelper = null;
    var lastValidSearchParameters = null;
    var hasRecommendWidget = false;
    var hasSearchWidget = false;
    return {
        $$type: "ais.index",
        $$widgetType: "ais.index",
        getIndexName: function getIndexName() {
            return indexName;
        },
        getIndexId: function getIndexId() {
            return indexId;
        },
        getHelper: function getHelper() {
            return helper;
        },
        getResults: function getResults() {
            var _derivedHelper;
            if (!((_derivedHelper = derivedHelper) !== null && _derivedHelper !== void 0 && _derivedHelper.lastResults)) return null;
            // To make the UI optimistic, we patch the state to display to the current
            // one instead of the one associated with the latest results.
            // This means user-driven UI changes (e.g., checked checkbox) are reflected
            // immediately instead of waiting for Algolia to respond, regardless of
            // the status of the network request.
            derivedHelper.lastResults._state = helper.state;
            return derivedHelper.lastResults;
        },
        getResultsForWidget: function getResultsForWidget(widget) {
            var _helper;
            if (widget.dependsOn !== "recommend" || (0, $aa2e53e8f7f529f4$export$a9c9a0d43506297d)(widget) || widget.$$id === undefined) return this.getResults();
            if (!((_helper = helper) !== null && _helper !== void 0 && _helper.lastRecommendResults)) return null;
            return helper.lastRecommendResults[widget.$$id];
        },
        getPreviousState: function getPreviousState() {
            return lastValidSearchParameters;
        },
        getScopedResults: function getScopedResults() {
            var widgetParent = this.getParent();
            var widgetSiblings;
            if (widgetParent) widgetSiblings = widgetParent.getWidgets();
            else if (indexName.length === 0) // The widget is the root but has no index name:
            // we resolve results from its children index widgets
            widgetSiblings = this.getWidgets();
            else // The widget is the root and has an index name:
            // we consider itself as the only sibling
            widgetSiblings = [
                this
            ];
            return $2f6f2e7746e4cc22$var$resolveScopedResultsFromWidgets(widgetSiblings);
        },
        getParent: function getParent() {
            return localParent;
        },
        createURL: function createURL(nextState) {
            if (typeof nextState === "function") return localInstantSearchInstance._createURL($2f6f2e7746e4cc22$var$_defineProperty({}, indexId, nextState(localUiState)));
            return localInstantSearchInstance._createURL($2f6f2e7746e4cc22$var$_defineProperty({}, indexId, $2f6f2e7746e4cc22$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: nextState,
                helper: helper
            })));
        },
        getWidgets: function getWidgets() {
            return localWidgets;
        },
        addWidgets: function addWidgets(widgets) {
            var _this = this;
            if (!Array.isArray(widgets)) throw new Error($2f6f2e7746e4cc22$var$withUsage("The `addWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.init !== "function" && typeof widget.render !== "function";
            })) throw new Error($2f6f2e7746e4cc22$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
            widgets.forEach(function(widget) {
                if ((0, $aa2e53e8f7f529f4$export$a9c9a0d43506297d)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === "recommend") localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === "recommend") hasRecommendWidget = true;
                else hasSearchWidget = true;
                (0, $4e377dc12d81017f$export$50b3ac0e47148c0b)(widget);
            });
            localWidgets = localWidgets.concat(widgets);
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                $2f6f2e7746e4cc22$var$privateHelperSetState(helper, {
                    state: $2f6f2e7746e4cc22$var$getLocalWidgetsSearchParameters(localWidgets, {
                        uiState: localUiState,
                        initialSearchParameters: helper.state
                    }),
                    recommendState: $2f6f2e7746e4cc22$var$getLocalWidgetsRecommendParameters(localWidgets, {
                        uiState: localUiState,
                        initialRecommendParameters: helper.recommendState
                    }),
                    _uiState: localUiState
                });
                // We compute the render state before calling `init` in a separate loop
                // to construct the whole render state object that is then passed to
                // `init`.
                widgets.forEach(function(widget) {
                    if (widget.getRenderState) {
                        var renderState = widget.getRenderState(localInstantSearchInstance.renderState[_this.getIndexId()] || {}, (0, $0aa2606e7b9711cf$export$dbf1227de6c1fbc6)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                        $2f6f2e7746e4cc22$var$storeRenderState({
                            renderState: renderState,
                            instantSearchInstance: localInstantSearchInstance,
                            parent: _this
                        });
                    }
                });
                widgets.forEach(function(widget) {
                    if (widget.init) widget.init((0, $0aa2606e7b9711cf$export$dbf1227de6c1fbc6)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                });
                localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        removeWidgets: function removeWidgets(widgets) {
            var _this2 = this;
            if (!Array.isArray(widgets)) throw new Error($2f6f2e7746e4cc22$var$withUsage("The `removeWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.dispose !== "function";
            })) throw new Error($2f6f2e7746e4cc22$var$withUsage("The widget definition expects a `dispose` method."));
            localWidgets = localWidgets.filter(function(widget) {
                return widgets.indexOf(widget) === -1;
            });
            localWidgets.forEach(function(widget) {
                if ((0, $aa2e53e8f7f529f4$export$a9c9a0d43506297d)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === "recommend") localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === "recommend") hasRecommendWidget = true;
                else hasSearchWidget = true;
            });
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                var _widgets$reduce = widgets.reduce(function(states, widget) {
                    // the `dispose` method exists at this point we already assert it
                    var next = widget.dispose({
                        helper: helper,
                        state: states.cleanedSearchState,
                        recommendState: states.cleanedRecommendState,
                        parent: _this2
                    });
                    if (next instanceof (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports))).RecommendParameters) states.cleanedRecommendState = next;
                    else if (next) states.cleanedSearchState = next;
                    return states;
                }, {
                    cleanedSearchState: helper.state,
                    cleanedRecommendState: helper.recommendState
                }), cleanedSearchState = _widgets$reduce.cleanedSearchState, cleanedRecommendState = _widgets$reduce.cleanedRecommendState;
                var newState = localInstantSearchInstance.future.preserveSharedStateOnUnmount ? $2f6f2e7746e4cc22$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: localUiState,
                    initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports))).SearchParameters({
                        index: this.getIndexName()
                    })
                }) : $2f6f2e7746e4cc22$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: $2f6f2e7746e4cc22$var$getLocalWidgetsUiState(localWidgets, {
                        searchParameters: cleanedSearchState,
                        helper: helper
                    }),
                    initialSearchParameters: cleanedSearchState
                });
                localUiState = $2f6f2e7746e4cc22$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: newState,
                    helper: helper
                });
                helper.setState(newState);
                helper.recommendState = cleanedRecommendState;
                if (localWidgets.length) localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        init: function init(_ref2) {
            var _this3 = this, _instantSearchInstanc;
            var instantSearchInstance = _ref2.instantSearchInstance, parent = _ref2.parent, uiState = _ref2.uiState;
            if (helper !== null) // helper is already initialized, therefore we do not need to set up
            // any listeners
            return;
            localInstantSearchInstance = instantSearchInstance;
            localParent = parent;
            localUiState = uiState[indexId] || {};
            // The `mainHelper` is already defined at this point. The instance is created
            // inside InstantSearch at the `start` method, which occurs before the `init`
            // step.
            var mainHelper = instantSearchInstance.mainHelper;
            var parameters = $2f6f2e7746e4cc22$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: localUiState,
                initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports))).SearchParameters({
                    index: indexName
                })
            });
            var recommendParameters = $2f6f2e7746e4cc22$var$getLocalWidgetsRecommendParameters(localWidgets, {
                uiState: localUiState,
                initialRecommendParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports))).RecommendParameters()
            });
            // This Helper is only used for state management we do not care about the
            // `searchClient`. Only the "main" Helper created at the `InstantSearch`
            // level is aware of the client.
            helper = (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports)))({}, parameters.index, parameters);
            helper.recommendState = recommendParameters;
            // We forward the call to `search` to the "main" instance of the Helper
            // which is responsible for managing the queries (it's the only one that is
            // aware of the `searchClient`).
            helper.search = function() {
                if (instantSearchInstance.onStateChange) {
                    instantSearchInstance.onStateChange({
                        uiState: instantSearchInstance.mainIndex.getWidgetUiState({}),
                        setUiState: function setUiState(nextState) {
                            return instantSearchInstance.setUiState(nextState, false);
                        }
                    });
                    // We don't trigger a search when controlled because it becomes the
                    // responsibility of `setUiState`.
                    return mainHelper;
                }
                return mainHelper.search();
            };
            helper.searchWithoutTriggeringOnStateChange = function() {
                return mainHelper.search();
            };
            // We use the same pattern for the `searchForFacetValues`.
            helper.searchForFacetValues = function(facetName, facetValue, maxFacetHits, userState) {
                var state = helper.state.setQueryParameters(userState);
                return mainHelper.searchForFacetValues(facetName, facetValue, maxFacetHits, state);
            };
            derivedHelper = mainHelper.derive(function() {
                return (0, $24da987d0ad66cbb$export$8049d91f25899769).apply(void 0, [
                    mainHelper.state
                ].concat($2f6f2e7746e4cc22$var$_toConsumableArray((0, $48c9905b4086c284$export$1c33c9881dac6797)(_this3))));
            }, function() {
                return _this3.getHelper().recommendState;
            });
            var indexInitialResults = (_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : _instantSearchInstanc[this.getIndexId()];
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.results) {
                // We restore the shape of the results provided to the instance to respect
                // the helper's structure.
                var results = new (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports))).SearchResults(new (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports))).SearchParameters(indexInitialResults.state), indexInitialResults.results);
                derivedHelper.lastResults = results;
                helper.lastResults = results;
            }
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.recommendResults) {
                var recommendResults = new (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports))).RecommendResults(new (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports))).RecommendParameters({
                    params: indexInitialResults.recommendResults.params
                }), indexInitialResults.recommendResults.results);
                derivedHelper.lastRecommendResults = recommendResults;
                helper.lastRecommendResults = recommendResults;
            }
            // Subscribe to the Helper state changes for the page before widgets
            // are initialized. This behavior mimics the original one of the Helper.
            // It makes sense to replicate it at the `init` step. We have another
            // listener on `change` below, once `init` is done.
            helper.on("change", function(_ref3) {
                var isPageReset = _ref3.isPageReset;
                if (isPageReset) $2f6f2e7746e4cc22$var$resetPageFromWidgets(localWidgets);
            });
            derivedHelper.on("search", function() {
                // The index does not manage the "staleness" of the search. This is the
                // responsibility of the main instance. It does not make sense to manage
                // it at the index level because it's either: all of them or none of them
                // that are stalled. The queries are performed into a single network request.
                instantSearchInstance.scheduleStalledRender();
            });
            derivedHelper.on("result", function(_ref4) {
                var results = _ref4.results;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastResults, which it used to in pre-federated
                // search behavior.
                helper.lastResults = results;
                lastValidSearchParameters = results === null || results === void 0 ? void 0 : results._state;
            });
            // eslint-disable-next-line no-warning-comments
            // TODO: listen to "result" event when events for Recommend are implemented
            derivedHelper.on("recommend:result", function(_ref5) {
                var recommend = _ref5.recommend;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastRecommendResults.
                helper.lastRecommendResults = recommend.results;
            });
            // We compute the render state before calling `init` in a separate loop
            // to construct the whole render state object that is then passed to
            // `init`.
            localWidgets.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this3.getIndexId()] || {}, (0, $0aa2606e7b9711cf$export$dbf1227de6c1fbc6)(instantSearchInstance, _this3, uiState));
                    $2f6f2e7746e4cc22$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this3
                    });
                }
            });
            localWidgets.forEach(function(widget) {
                if (widget.init) widget.init((0, $0aa2606e7b9711cf$export$dbf1227de6c1fbc6)(instantSearchInstance, _this3, uiState));
            });
            // Subscribe to the Helper state changes for the `uiState` once widgets
            // are initialized. Until the first render, state changes are part of the
            // configuration step. This is mainly for backward compatibility with custom
            // widgets. When the subscription happens before the `init` step, the (static)
            // configuration of the widget is pushed in the URL. That's what we want to avoid.
            // https://github.com/algolia/instantsearch/pull/994/commits/4a672ae3fd78809e213de0368549ef12e9dc9454
            helper.on("change", function(event) {
                var state = event.state;
                var _uiState = event._uiState;
                localUiState = $2f6f2e7746e4cc22$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: state,
                    helper: helper
                }, _uiState || {});
                // We don't trigger an internal change when controlled because it
                // becomes the responsibility of `setUiState`.
                if (!instantSearchInstance.onStateChange) instantSearchInstance.onInternalStateChange();
            });
            if (indexInitialResults) // If there are initial results, we're not notified of the next results
            // because we don't trigger an initial search. We therefore need to directly
            // schedule a render that will render the results injected on the helper.
            instantSearchInstance.scheduleRender();
            if (hasRecommendWidget) instantSearchInstance._hasRecommendWidget = true;
            if (hasSearchWidget) instantSearchInstance._hasSearchWidget = true;
        },
        render: function render(_ref6) {
            var _derivedHelper2, _this4 = this;
            var instantSearchInstance = _ref6.instantSearchInstance;
            // we can't attach a listener to the error event of search, as the error
            // then would no longer be thrown for global handlers.
            if (instantSearchInstance.status === "error" && !instantSearchInstance.mainHelper.hasPendingRequests() && lastValidSearchParameters) helper.setState(lastValidSearchParameters);
            // We only render index widgets if there are no results.
            // This makes sure `render` is never called with `results` being `null`.
            var widgetsToRender = this.getResults() || (_derivedHelper2 = derivedHelper) !== null && _derivedHelper2 !== void 0 && _derivedHelper2.lastRecommendResults ? localWidgets : localWidgets.filter((0, $aa2e53e8f7f529f4$export$a9c9a0d43506297d));
            widgetsToRender = widgetsToRender.filter(function(widget) {
                if (!widget.shouldRender) return true;
                return widget.shouldRender({
                    instantSearchInstance: instantSearchInstance
                });
            });
            widgetsToRender.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this4.getIndexId()] || {}, (0, $0aa2606e7b9711cf$export$c3ba97e79c76dd38)(instantSearchInstance, _this4, widget));
                    $2f6f2e7746e4cc22$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this4
                    });
                }
            });
            widgetsToRender.forEach(function(widget) {
                // At this point, all the variables used below are set. Both `helper`
                // and `derivedHelper` have been created at the `init` step. The attribute
                // `lastResults` might be `null` though. It's possible that a stalled render
                // happens before the result e.g with a dynamically added index the request might
                // be delayed. The render is triggered for the complete tree but some parts do
                // not have results yet.
                if (widget.render) widget.render((0, $0aa2606e7b9711cf$export$c3ba97e79c76dd38)(instantSearchInstance, _this4, widget));
            });
        },
        dispose: function dispose() {
            var _this5 = this, _helper2, _derivedHelper3;
            localWidgets.forEach(function(widget) {
                if (widget.dispose && helper) // The dispose function is always called once the instance is started
                // (it's an effect of `removeWidgets`). The index is initialized and
                // the Helper is available. We don't care about the return value of
                // `dispose` because the index is removed. We can't call `removeWidgets`
                // because we want to keep the widgets on the instance, to allow idempotent
                // operations on `add` & `remove`.
                widget.dispose({
                    helper: helper,
                    state: helper.state,
                    recommendState: helper.recommendState,
                    parent: _this5
                });
            });
            localInstantSearchInstance = null;
            localParent = null;
            (_helper2 = helper) === null || _helper2 === void 0 || _helper2.removeAllListeners();
            helper = null;
            (_derivedHelper3 = derivedHelper) === null || _derivedHelper3 === void 0 || _derivedHelper3.detach();
            derivedHelper = null;
        },
        getWidgetUiState: function getWidgetUiState(uiState) {
            return localWidgets.filter((0, $aa2e53e8f7f529f4$export$a9c9a0d43506297d)).reduce(function(previousUiState, innerIndex) {
                return innerIndex.getWidgetUiState(previousUiState);
            }, $2f6f2e7746e4cc22$var$_objectSpread($2f6f2e7746e4cc22$var$_objectSpread({}, uiState), {}, $2f6f2e7746e4cc22$var$_defineProperty({}, indexId, $2f6f2e7746e4cc22$var$_objectSpread($2f6f2e7746e4cc22$var$_objectSpread({}, uiState[indexId]), localUiState))));
        },
        getWidgetState: function getWidgetState(uiState) {
            return this.getWidgetUiState(uiState);
        },
        getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref7) {
            var uiState = _ref7.uiState;
            return $2f6f2e7746e4cc22$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: uiState,
                initialSearchParameters: searchParameters
            });
        },
        refreshUiState: function refreshUiState() {
            localUiState = $2f6f2e7746e4cc22$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: this.getHelper().state,
                helper: this.getHelper()
            }, localUiState);
        },
        setIndexUiState: function setIndexUiState(indexUiState) {
            var nextIndexUiState = typeof indexUiState === "function" ? indexUiState(localUiState) : indexUiState;
            localInstantSearchInstance.setUiState(function(state) {
                return $2f6f2e7746e4cc22$var$_objectSpread($2f6f2e7746e4cc22$var$_objectSpread({}, state), {}, $2f6f2e7746e4cc22$var$_defineProperty({}, indexId, nextIndexUiState));
            });
        }
    };
};
var $2f6f2e7746e4cc22$export$2e2bcd8739ae039 = $2f6f2e7746e4cc22$var$index;
function $2f6f2e7746e4cc22$var$storeRenderState(_ref8) {
    var renderState = _ref8.renderState, instantSearchInstance = _ref8.instantSearchInstance, parent = _ref8.parent;
    var parentIndexName = parent ? parent.getIndexId() : instantSearchInstance.mainIndex.getIndexId();
    instantSearchInstance.renderState = $2f6f2e7746e4cc22$var$_objectSpread($2f6f2e7746e4cc22$var$_objectSpread({}, instantSearchInstance.renderState), {}, $2f6f2e7746e4cc22$var$_defineProperty({}, parentIndexName, $2f6f2e7746e4cc22$var$_objectSpread($2f6f2e7746e4cc22$var$_objectSpread({}, instantSearchInstance.renderState[parentIndexName]), renderState)));
}



function $65b35437084c827d$export$f5dd818bff069720(value, numberLocale) {
    return value.toLocaleString(numberLocale);
}


function $dc53f51142000448$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dc53f51142000448$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dc53f51142000448$var$_typeof(o);
}
function $dc53f51142000448$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dc53f51142000448$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dc53f51142000448$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dc53f51142000448$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dc53f51142000448$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dc53f51142000448$var$_defineProperty(obj, key, value) {
    key = $dc53f51142000448$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc53f51142000448$var$_toPropertyKey(t) {
    var i = $dc53f51142000448$var$_toPrimitive(t, "string");
    return "symbol" == $dc53f51142000448$var$_typeof(i) ? i : String(i);
}
function $dc53f51142000448$var$_toPrimitive(t, r) {
    if ("object" != $dc53f51142000448$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dc53f51142000448$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $dc53f51142000448$export$2e2bcd8739ae039(_ref) {
    var numberLocale = _ref.numberLocale;
    return {
        formatNumber: function formatNumber(value, render) {
            return (0, $65b35437084c827d$export$f5dd818bff069720)(Number(render(value)), numberLocale);
        },
        highlight: function highlight(options, render) {
            try {
                var highlightOptions = JSON.parse(options);
                return render((0, $7406f687e3aa4bbe$export$2e2bcd8739ae039)($dc53f51142000448$var$_objectSpread($dc53f51142000448$var$_objectSpread({}, highlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe highlight helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseHighlight: function reverseHighlight(options, render) {
            try {
                var reverseHighlightOptions = JSON.parse(options);
                return render((0, $252f56918a3355b2$export$2e2bcd8739ae039)($dc53f51142000448$var$_objectSpread($dc53f51142000448$var$_objectSpread({}, reverseHighlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseHighlight helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        snippet: function snippet(options, render) {
            try {
                var snippetOptions = JSON.parse(options);
                return render((0, $e443915becc5e204$export$2e2bcd8739ae039)($dc53f51142000448$var$_objectSpread($dc53f51142000448$var$_objectSpread({}, snippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe snippet helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseSnippet: function reverseSnippet(options, render) {
            try {
                var reverseSnippetOptions = JSON.parse(options);
                return render((0, $6a226ae052dfdaa0$export$2e2bcd8739ae039)($dc53f51142000448$var$_objectSpread($dc53f51142000448$var$_objectSpread({}, reverseSnippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseSnippet helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        insights: function insights(options, render) {
            try {
                var _JSON$parse = JSON.parse(options), method = _JSON$parse.method, payload = _JSON$parse.payload;
                return render((0, $0960a378c85a0fdc$export$2e2bcd8739ae039)(method, $dc53f51142000448$var$_objectSpread({
                    objectIDs: [
                        this.objectID
                    ]
                }, payload)));
            } catch (error) {
                throw new Error('\nThe insights helper expects a JSON object of the format:\n{ "method": "method-name", "payload": { "eventName": "name of the event" } }');
            }
        }
    };
}


var $9dedb13b89ca67f4$var$nextMicroTask = Promise.resolve();
function $9dedb13b89ca67f4$export$260e5c0943f31606(callback) {
    var progress = null;
    var cancelled = false;
    var fn = function fn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (progress !== null) return;
        progress = $9dedb13b89ca67f4$var$nextMicroTask.then(function() {
            progress = null;
            if (cancelled) {
                cancelled = false;
                return;
            }
            callback.apply(void 0, args);
        });
    };
    fn.wait = function() {
        if (progress === null) throw new Error("The deferred function should be called before calling `wait()`");
        return progress;
    };
    fn.cancel = function() {
        if (progress === null) return;
        cancelled = true;
    };
    return fn;
}

function $97b78abc27fdc536$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $97b78abc27fdc536$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $97b78abc27fdc536$var$_typeof(o);
}
function $97b78abc27fdc536$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $97b78abc27fdc536$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $97b78abc27fdc536$var$ownKeys(Object(t), !0).forEach(function(r) {
            $97b78abc27fdc536$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $97b78abc27fdc536$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $97b78abc27fdc536$var$_defineProperty(obj, key, value) {
    key = $97b78abc27fdc536$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $97b78abc27fdc536$var$_toPropertyKey(t) {
    var i = $97b78abc27fdc536$var$_toPrimitive(t, "string");
    return "symbol" == $97b78abc27fdc536$var$_typeof(i) ? i : String(i);
}
function $97b78abc27fdc536$var$_toPrimitive(t, r) {
    if ("object" != $97b78abc27fdc536$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $97b78abc27fdc536$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $97b78abc27fdc536$export$53ef00b131a96aa6(helper, initialResults) {
    var recommendCache = Object.keys(initialResults).reduce(function(acc, indexName) {
        var initialResult = initialResults[indexName];
        if (initialResult.recommendResults) // @MAJOR: Use `Object.assign` instead of spread operator
        return $97b78abc27fdc536$var$_objectSpread($97b78abc27fdc536$var$_objectSpread({}, acc), initialResult.recommendResults.results);
        return acc;
    }, {});
    helper._recommendCache = recommendCache;
}

function $7750fe0111d1e0f0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7750fe0111d1e0f0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7750fe0111d1e0f0$var$_typeof(o);
}
function $7750fe0111d1e0f0$var$_slicedToArray(arr, i) {
    return $7750fe0111d1e0f0$var$_arrayWithHoles(arr) || $7750fe0111d1e0f0$var$_iterableToArrayLimit(arr, i) || $7750fe0111d1e0f0$var$_unsupportedIterableToArray(arr, i) || $7750fe0111d1e0f0$var$_nonIterableRest();
}
function $7750fe0111d1e0f0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7750fe0111d1e0f0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7750fe0111d1e0f0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7750fe0111d1e0f0$var$_arrayLikeToArray(o, minLen);
}
function $7750fe0111d1e0f0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7750fe0111d1e0f0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7750fe0111d1e0f0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7750fe0111d1e0f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7750fe0111d1e0f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7750fe0111d1e0f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7750fe0111d1e0f0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7750fe0111d1e0f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7750fe0111d1e0f0$var$_defineProperty(obj, key, value) {
    key = $7750fe0111d1e0f0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7750fe0111d1e0f0$var$_toPropertyKey(t) {
    var i = $7750fe0111d1e0f0$var$_toPrimitive(t, "string");
    return "symbol" == $7750fe0111d1e0f0$var$_typeof(i) ? i : String(i);
}
function $7750fe0111d1e0f0$var$_toPrimitive(t, r) {
    if ("object" != $7750fe0111d1e0f0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7750fe0111d1e0f0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7750fe0111d1e0f0$export$7edf4eca27ca3a19(client, results) {
    if (!results) return;
    // Disable cache hydration on:
    // - Algoliasearch API Client < v4 with cache disabled
    // - Third party clients (detected by the `addAlgoliaAgent` function missing)
    if ((!("transporter" in client) || client._cacheHydrated) && (!client._useCache || typeof client.addAlgoliaAgent !== "function")) return;
    var cachedRequest = [
        Object.keys(results).reduce(function(acc, key) {
            var _results$key = results[key], state = _results$key.state, requestParams = _results$key.requestParams, serverResults = _results$key.results;
            var mappedResults = serverResults && state ? serverResults.map(function(result, idx) {
                return $7750fe0111d1e0f0$var$_objectSpread({
                    indexName: state.index || result.index
                }, requestParams !== null && requestParams !== void 0 && requestParams[idx] || result.params ? {
                    params: $7750fe0111d1e0f0$var$serializeQueryParameters((requestParams === null || requestParams === void 0 ? void 0 : requestParams[idx]) || $7750fe0111d1e0f0$var$deserializeQueryParameters(result.params))
                } : {});
            }) : [];
            return acc.concat(mappedResults);
        }, [])
    ];
    var cachedResults = Object.keys(results).reduce(function(acc, key) {
        var res = results[key].results;
        if (!res) return acc;
        return acc.concat(res);
    }, []);
    // Algoliasearch API Client >= v4
    // To hydrate the client we need to populate the cache with the data from
    // the server (done in `hydrateSearchClientWithMultiIndexRequest` or
    // `hydrateSearchClientWithSingleIndexRequest`). But since there is no way
    // for us to compute the key the same way as `algoliasearch-client` we need
    // to populate it on a custom key and override the `search` method to
    // search on it first.
    if ("transporter" in client && !client._cacheHydrated) {
        client._cacheHydrated = true;
        var baseMethod = client.search.bind(client);
        client.search = function(requests) {
            for(var _len = arguments.length, methodArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)methodArgs[_key - 1] = arguments[_key];
            var requestsWithSerializedParams = Array.isArray(requests) ? // search client
            requests.map(function(request) {
                return $7750fe0111d1e0f0$var$_objectSpread($7750fe0111d1e0f0$var$_objectSpread({}, request), {}, {
                    params: $7750fe0111d1e0f0$var$serializeQueryParameters(request.params)
                });
            }) : // composition client
            $7750fe0111d1e0f0$var$serializeQueryParameters(requests.requestBody.params);
            return client.transporter.responsesCache.get({
                method: "search",
                args: [
                    requestsWithSerializedParams
                ].concat(methodArgs)
            }, function() {
                return baseMethod.apply(void 0, [
                    requests
                ].concat(methodArgs));
            });
        };
        client.transporter.responsesCache.set({
            method: "search",
            args: cachedRequest
        }, {
            results: cachedResults
        });
    }
    // Algoliasearch API Client < v4
    // Prior to client v4 we didn't have a proper API to hydrate the client
    // cache from the outside. The following code populates the cache with
    // a single-index result. You can find more information about the
    // computation of the key inside the client (see link below).
    // https://github.com/algolia/algoliasearch-client-javascript/blob/c27e89ff92b2a854ae6f40dc524bffe0f0cbc169/src/AlgoliaSearchCore.js#L232-L240
    if (!("transporter" in client)) {
        var cacheKey = "/1/indexes/*/queries_body_".concat(JSON.stringify({
            requests: cachedRequest
        }));
        client.cache = $7750fe0111d1e0f0$var$_objectSpread($7750fe0111d1e0f0$var$_objectSpread({}, client.cache), {}, $7750fe0111d1e0f0$var$_defineProperty({}, cacheKey, JSON.stringify({
            results: Object.keys(results).map(function(key) {
                return results[key].results;
            })
        })));
    }
}
function $7750fe0111d1e0f0$var$deserializeQueryParameters(parameters) {
    return parameters.split("&").reduce(function(acc, parameter) {
        var _parameter$split = parameter.split("="), _parameter$split2 = $7750fe0111d1e0f0$var$_slicedToArray(_parameter$split, 2), key = _parameter$split2[0], value = _parameter$split2[1];
        acc[key] = value ? decodeURIComponent(value) : "";
        return acc;
    }, {});
}
// This function is copied from the algoliasearch v4 API Client. If modified,
// consider updating it also in `serializeQueryParameters` from `@algolia/transporter`.
function $7750fe0111d1e0f0$var$serializeQueryParameters(parameters) {
    var isObjectOrArray = function isObjectOrArray(value) {
        return Object.prototype.toString.call(value) === "[object Object]" || Object.prototype.toString.call(value) === "[object Array]";
    };
    var encode = function encode(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var i = 0;
        return format.replace(/%s/g, function() {
            return encodeURIComponent(args[i++]);
        });
    };
    return Object.keys(parameters).map(function(key) {
        return encode("%s=%s", key, isObjectOrArray(parameters[key]) ? JSON.stringify(parameters[key]) : parameters[key]);
    }).join("&");
}



function $aa1f08ba40510f8e$export$fd5e8f1329b3d5e0(finalUiState, indexWidget) {
    var nextIndexUiState = finalUiState[indexWidget.getIndexId()] || {};
    indexWidget.getHelper().setState(indexWidget.getWidgetSearchParameters(indexWidget.getHelper().state, {
        uiState: nextIndexUiState
    }));
    indexWidget.getWidgets().filter((0, $aa2e53e8f7f529f4$export$a9c9a0d43506297d)).forEach(function(widget) {
        return $aa1f08ba40510f8e$export$fd5e8f1329b3d5e0(finalUiState, widget);
    });
}


var $4d4d6a84f0b16934$export$2e2bcd8739ae039 = "4.77.3";


function $17130158ec60d8d6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $17130158ec60d8d6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $17130158ec60d8d6$var$_typeof(o);
}
function $17130158ec60d8d6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $17130158ec60d8d6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $17130158ec60d8d6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $17130158ec60d8d6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $17130158ec60d8d6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $17130158ec60d8d6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $17130158ec60d8d6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $17130158ec60d8d6$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $17130158ec60d8d6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $17130158ec60d8d6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $17130158ec60d8d6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $17130158ec60d8d6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $17130158ec60d8d6$var$_setPrototypeOf(subClass, superClass);
}
function $17130158ec60d8d6$var$_setPrototypeOf(o, p) {
    $17130158ec60d8d6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $17130158ec60d8d6$var$_setPrototypeOf(o, p);
}
function $17130158ec60d8d6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $17130158ec60d8d6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $17130158ec60d8d6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $17130158ec60d8d6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $17130158ec60d8d6$var$_possibleConstructorReturn(this, result);
    };
}
function $17130158ec60d8d6$var$_possibleConstructorReturn(self, call) {
    if (call && ($17130158ec60d8d6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $17130158ec60d8d6$var$_assertThisInitialized(self);
}
function $17130158ec60d8d6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $17130158ec60d8d6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $17130158ec60d8d6$var$_getPrototypeOf(o) {
    $17130158ec60d8d6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $17130158ec60d8d6$var$_getPrototypeOf(o);
}
function $17130158ec60d8d6$var$_defineProperty(obj, key, value) {
    key = $17130158ec60d8d6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $17130158ec60d8d6$var$_toPropertyKey(t) {
    var i = $17130158ec60d8d6$var$_toPrimitive(t, "string");
    return "symbol" == $17130158ec60d8d6$var$_typeof(i) ? i : String(i);
}
function $17130158ec60d8d6$var$_toPrimitive(t, r) {
    if ("object" != $17130158ec60d8d6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $17130158ec60d8d6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $17130158ec60d8d6$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "instantsearch"
});
function $17130158ec60d8d6$var$defaultCreateURL() {
    return "#";
}
var $17130158ec60d8d6$export$8bd42a83af1ca676 = {
    preserveSharedStateOnUnmount: false,
    persistHierarchicalRootCount: false
};
/**
 * The actual implementation of the InstantSearch. This is
 * created using the `instantsearch` factory function.
 * It emits the 'render' event every time a search is done
 */ var $17130158ec60d8d6$var$InstantSearch = /*#__PURE__*/ function(_EventEmitter) {
    $17130158ec60d8d6$var$_inherits(InstantSearch, _EventEmitter);
    var _super = $17130158ec60d8d6$var$_createSuper(InstantSearch);
    function InstantSearch(options) {
        var _options$future2;
        var _this;
        $17130158ec60d8d6$var$_classCallCheck(this, InstantSearch);
        _this = _super.call(this);
        // prevent `render` event listening from causing a warning
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "client", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "indexName", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "compositionID", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "insightsClient", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "onStateChange", null);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "future", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "helper", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "mainHelper", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "mainIndex", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "started", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "templatesConfig", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "renderState", {});
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "_stalledSearchDelay", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "_searchStalledTimer", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "_initialUiState", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "_initialResults", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "_createURL", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "_searchFunction", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "_mainHelperSearch", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "_hasSearchWidget", false);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "_hasRecommendWidget", false);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "_insights", void 0);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "middleware", []);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "sendEventToInsights", void 0);
        /**
     * The status of the search. Can be "idle", "loading", "stalled", or "error".
     */ $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "status", "idle");
        /**
     * The last returned error from the Search API.
     * The error gets cleared when the next valid search response is rendered.
     */ $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "error", undefined);
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "scheduleSearch", (0, $9dedb13b89ca67f4$export$260e5c0943f31606)(function() {
            if (_this.started) _this.mainHelper.search();
        }));
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "scheduleRender", (0, $9dedb13b89ca67f4$export$260e5c0943f31606)(function() {
            var _this$mainHelper;
            var shouldResetStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (!((_this$mainHelper = _this.mainHelper) !== null && _this$mainHelper !== void 0 && _this$mainHelper.hasPendingRequests())) {
                clearTimeout(_this._searchStalledTimer);
                _this._searchStalledTimer = null;
                if (shouldResetStatus) {
                    _this.status = "idle";
                    _this.error = undefined;
                }
            }
            _this.mainIndex.render({
                instantSearchInstance: $17130158ec60d8d6$var$_assertThisInitialized(_this)
            });
            _this.emit("render");
        }));
        $17130158ec60d8d6$var$_defineProperty($17130158ec60d8d6$var$_assertThisInitialized(_this), "onInternalStateChange", (0, $9dedb13b89ca67f4$export$260e5c0943f31606)(function() {
            var nextUiState = _this.mainIndex.getWidgetUiState({});
            _this.middleware.forEach(function(_ref) {
                var instance = _ref.instance;
                instance.onStateChange({
                    uiState: nextUiState
                });
            });
        }));
        _this.setMaxListeners(100);
        var _options$indexName = options.indexName, indexName = _options$indexName === void 0 ? "" : _options$indexName, compositionID = options.compositionID, numberLocale = options.numberLocale, _options$initialUiSta = options.initialUiState, initialUiState = _options$initialUiSta === void 0 ? {} : _options$initialUiSta, _options$routing = options.routing, routing = _options$routing === void 0 ? null : _options$routing, _options$insights = options.insights, insights = _options$insights === void 0 ? undefined : _options$insights, searchFunction = options.searchFunction, _options$stalledSearc = options.stalledSearchDelay, stalledSearchDelay = _options$stalledSearc === void 0 ? 200 : _options$stalledSearc, _options$searchClient = options.searchClient, searchClient = _options$searchClient === void 0 ? null : _options$searchClient, _options$insightsClie = options.insightsClient, insightsClient = _options$insightsClie === void 0 ? null : _options$insightsClie, _options$onStateChang = options.onStateChange, onStateChange = _options$onStateChang === void 0 ? null : _options$onStateChang, _options$future = options.future, future = _options$future === void 0 ? $17130158ec60d8d6$var$_objectSpread($17130158ec60d8d6$var$_objectSpread({}, $17130158ec60d8d6$export$8bd42a83af1ca676), options.future || {}) : _options$future;
        if (searchClient === null) throw new Error($17130158ec60d8d6$var$withUsage("The `searchClient` option is required."));
        if (typeof searchClient.search !== "function") throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
        if (typeof searchClient.addAlgoliaAgent === "function") searchClient.addAlgoliaAgent("instantsearch.js (".concat((0, $4d4d6a84f0b16934$export$2e2bcd8739ae039), ")"));
        if (insightsClient && typeof insightsClient !== "function") throw new Error($17130158ec60d8d6$var$withUsage("The `insightsClient` option should be a function."));
        _this.client = searchClient;
        _this.future = future;
        _this.insightsClient = insightsClient;
        _this.indexName = indexName;
        _this.compositionID = compositionID;
        _this.helper = null;
        _this.mainHelper = null;
        _this.mainIndex = (0, $2f6f2e7746e4cc22$export$2e2bcd8739ae039)({
            // we use an index widget to render compositions
            // this only works because there's only one composition index allow for now
            indexName: _this.compositionID || _this.indexName
        });
        _this.onStateChange = onStateChange;
        _this.started = false;
        _this.templatesConfig = {
            helpers: (0, $dc53f51142000448$export$2e2bcd8739ae039)({
                numberLocale: numberLocale
            }),
            compileOptions: {}
        };
        _this._stalledSearchDelay = stalledSearchDelay;
        _this._searchStalledTimer = null;
        _this._createURL = $17130158ec60d8d6$var$defaultCreateURL;
        _this._initialUiState = initialUiState;
        _this._initialResults = null;
        _this._insights = insights;
        if (searchFunction) _this._searchFunction = searchFunction;
        _this.sendEventToInsights = (0, $846d3432ff405e8b$export$8793edee2d425525);
        if (routing) {
            var routerOptions = typeof routing === "boolean" ? {} : routing;
            routerOptions.$$internal = true;
            _this.use((0, $be4c23fbdfdd3f2f$export$1fe5128387816284)(routerOptions));
        }
        // This is the default Insights middleware,
        // added when `insights` is set to true by the user.
        // Any user-provided middleware will be added later and override this one.
        if (insights) {
            var insightsOptions = typeof insights === "boolean" ? {} : insights;
            insightsOptions.$$internal = true;
            _this.use((0, $d0531431952f7f4f$export$91e0bf09562e2c44)(insightsOptions));
        }
        if ((0, $44d0263adf33480c$export$4b4254890acf93e7)()) _this.use((0, $44d0263adf33480c$export$8ee9d2447935ed96)({
            $$internal: true
        }));
        return _this;
    }
    /**
   * Hooks a middleware into the InstantSearch lifecycle.
   */ $17130158ec60d8d6$var$_createClass(InstantSearch, [
        {
            key: "_isSearchStalled",
            get: /**
     * @deprecated use `status === 'stalled'` instead
     */ function get() {
                return this.status === "stalled";
            }
        },
        {
            key: "use",
            value: function use() {
                var _this2 = this;
                for(var _len = arguments.length, middleware = new Array(_len), _key = 0; _key < _len; _key++)middleware[_key] = arguments[_key];
                var newMiddlewareList = middleware.map(function(fn) {
                    var newMiddleware = $17130158ec60d8d6$var$_objectSpread({
                        $$type: "__unknown__",
                        $$internal: false,
                        subscribe: (0, $846d3432ff405e8b$export$8793edee2d425525),
                        started: (0, $846d3432ff405e8b$export$8793edee2d425525),
                        unsubscribe: (0, $846d3432ff405e8b$export$8793edee2d425525),
                        onStateChange: (0, $846d3432ff405e8b$export$8793edee2d425525)
                    }, fn({
                        instantSearchInstance: _this2
                    }));
                    _this2.middleware.push({
                        creator: fn,
                        instance: newMiddleware
                    });
                    return newMiddleware;
                });
                // If the instance has already started, we directly subscribe the
                // middleware so they're notified of changes.
                if (this.started) newMiddlewareList.forEach(function(m) {
                    m.subscribe();
                    m.started();
                });
                return this;
            }
        },
        {
            key: "unuse",
            value: function unuse() {
                for(var _len2 = arguments.length, middlewareToUnuse = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)middlewareToUnuse[_key2] = arguments[_key2];
                this.middleware.filter(function(m) {
                    return middlewareToUnuse.includes(m.creator);
                }).forEach(function(m) {
                    return m.instance.unsubscribe();
                });
                this.middleware = this.middleware.filter(function(m) {
                    return !middlewareToUnuse.includes(m.creator);
                });
                return this;
            }
        },
        {
            key: "EXPERIMENTAL_use",
            value: function EXPERIMENTAL_use() {
                return this.use.apply(this, arguments);
            }
        },
        {
            key: "addWidget",
            value: function addWidget(widget) {
                return this.addWidgets([
                    widget
                ]);
            }
        },
        {
            key: "addWidgets",
            value: function addWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($17130158ec60d8d6$var$withUsage("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.init !== "function" && typeof widget.render !== "function";
                })) throw new Error($17130158ec60d8d6$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
                if (this.compositionID && widgets.some((0, $aa2e53e8f7f529f4$export$a9c9a0d43506297d))) throw new Error($17130158ec60d8d6$var$withUsage("The `index` widget cannot be used with a composition-based InstantSearch implementation."));
                this.mainIndex.addWidgets(widgets);
                return this;
            }
        },
        {
            key: "removeWidget",
            value: function removeWidget(widget) {
                return this.removeWidgets([
                    widget
                ]);
            }
        },
        {
            key: "removeWidgets",
            value: function removeWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($17130158ec60d8d6$var$withUsage("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.dispose !== "function";
                })) throw new Error($17130158ec60d8d6$var$withUsage("The widget definition expects a `dispose` method."));
                this.mainIndex.removeWidgets(widgets);
                return this;
            }
        },
        {
            key: "start",
            value: function start() {
                var _this3 = this;
                if (this.started) throw new Error($17130158ec60d8d6$var$withUsage("The `start` method has already been called once."));
                // This Helper is used for the queries, we don't care about its state. The
                // states are managed at the `index` level. We use this Helper to create
                // DerivedHelper scoped into the `index` widgets.
                // In Vue InstantSearch' hydrate, a main helper gets set before start, so
                // we need to respect this helper as a way to keep all listeners correct.
                var mainHelper = this.mainHelper || (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports)))(this.client, this.indexName, undefined, {
                    persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
                });
                if (this.compositionID) mainHelper.searchForFacetValues = mainHelper.searchForCompositionFacetValues.bind(mainHelper);
                mainHelper.search = function() {
                    _this3.status = "loading";
                    _this3.scheduleRender(false);
                    // This solution allows us to keep the exact same API for the users but
                    // under the hood, we have a different implementation. It should be
                    // completely transparent for the rest of the codebase. Only this module
                    // is impacted.
                    if (_this3._hasSearchWidget) {
                        if (_this3.compositionID) mainHelper.searchWithComposition();
                        else mainHelper.searchOnlyWithDerivedHelpers();
                    }
                    if (_this3._hasRecommendWidget) mainHelper.recommend();
                    return mainHelper;
                };
                if (this._searchFunction) {
                    // this client isn't used to actually search, but required for the helper
                    // to not throw errors
                    var fakeClient = {
                        search: function search() {
                            return new Promise((0, $846d3432ff405e8b$export$8793edee2d425525));
                        }
                    };
                    this._mainHelperSearch = mainHelper.search.bind(mainHelper);
                    mainHelper.search = function() {
                        var mainIndexHelper = _this3.mainIndex.getHelper();
                        var searchFunctionHelper = (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports)))(fakeClient, mainIndexHelper.state.index, mainIndexHelper.state);
                        searchFunctionHelper.once("search", function(_ref2) {
                            var state = _ref2.state;
                            mainIndexHelper.overrideStateWithoutTriggeringChangeEvent(state);
                            _this3._mainHelperSearch();
                        });
                        // Forward state changes from `searchFunctionHelper` to `mainIndexHelper`
                        searchFunctionHelper.on("change", function(_ref3) {
                            var state = _ref3.state;
                            mainIndexHelper.setState(state);
                        });
                        _this3._searchFunction(searchFunctionHelper);
                        return mainHelper;
                    };
                }
                // Only the "main" Helper emits the `error` event vs the one for `search`
                // and `results` that are also emitted on the derived one.
                mainHelper.on("error", function(_ref4) {
                    var error = _ref4.error;
                    if (!(error instanceof Error)) {
                        // typescript lies here, error is in some cases { name: string, message: string }
                        var err = error;
                        error = Object.keys(err).reduce(function(acc, key) {
                            acc[key] = err[key];
                            return acc;
                        }, new Error(err.message));
                    }
                    // If an error is emitted, it is re-thrown by events. In previous versions
                    // we emitted {error}, which is thrown as:
                    // "Uncaught, unspecified \"error\" event. ([object Object])"
                    // To avoid breaking changes, we make the error available in both
                    // `error` and `error.error`
                    // @MAJOR emit only error
                    error.error = error;
                    _this3.error = error;
                    _this3.status = "error";
                    _this3.scheduleRender(false);
                    // This needs to execute last because it throws the error.
                    _this3.emit("error", error);
                });
                this.mainHelper = mainHelper;
                this.middleware.forEach(function(_ref5) {
                    var instance = _ref5.instance;
                    instance.subscribe();
                });
                this.mainIndex.init({
                    instantSearchInstance: this,
                    parent: null,
                    uiState: this._initialUiState
                });
                if (this._initialResults) {
                    (0, $7750fe0111d1e0f0$export$7edf4eca27ca3a19)(this.client, this._initialResults);
                    (0, $97b78abc27fdc536$export$53ef00b131a96aa6)(this.mainHelper, this._initialResults);
                    var originalScheduleSearch = this.scheduleSearch;
                    // We don't schedule a first search when initial results are provided
                    // because we already have the results to render. This skips the initial
                    // network request on the browser on `start`.
                    this.scheduleSearch = (0, $9dedb13b89ca67f4$export$260e5c0943f31606)((0, $846d3432ff405e8b$export$8793edee2d425525));
                    // We also skip the initial network request when widgets are dynamically
                    // added in the first tick (that's the case in all the framework-based flavors).
                    // When we add a widget to `index`, it calls `scheduleSearch`. We can rely
                    // on our `defer` util to restore the original `scheduleSearch` value once
                    // widgets are added to hook back to the regular lifecycle.
                    (0, $9dedb13b89ca67f4$export$260e5c0943f31606)(function() {
                        _this3.scheduleSearch = originalScheduleSearch;
                    })();
                } else if (this.mainIndex.getWidgets().length > 0) this.scheduleSearch();
                // Keep the previous reference for legacy purpose, some pattern use
                // the direct Helper access `search.helper` (e.g multi-index).
                this.helper = this.mainIndex.getHelper();
                // track we started the search if we add more widgets,
                // to init them directly after add
                this.started = true;
                this.middleware.forEach(function(_ref6) {
                    var instance = _ref6.instance;
                    instance.started();
                });
                // This is the automatic Insights middleware,
                // added when `insights` is unset and the initial results possess `queryID`.
                // Any user-provided middleware will be added later and override this one.
                if (typeof this._insights === "undefined") mainHelper.derivedHelpers[0].once("result", function() {
                    var hasAutomaticInsights = _this3.mainIndex.getScopedResults().some(function(_ref7) {
                        var results = _ref7.results;
                        return results === null || results === void 0 ? void 0 : results._automaticInsights;
                    });
                    if (hasAutomaticInsights) _this3.use((0, $d0531431952f7f4f$export$91e0bf09562e2c44)({
                        $$internal: true,
                        $$automatic: true
                    }));
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this$mainHelper2;
                this.scheduleSearch.cancel();
                this.scheduleRender.cancel();
                clearTimeout(this._searchStalledTimer);
                this.removeWidgets(this.mainIndex.getWidgets());
                this.mainIndex.dispose();
                // You can not start an instance two times, therefore a disposed instance
                // needs to set started as false otherwise this can not be restarted at a
                // later point.
                this.started = false;
                // The helper needs to be reset to perform the next search from a fresh state.
                // If not reset, it would use the state stored before calling `dispose()`.
                this.removeAllListeners();
                (_this$mainHelper2 = this.mainHelper) === null || _this$mainHelper2 === void 0 || _this$mainHelper2.removeAllListeners();
                this.mainHelper = null;
                this.helper = null;
                this.middleware.forEach(function(_ref8) {
                    var instance = _ref8.instance;
                    instance.unsubscribe();
                });
            }
        },
        {
            key: "scheduleStalledRender",
            value: function scheduleStalledRender() {
                var _this4 = this;
                if (!this._searchStalledTimer) this._searchStalledTimer = setTimeout(function() {
                    _this4.status = "stalled";
                    _this4.scheduleRender();
                }, this._stalledSearchDelay);
            }
        },
        {
            key: "setUiState",
            value: function setUiState(uiState) {
                var _this5 = this;
                var callOnStateChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (!this.mainHelper) throw new Error($17130158ec60d8d6$var$withUsage("The `start` method needs to be called before `setUiState`."));
                // We refresh the index UI state to update the local UI state that the
                // main index passes to the function form of `setUiState`.
                this.mainIndex.refreshUiState();
                var nextUiState = typeof uiState === "function" ? uiState(this.mainIndex.getWidgetUiState({})) : uiState;
                if (this.onStateChange && callOnStateChange) this.onStateChange({
                    uiState: nextUiState,
                    setUiState: function setUiState(finalUiState) {
                        (0, $aa1f08ba40510f8e$export$fd5e8f1329b3d5e0)(typeof finalUiState === "function" ? finalUiState(nextUiState) : finalUiState, _this5.mainIndex);
                        _this5.scheduleSearch();
                        _this5.onInternalStateChange();
                    }
                });
                else {
                    (0, $aa1f08ba40510f8e$export$fd5e8f1329b3d5e0)(nextUiState, this.mainIndex);
                    this.scheduleSearch();
                    this.onInternalStateChange();
                }
            }
        },
        {
            key: "getUiState",
            value: function getUiState() {
                if (this.started) // We refresh the index UI state to make sure changes from `refine` are taken in account
                this.mainIndex.refreshUiState();
                return this.mainIndex.getWidgetUiState({});
            }
        },
        {
            key: "createURL",
            value: function createURL() {
                var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.started) throw new Error($17130158ec60d8d6$var$withUsage("The `start` method needs to be called before `createURL`."));
                return this._createURL(nextState);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                if (!this.mainHelper) throw new Error($17130158ec60d8d6$var$withUsage("The `start` method needs to be called before `refresh`."));
                this.mainHelper.clearCache().search();
            }
        }
    ]);
    return InstantSearch;
}((0, (/*@__PURE__*/$parcel$interopDefault($b40ee84aff520977$exports))));
var $17130158ec60d8d6$export$2e2bcd8739ae039 = $17130158ec60d8d6$var$InstantSearch;



/**
 * Logs a warning when this function is called, in development environment only.
 */ var $764d4a40d07f7ed3$export$b680e6b2c82f8c2f = function deprecate(fn, message) {
    return fn;
};
/**
 * Logs a warning
 * This is used to log issues in development environment only.
 */ var $764d4a40d07f7ed3$export$c106dd0671a0fc2d = (0, $846d3432ff405e8b$export$8793edee2d425525);
/**
 * Logs a warning if the condition is not met.
 * This is used to log issues in development environment only.
 */ var $764d4a40d07f7ed3$export$491112666e282270 = (0, $846d3432ff405e8b$export$8793edee2d425525);




/**
 * InstantSearch is the main component of InstantSearch.js. This object
 * manages the widget and lets you add new ones.
 *
 * Two parameters are required to get you started with InstantSearch.js:
 *  - `indexName`: the main index that you will use for your new search UI
 *  - `searchClient`: the search client to plug to InstantSearch.js
 *
 * The [search client provided by Algolia](algolia.com/doc/api-client/getting-started/what-is-the-api-client/javascript/)
 * needs an `appId` and an `apiKey`. Those parameters can be found in your
 * [Algolia dashboard](https://www.algolia.com/api-keys).
 *
 * If you want to get up and running quickly with InstantSearch.js, have a
 * look at the [getting started](https://www.algolia.com/doc/guides/building-search-ui/getting-started/js/).
 */ var $48737dfc970c14bb$var$instantsearch = function instantsearch(options) {
    return new (0, $17130158ec60d8d6$export$2e2bcd8739ae039)(options);
};
$48737dfc970c14bb$var$instantsearch.version = (0, $4d4d6a84f0b16934$export$2e2bcd8739ae039);
$48737dfc970c14bb$var$instantsearch.createInfiniteHitsSessionStorageCache = (0, $764d4a40d07f7ed3$export$b680e6b2c82f8c2f)((0, $bed699150dce830c$export$2e2bcd8739ae039), "import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/lib/infiniteHitsCache'");
$48737dfc970c14bb$var$instantsearch.highlight = (0, $764d4a40d07f7ed3$export$b680e6b2c82f8c2f)((0, $7406f687e3aa4bbe$export$2e2bcd8739ae039), "import { highlight } from 'instantsearch.js/es/helpers'");
$48737dfc970c14bb$var$instantsearch.reverseHighlight = (0, $764d4a40d07f7ed3$export$b680e6b2c82f8c2f)((0, $252f56918a3355b2$export$2e2bcd8739ae039), "import { reverseHighlight } from 'instantsearch.js/es/helpers'");
$48737dfc970c14bb$var$instantsearch.snippet = (0, $764d4a40d07f7ed3$export$b680e6b2c82f8c2f)((0, $e443915becc5e204$export$2e2bcd8739ae039), "import { snippet } from 'instantsearch.js/es/helpers'");
$48737dfc970c14bb$var$instantsearch.reverseSnippet = (0, $764d4a40d07f7ed3$export$b680e6b2c82f8c2f)((0, $6a226ae052dfdaa0$export$2e2bcd8739ae039), "import { reverseSnippet } from 'instantsearch.js/es/helpers'");
$48737dfc970c14bb$var$instantsearch.insights = (0, $0960a378c85a0fdc$export$2e2bcd8739ae039);
$48737dfc970c14bb$var$instantsearch.getInsightsAnonymousUserToken = (0, $62e320c3ff1379b2$export$2e2bcd8739ae039);
Object.defineProperty($48737dfc970c14bb$var$instantsearch, "widgets", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.widgets\" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from 'instantsearch.js/es/widgets'");
    }
});
Object.defineProperty($48737dfc970c14bb$var$instantsearch, "connectors", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.connectors\" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from 'instantsearch.js/es/connectors'");
    }
});
Object.defineProperty($48737dfc970c14bb$var$instantsearch, "templates", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.templates\" are not available from the ES build.\n\nTo import the templates:\n\nimport { carousel } from 'instantsearch.js/es/templates'");
    }
});
var $48737dfc970c14bb$export$2e2bcd8739ae039 = $48737dfc970c14bb$var$instantsearch;


function $6d13b29dffb7bdff$export$a274e22fb40f762e() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.reduce(function(acc, className) {
        if (Array.isArray(className)) return acc.concat(className);
        return acc.concat([
            className
        ]);
    }, []).filter(Boolean).join(" ");
}


var $fd5c1591a458e61e$var$n, $fd5c1591a458e61e$export$41c562ebe57d11e2, $fd5c1591a458e61e$var$u, $fd5c1591a458e61e$export$a8257692ac88316c, $fd5c1591a458e61e$var$i, $fd5c1591a458e61e$var$r, $fd5c1591a458e61e$var$o, $fd5c1591a458e61e$var$e, $fd5c1591a458e61e$var$f, $fd5c1591a458e61e$var$c, $fd5c1591a458e61e$var$s, $fd5c1591a458e61e$var$a, $fd5c1591a458e61e$var$h, $fd5c1591a458e61e$var$p = {}, $fd5c1591a458e61e$var$v = [], $fd5c1591a458e61e$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $fd5c1591a458e61e$var$d = Array.isArray;
function $fd5c1591a458e61e$var$w(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $fd5c1591a458e61e$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $fd5c1591a458e61e$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $fd5c1591a458e61e$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $fd5c1591a458e61e$var$m(l, e, i, r, null);
}
function $fd5c1591a458e61e$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$fd5c1591a458e61e$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $fd5c1591a458e61e$export$41c562ebe57d11e2.vnode && $fd5c1591a458e61e$export$41c562ebe57d11e2.vnode(e), e;
}
function $fd5c1591a458e61e$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $fd5c1591a458e61e$export$ffb0004e005737fa(n) {
    return n.children;
}
function $fd5c1591a458e61e$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $fd5c1591a458e61e$var$S(n, l) {
    if (null == l) return n.__ ? $fd5c1591a458e61e$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $fd5c1591a458e61e$var$S(n) : null;
}
function $fd5c1591a458e61e$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $fd5c1591a458e61e$var$C(n);
    }
}
function $fd5c1591a458e61e$var$M(n) {
    (!n.__d && (n.__d = !0) && $fd5c1591a458e61e$var$i.push(n) && !$fd5c1591a458e61e$var$$.__r++ || $fd5c1591a458e61e$var$r !== $fd5c1591a458e61e$export$41c562ebe57d11e2.debounceRendering) && (($fd5c1591a458e61e$var$r = $fd5c1591a458e61e$export$41c562ebe57d11e2.debounceRendering) || $fd5c1591a458e61e$var$o)($fd5c1591a458e61e$var$$);
}
function $fd5c1591a458e61e$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $fd5c1591a458e61e$var$i.length;)$fd5c1591a458e61e$var$i.length > s && $fd5c1591a458e61e$var$i.sort($fd5c1591a458e61e$var$e), n = $fd5c1591a458e61e$var$i.shift(), s = $fd5c1591a458e61e$var$i.length, n.__d && (t = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $fd5c1591a458e61e$var$w({}, r)).__v = r.__v + 1, $fd5c1591a458e61e$export$41c562ebe57d11e2.vnode && $fd5c1591a458e61e$export$41c562ebe57d11e2.vnode(t), $fd5c1591a458e61e$var$j(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $fd5c1591a458e61e$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $fd5c1591a458e61e$var$z(f, t, c), t.__e != o && $fd5c1591a458e61e$var$C(t)));
    $fd5c1591a458e61e$var$$.__r = 0;
}
function $fd5c1591a458e61e$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, d, w, g, _ = t && t.__k || $fd5c1591a458e61e$var$v, m = l.length;
    for(f = $fd5c1591a458e61e$var$P(u, l, _, f, m), a = 0; a < m; a++)null != (y = u.__k[a]) && (h = -1 === y.__i ? $fd5c1591a458e61e$var$p : _[y.__i] || $fd5c1591a458e61e$var$p, y.__i = a, g = $fd5c1591a458e61e$var$j(n, y, h, i, r, o, e, f, c, s), d = y.__e, y.ref && h.ref != y.ref && (h.ref && $fd5c1591a458e61e$var$V(h.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 4 & y.__u || h.__k === y.__k ? f = $fd5c1591a458e61e$var$A(y, f, n) : "function" == typeof y.type && void 0 !== g ? f = g : d && (f = d.nextSibling), y.__u &= -7);
    return u.__e = w, f;
}
function $fd5c1591a458e61e$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? $fd5c1591a458e61e$var$m(null, o, null, null, null) : $fd5c1591a458e61e$var$d(o) ? $fd5c1591a458e61e$var$m($fd5c1591a458e61e$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : void 0 === o.constructor && o.__b > 0 ? $fd5c1591a458e61e$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 !== (c = o.__i = $fd5c1591a458e61e$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null === e.__v ? (-1 == c && h--, "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $fd5c1591a458e61e$var$S(e)), $fd5c1591a458e61e$var$q(e, e));
    return t;
}
function $fd5c1591a458e61e$var$A(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $fd5c1591a458e61e$var$A(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $fd5c1591a458e61e$var$S(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $fd5c1591a458e61e$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($fd5c1591a458e61e$var$d(n) ? n.some(function(n) {
        $fd5c1591a458e61e$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $fd5c1591a458e61e$var$L(n, l, u, t) {
    var i, r, o = n.key, e = n.type, f = l[u];
    if (null === f || f && o == f.key && e === f.type && 0 == (2 & f.__u)) return u;
    if (t > (null != f && 0 == (2 & f.__u) ? 1 : 0)) for(i = u - 1, r = u + 1; i >= 0 || r < l.length;){
        if (i >= 0) {
            if ((f = l[i]) && 0 == (2 & f.__u) && o == f.key && e === f.type) return i;
            i--;
        }
        if (r < l.length) {
            if ((f = l[r]) && 0 == (2 & f.__u) && o == f.key && e === f.type) return r;
            r++;
        }
    }
    return -1;
}
function $fd5c1591a458e61e$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $fd5c1591a458e61e$var$y.test(l) ? u : u + "px";
}
function $fd5c1591a458e61e$var$F(n, l, u, t, i) {
    var r;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $fd5c1591a458e61e$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $fd5c1591a458e61e$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($fd5c1591a458e61e$var$f, "$1")), l = l.toLowerCase() in n || "onFocusOut" == l || "onFocusIn" == l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $fd5c1591a458e61e$var$c, n.addEventListener(l, r ? $fd5c1591a458e61e$var$a : $fd5c1591a458e61e$var$s, r)) : n.removeEventListener(l, r ? $fd5c1591a458e61e$var$a : $fd5c1591a458e61e$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $fd5c1591a458e61e$var$O(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $fd5c1591a458e61e$var$c++;
            else if (u.t < t.u) return;
            return t($fd5c1591a458e61e$export$41c562ebe57d11e2.event ? $fd5c1591a458e61e$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $fd5c1591a458e61e$var$j(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, F, O = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $fd5c1591a458e61e$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof O) try {
        if (b = u.props, S = "prototype" in O && O.prototype.render, C = (a = O.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new O(b, M) : (u.__c = h = new $fd5c1591a458e61e$export$16fa2f45be04daa8(b, M), h.constructor = O, h.render = $fd5c1591a458e61e$var$B), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != O.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $fd5c1591a458e61e$var$w({}, h.__s)), $fd5c1591a458e61e$var$w(h.__s, O.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == O.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == O.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v)) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $fd5c1591a458e61e$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $fd5c1591a458e61e$var$w($fd5c1591a458e61e$var$w({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), T = (L = null != a && a.type === $fd5c1591a458e61e$export$ffb0004e005737fa && null == a.key) ? a.props.children : a, L && (a.props.children = null), f = $fd5c1591a458e61e$var$I(n, $fd5c1591a458e61e$var$d(T) ? T : [
            T
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else for(F = o.length; F--;)$fd5c1591a458e61e$var$g(o[F]);
        } else u.__e = t.__e, u.__k = t.__k;
        $fd5c1591a458e61e$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $fd5c1591a458e61e$var$N(t.__e, u, t, i, r, o, e, c, s);
    return (a = $fd5c1591a458e61e$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $fd5c1591a458e61e$var$z(n, u, t) {
    for(var i = 0; i < t.length; i++)$fd5c1591a458e61e$var$V(t[i], t[++i], t[++i]);
    $fd5c1591a458e61e$export$41c562ebe57d11e2.__c && $fd5c1591a458e61e$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $fd5c1591a458e61e$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $fd5c1591a458e61e$var$N(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, w, _, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((w = e[a]) && "setAttribute" in w == !!x && (x ? w.localName == x : 3 == w.nodeType)) {
            u = w, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($fd5c1591a458e61e$export$41c562ebe57d11e2.__m && $fd5c1591a458e61e$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null === x) b === k || c && u.data === k || (u.data = k);
    else {
        if (e = e && $fd5c1591a458e61e$var$n.call(u.childNodes), b = i.props || $fd5c1591a458e61e$var$p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(w = u.attributes[a]).name] = w.value;
        for(a in b)if (w = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = w;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $fd5c1591a458e61e$var$F(u, a, null, w, o);
        }
        for(a in k)w = k[a], "children" == a ? y = w : "dangerouslySetInnerHTML" == a ? h = w : "value" == a ? _ = w : "checked" == a ? m = w : c && "function" != typeof w || b[a] === w || $fd5c1591a458e61e$var$F(u, a, w, b[a], o);
        if (h) c || v && (h.__html === v.__html || h.__html === u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $fd5c1591a458e61e$var$I("template" === t.type ? u.content : u, $fd5c1591a458e61e$var$d(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $fd5c1591a458e61e$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$fd5c1591a458e61e$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : void 0 !== _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ !== b[a]) && $fd5c1591a458e61e$var$F(u, a, _, b[a], o), a = "checked", void 0 !== m && m !== u[a] && $fd5c1591a458e61e$var$F(u, a, m, b[a], o));
    }
    return u;
}
function $fd5c1591a458e61e$var$V(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $fd5c1591a458e61e$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $fd5c1591a458e61e$var$q(n, u, t) {
    var i, r;
    if ($fd5c1591a458e61e$export$41c562ebe57d11e2.unmount && $fd5c1591a458e61e$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $fd5c1591a458e61e$var$V(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $fd5c1591a458e61e$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $fd5c1591a458e61e$var$q(i[r], u, t || "function" != typeof n.type);
    t || $fd5c1591a458e61e$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $fd5c1591a458e61e$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $fd5c1591a458e61e$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $fd5c1591a458e61e$export$41c562ebe57d11e2.__ && $fd5c1591a458e61e$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $fd5c1591a458e61e$var$j(t, u = (!r && i || t).__k = $fd5c1591a458e61e$export$c8a8987d4410bf2d($fd5c1591a458e61e$export$ffb0004e005737fa, null, [
        u
    ]), o || $fd5c1591a458e61e$var$p, $fd5c1591a458e61e$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $fd5c1591a458e61e$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $fd5c1591a458e61e$var$z(e, u, f);
}
function $fd5c1591a458e61e$export$fa8d919ba61d84db(n, l) {
    $fd5c1591a458e61e$export$b3890eb0ae9dca99(n, l, $fd5c1591a458e61e$export$fa8d919ba61d84db);
}
function $fd5c1591a458e61e$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $fd5c1591a458e61e$var$w({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && void 0 !== e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $fd5c1591a458e61e$var$n.call(arguments, 2) : t), $fd5c1591a458e61e$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $fd5c1591a458e61e$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value !== n.value && u.forEach(function(n) {
                n.__e = !0, $fd5c1591a458e61e$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $fd5c1591a458e61e$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$fd5c1591a458e61e$var$n = $fd5c1591a458e61e$var$v.slice, $fd5c1591a458e61e$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $fd5c1591a458e61e$var$u = 0, $fd5c1591a458e61e$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $fd5c1591a458e61e$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $fd5c1591a458e61e$var$w({}, this.state), "function" == typeof n && (n = n($fd5c1591a458e61e$var$w({}, u), this.props)), n && $fd5c1591a458e61e$var$w(u, n), null != n && this.__v && (l && this._sb.push(l), $fd5c1591a458e61e$var$M(this));
}, $fd5c1591a458e61e$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $fd5c1591a458e61e$var$M(this));
}, $fd5c1591a458e61e$export$16fa2f45be04daa8.prototype.render = $fd5c1591a458e61e$export$ffb0004e005737fa, $fd5c1591a458e61e$var$i = [], $fd5c1591a458e61e$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $fd5c1591a458e61e$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $fd5c1591a458e61e$var$$.__r = 0, $fd5c1591a458e61e$var$f = /(PointerCapture)$|Capture$/i, $fd5c1591a458e61e$var$c = 0, $fd5c1591a458e61e$var$s = $fd5c1591a458e61e$var$O(!1), $fd5c1591a458e61e$var$a = $fd5c1591a458e61e$var$O(!0), $fd5c1591a458e61e$var$h = 0;





var $a01e24a5991c23e2$var$t, $a01e24a5991c23e2$var$r, $a01e24a5991c23e2$var$u, $a01e24a5991c23e2$var$i, $a01e24a5991c23e2$var$o = 0, $a01e24a5991c23e2$var$f = [], $a01e24a5991c23e2$var$c = (0, $fd5c1591a458e61e$export$41c562ebe57d11e2), $a01e24a5991c23e2$var$e = $a01e24a5991c23e2$var$c.__b, $a01e24a5991c23e2$var$a = $a01e24a5991c23e2$var$c.__r, $a01e24a5991c23e2$var$v = $a01e24a5991c23e2$var$c.diffed, $a01e24a5991c23e2$var$l = $a01e24a5991c23e2$var$c.__c, $a01e24a5991c23e2$var$m = $a01e24a5991c23e2$var$c.unmount, $a01e24a5991c23e2$var$s = $a01e24a5991c23e2$var$c.__;
function $a01e24a5991c23e2$var$p(n, t) {
    $a01e24a5991c23e2$var$c.__h && $a01e24a5991c23e2$var$c.__h($a01e24a5991c23e2$var$r, n, $a01e24a5991c23e2$var$o || t), $a01e24a5991c23e2$var$o = 0;
    var u = $a01e24a5991c23e2$var$r.__H || ($a01e24a5991c23e2$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $a01e24a5991c23e2$export$60241385465d0a34(n) {
    return $a01e24a5991c23e2$var$o = 1, $a01e24a5991c23e2$export$13e3392192263954($a01e24a5991c23e2$var$D, n);
}
function $a01e24a5991c23e2$export$13e3392192263954(n, u, i) {
    var o = $a01e24a5991c23e2$var$p($a01e24a5991c23e2$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $a01e24a5991c23e2$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $a01e24a5991c23e2$var$r, !$a01e24a5991c23e2$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $a01e24a5991c23e2$var$r.__f = !0;
        var c = $a01e24a5991c23e2$var$r.shouldComponentUpdate, e = $a01e24a5991c23e2$var$r.componentWillUpdate;
        $a01e24a5991c23e2$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $a01e24a5991c23e2$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $a01e24a5991c23e2$export$6d9c69b0de29b591(n, u) {
    var i = $a01e24a5991c23e2$var$p($a01e24a5991c23e2$var$t++, 3);
    !$a01e24a5991c23e2$var$c.__s && $a01e24a5991c23e2$var$C(i.__H, u) && (i.__ = n, i.u = u, $a01e24a5991c23e2$var$r.__H.__h.push(i));
}
function $a01e24a5991c23e2$export$e5c5a5f917a5871c(n, u) {
    var i = $a01e24a5991c23e2$var$p($a01e24a5991c23e2$var$t++, 4);
    !$a01e24a5991c23e2$var$c.__s && $a01e24a5991c23e2$var$C(i.__H, u) && (i.__ = n, i.u = u, $a01e24a5991c23e2$var$r.__h.push(i));
}
function $a01e24a5991c23e2$export$b8f5890fc79d6aca(n) {
    return $a01e24a5991c23e2$var$o = 5, $a01e24a5991c23e2$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $a01e24a5991c23e2$export$d5a552a76deda3c2(n, t, r) {
    $a01e24a5991c23e2$var$o = 6, $a01e24a5991c23e2$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $a01e24a5991c23e2$export$1538c33de8887b59(n, r) {
    var u = $a01e24a5991c23e2$var$p($a01e24a5991c23e2$var$t++, 7);
    return $a01e24a5991c23e2$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $a01e24a5991c23e2$export$35808ee640e87ca7(n, t) {
    return $a01e24a5991c23e2$var$o = 8, $a01e24a5991c23e2$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $a01e24a5991c23e2$export$fae74005e78b1a27(n) {
    var u = $a01e24a5991c23e2$var$r.context[n.__c], i = $a01e24a5991c23e2$var$p($a01e24a5991c23e2$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($a01e24a5991c23e2$var$r)), u.props.value) : n.__;
}
function $a01e24a5991c23e2$export$dc8fbce3eb94dc1e(n, t) {
    $a01e24a5991c23e2$var$c.useDebugValue && $a01e24a5991c23e2$var$c.useDebugValue(t ? t(n) : n);
}
function $a01e24a5991c23e2$export$c052f6604b7d51fe(n) {
    var u = $a01e24a5991c23e2$var$p($a01e24a5991c23e2$var$t++, 10), i = $a01e24a5991c23e2$export$60241385465d0a34();
    return u.__ = n, $a01e24a5991c23e2$var$r.componentDidCatch || ($a01e24a5991c23e2$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $a01e24a5991c23e2$export$f680877a34711e37() {
    var n = $a01e24a5991c23e2$var$p($a01e24a5991c23e2$var$t++, 11);
    if (!n.__) {
        for(var u = $a01e24a5991c23e2$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $a01e24a5991c23e2$var$j() {
    for(var n; n = $a01e24a5991c23e2$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($a01e24a5991c23e2$var$z), n.__H.__h.forEach($a01e24a5991c23e2$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $a01e24a5991c23e2$var$c.__e(t, n.__v);
    }
}
$a01e24a5991c23e2$var$c.__b = function(n) {
    $a01e24a5991c23e2$var$r = null, $a01e24a5991c23e2$var$e && $a01e24a5991c23e2$var$e(n);
}, $a01e24a5991c23e2$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $a01e24a5991c23e2$var$s && $a01e24a5991c23e2$var$s(n, t);
}, $a01e24a5991c23e2$var$c.__r = function(n) {
    $a01e24a5991c23e2$var$a && $a01e24a5991c23e2$var$a(n), $a01e24a5991c23e2$var$t = 0;
    var i = ($a01e24a5991c23e2$var$r = n.__c).__H;
    i && ($a01e24a5991c23e2$var$u === $a01e24a5991c23e2$var$r ? (i.__h = [], $a01e24a5991c23e2$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($a01e24a5991c23e2$var$z), i.__h.forEach($a01e24a5991c23e2$var$B), i.__h = [], $a01e24a5991c23e2$var$t = 0)), $a01e24a5991c23e2$var$u = $a01e24a5991c23e2$var$r;
}, $a01e24a5991c23e2$var$c.diffed = function(n) {
    $a01e24a5991c23e2$var$v && $a01e24a5991c23e2$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $a01e24a5991c23e2$var$f.push(t) && $a01e24a5991c23e2$var$i === $a01e24a5991c23e2$var$c.requestAnimationFrame || (($a01e24a5991c23e2$var$i = $a01e24a5991c23e2$var$c.requestAnimationFrame) || $a01e24a5991c23e2$var$w)($a01e24a5991c23e2$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $a01e24a5991c23e2$var$u = $a01e24a5991c23e2$var$r = null;
}, $a01e24a5991c23e2$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($a01e24a5991c23e2$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $a01e24a5991c23e2$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $a01e24a5991c23e2$var$c.__e(r, n.__v);
        }
    }), $a01e24a5991c23e2$var$l && $a01e24a5991c23e2$var$l(n, t);
}, $a01e24a5991c23e2$var$c.unmount = function(n) {
    $a01e24a5991c23e2$var$m && $a01e24a5991c23e2$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $a01e24a5991c23e2$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $a01e24a5991c23e2$var$c.__e(t, r.__v));
};
var $a01e24a5991c23e2$var$k = "function" == typeof requestAnimationFrame;
function $a01e24a5991c23e2$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $a01e24a5991c23e2$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $a01e24a5991c23e2$var$k && (t = requestAnimationFrame(r));
}
function $a01e24a5991c23e2$var$z(n) {
    var t = $a01e24a5991c23e2$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $a01e24a5991c23e2$var$r = t;
}
function $a01e24a5991c23e2$var$B(n) {
    var t = $a01e24a5991c23e2$var$r;
    n.__c = n.__(), $a01e24a5991c23e2$var$r = t;
}
function $a01e24a5991c23e2$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $a01e24a5991c23e2$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}



var $31c9ff34a9353855$exports = {};
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ // This file is for use with Node.js. See dist/ for browser files.
var $05624f8025399071$exports = {};
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ (function(Hogan) {
    // Setup regex  assignments
    // remove whitespace according to Mustache spec
    var rIsWhitespace = /\S/, rQuot = /\"/g, rNewline = /\n/g, rCr = /\r/g, rSlash = /\\/g, rLineSep = /\u2028/, rParagraphSep = /\u2029/;
    Hogan.tags = {
        "#": 1,
        "^": 2,
        "<": 3,
        "$": 4,
        "/": 5,
        "!": 6,
        ">": 7,
        "=": 8,
        "_v": 9,
        "{": 10,
        "&": 11,
        "_t": 12
    };
    Hogan.scan = function scan(text, delimiters) {
        var len = text.length, IN_TEXT = 0, IN_TAG_TYPE = 1, IN_TAG = 2, state = IN_TEXT, tagType = null, tag = null, buf = "", tokens = [], seenTag = false, i = 0, lineStart = 0, otag = "{{", ctag = "}}";
        function addBuf() {
            if (buf.length > 0) {
                tokens.push({
                    tag: "_t",
                    text: new String(buf)
                });
                buf = "";
            }
        }
        function lineIsWhitespace() {
            var isAllWhitespace = true;
            for(var j = lineStart; j < tokens.length; j++){
                isAllWhitespace = Hogan.tags[tokens[j].tag] < Hogan.tags["_v"] || tokens[j].tag == "_t" && tokens[j].text.match(rIsWhitespace) === null;
                if (!isAllWhitespace) return false;
            }
            return isAllWhitespace;
        }
        function filterLine(haveSeenTag, noNewLine) {
            addBuf();
            if (haveSeenTag && lineIsWhitespace()) {
                for(var j = lineStart, next; j < tokens.length; j++)if (tokens[j].text) {
                    if ((next = tokens[j + 1]) && next.tag == ">") // set indent to token value
                    next.indent = tokens[j].text.toString();
                    tokens.splice(j, 1);
                }
            } else if (!noNewLine) tokens.push({
                tag: "\n"
            });
            seenTag = false;
            lineStart = tokens.length;
        }
        function changeDelimiters(text, index) {
            var close = "=" + ctag, closeIndex = text.indexOf(close, index), delimiters = trim(text.substring(text.indexOf("=", index) + 1, closeIndex)).split(" ");
            otag = delimiters[0];
            ctag = delimiters[delimiters.length - 1];
            return closeIndex + close.length - 1;
        }
        if (delimiters) {
            delimiters = delimiters.split(" ");
            otag = delimiters[0];
            ctag = delimiters[1];
        }
        for(i = 0; i < len; i++){
            if (state == IN_TEXT) {
                if (tagChange(otag, text, i)) {
                    --i;
                    addBuf();
                    state = IN_TAG_TYPE;
                } else if (text.charAt(i) == "\n") filterLine(seenTag);
                else buf += text.charAt(i);
            } else if (state == IN_TAG_TYPE) {
                i += otag.length - 1;
                tag = Hogan.tags[text.charAt(i + 1)];
                tagType = tag ? text.charAt(i + 1) : "_v";
                if (tagType == "=") {
                    i = changeDelimiters(text, i);
                    state = IN_TEXT;
                } else {
                    if (tag) i++;
                    state = IN_TAG;
                }
                seenTag = i;
            } else if (tagChange(ctag, text, i)) {
                tokens.push({
                    tag: tagType,
                    n: trim(buf),
                    otag: otag,
                    ctag: ctag,
                    i: tagType == "/" ? seenTag - otag.length : i + ctag.length
                });
                buf = "";
                i += ctag.length - 1;
                state = IN_TEXT;
                if (tagType == "{") {
                    if (ctag == "}}") i++;
                    else cleanTripleStache(tokens[tokens.length - 1]);
                }
            } else buf += text.charAt(i);
        }
        filterLine(seenTag, true);
        return tokens;
    };
    function cleanTripleStache(token) {
        if (token.n.substr(token.n.length - 1) === "}") token.n = token.n.substring(0, token.n.length - 1);
    }
    function trim(s) {
        if (s.trim) return s.trim();
        return s.replace(/^\s*|\s*$/g, "");
    }
    function tagChange(tag, text, index) {
        if (text.charAt(index) != tag.charAt(0)) return false;
        for(var i = 1, l = tag.length; i < l; i++){
            if (text.charAt(index + i) != tag.charAt(i)) return false;
        }
        return true;
    }
    // the tags allowed inside super templates
    var allowedInSuper = {
        "_t": true,
        "\n": true,
        "$": true,
        "/": true
    };
    function buildTree(tokens, kind, stack, customTags) {
        var instructions = [], opener = null, tail = null, token = null;
        tail = stack[stack.length - 1];
        while(tokens.length > 0){
            token = tokens.shift();
            if (tail && tail.tag == "<" && !(token.tag in allowedInSuper)) throw new Error("Illegal content in < super tag.");
            if (Hogan.tags[token.tag] <= Hogan.tags["$"] || isOpener(token, customTags)) {
                stack.push(token);
                token.nodes = buildTree(tokens, token.tag, stack, customTags);
            } else if (token.tag == "/") {
                if (stack.length === 0) throw new Error("Closing tag without opener: /" + token.n);
                opener = stack.pop();
                if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) throw new Error("Nesting error: " + opener.n + " vs. " + token.n);
                opener.end = token.i;
                return instructions;
            } else if (token.tag == "\n") token.last = tokens.length == 0 || tokens[0].tag == "\n";
            instructions.push(token);
        }
        if (stack.length > 0) throw new Error("missing closing tag: " + stack.pop().n);
        return instructions;
    }
    function isOpener(token, tags) {
        for(var i = 0, l = tags.length; i < l; i++)if (tags[i].o == token.n) {
            token.tag = "#";
            return true;
        }
    }
    function isCloser(close, open, tags) {
        for(var i = 0, l = tags.length; i < l; i++){
            if (tags[i].c == close && tags[i].o == open) return true;
        }
    }
    function stringifySubstitutions(obj) {
        var items = [];
        for(var key in obj)items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + "}");
        return "{ " + items.join(",") + " }";
    }
    function stringifyPartials(codeObj) {
        var partials = [];
        for(var key in codeObj.partials)partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
        return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
    }
    Hogan.stringify = function(codeObj, text, options) {
        return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) + "}";
    };
    var serialNo = 0;
    Hogan.generate = function(tree, text, options) {
        serialNo = 0;
        var context = {
            code: "",
            subs: {},
            partials: {}
        };
        Hogan.walk(tree, context);
        if (options.asString) return this.stringify(context, text, options);
        return this.makeTemplate(context, text, options);
    };
    Hogan.wrapMain = function(code) {
        return 'var t=this;t.b(i=i||"");' + code + "return t.fl();";
    };
    Hogan.template = Hogan.Template;
    Hogan.makeTemplate = function(codeObj, text, options) {
        var template = this.makePartials(codeObj);
        template.code = new Function("c", "p", "i", this.wrapMain(codeObj.code));
        return new this.template(template, text, this, options);
    };
    Hogan.makePartials = function(codeObj) {
        var key, template = {
            subs: {},
            partials: codeObj.partials,
            name: codeObj.name
        };
        for(key in template.partials)template.partials[key] = this.makePartials(template.partials[key]);
        for(key in codeObj.subs)template.subs[key] = new Function("c", "p", "t", "i", codeObj.subs[key]);
        return template;
    };
    function esc(s) {
        return s.replace(rSlash, "\\\\").replace(rQuot, '\\"').replace(rNewline, "\\n").replace(rCr, "\\r").replace(rLineSep, "\\u2028").replace(rParagraphSep, "\\u2029");
    }
    function chooseMethod(s) {
        return ~s.indexOf(".") ? "d" : "f";
    }
    function createPartial(node, context) {
        var prefix = "<" + (context.prefix || "");
        var sym = prefix + node.n + serialNo++;
        context.partials[sym] = {
            name: node.n,
            partials: {}
        };
        context.code += 't.b(t.rp("' + esc(sym) + '",c,p,"' + (node.indent || "") + '"));';
        return sym;
    }
    Hogan.codegen = {
        "#": function(node, context) {
            context.code += "if(t.s(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' + "c,p,0," + node.i + "," + node.end + ',"' + node.otag + " " + node.ctag + '")){' + "t.rs(c,p," + "function(c,p,t){";
            Hogan.walk(node.nodes, context);
            context.code += "});c.pop();}";
        },
        "^": function(node, context) {
            context.code += "if(!t.s(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
            Hogan.walk(node.nodes, context);
            context.code += "};";
        },
        ">": createPartial,
        "<": function(node, context) {
            var ctx = {
                partials: {},
                code: "",
                subs: {},
                inPartial: true
            };
            Hogan.walk(node.nodes, ctx);
            var template = context.partials[createPartial(node, context)];
            template.subs = ctx.subs;
            template.partials = ctx.partials;
        },
        "$": function(node, context) {
            var ctx = {
                subs: {},
                code: "",
                partials: context.partials,
                prefix: node.n
            };
            Hogan.walk(node.nodes, ctx);
            context.subs[node.n] = ctx.code;
            if (!context.inPartial) context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
        },
        "\n": function(node, context) {
            context.code += write('"\\n"' + (node.last ? "" : " + i"));
        },
        "_v": function(node, context) {
            context.code += "t.b(t.v(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
        },
        "_t": function(node, context) {
            context.code += write('"' + esc(node.text) + '"');
        },
        "{": tripleStache,
        "&": tripleStache
    };
    function tripleStache(node, context) {
        context.code += "t.b(t.t(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    }
    function write(s) {
        return "t.b(" + s + ");";
    }
    Hogan.walk = function(nodelist, context) {
        var func;
        for(var i = 0, l = nodelist.length; i < l; i++){
            func = Hogan.codegen[nodelist[i].tag];
            func && func(nodelist[i], context);
        }
        return context;
    };
    Hogan.parse = function(tokens, text, options) {
        options = options || {};
        return buildTree(tokens, "", [], options.sectionTags || []);
    };
    Hogan.cache = {};
    Hogan.cacheKey = function(text, options) {
        return [
            text,
            !!options.asString,
            !!options.disableLambda,
            options.delimiters,
            !!options.modelGet
        ].join("||");
    };
    Hogan.compile = function(text, options) {
        options = options || {};
        var key = Hogan.cacheKey(text, options);
        var template = this.cache[key];
        if (template) {
            var partials = template.partials;
            for(var name in partials)delete partials[name].instance;
            return template;
        }
        template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
        return this.cache[key] = template;
    };
})($05624f8025399071$exports);



$05624f8025399071$exports.Template = (parcelRequire("hwIuZ")).Template;
$05624f8025399071$exports.template = $05624f8025399071$exports.Template;
$31c9ff34a9353855$exports = $05624f8025399071$exports;



var $7b199b72ddebcffc$var$n = function(t, s, r, e) {
    var u;
    s[0] = 0;
    for(var h = 1; h < s.length; h++){
        var p = s[h++], a = s[h] ? (s[0] |= p ? 1 : 2, r[s[h++]]) : s[++h];
        3 === p ? e[0] = a : 4 === p ? e[1] = Object.assign(e[1] || {}, a) : 5 === p ? (e[1] = e[1] || {})[s[++h]] = a : 6 === p ? e[1][s[++h]] += a + "" : p ? (u = t.apply(a, $7b199b72ddebcffc$var$n(t, a, r, [
            "",
            null
        ])), e.push(u), a[0] ? s[0] |= 2 : (s[h - 2] = 0, s[h] = u)) : e.push(a);
    }
    return e;
}, $7b199b72ddebcffc$var$t = new Map;
function $7b199b72ddebcffc$export$2e2bcd8739ae039(s) {
    var r = $7b199b72ddebcffc$var$t.get(this);
    return r || (r = new Map, $7b199b72ddebcffc$var$t.set(this, r)), (r = $7b199b72ddebcffc$var$n(this, r.get(s) || (r.set(s, r = function(n) {
        for(var t, s, r = 1, e = "", u = "", h = [
            0
        ], p = function(n) {
            1 === r && (n || (e = e.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? h.push(0, n, e) : 3 === r && (n || e) ? (h.push(3, n, e), r = 2) : 2 === r && "..." === e && n ? h.push(4, n, 0) : 2 === r && e && !n ? h.push(5, 0, !0, e) : r >= 5 && ((e || !n && 5 === r) && (h.push(r, 0, e, s), r = 6), n && (h.push(r, n, 0, s), r = 6)), e = "";
        }, a = 0; a < n.length; a++){
            a && (1 === r && p(), p(a));
            for(var l = 0; l < n[a].length; l++)t = n[a][l], 1 === r ? "<" === t ? (p(), h = [
                h
            ], r = 3) : e += t : 4 === r ? "--" === e && ">" === t ? (r = 1, e = "") : e = t + e[0] : u ? t === u ? u = "" : e += t : '"' === t || "'" === t ? u = t : ">" === t ? (p(), r = 1) : r && ("=" === t ? (r = 5, s = e, e = "") : "/" === t && (r < 5 || ">" === n[a][l + 1]) ? (p(), 3 === r && (h = h[0]), r = h, (h = h[0]).push(2, 0, r), r = 0) : " " === t || "	" === t || "\n" === t || "\r" === t ? (p(), r = 2) : e += t), 3 === r && "!--" === e && (r = 4, h = h[0]);
        }
        return p(), h;
    }(s)), r), arguments, [])).length > 1 ? r : r[0];
}


var $8d2478f1bb7b2a29$export$c0bb0b647f701bb5 = (0, $7b199b72ddebcffc$export$2e2bcd8739ae039).bind((0, $fd5c1591a458e61e$export$c8a8987d4410bf2d));





function $3f4dad95783025c7$export$2e2bcd8739ae039() {
    return $3f4dad95783025c7$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3f4dad95783025c7$export$2e2bcd8739ae039.apply(null, arguments);
}


function $470ffcf4c0843a46$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $e873bb60d4749aff$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $470ffcf4c0843a46$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $58de08214c488657$var$_excluded = [
    "parts",
    "highlightedTagName",
    "nonHighlightedTagName",
    "separator",
    "className",
    "classNames"
];
function $58de08214c488657$var$createHighlightPartComponent(_ref) {
    var createElement = _ref.createElement;
    return function HighlightPart(_ref2) {
        var classNames = _ref2.classNames, children = _ref2.children, highlightedTagName = _ref2.highlightedTagName, isHighlighted = _ref2.isHighlighted, nonHighlightedTagName = _ref2.nonHighlightedTagName;
        var TagName = isHighlighted ? highlightedTagName : nonHighlightedTagName;
        return createElement(TagName, {
            className: isHighlighted ? classNames.highlighted : classNames.nonHighlighted
        }, children);
    };
}
function $58de08214c488657$export$c8682df1c852a966(_ref3) {
    var createElement = _ref3.createElement, Fragment = _ref3.Fragment;
    var HighlightPart = $58de08214c488657$var$createHighlightPartComponent({
        createElement: createElement,
        Fragment: Fragment
    });
    return function Highlight(userProps) {
        var parts = userProps.parts, _userProps$highlighte = userProps.highlightedTagName, highlightedTagName = _userProps$highlighte === void 0 ? "mark" : _userProps$highlighte, _userProps$nonHighlig = userProps.nonHighlightedTagName, nonHighlightedTagName = _userProps$nonHighlig === void 0 ? "span" : _userProps$nonHighlig, _userProps$separator = userProps.separator, separator = _userProps$separator === void 0 ? ", " : _userProps$separator, className = userProps.className, _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, props = (0, $e873bb60d4749aff$export$2e2bcd8739ae039)(userProps, $58de08214c488657$var$_excluded);
        return createElement("span", (0, $3f4dad95783025c7$export$2e2bcd8739ae039)({}, props, {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(classNames.root, className)
        }), parts.map(function(part, partIndex) {
            var isLastPart = partIndex === parts.length - 1;
            return createElement(Fragment, {
                key: partIndex
            }, part.map(function(subPart, subPartIndex) {
                return createElement(HighlightPart, {
                    key: subPartIndex,
                    classNames: classNames,
                    highlightedTagName: highlightedTagName,
                    nonHighlightedTagName: nonHighlightedTagName,
                    isHighlighted: subPart.isHighlighted
                }, subPart.value);
            }), !isLastPart && createElement("span", {
                className: classNames.separator
            }, separator));
        }));
    };
}



var $34f1f59e97e1c36a$export$57a0c6fc80bec05c = (0, $58de08214c488657$export$c8682df1c852a966)({
    createElement: (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d),
    Fragment: (0, $fd5c1591a458e61e$export$ffb0004e005737fa)
});


var $50734be8f7df4273$var$_excluded = [
    "classNames"
];
function $50734be8f7df4273$var$_extends() {
    $50734be8f7df4273$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $50734be8f7df4273$var$_extends.apply(this, arguments);
}
function $50734be8f7df4273$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $50734be8f7df4273$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $50734be8f7df4273$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $50734be8f7df4273$export$39dbc3f558091353(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $50734be8f7df4273$var$_objectWithoutProperties(_ref, $50734be8f7df4273$var$_excluded);
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $34f1f59e97e1c36a$export$57a0c6fc80bec05c), $50734be8f7df4273$var$_extends({
        classNames: {
            root: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Highlight", classNames.root),
            highlighted: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Highlight-highlighted", classNames.highlighted),
            nonHighlighted: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Highlight-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Highlight-separator", classNames.separator)
        }
    }, props));
}


function $ed503148523a0fc1$export$45b10814cc054894(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}


var $4cc40a944072626d$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
];
function $4cc40a944072626d$var$_extends() {
    $4cc40a944072626d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4cc40a944072626d$var$_extends.apply(this, arguments);
}
function $4cc40a944072626d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4cc40a944072626d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4cc40a944072626d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4cc40a944072626d$export$39dbc3f558091353(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $4cc40a944072626d$var$_objectWithoutProperties(_ref, $4cc40a944072626d$var$_excluded);
    var property = (0, $b4f0c35eb9590d0c$export$d14846335956eefa)(hit._highlightResult, attribute) || [];
    var properties = (0, $ed503148523a0fc1$export$45b10814cc054894)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $40278fc744783199$export$e04d28e65b830ebf)((0, $272444c6ab685d67$export$e8bacd2802a88316)(value || ""));
    });
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $50734be8f7df4273$export$39dbc3f558091353), $4cc40a944072626d$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}





var $d1d14778903cbbf1$var$_excluded = [
    "classNames"
];
function $d1d14778903cbbf1$var$_extends() {
    $d1d14778903cbbf1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d1d14778903cbbf1$var$_extends.apply(this, arguments);
}
function $d1d14778903cbbf1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d1d14778903cbbf1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d1d14778903cbbf1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d1d14778903cbbf1$export$f346643e8570b662(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $d1d14778903cbbf1$var$_objectWithoutProperties(_ref, $d1d14778903cbbf1$var$_excluded);
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $34f1f59e97e1c36a$export$57a0c6fc80bec05c), $d1d14778903cbbf1$var$_extends({
        classNames: {
            root: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-ReverseHighlight", classNames.root),
            highlighted: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-ReverseHighlight-highlighted", classNames.highlighted),
            nonHighlighted: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-ReverseHighlight-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-ReverseHighlight-separator", classNames.separator)
        }
    }, props));
}



function $1a4aefda18002e98$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1a4aefda18002e98$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1a4aefda18002e98$var$_typeof(o);
}
var $1a4aefda18002e98$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
], $1a4aefda18002e98$var$_excluded2 = [
    "isHighlighted"
];
function $1a4aefda18002e98$var$_extends() {
    $1a4aefda18002e98$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a4aefda18002e98$var$_extends.apply(this, arguments);
}
function $1a4aefda18002e98$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a4aefda18002e98$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a4aefda18002e98$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1a4aefda18002e98$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a4aefda18002e98$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1a4aefda18002e98$var$_defineProperty(obj, key, value) {
    key = $1a4aefda18002e98$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1a4aefda18002e98$var$_toPropertyKey(t) {
    var i = $1a4aefda18002e98$var$_toPrimitive(t, "string");
    return "symbol" == $1a4aefda18002e98$var$_typeof(i) ? i : String(i);
}
function $1a4aefda18002e98$var$_toPrimitive(t, r) {
    if ("object" != $1a4aefda18002e98$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1a4aefda18002e98$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1a4aefda18002e98$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1a4aefda18002e98$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1a4aefda18002e98$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1a4aefda18002e98$export$f346643e8570b662(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $1a4aefda18002e98$var$_objectWithoutProperties(_ref, $1a4aefda18002e98$var$_excluded);
    var property = (0, $b4f0c35eb9590d0c$export$d14846335956eefa)(hit._highlightResult, attribute) || [];
    var properties = (0, $ed503148523a0fc1$export$45b10814cc054894)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $40278fc744783199$export$e04d28e65b830ebf)((0, $272444c6ab685d67$export$e8bacd2802a88316)(value || "")).map(function(_ref3) {
            var isHighlighted = _ref3.isHighlighted, rest = $1a4aefda18002e98$var$_objectWithoutProperties(_ref3, $1a4aefda18002e98$var$_excluded2);
            return $1a4aefda18002e98$var$_objectSpread($1a4aefda18002e98$var$_objectSpread({}, rest), {}, {
                isHighlighted: !isHighlighted
            });
        });
    });
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $d1d14778903cbbf1$export$f346643e8570b662), $1a4aefda18002e98$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}





var $a4af49f056526bd3$var$_excluded = [
    "classNames"
];
function $a4af49f056526bd3$var$_extends() {
    $a4af49f056526bd3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a4af49f056526bd3$var$_extends.apply(this, arguments);
}
function $a4af49f056526bd3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a4af49f056526bd3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a4af49f056526bd3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a4af49f056526bd3$export$235f9e0721ad46fa(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $a4af49f056526bd3$var$_objectWithoutProperties(_ref, $a4af49f056526bd3$var$_excluded);
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $34f1f59e97e1c36a$export$57a0c6fc80bec05c), $a4af49f056526bd3$var$_extends({
        classNames: {
            root: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-ReverseSnippet", classNames.root),
            highlighted: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-ReverseSnippet-highlighted", classNames.highlighted),
            nonHighlighted: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-ReverseSnippet-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-ReverseSnippet-separator", classNames.separator)
        }
    }, props));
}



function $d5abdf863d9ea711$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d5abdf863d9ea711$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d5abdf863d9ea711$var$_typeof(o);
}
var $d5abdf863d9ea711$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
], $d5abdf863d9ea711$var$_excluded2 = [
    "isHighlighted"
];
function $d5abdf863d9ea711$var$_extends() {
    $d5abdf863d9ea711$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d5abdf863d9ea711$var$_extends.apply(this, arguments);
}
function $d5abdf863d9ea711$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5abdf863d9ea711$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5abdf863d9ea711$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d5abdf863d9ea711$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5abdf863d9ea711$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d5abdf863d9ea711$var$_defineProperty(obj, key, value) {
    key = $d5abdf863d9ea711$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d5abdf863d9ea711$var$_toPropertyKey(t) {
    var i = $d5abdf863d9ea711$var$_toPrimitive(t, "string");
    return "symbol" == $d5abdf863d9ea711$var$_typeof(i) ? i : String(i);
}
function $d5abdf863d9ea711$var$_toPrimitive(t, r) {
    if ("object" != $d5abdf863d9ea711$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d5abdf863d9ea711$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d5abdf863d9ea711$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d5abdf863d9ea711$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d5abdf863d9ea711$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d5abdf863d9ea711$export$235f9e0721ad46fa(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $d5abdf863d9ea711$var$_objectWithoutProperties(_ref, $d5abdf863d9ea711$var$_excluded);
    var property = (0, $b4f0c35eb9590d0c$export$d14846335956eefa)(hit._snippetResult, attribute) || [];
    var properties = (0, $ed503148523a0fc1$export$45b10814cc054894)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $40278fc744783199$export$e04d28e65b830ebf)((0, $272444c6ab685d67$export$e8bacd2802a88316)(value || "")).map(function(_ref3) {
            var isHighlighted = _ref3.isHighlighted, rest = $d5abdf863d9ea711$var$_objectWithoutProperties(_ref3, $d5abdf863d9ea711$var$_excluded2);
            return $d5abdf863d9ea711$var$_objectSpread($d5abdf863d9ea711$var$_objectSpread({}, rest), {}, {
                isHighlighted: !isHighlighted
            });
        });
    });
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $a4af49f056526bd3$export$235f9e0721ad46fa), $d5abdf863d9ea711$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}





var $b4dc9170bc2ec424$var$_excluded = [
    "classNames"
];
function $b4dc9170bc2ec424$var$_extends() {
    $b4dc9170bc2ec424$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b4dc9170bc2ec424$var$_extends.apply(this, arguments);
}
function $b4dc9170bc2ec424$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b4dc9170bc2ec424$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b4dc9170bc2ec424$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b4dc9170bc2ec424$export$10c56fa12fda26f9(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $b4dc9170bc2ec424$var$_objectWithoutProperties(_ref, $b4dc9170bc2ec424$var$_excluded);
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $34f1f59e97e1c36a$export$57a0c6fc80bec05c), $b4dc9170bc2ec424$var$_extends({
        classNames: {
            root: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Snippet", classNames.root),
            highlighted: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Snippet-highlighted", classNames.highlighted),
            nonHighlighted: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Snippet-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Snippet-separator", classNames.separator)
        }
    }, props));
}



var $c44dee57f74b5c33$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
];
function $c44dee57f74b5c33$var$_extends() {
    $c44dee57f74b5c33$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c44dee57f74b5c33$var$_extends.apply(this, arguments);
}
function $c44dee57f74b5c33$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c44dee57f74b5c33$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c44dee57f74b5c33$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c44dee57f74b5c33$export$10c56fa12fda26f9(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $c44dee57f74b5c33$var$_objectWithoutProperties(_ref, $c44dee57f74b5c33$var$_excluded);
    var property = (0, $b4f0c35eb9590d0c$export$d14846335956eefa)(hit._snippetResult, attribute) || [];
    var properties = (0, $ed503148523a0fc1$export$45b10814cc054894)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $40278fc744783199$export$e04d28e65b830ebf)((0, $272444c6ab685d67$export$e8bacd2802a88316)(value || ""));
    });
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $b4dc9170bc2ec424$export$10c56fa12fda26f9), $c44dee57f74b5c33$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}


function $e5262e6e4ba60fe6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e5262e6e4ba60fe6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e5262e6e4ba60fe6$var$_typeof(o);
}
function $e5262e6e4ba60fe6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e5262e6e4ba60fe6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e5262e6e4ba60fe6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e5262e6e4ba60fe6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e5262e6e4ba60fe6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e5262e6e4ba60fe6$var$_defineProperty(obj, key, value) {
    key = $e5262e6e4ba60fe6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e5262e6e4ba60fe6$var$_toPropertyKey(t) {
    var i = $e5262e6e4ba60fe6$var$_toPrimitive(t, "string");
    return "symbol" == $e5262e6e4ba60fe6$var$_typeof(i) ? i : String(i);
}
function $e5262e6e4ba60fe6$var$_toPrimitive(t, r) {
    if ("object" != $e5262e6e4ba60fe6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e5262e6e4ba60fe6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// We add all our template helper methods to the template as lambdas. Note
// that lambdas in Mustache are supposed to accept a second argument of
// `render` to get the rendered value, not the literal `{{value}}`. But
// this is currently broken (see https://github.com/twitter/hogan.js/issues/222).
function $e5262e6e4ba60fe6$var$transformHelpersToHogan() {
    var helpers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var compileOptions = arguments.length > 1 ? arguments[1] : undefined;
    var data = arguments.length > 2 ? arguments[2] : undefined;
    return Object.keys(helpers).reduce(function(acc, helperKey) {
        return $e5262e6e4ba60fe6$var$_objectSpread($e5262e6e4ba60fe6$var$_objectSpread({}, acc), {}, $e5262e6e4ba60fe6$var$_defineProperty({}, helperKey, function() {
            var _this = this;
            return function(text) {
                var render = function render(value) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($31c9ff34a9353855$exports))).compile(value, compileOptions).render(_this);
                };
                return helpers[helperKey].call(data, text, render);
            };
        }));
    }, {});
}
function $e5262e6e4ba60fe6$export$b5c363744c17aeab(_ref) {
    var templates = _ref.templates, templateKey = _ref.templateKey, compileOptions = _ref.compileOptions, helpers = _ref.helpers, data = _ref.data, bindEvent = _ref.bindEvent, sendEvent = _ref.sendEvent;
    var template = templates[templateKey];
    if (typeof template !== "string" && typeof template !== "function") throw new Error("Template must be 'string' or 'function', was '".concat($e5262e6e4ba60fe6$var$_typeof(template), "' (key: ").concat(templateKey, ")"));
    if (typeof template === "function") {
        // @MAJOR no longer pass bindEvent when string templates are removed
        var params = bindEvent || {};
        params.html = (0, $8d2478f1bb7b2a29$export$c0bb0b647f701bb5);
        params.sendEvent = sendEvent;
        params.components = {
            Highlight: (0, $4cc40a944072626d$export$39dbc3f558091353),
            ReverseHighlight: (0, $1a4aefda18002e98$export$f346643e8570b662),
            Snippet: (0, $c44dee57f74b5c33$export$10c56fa12fda26f9),
            ReverseSnippet: (0, $d5abdf863d9ea711$export$235f9e0721ad46fa)
        };
        // @MAJOR remove the `as any` when string templates are removed
        // needed because not every template receives sendEvent
        return template(data, params);
    }
    var transformedHelpers = $e5262e6e4ba60fe6$var$transformHelpersToHogan(helpers, compileOptions, data);
    return (0, (/*@__PURE__*/$parcel$interopDefault($31c9ff34a9353855$exports))).compile(template, compileOptions).render($e5262e6e4ba60fe6$var$_objectSpread($e5262e6e4ba60fe6$var$_objectSpread({}, data), {}, {
        helpers: transformedHelpers
    })).replace(/[ \n\r\t\f\xA0]+/g, function(spaces) {
        return spaces.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ");
    }).trim();
}



function $3d665ba039c115b1$var$_extends() {
    $3d665ba039c115b1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3d665ba039c115b1$var$_extends.apply(this, arguments);
}
function $3d665ba039c115b1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3d665ba039c115b1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3d665ba039c115b1$var$_typeof(o);
}
function $3d665ba039c115b1$var$_toConsumableArray(arr) {
    return $3d665ba039c115b1$var$_arrayWithoutHoles(arr) || $3d665ba039c115b1$var$_iterableToArray(arr) || $3d665ba039c115b1$var$_unsupportedIterableToArray(arr) || $3d665ba039c115b1$var$_nonIterableSpread();
}
function $3d665ba039c115b1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3d665ba039c115b1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3d665ba039c115b1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3d665ba039c115b1$var$_arrayLikeToArray(o, minLen);
}
function $3d665ba039c115b1$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3d665ba039c115b1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3d665ba039c115b1$var$_arrayLikeToArray(arr);
}
function $3d665ba039c115b1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3d665ba039c115b1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3d665ba039c115b1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3d665ba039c115b1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3d665ba039c115b1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3d665ba039c115b1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3d665ba039c115b1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3d665ba039c115b1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3d665ba039c115b1$var$_setPrototypeOf(subClass, superClass);
}
function $3d665ba039c115b1$var$_setPrototypeOf(o, p) {
    $3d665ba039c115b1$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3d665ba039c115b1$var$_setPrototypeOf(o, p);
}
function $3d665ba039c115b1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3d665ba039c115b1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3d665ba039c115b1$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3d665ba039c115b1$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3d665ba039c115b1$var$_possibleConstructorReturn(this, result);
    };
}
function $3d665ba039c115b1$var$_possibleConstructorReturn(self, call) {
    if (call && ($3d665ba039c115b1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3d665ba039c115b1$var$_assertThisInitialized(self);
}
function $3d665ba039c115b1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3d665ba039c115b1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3d665ba039c115b1$var$_getPrototypeOf(o) {
    $3d665ba039c115b1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3d665ba039c115b1$var$_getPrototypeOf(o);
}
function $3d665ba039c115b1$var$_defineProperty(obj, key, value) {
    key = $3d665ba039c115b1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3d665ba039c115b1$var$_toPropertyKey(t) {
    var i = $3d665ba039c115b1$var$_toPrimitive(t, "string");
    return "symbol" == $3d665ba039c115b1$var$_typeof(i) ? i : String(i);
}
function $3d665ba039c115b1$var$_toPrimitive(t, r) {
    if ("object" != $3d665ba039c115b1$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3d665ba039c115b1$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3d665ba039c115b1$var$RawHtml = /*#__PURE__*/ function(_Component) {
    $3d665ba039c115b1$var$_inherits(RawHtml, _Component);
    var _super = $3d665ba039c115b1$var$_createSuper(RawHtml);
    function RawHtml() {
        var _this;
        $3d665ba039c115b1$var$_classCallCheck(this, RawHtml);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $3d665ba039c115b1$var$_defineProperty($3d665ba039c115b1$var$_assertThisInitialized(_this), "ref", (0, $fd5c1591a458e61e$export$7d1e3a5e95ceca43)());
        $3d665ba039c115b1$var$_defineProperty($3d665ba039c115b1$var$_assertThisInitialized(_this), "nodes", []);
        return _this;
    }
    $3d665ba039c115b1$var$_createClass(RawHtml, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var fragment = new DocumentFragment();
                var root = document.createElement("div");
                root.innerHTML = this.props.content;
                this.nodes = $3d665ba039c115b1$var$_toConsumableArray(root.childNodes);
                this.nodes.forEach(function(node) {
                    return fragment.appendChild(node);
                });
                this.ref.current.replaceWith(fragment);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.nodes.forEach(function(node) {
                    if (node instanceof Element) {
                        node.outerHTML = "";
                        return;
                    }
                    node.nodeValue = "";
                });
                // if there is one TextNode first and one TextNode last, the
                // last one's nodeValue will be assigned to the first.
                if (this.nodes[0].nodeValue) this.nodes[0].nodeValue = "";
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("div", {
                    ref: this.ref
                });
            }
        }
    ]);
    return RawHtml;
}((0, $fd5c1591a458e61e$export$16fa2f45be04daa8));
var $3d665ba039c115b1$var$defaultProps = {
    data: {},
    rootTagName: "div",
    useCustomCompileOptions: {},
    templates: {},
    templatesConfig: {}
};
// @TODO: Template should be a generic and receive TData to pass to Templates (to avoid TTemplateData to be set as `any`)
var $3d665ba039c115b1$var$Template = /*#__PURE__*/ function(_Component2) {
    $3d665ba039c115b1$var$_inherits(Template, _Component2);
    var _super2 = $3d665ba039c115b1$var$_createSuper(Template);
    function Template() {
        $3d665ba039c115b1$var$_classCallCheck(this, Template);
        return _super2.apply(this, arguments);
    }
    $3d665ba039c115b1$var$_createClass(Template, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, $522688c948998c6d$export$248d38f6296296c5)(this.props.data, nextProps.data) || this.props.templateKey !== nextProps.templateKey || !(0, $522688c948998c6d$export$248d38f6296296c5)(this.props.rootProps, nextProps.rootProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var nonFunctionTemplates;
                var RootTagName = this.props.rootTagName === "fragment" ? (0, $fd5c1591a458e61e$export$ffb0004e005737fa) : this.props.rootTagName;
                var useCustomCompileOptions = this.props.useCustomCompileOptions[this.props.templateKey];
                var compileOptions = useCustomCompileOptions ? this.props.templatesConfig.compileOptions : {};
                var content = (0, $e5262e6e4ba60fe6$export$b5c363744c17aeab)({
                    templates: this.props.templates,
                    templateKey: this.props.templateKey,
                    compileOptions: compileOptions,
                    helpers: this.props.templatesConfig.helpers,
                    data: this.props.data,
                    bindEvent: this.props.bindEvent,
                    sendEvent: this.props.sendEvent
                });
                if (content === null) // Adds a noscript to the DOM but virtual DOM is null
                // See http://facebook.github.io/react/docs/component-specs.html#render
                return null;
                if ($3d665ba039c115b1$var$_typeof(content) === "object") return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)(RootTagName, this.props.rootProps, content);
                // This is to handle Hogan templates with Fragment as rootTagName
                if (RootTagName === (0, $fd5c1591a458e61e$export$ffb0004e005737fa)) return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)($3d665ba039c115b1$var$RawHtml, {
                    content: content,
                    key: Math.random()
                });
                return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)(RootTagName, $3d665ba039c115b1$var$_extends({}, this.props.rootProps, {
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                }));
            }
        }
    ]);
    return Template;
}((0, $fd5c1591a458e61e$export$16fa2f45be04daa8));
$3d665ba039c115b1$var$_defineProperty($3d665ba039c115b1$var$Template, "defaultProps", $3d665ba039c115b1$var$defaultProps);
var $3d665ba039c115b1$export$2e2bcd8739ae039 = $3d665ba039c115b1$var$Template;


function $7b0f4c97a89629f0$var$_slicedToArray(arr, i) {
    return $7b0f4c97a89629f0$var$_arrayWithHoles(arr) || $7b0f4c97a89629f0$var$_iterableToArrayLimit(arr, i) || $7b0f4c97a89629f0$var$_unsupportedIterableToArray(arr, i) || $7b0f4c97a89629f0$var$_nonIterableRest();
}
function $7b0f4c97a89629f0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7b0f4c97a89629f0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7b0f4c97a89629f0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7b0f4c97a89629f0$var$_arrayLikeToArray(o, minLen);
}
function $7b0f4c97a89629f0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7b0f4c97a89629f0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7b0f4c97a89629f0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7b0f4c97a89629f0$var$Panel(props) {
    var _useState = (0, $a01e24a5991c23e2$export$60241385465d0a34)(props.isCollapsed), _useState2 = $7b0f4c97a89629f0$var$_slicedToArray(_useState, 2), isCollapsed = _useState2[0], setIsCollapsed = _useState2[1];
    var _useState3 = (0, $a01e24a5991c23e2$export$60241385465d0a34)(false), _useState4 = $7b0f4c97a89629f0$var$_slicedToArray(_useState3, 2), isControlled = _useState4[0], setIsControlled = _useState4[1];
    var bodyRef = (0, $a01e24a5991c23e2$export$b8f5890fc79d6aca)(null);
    (0, $a01e24a5991c23e2$export$6d9c69b0de29b591)(function() {
        var node = bodyRef.current;
        if (!node) return undefined;
        node.appendChild(props.bodyElement);
        return function() {
            node.removeChild(props.bodyElement);
        };
    }, [
        bodyRef,
        props.bodyElement
    ]);
    if (!isControlled && props.isCollapsed !== isCollapsed) setIsCollapsed(props.isCollapsed);
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("div", {
        className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(props.cssClasses.root, props.hidden && props.cssClasses.noRefinementRoot, props.collapsible && props.cssClasses.collapsibleRoot, isCollapsed && props.cssClasses.collapsedRoot),
        hidden: props.hidden
    }, props.templates.header && (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("div", {
        className: props.cssClasses.header
    }, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), {
        templates: props.templates,
        templateKey: "header",
        rootTagName: "span",
        data: props.data
    }), props.collapsible && (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("button", {
        className: props.cssClasses.collapseButton,
        "aria-expanded": !isCollapsed,
        onClick: function onClick(event) {
            event.preventDefault();
            setIsControlled(true);
            setIsCollapsed(function(prevIsCollapsed) {
                return !prevIsCollapsed;
            });
        }
    }, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), {
        templates: props.templates,
        templateKey: "collapseButtonText",
        rootTagName: "span",
        data: {
            collapsed: isCollapsed
        }
    }))), (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("div", {
        className: props.cssClasses.body,
        ref: bodyRef
    }), props.templates.footer && (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), {
        templates: props.templates,
        templateKey: "footer",
        rootProps: {
            className: props.cssClasses.footer
        },
        data: props.data
    }));
}
var $7b0f4c97a89629f0$export$2e2bcd8739ae039 = $7b0f4c97a89629f0$var$Panel;



function $d35caed0f631dde2$export$124b2c3e0d3efb2d(object) {
    return object instanceof HTMLElement || Boolean(object) && object.nodeType > 0;
}


function $b8c98bbd5148a964$export$ffb2c7b8d67c359a(selectorOrHTMLElement) {
    var isSelectorString = typeof selectorOrHTMLElement === "string";
    var domElement = isSelectorString ? document.querySelector(selectorOrHTMLElement) : selectorOrHTMLElement;
    if (!(0, $d35caed0f631dde2$export$124b2c3e0d3efb2d)(domElement)) {
        var errorMessage = "Container must be `string` or `HTMLElement`.";
        if (isSelectorString) errorMessage += " Unable to find ".concat(selectorOrHTMLElement);
        throw new Error(errorMessage);
    }
    return domElement;
}


function $99926ac7ef17db44$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $99926ac7ef17db44$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $99926ac7ef17db44$var$_typeof(o);
}
function $99926ac7ef17db44$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $99926ac7ef17db44$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $99926ac7ef17db44$var$ownKeys(Object(t), !0).forEach(function(r) {
            $99926ac7ef17db44$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $99926ac7ef17db44$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $99926ac7ef17db44$var$_defineProperty(obj, key, value) {
    key = $99926ac7ef17db44$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $99926ac7ef17db44$var$_toPropertyKey(t) {
    var i = $99926ac7ef17db44$var$_toPrimitive(t, "string");
    return "symbol" == $99926ac7ef17db44$var$_typeof(i) ? i : String(i);
}
function $99926ac7ef17db44$var$_toPrimitive(t, r) {
    if ("object" != $99926ac7ef17db44$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $99926ac7ef17db44$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $99926ac7ef17db44$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "panel"
});
var $99926ac7ef17db44$var$suit = (0, $23fceae7dc9dc95c$export$d8556a2a8f973135)("Panel");
var $99926ac7ef17db44$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, bodyContainerNode = _ref.bodyContainerNode, cssClasses = _ref.cssClasses, templates = _ref.templates;
    return function(_ref2) {
        var options = _ref2.options, hidden = _ref2.hidden, collapsible = _ref2.collapsible, collapsed = _ref2.collapsed;
        (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)((0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $7b0f4c97a89629f0$export$2e2bcd8739ae039), {
            cssClasses: cssClasses,
            hidden: hidden,
            collapsible: collapsible,
            isCollapsed: collapsed,
            templates: templates,
            data: options,
            bodyElement: bodyContainerNode
        }), containerNode);
    };
};
/**
 * The panel widget wraps other widgets in a consistent panel design.
 * It also reacts, indicates and sets CSS classes when widgets are no longer relevant for refining.
 */ var $99926ac7ef17db44$var$panel = function panel(panelWidgetParams) {
    var _ref3 = panelWidgetParams || {}, _ref3$templates = _ref3.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, _ref3$hidden = _ref3.hidden, hidden = _ref3$hidden === void 0 ? function() {
        return false;
    } : _ref3$hidden, collapsed = _ref3.collapsed, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses;
    var bodyContainerNode = document.createElement("div");
    var collapsible = Boolean(collapsed);
    var collapsedFn = typeof collapsed === "function" ? collapsed : function() {
        return false;
    };
    var cssClasses = {
        root: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($99926ac7ef17db44$var$suit(), userCssClasses.root),
        noRefinementRoot: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($99926ac7ef17db44$var$suit({
            modifierName: "noRefinement"
        }), userCssClasses.noRefinementRoot),
        collapsibleRoot: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($99926ac7ef17db44$var$suit({
            modifierName: "collapsible"
        }), userCssClasses.collapsibleRoot),
        collapsedRoot: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($99926ac7ef17db44$var$suit({
            modifierName: "collapsed"
        }), userCssClasses.collapsedRoot),
        collapseButton: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($99926ac7ef17db44$var$suit({
            descendantName: "collapseButton"
        }), userCssClasses.collapseButton),
        collapseIcon: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($99926ac7ef17db44$var$suit({
            descendantName: "collapseIcon"
        }), userCssClasses.collapseIcon),
        body: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($99926ac7ef17db44$var$suit({
            descendantName: "body"
        }), userCssClasses.body),
        header: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($99926ac7ef17db44$var$suit({
            descendantName: "header"
        }), userCssClasses.header),
        footer: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($99926ac7ef17db44$var$suit({
            descendantName: "footer"
        }), userCssClasses.footer)
    };
    return function(widgetFactory) {
        return function(widgetParams) {
            if (!(widgetParams && widgetParams.container)) throw new Error($99926ac7ef17db44$var$withUsage("The `container` option is required in the widget within the panel."));
            var containerNode = (0, $b8c98bbd5148a964$export$ffb2c7b8d67c359a)(widgetParams.container);
            var defaultTemplates = {
                collapseButtonText: function collapseButtonText(_ref4) {
                    var isCollapsed = _ref4.collapsed;
                    return '<svg\n          class="'.concat(cssClasses.collapseIcon, '"\n          style="width: 1em; height: 1em;"\n          viewBox="0 0 500 500"\n        >\n        <path d="').concat(isCollapsed ? "M100 250l300-150v300z" : "M250 400l150-300H100z", '" fill="currentColor" />\n        </svg>');
                }
            };
            var renderPanel = $99926ac7ef17db44$var$renderer({
                containerNode: containerNode,
                bodyContainerNode: bodyContainerNode,
                cssClasses: cssClasses,
                templates: $99926ac7ef17db44$var$_objectSpread($99926ac7ef17db44$var$_objectSpread({}, defaultTemplates), templates)
            });
            var widget = widgetFactory($99926ac7ef17db44$var$_objectSpread($99926ac7ef17db44$var$_objectSpread({}, widgetParams), {}, {
                container: bodyContainerNode
            }));
            // TypeScript somehow loses track of the ...widget type, since it's
            // not directly returned. Eventually the "as AugmentedWidget<typeof widgetFactory>"
            // will not be needed anymore.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return $99926ac7ef17db44$var$_objectSpread($99926ac7ef17db44$var$_objectSpread({}, widget), {}, {
                init: function init() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var renderOptions = args[0];
                    var options = $99926ac7ef17db44$var$_objectSpread($99926ac7ef17db44$var$_objectSpread({}, widget.getWidgetRenderState ? widget.getWidgetRenderState(renderOptions) : {}), renderOptions);
                    renderPanel({
                        options: options,
                        hidden: true,
                        collapsible: collapsible,
                        collapsed: false
                    });
                    if (typeof widget.init === "function") {
                        var _widget$init;
                        (_widget$init = widget.init).call.apply(_widget$init, [
                            this
                        ].concat(args));
                    }
                },
                render: function render() {
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    var renderOptions = args[0];
                    var options = $99926ac7ef17db44$var$_objectSpread($99926ac7ef17db44$var$_objectSpread({}, widget.getWidgetRenderState ? widget.getWidgetRenderState(renderOptions) : {}), renderOptions);
                    renderPanel({
                        options: options,
                        hidden: Boolean(hidden(options)),
                        collapsible: collapsible,
                        collapsed: Boolean(collapsedFn(options))
                    });
                    if (typeof widget.render === "function") {
                        var _widget$render;
                        (_widget$render = widget.render).call.apply(_widget$render, [
                            this
                        ].concat(args));
                    }
                },
                dispose: function dispose() {
                    (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)(null, containerNode);
                    if (typeof widget.dispose === "function") {
                        var _widget$dispose;
                        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                        return (_widget$dispose = widget.dispose).call.apply(_widget$dispose, [
                            this
                        ].concat(args));
                    }
                    return undefined;
                }
            });
        };
    };
};
var $99926ac7ef17db44$export$2e2bcd8739ae039 = $99926ac7ef17db44$var$panel;





function $d3ddefa5c7b3300b$export$5b1771037ab7c451(event) {
    var isMiddleClick = event.button === 1;
    return isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
}





function $32b2f46ed1cf6dbc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $32b2f46ed1cf6dbc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $32b2f46ed1cf6dbc$var$_typeof(o);
}
function $32b2f46ed1cf6dbc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $32b2f46ed1cf6dbc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $32b2f46ed1cf6dbc$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $32b2f46ed1cf6dbc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $32b2f46ed1cf6dbc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $32b2f46ed1cf6dbc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $32b2f46ed1cf6dbc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $32b2f46ed1cf6dbc$var$_setPrototypeOf(subClass, superClass);
}
function $32b2f46ed1cf6dbc$var$_setPrototypeOf(o, p) {
    $32b2f46ed1cf6dbc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $32b2f46ed1cf6dbc$var$_setPrototypeOf(o, p);
}
function $32b2f46ed1cf6dbc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $32b2f46ed1cf6dbc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $32b2f46ed1cf6dbc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $32b2f46ed1cf6dbc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $32b2f46ed1cf6dbc$var$_possibleConstructorReturn(this, result);
    };
}
function $32b2f46ed1cf6dbc$var$_possibleConstructorReturn(self, call) {
    if (call && ($32b2f46ed1cf6dbc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $32b2f46ed1cf6dbc$var$_assertThisInitialized(self);
}
function $32b2f46ed1cf6dbc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $32b2f46ed1cf6dbc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $32b2f46ed1cf6dbc$var$_getPrototypeOf(o) {
    $32b2f46ed1cf6dbc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $32b2f46ed1cf6dbc$var$_getPrototypeOf(o);
}
function $32b2f46ed1cf6dbc$var$_defineProperty(obj, key, value) {
    key = $32b2f46ed1cf6dbc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $32b2f46ed1cf6dbc$var$_toPropertyKey(t) {
    var i = $32b2f46ed1cf6dbc$var$_toPrimitive(t, "string");
    return "symbol" == $32b2f46ed1cf6dbc$var$_typeof(i) ? i : String(i);
}
function $32b2f46ed1cf6dbc$var$_toPrimitive(t, r) {
    if ("object" != $32b2f46ed1cf6dbc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $32b2f46ed1cf6dbc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $32b2f46ed1cf6dbc$var$defaultProps = {
    query: "",
    showSubmit: true,
    showReset: true,
    showLoadingIndicator: true,
    autofocus: false,
    searchAsYouType: true,
    ignoreCompositionEvents: false,
    isSearchStalled: false,
    disabled: false,
    ariaLabel: "Search",
    onChange: (0, $846d3432ff405e8b$export$8793edee2d425525),
    onSubmit: (0, $846d3432ff405e8b$export$8793edee2d425525),
    onReset: (0, $846d3432ff405e8b$export$8793edee2d425525),
    refine: (0, $846d3432ff405e8b$export$8793edee2d425525)
};
var $32b2f46ed1cf6dbc$var$SearchBox = /*#__PURE__*/ function(_Component) {
    $32b2f46ed1cf6dbc$var$_inherits(SearchBox, _Component);
    var _super = $32b2f46ed1cf6dbc$var$_createSuper(SearchBox);
    function SearchBox() {
        var _this;
        $32b2f46ed1cf6dbc$var$_classCallCheck(this, SearchBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $32b2f46ed1cf6dbc$var$_defineProperty($32b2f46ed1cf6dbc$var$_assertThisInitialized(_this), "state", {
            query: _this.props.query,
            focused: false
        });
        $32b2f46ed1cf6dbc$var$_defineProperty($32b2f46ed1cf6dbc$var$_assertThisInitialized(_this), "input", (0, $fd5c1591a458e61e$export$7d1e3a5e95ceca43)());
        $32b2f46ed1cf6dbc$var$_defineProperty($32b2f46ed1cf6dbc$var$_assertThisInitialized(_this), "onInput", function(event) {
            var _this$props = _this.props, searchAsYouType = _this$props.searchAsYouType, refine = _this$props.refine, onChange = _this$props.onChange;
            var query = event.target.value;
            if (!(_this.props.ignoreCompositionEvents && event.isComposing)) {
                if (searchAsYouType) refine(query);
                _this.setState({
                    query: query
                });
                onChange(event);
            }
        });
        $32b2f46ed1cf6dbc$var$_defineProperty($32b2f46ed1cf6dbc$var$_assertThisInitialized(_this), "onSubmit", function(event) {
            var _this$props2 = _this.props, searchAsYouType = _this$props2.searchAsYouType, refine = _this$props2.refine, onSubmit = _this$props2.onSubmit;
            event.preventDefault();
            event.stopPropagation();
            if (_this.input.current) _this.input.current.blur();
            if (!searchAsYouType) refine(_this.state.query);
            onSubmit(event);
            return false;
        });
        $32b2f46ed1cf6dbc$var$_defineProperty($32b2f46ed1cf6dbc$var$_assertThisInitialized(_this), "onReset", function(event) {
            var _this$props3 = _this.props, refine = _this$props3.refine, onReset = _this$props3.onReset;
            var query = "";
            if (_this.input.current) _this.input.current.focus();
            refine(query);
            _this.setState({
                query: query
            });
            onReset(event);
        });
        $32b2f46ed1cf6dbc$var$_defineProperty($32b2f46ed1cf6dbc$var$_assertThisInitialized(_this), "onBlur", function() {
            _this.setState({
                focused: false
            });
        });
        $32b2f46ed1cf6dbc$var$_defineProperty($32b2f46ed1cf6dbc$var$_assertThisInitialized(_this), "onFocus", function() {
            _this.setState({
                focused: true
            });
        });
        return _this;
    }
    $32b2f46ed1cf6dbc$var$_createClass(SearchBox, [
        {
            key: "resetInput",
            value: /**
     * This public method is used in the RefinementList SFFV search box
     * to reset the input state when an item is selected.
     *
     * @see RefinementList#componentWillReceiveProps
     * @return {undefined}
     */ function resetInput() {
                this.setState({
                    query: ""
                });
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                /**
       * when the user is typing, we don't want to replace the query typed
       * by the user (state.query) with the query exposed by the connector (props.query)
       * see: https://github.com/algolia/instantsearch/issues/4141
       */ if (!this.state.focused && nextProps.query !== this.state.query) this.setState({
                    query: nextProps.query
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, cssClasses = _this$props4.cssClasses, placeholder = _this$props4.placeholder, autofocus = _this$props4.autofocus, showSubmit = _this$props4.showSubmit, showReset = _this$props4.showReset, showLoadingIndicator = _this$props4.showLoadingIndicator, templates = _this$props4.templates, isSearchStalled = _this$props4.isSearchStalled, ariaLabel = _this$props4.ariaLabel;
                return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("div", {
                    className: cssClasses.root
                }, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("form", {
                    action: "",
                    role: "search",
                    className: cssClasses.form,
                    noValidate: true,
                    onSubmit: this.onSubmit,
                    onReset: this.onReset
                }, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("input", {
                    ref: this.input,
                    value: this.state.query,
                    disabled: this.props.disabled,
                    className: cssClasses.input,
                    type: "search",
                    placeholder: placeholder,
                    autoFocus: autofocus,
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "off",
                    spellCheck: "false",
                    maxLength: 512,
                    onInput: this.onInput,
                    oncompositionend: this.onInput,
                    onBlur: this.onBlur,
                    onFocus: this.onFocus,
                    "aria-label": ariaLabel
                }), (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), {
                    templateKey: "submit",
                    rootTagName: "button",
                    rootProps: {
                        className: cssClasses.submit,
                        type: "submit",
                        title: "Submit the search query",
                        hidden: !showSubmit
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                }), (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), {
                    templateKey: "reset",
                    rootTagName: "button",
                    rootProps: {
                        className: cssClasses.reset,
                        type: "reset",
                        title: "Clear the search query",
                        hidden: !(showReset && this.state.query.trim() && !isSearchStalled)
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                }), showLoadingIndicator && (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), {
                    templateKey: "loadingIndicator",
                    rootTagName: "span",
                    rootProps: {
                        className: cssClasses.loadingIndicator,
                        hidden: !isSearchStalled
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                })));
            }
        }
    ]);
    return SearchBox;
}((0, $fd5c1591a458e61e$export$16fa2f45be04daa8));
$32b2f46ed1cf6dbc$var$_defineProperty($32b2f46ed1cf6dbc$var$SearchBox, "defaultProps", $32b2f46ed1cf6dbc$var$defaultProps);
var $32b2f46ed1cf6dbc$export$2e2bcd8739ae039 = $32b2f46ed1cf6dbc$var$SearchBox;





function $e408ac517c87b7a7$var$_extends() {
    $e408ac517c87b7a7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e408ac517c87b7a7$var$_extends.apply(this, arguments);
}
function $e408ac517c87b7a7$var$RefinementListItem(_ref) {
    var className = _ref.className, handleClick = _ref.handleClick, facetValueToRefine = _ref.facetValueToRefine, isRefined = _ref.isRefined, templateProps = _ref.templateProps, templateKey = _ref.templateKey, templateData = _ref.templateData, subItems = _ref.subItems;
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("li", {
        className: className,
        onClick: function onClick(originalEvent) {
            handleClick({
                facetValueToRefine: facetValueToRefine,
                isRefined: isRefined,
                originalEvent: originalEvent
            });
        }
    }, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), $e408ac517c87b7a7$var$_extends({}, templateProps, {
        templateKey: templateKey,
        data: templateData
    })), subItems);
}
var $e408ac517c87b7a7$export$2e2bcd8739ae039 = $e408ac517c87b7a7$var$RefinementListItem;


var $d4b5e5eac5306500$var$_excluded = [
    "root"
];
function $d4b5e5eac5306500$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d4b5e5eac5306500$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d4b5e5eac5306500$var$_typeof(o);
}
function $d4b5e5eac5306500$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d4b5e5eac5306500$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d4b5e5eac5306500$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d4b5e5eac5306500$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d4b5e5eac5306500$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d4b5e5eac5306500$var$_extends() {
    $d4b5e5eac5306500$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d4b5e5eac5306500$var$_extends.apply(this, arguments);
}
function $d4b5e5eac5306500$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d4b5e5eac5306500$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d4b5e5eac5306500$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d4b5e5eac5306500$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d4b5e5eac5306500$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d4b5e5eac5306500$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d4b5e5eac5306500$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d4b5e5eac5306500$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d4b5e5eac5306500$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d4b5e5eac5306500$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d4b5e5eac5306500$var$_setPrototypeOf(subClass, superClass);
}
function $d4b5e5eac5306500$var$_setPrototypeOf(o, p) {
    $d4b5e5eac5306500$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d4b5e5eac5306500$var$_setPrototypeOf(o, p);
}
function $d4b5e5eac5306500$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d4b5e5eac5306500$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d4b5e5eac5306500$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d4b5e5eac5306500$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d4b5e5eac5306500$var$_possibleConstructorReturn(this, result);
    };
}
function $d4b5e5eac5306500$var$_possibleConstructorReturn(self, call) {
    if (call && ($d4b5e5eac5306500$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d4b5e5eac5306500$var$_assertThisInitialized(self);
}
function $d4b5e5eac5306500$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d4b5e5eac5306500$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d4b5e5eac5306500$var$_getPrototypeOf(o) {
    $d4b5e5eac5306500$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d4b5e5eac5306500$var$_getPrototypeOf(o);
}
function $d4b5e5eac5306500$var$_defineProperty(obj, key, value) {
    key = $d4b5e5eac5306500$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d4b5e5eac5306500$var$_toPropertyKey(t) {
    var i = $d4b5e5eac5306500$var$_toPrimitive(t, "string");
    return "symbol" == $d4b5e5eac5306500$var$_typeof(i) ? i : String(i);
}
function $d4b5e5eac5306500$var$_toPrimitive(t, r) {
    if ("object" != $d4b5e5eac5306500$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d4b5e5eac5306500$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// CSS types
var $d4b5e5eac5306500$var$defaultProps = {
    cssClasses: {},
    depth: 0
};
function $d4b5e5eac5306500$var$isHierarchicalMenuItem(facetValue) {
    return facetValue.data !== undefined;
}
var $d4b5e5eac5306500$var$RefinementList = /*#__PURE__*/ function(_Component) {
    $d4b5e5eac5306500$var$_inherits(RefinementList, _Component);
    var _super = $d4b5e5eac5306500$var$_createSuper(RefinementList);
    function RefinementList() {
        var _this;
        $d4b5e5eac5306500$var$_classCallCheck(this, RefinementList);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $d4b5e5eac5306500$var$_defineProperty($d4b5e5eac5306500$var$_assertThisInitialized(_this), "listRef", (0, $fd5c1591a458e61e$export$7d1e3a5e95ceca43)());
        $d4b5e5eac5306500$var$_defineProperty($d4b5e5eac5306500$var$_assertThisInitialized(_this), "searchBox", (0, $fd5c1591a458e61e$export$7d1e3a5e95ceca43)());
        $d4b5e5eac5306500$var$_defineProperty($d4b5e5eac5306500$var$_assertThisInitialized(_this), "lastRefinedValue", undefined);
        $d4b5e5eac5306500$var$_defineProperty($d4b5e5eac5306500$var$_assertThisInitialized(_this), "_generateFacetItem", function(facetValue) {
            var subItems;
            if ($d4b5e5eac5306500$var$isHierarchicalMenuItem(facetValue) && Array.isArray(facetValue.data) && facetValue.data.length > 0) {
                var _this$props$cssClasse = _this.props.cssClasses, root = _this$props$cssClasse.root, cssClasses = $d4b5e5eac5306500$var$_objectWithoutProperties(_this$props$cssClasse, $d4b5e5eac5306500$var$_excluded);
                subItems = (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)(RefinementList, $d4b5e5eac5306500$var$_extends({}, _this.props, {
                    // We want to keep `root` required for external usage but not for the
                    // sub items.
                    cssClasses: cssClasses,
                    depth: _this.props.depth + 1,
                    facetValues: facetValue.data,
                    showMore: false,
                    className: _this.props.cssClasses.childList
                }));
            }
            var url = _this.props.createURL(facetValue.value);
            var templateData = $d4b5e5eac5306500$var$_objectSpread($d4b5e5eac5306500$var$_objectSpread({}, facetValue), {}, {
                url: url,
                attribute: _this.props.attribute,
                cssClasses: _this.props.cssClasses,
                isFromSearch: _this.props.isFromSearch
            });
            var key = facetValue.value;
            if (facetValue.isRefined !== undefined) key += "/".concat(facetValue.isRefined);
            if (facetValue.count !== undefined) key += "/".concat(facetValue.count);
            var refinementListItemClassName = (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(_this.props.cssClasses.item, facetValue.isRefined && _this.props.cssClasses.selectedItem, !facetValue.count && _this.props.cssClasses.disabledItem, Boolean($d4b5e5eac5306500$var$isHierarchicalMenuItem(facetValue) && Array.isArray(facetValue.data) && facetValue.data.length > 0) && _this.props.cssClasses.parentItem);
            return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $e408ac517c87b7a7$export$2e2bcd8739ae039), {
                templateKey: "item",
                key: key,
                facetValueToRefine: facetValue.value,
                handleClick: _this.handleItemClick,
                isRefined: facetValue.isRefined,
                className: refinementListItemClassName,
                subItems: subItems,
                templateData: templateData,
                templateProps: _this.props.templateProps
            });
        });
        // Click events on DOM tree like LABEL > INPUT will result in two click events
        // instead of one.
        // No matter the framework, see https://www.google.com/search?q=click+label+twice
        //
        // Thus making it hard to distinguish activation from deactivation because both click events
        // are very close. Debounce is a solution but hacky.
        //
        // So the code here checks if the click was done on or in a LABEL. If this LABEL
        // has a checkbox inside, we ignore the first click event because we will get another one.
        //
        // We also check if the click was done inside a link and then e.preventDefault() because we already
        // handle the url
        //
        // Finally, we always stop propagation of the event to avoid multiple levels RefinementLists to fail: click
        // on child would click on parent also
        $d4b5e5eac5306500$var$_defineProperty($d4b5e5eac5306500$var$_assertThisInitialized(_this), "handleItemClick", function(_ref) {
            var facetValueToRefine = _ref.facetValueToRefine, isRefined = _ref.isRefined, originalEvent = _ref.originalEvent;
            if ((0, $d3ddefa5c7b3300b$export$5b1771037ab7c451)(originalEvent)) // do not alter the default browser behavior
            // if one special key is down
            return;
            var parent = originalEvent.target;
            if (parent === null || parent.parentNode === null) return;
            if (isRefined && parent.parentNode.querySelector('input[type="radio"]:checked')) // Prevent refinement for being reset if the user clicks on an already checked radio button
            return;
            if (parent.tagName === "INPUT") {
                _this.refine(facetValueToRefine);
                return;
            }
            while(parent !== originalEvent.currentTarget){
                if (parent.tagName === "LABEL" && (parent.querySelector('input[type="checkbox"]') || parent.querySelector('input[type="radio"]'))) return;
                if (parent.tagName === "A" && parent.href) originalEvent.preventDefault();
                parent = parent.parentNode;
            }
            originalEvent.stopPropagation();
            _this.refine(facetValueToRefine);
        });
        return _this;
    }
    $d4b5e5eac5306500$var$_createClass(RefinementList, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var areFacetValuesDifferent = !(0, $522688c948998c6d$export$248d38f6296296c5)(this.props.facetValues, nextProps.facetValues);
                return areFacetValuesDifferent;
            }
        },
        {
            key: "refine",
            value: function refine(facetValueToRefine) {
                this.lastRefinedValue = facetValueToRefine;
                this.props.toggleRefinement(facetValueToRefine);
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (this.searchBox.current && !nextProps.isFromSearch) this.searchBox.current.resetInput();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$listRef$current, _this$listRef$current2, _this$lastRefinedValu;
                (_this$listRef$current = this.listRef.current) === null || _this$listRef$current === void 0 || (_this$listRef$current2 = _this$listRef$current.querySelector('input[value="'.concat((_this$lastRefinedValu = this.lastRefinedValue) === null || _this$lastRefinedValu === void 0 ? void 0 : _this$lastRefinedValu.replace('"', '\\"'), '"]'))) === null || _this$listRef$current2 === void 0 || _this$listRef$current2.focus();
                this.lastRefinedValue = undefined;
            }
        },
        {
            key: "refineFirstValue",
            value: function refineFirstValue() {
                var firstValue = this.props.facetValues && this.props.facetValues[0];
                if (firstValue) {
                    var actualValue = firstValue.value;
                    this.props.toggleRefinement(actualValue);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var showMoreButtonClassName = (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(this.props.cssClasses.showMore, !(this.props.showMore === true && this.props.canToggleShowMore) && this.props.cssClasses.disabledShowMore);
                var showMoreButton = this.props.showMore === true && (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), $d4b5e5eac5306500$var$_extends({}, this.props.templateProps, {
                    templateKey: "showMoreText",
                    rootTagName: "button",
                    rootProps: {
                        className: showMoreButtonClassName,
                        disabled: !this.props.canToggleShowMore,
                        onClick: this.props.toggleShowMore
                    },
                    data: {
                        isShowingMore: this.props.isShowingMore
                    }
                }));
                var shouldDisableSearchBox = this.props.searchIsAlwaysActive !== true && !(this.props.isFromSearch || !this.props.hasExhaustiveItems);
                var searchBox = this.props.searchFacetValues && (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("div", {
                    className: this.props.cssClasses.searchBox
                }, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $32b2f46ed1cf6dbc$export$2e2bcd8739ae039), {
                    ref: this.searchBox,
                    placeholder: this.props.searchPlaceholder,
                    disabled: shouldDisableSearchBox,
                    cssClasses: this.props.cssClasses.searchable,
                    templates: this.props.searchBoxTemplateProps.templates,
                    onChange: function onChange(event) {
                        return _this2.props.searchFacetValues(event.target.value);
                    },
                    onReset: function onReset() {
                        return _this2.props.searchFacetValues("");
                    },
                    onSubmit: function onSubmit() {
                        return _this2.refineFirstValue();
                    },
                    searchAsYouType: false,
                    ariaLabel: "Search for filters"
                }));
                var facetValues = this.props.facetValues && this.props.facetValues.length > 0 && (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("ul", {
                    ref: this.listRef,
                    className: this.props.cssClasses.list
                }, this.props.facetValues.map(this._generateFacetItem, this));
                var noResults = this.props.searchFacetValues && this.props.isFromSearch && (!this.props.facetValues || this.props.facetValues.length === 0) && (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), $d4b5e5eac5306500$var$_extends({}, this.props.templateProps, {
                    templateKey: "searchableNoResults",
                    rootProps: {
                        className: this.props.cssClasses.noResults
                    }
                }));
                var rootClassName = (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(this.props.cssClasses.root, (!this.props.facetValues || this.props.facetValues.length === 0) && this.props.cssClasses.noRefinementRoot, this.props.className);
                return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("div", {
                    className: rootClassName
                }, this.props.children, searchBox, facetValues, noResults, showMoreButton);
            }
        }
    ]);
    return RefinementList;
}((0, $fd5c1591a458e61e$export$16fa2f45be04daa8));
$d4b5e5eac5306500$var$_defineProperty($d4b5e5eac5306500$var$RefinementList, "defaultProps", $d4b5e5eac5306500$var$defaultProps);
var $d4b5e5eac5306500$export$2e2bcd8739ae039 = $d4b5e5eac5306500$var$RefinementList;


function $530a246a47f1a3e6$export$11cc42aebef2ef3a(object) {
    return Object.prototype.toString.call(object).slice(8, -1);
}


function $300f63447e4459ed$export$adc2a8e09aa583ee(rendering, usage) {
    if (rendering === undefined || typeof rendering !== "function") throw new Error("The render function is not valid (received type ".concat((0, $530a246a47f1a3e6$export$11cc42aebef2ef3a)(rendering), ").\n\n").concat(usage));
}

function $2f20fda9f4fe5595$export$12368a7050a31bdd(helper, facet, value) {
    if (helper.state.isHierarchicalFacet(facet)) return helper.state.isHierarchicalFacetRefined(facet, value);
    else if (helper.state.isConjunctiveFacet(facet)) return helper.state.isFacetRefined(facet, value);
    else return helper.state.isDisjunctiveFacetRefined(facet, value);
}


function $b970f2571c948b66$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b970f2571c948b66$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b970f2571c948b66$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b970f2571c948b66$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b970f2571c948b66$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b970f2571c948b66$var$_defineProperty(obj, key, value) {
    key = $b970f2571c948b66$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b970f2571c948b66$var$_toPropertyKey(t) {
    var i = $b970f2571c948b66$var$_toPrimitive(t, "string");
    return "symbol" == $b970f2571c948b66$var$_typeof(i) ? i : String(i);
}
function $b970f2571c948b66$var$_toPrimitive(t, r) {
    if ("object" != $b970f2571c948b66$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b970f2571c948b66$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b970f2571c948b66$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b970f2571c948b66$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b970f2571c948b66$var$_typeof(o);
}
function $b970f2571c948b66$var$_slicedToArray(arr, i) {
    return $b970f2571c948b66$var$_arrayWithHoles(arr) || $b970f2571c948b66$var$_iterableToArrayLimit(arr, i) || $b970f2571c948b66$var$_unsupportedIterableToArray(arr, i) || $b970f2571c948b66$var$_nonIterableRest();
}
function $b970f2571c948b66$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b970f2571c948b66$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b970f2571c948b66$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b970f2571c948b66$var$_arrayLikeToArray(o, minLen);
}
function $b970f2571c948b66$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b970f2571c948b66$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b970f2571c948b66$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b970f2571c948b66$export$75bfa3473d01f29f(_ref) {
    var instantSearchInstance = _ref.instantSearchInstance, helper = _ref.helper, attr = _ref.attribute, widgetType = _ref.widgetType;
    var sendEventForFacet = function sendEventForFacet() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var facetValue = args[1], _args$ = args[2], eventName = _args$ === void 0 ? "Filter Applied" : _args$, _args$2 = args[3], additionalData = _args$2 === void 0 ? {} : _args$2;
        var _args$0$split = args[0].split(":"), _args$0$split2 = $b970f2571c948b66$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
        var attribute = typeof attr === "string" ? attr : attr(facetValue);
        if (args.length === 1 && $b970f2571c948b66$var$_typeof(args[0]) === "object") instantSearchInstance.sendEventToInsights(args[0]);
        else if (eventType === "click" && args.length >= 2 && args.length <= 4) {
            if (!(0, $2f20fda9f4fe5595$export$12368a7050a31bdd)(helper, attribute, facetValue)) // send event only when the facet is being checked "ON"
            instantSearchInstance.sendEventToInsights({
                insightsMethod: "clickedFilters",
                widgetType: widgetType,
                eventType: eventType,
                eventModifier: eventModifier,
                payload: $b970f2571c948b66$var$_objectSpread({
                    eventName: eventName,
                    index: helper.getIndex(),
                    filters: [
                        "".concat(attribute, ":").concat(facetValue)
                    ]
                }, additionalData),
                attribute: attribute
            });
        }
    };
    return sendEventForFacet;
}


function $235c9714ec9d3c87$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $235c9714ec9d3c87$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $235c9714ec9d3c87$var$_typeof(o);
}
var $235c9714ec9d3c87$var$_excluded = [
    "name",
    "escapedValue"
], $235c9714ec9d3c87$var$_excluded2 = [
    "escapedValue",
    "value"
];
function $235c9714ec9d3c87$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $235c9714ec9d3c87$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $235c9714ec9d3c87$var$ownKeys(Object(t), !0).forEach(function(r) {
            $235c9714ec9d3c87$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $235c9714ec9d3c87$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $235c9714ec9d3c87$var$_defineProperty(obj, key, value) {
    key = $235c9714ec9d3c87$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $235c9714ec9d3c87$var$_toPropertyKey(t) {
    var i = $235c9714ec9d3c87$var$_toPrimitive(t, "string");
    return "symbol" == $235c9714ec9d3c87$var$_typeof(i) ? i : String(i);
}
function $235c9714ec9d3c87$var$_toPrimitive(t, r) {
    if ("object" != $235c9714ec9d3c87$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $235c9714ec9d3c87$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $235c9714ec9d3c87$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $235c9714ec9d3c87$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $235c9714ec9d3c87$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $235c9714ec9d3c87$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "refinement-list",
    connector: true
});
var $235c9714ec9d3c87$var$DEFAULT_SORT = [
    "isRefined",
    "count:desc",
    "name:asc"
];
/**
 * **RefinementList** connector provides the logic to build a custom widget that
 * will let the user filter the results based on the values of a specific facet.
 *
 * **Requirement:** the attribute passed as `attribute` must be present in
 * attributesForFaceting of the searched index.
 *
 * This connector provides:
 * - a `refine()` function to select an item.
 * - a `toggleShowMore()` function to display more or less items
 * - a `searchForItems()` function to search within the items.
 */ var $235c9714ec9d3c87$var$connectRefinementList = function connectRefinementList(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $846d3432ff405e8b$export$8793edee2d425525);
    (0, $300f63447e4459ed$export$adc2a8e09aa583ee)(renderFn, $235c9714ec9d3c87$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, attribute = _ref.attribute, _ref$operator = _ref.operator, operator = _ref$operator === void 0 ? "or" : _ref$operator, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$showMore = _ref.showMore, showMore = _ref$showMore === void 0 ? false : _ref$showMore, _ref$showMoreLimit = _ref.showMoreLimit, showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit, _ref$sortBy = _ref.sortBy, sortBy = _ref$sortBy === void 0 ? $235c9714ec9d3c87$var$DEFAULT_SORT : _ref$sortBy, _ref$escapeFacetValue = _ref.escapeFacetValues, escapeFacetValues = _ref$escapeFacetValue === void 0 ? true : _ref$escapeFacetValue, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (!attribute) throw new Error($235c9714ec9d3c87$var$withUsage("The `attribute` option is required."));
        if (!/^(and|or)$/.test(operator)) throw new Error($235c9714ec9d3c87$var$withUsage('The `operator` must one of: `"and"`, `"or"` (got "'.concat(operator, '").')));
        if (showMore === true && showMoreLimit <= limit) throw new Error($235c9714ec9d3c87$var$withUsage("`showMoreLimit` should be greater than `limit`."));
        var formatItems = function formatItems(_ref2) {
            var label = _ref2.name, value = _ref2.escapedValue, item = $235c9714ec9d3c87$var$_objectWithoutProperties(_ref2, $235c9714ec9d3c87$var$_excluded);
            return $235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, item), {}, {
                value: value,
                label: label,
                highlighted: label
            });
        };
        var lastResultsFromMainSearch;
        var lastItemsFromMainSearch = [];
        var hasExhaustiveItems = true;
        var triggerRefine;
        var sendEvent;
        var isShowingMore = false;
        // Provide the same function to the `renderFn` so that way the user
        // has to only bind it once when `isFirstRendering` for instance
        var toggleShowMore = function toggleShowMore() {};
        function cachedToggleShowMore() {
            toggleShowMore();
        }
        function createToggleShowMore(renderOptions, widget) {
            return function() {
                isShowingMore = !isShowingMore;
                widget.render(renderOptions);
            };
        }
        function getLimit() {
            return isShowingMore ? showMoreLimit : limit;
        }
        var searchForFacetValues = function searchForFacetValues() {
            return function() {};
        };
        var createSearchForFacetValues = function createSearchForFacetValues(helper, widget) {
            return function(renderOptions) {
                return function(query) {
                    var instantSearchInstance = renderOptions.instantSearchInstance, searchResults = renderOptions.results;
                    if (query === "" && lastItemsFromMainSearch) // render with previous data from the helper.
                    renderFn($235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, widget.getWidgetRenderState($235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, renderOptions), {}, {
                        results: lastResultsFromMainSearch
                    }))), {}, {
                        instantSearchInstance: instantSearchInstance
                    }), false);
                    else {
                        var tags = {
                            highlightPreTag: escapeFacetValues ? (0, $ffe8c7f6cc3688f1$export$1e7338a8952eaf35).highlightPreTag : (0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPreTag,
                            highlightPostTag: escapeFacetValues ? (0, $ffe8c7f6cc3688f1$export$1e7338a8952eaf35).highlightPostTag : (0, $ffe8c7f6cc3688f1$export$62e796b7905e8e6b).highlightPostTag
                        };
                        helper.searchForFacetValues(attribute, query, // We cap the `maxFacetHits` value to 100 because the Algolia API
                        // doesn't support a greater number.
                        // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
                        Math.min(getLimit(), 100), tags).then(function(results) {
                            var facetValues = escapeFacetValues ? (0, $ffe8c7f6cc3688f1$export$9ae2e822836b2e1a)(results.facetHits) : results.facetHits;
                            var normalizedFacetValues = transformItems(facetValues.map(function(_ref3) {
                                var escapedValue = _ref3.escapedValue, value = _ref3.value, item = $235c9714ec9d3c87$var$_objectWithoutProperties(_ref3, $235c9714ec9d3c87$var$_excluded2);
                                return $235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, item), {}, {
                                    value: escapedValue,
                                    label: value
                                });
                            }), {
                                results: searchResults
                            });
                            renderFn($235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, widget.getWidgetRenderState($235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, renderOptions), {}, {
                                results: lastResultsFromMainSearch
                            }))), {}, {
                                items: normalizedFacetValues,
                                canToggleShowMore: false,
                                canRefine: true,
                                isFromSearch: true,
                                instantSearchInstance: instantSearchInstance
                            }), false);
                        });
                    }
                };
            };
        };
        return {
            $$type: "ais.refinementList",
            init: function init(initOptions) {
                renderFn($235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                renderFn($235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, renderState), {}, {
                    refinementList: $235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, renderState.refinementList), {}, $235c9714ec9d3c87$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(renderOptions) {
                var _this = this;
                var results = renderOptions.results, state = renderOptions.state, _createURL = renderOptions.createURL, instantSearchInstance = renderOptions.instantSearchInstance, helper = renderOptions.helper;
                var items = [];
                var facetValues = [];
                if (!sendEvent || !triggerRefine || !searchForFacetValues) {
                    sendEvent = (0, $b970f2571c948b66$export$75bfa3473d01f29f)({
                        instantSearchInstance: instantSearchInstance,
                        helper: helper,
                        attribute: attribute,
                        widgetType: this.$$type
                    });
                    triggerRefine = function triggerRefine(facetValue) {
                        sendEvent("click:internal", facetValue);
                        helper.toggleFacetRefinement(attribute, facetValue).search();
                    };
                    searchForFacetValues = createSearchForFacetValues(helper, this);
                }
                if (results) {
                    var values = results.getFacetValues(attribute, {
                        sortBy: sortBy,
                        facetOrdering: sortBy === $235c9714ec9d3c87$var$DEFAULT_SORT
                    });
                    facetValues = values && Array.isArray(values) ? values : [];
                    items = transformItems(facetValues.slice(0, getLimit()).map(formatItems), {
                        results: results
                    });
                    var maxValuesPerFacetConfig = state.maxValuesPerFacet;
                    var currentLimit = getLimit();
                    // If the limit is the max number of facet retrieved it is impossible to know
                    // if the facets are exhaustive. The only moment we are sure it is exhaustive
                    // is when it is strictly under the number requested unless we know that another
                    // widget has requested more values (maxValuesPerFacet > getLimit()).
                    // Because this is used for making the search of facets unable or not, it is important
                    // to be conservative here.
                    hasExhaustiveItems = maxValuesPerFacetConfig > currentLimit ? facetValues.length <= currentLimit : facetValues.length < currentLimit;
                    lastResultsFromMainSearch = results;
                    lastItemsFromMainSearch = items;
                    if (renderOptions.results) toggleShowMore = createToggleShowMore(renderOptions, this);
                }
                // Do not mistake searchForFacetValues and searchFacetValues which is the actual search
                // function
                var searchFacetValues = searchForFacetValues && searchForFacetValues(renderOptions);
                var canShowLess = isShowingMore && lastItemsFromMainSearch.length > limit;
                var canShowMore = showMore && !hasExhaustiveItems;
                var canToggleShowMore = canShowLess || canShowMore;
                return {
                    createURL: function createURL(facetValue) {
                        return _createURL(function(uiState) {
                            return _this.getWidgetUiState(uiState, {
                                searchParameters: state.resetPage().toggleFacetRefinement(attribute, facetValue),
                                helper: helper
                            });
                        });
                    },
                    items: items,
                    refine: triggerRefine,
                    searchForItems: searchFacetValues,
                    isFromSearch: false,
                    canRefine: items.length > 0,
                    widgetParams: widgetParams,
                    isShowingMore: isShowingMore,
                    canToggleShowMore: canToggleShowMore,
                    toggleShowMore: cachedToggleShowMore,
                    sendEvent: sendEvent,
                    hasExhaustiveItems: hasExhaustiveItems
                };
            },
            dispose: function dispose(_ref4) {
                var state = _ref4.state;
                unmountFn();
                var withoutMaxValuesPerFacet = state.setQueryParameter("maxValuesPerFacet", undefined);
                if (operator === "and") return withoutMaxValuesPerFacet.removeFacet(attribute);
                return withoutMaxValuesPerFacet.removeDisjunctiveFacet(attribute);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
                var searchParameters = _ref5.searchParameters;
                var values = operator === "or" ? searchParameters.getDisjunctiveRefinements(attribute) : searchParameters.getConjunctiveRefinements(attribute);
                return $235c9714ec9d3c87$var$removeEmptyRefinementsFromUiState($235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, uiState), {}, {
                    refinementList: $235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, uiState.refinementList), {}, $235c9714ec9d3c87$var$_defineProperty({}, attribute, values))
                }), attribute);
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
                var uiState = _ref6.uiState;
                var isDisjunctive = operator === "or";
                if (searchParameters.isHierarchicalFacet(attribute)) return searchParameters;
                if (isDisjunctive && searchParameters.isConjunctiveFacet(attribute) || !isDisjunctive && searchParameters.isDisjunctiveFacet(attribute)) return searchParameters;
                var values = uiState.refinementList && uiState.refinementList[attribute];
                var withFacetConfiguration = isDisjunctive ? searchParameters.addDisjunctiveFacet(attribute).removeDisjunctiveFacetRefinement(attribute) : searchParameters.addFacet(attribute).removeFacetRefinement(attribute);
                var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
                var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
                var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter("maxValuesPerFacet", nextMaxValuesPerFacet);
                if (!values) {
                    var key = isDisjunctive ? "disjunctiveFacetsRefinements" : "facetsRefinements";
                    return withMaxValuesPerFacet.setQueryParameters($235c9714ec9d3c87$var$_defineProperty({}, key, $235c9714ec9d3c87$var$_objectSpread($235c9714ec9d3c87$var$_objectSpread({}, withMaxValuesPerFacet[key]), {}, $235c9714ec9d3c87$var$_defineProperty({}, attribute, []))));
                }
                return values.reduce(function(parameters, value) {
                    return isDisjunctive ? parameters.addDisjunctiveFacetRefinement(attribute, value) : parameters.addFacetRefinement(attribute, value);
                }, withMaxValuesPerFacet);
            }
        };
    };
};
function $235c9714ec9d3c87$var$removeEmptyRefinementsFromUiState(indexUiState, attribute) {
    if (!indexUiState.refinementList) return indexUiState;
    if (!indexUiState.refinementList[attribute] || indexUiState.refinementList[attribute].length === 0) delete indexUiState.refinementList[attribute];
    if (Object.keys(indexUiState.refinementList).length === 0) delete indexUiState.refinementList;
    return indexUiState;
}
var $235c9714ec9d3c87$export$2e2bcd8739ae039 = $235c9714ec9d3c87$var$connectRefinementList;




function $4a70ab09dd697263$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4a70ab09dd697263$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4a70ab09dd697263$var$_typeof(o);
}
function $4a70ab09dd697263$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4a70ab09dd697263$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4a70ab09dd697263$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4a70ab09dd697263$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4a70ab09dd697263$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4a70ab09dd697263$var$_defineProperty(obj, key, value) {
    key = $4a70ab09dd697263$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4a70ab09dd697263$var$_toPropertyKey(t) {
    var i = $4a70ab09dd697263$var$_toPrimitive(t, "string");
    return "symbol" == $4a70ab09dd697263$var$_typeof(i) ? i : String(i);
}
function $4a70ab09dd697263$var$_toPrimitive(t, r) {
    if ("object" != $4a70ab09dd697263$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4a70ab09dd697263$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4a70ab09dd697263$var$_toConsumableArray(arr) {
    return $4a70ab09dd697263$var$_arrayWithoutHoles(arr) || $4a70ab09dd697263$var$_iterableToArray(arr) || $4a70ab09dd697263$var$_unsupportedIterableToArray(arr) || $4a70ab09dd697263$var$_nonIterableSpread();
}
function $4a70ab09dd697263$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4a70ab09dd697263$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4a70ab09dd697263$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4a70ab09dd697263$var$_arrayLikeToArray(o, minLen);
}
function $4a70ab09dd697263$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4a70ab09dd697263$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4a70ab09dd697263$var$_arrayLikeToArray(arr);
}
function $4a70ab09dd697263$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4a70ab09dd697263$var$prepareTemplates(// can not use = {} here, since the template could have different constraints
defaultTemplates) {
    var templates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allKeys = (0, $57b7a6525254cbcf$export$f70730c3d1fc524e)([].concat($4a70ab09dd697263$var$_toConsumableArray(Object.keys(defaultTemplates || {})), $4a70ab09dd697263$var$_toConsumableArray(Object.keys(templates))));
    return allKeys.reduce(function(config, key) {
        var defaultTemplate = defaultTemplates ? defaultTemplates[key] : undefined;
        var customTemplate = templates[key];
        var isCustomTemplate = customTemplate !== undefined && customTemplate !== defaultTemplate;
        config.templates[key] = isCustomTemplate ? customTemplate : defaultTemplate;
        config.useCustomCompileOptions[key] = isCustomTemplate;
        return config;
    }, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        templates: {},
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        useCustomCompileOptions: {}
    });
}
function $4a70ab09dd697263$export$2938ff6a58d41f25(_ref) {
    var defaultTemplates = _ref.defaultTemplates, templates = _ref.templates, templatesConfig = _ref.templatesConfig;
    var preparedTemplates = $4a70ab09dd697263$var$prepareTemplates(defaultTemplates, templates);
    return $4a70ab09dd697263$var$_objectSpread({
        templatesConfig: templatesConfig
    }, preparedTemplates);
}




var $ecd69f3ae59539f0$var$_ref2 = (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("path", {
    d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
});
var $ecd69f3ae59539f0$var$_ref4 = (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("path", {
    d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
});
var $ecd69f3ae59539f0$var$_ref6 = (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("g", {
    fill: "none",
    "fill-rule": "evenodd"
}, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("g", {
    transform: "translate(1 1)",
    "stroke-width": "2"
}, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("circle", {
    "stroke-opacity": ".5",
    cx: "18",
    cy: "18",
    r: "18"
}), (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
}, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
}))));
var $ecd69f3ae59539f0$var$defaultTemplate = {
    reset: function reset(_ref) {
        var cssClasses = _ref.cssClasses;
        return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("svg", {
            className: cssClasses.resetIcon,
            viewBox: "0 0 20 20",
            width: "10",
            height: "10",
            "aria-hidden": "true"
        }, $ecd69f3ae59539f0$var$_ref2);
    },
    submit: function submit(_ref3) {
        var cssClasses = _ref3.cssClasses;
        return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("svg", {
            className: cssClasses.submitIcon,
            width: "10",
            height: "10",
            viewBox: "0 0 40 40",
            "aria-hidden": "true"
        }, $ecd69f3ae59539f0$var$_ref4);
    },
    loadingIndicator: function loadingIndicator(_ref5) {
        var cssClasses = _ref5.cssClasses;
        /* eslint-disable react/no-unknown-property */ // Preact supports kebab case attributes, and using camel case would
        // require using `preact/compat`.
        // @TODO: reconsider using the `react` ESLint preset
        return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("svg", {
            "aria-label": "Results are loading",
            className: cssClasses.loadingIcon,
            width: "16",
            height: "16",
            viewBox: "0 0 38 38",
            stroke: "#444",
            "aria-hidden": "true"
        }, $ecd69f3ae59539f0$var$_ref6);
    /* eslint-enable react/no-unknown-property */ }
};
var $ecd69f3ae59539f0$export$2e2bcd8739ae039 = $ecd69f3ae59539f0$var$defaultTemplate;





var $6e2293976e6c1cb0$var$defaultTemplates = {
    item: function item(_ref) {
        var cssClasses = _ref.cssClasses, count = _ref.count, value = _ref.value, highlighted = _ref.highlighted, isRefined = _ref.isRefined, isFromSearch = _ref.isFromSearch;
        return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("label", {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(cssClasses.label)
        }, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("input", {
            type: "checkbox",
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(cssClasses.checkbox),
            value: value,
            defaultChecked: isRefined
        }), (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("span", {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(cssClasses.labelText),
            dangerouslySetInnerHTML: isFromSearch ? {
                __html: highlighted
            } : undefined
        }, !isFromSearch && highlighted), (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("span", {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(cssClasses.count)
        }, (0, $65b35437084c827d$export$f5dd818bff069720)(count)));
    },
    showMoreText: function showMoreText(_ref2) {
        var isShowingMore = _ref2.isShowingMore;
        return isShowingMore ? "Show less" : "Show more";
    },
    searchableNoResults: function searchableNoResults() {
        return "No results";
    }
};
var $6e2293976e6c1cb0$export$2e2bcd8739ae039 = $6e2293976e6c1cb0$var$defaultTemplates;


function $9f5a6a0cb29ddb10$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9f5a6a0cb29ddb10$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9f5a6a0cb29ddb10$var$_typeof(o);
}
function $9f5a6a0cb29ddb10$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f5a6a0cb29ddb10$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f5a6a0cb29ddb10$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9f5a6a0cb29ddb10$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f5a6a0cb29ddb10$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9f5a6a0cb29ddb10$var$_defineProperty(obj, key, value) {
    key = $9f5a6a0cb29ddb10$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9f5a6a0cb29ddb10$var$_toPropertyKey(t) {
    var i = $9f5a6a0cb29ddb10$var$_toPrimitive(t, "string");
    return "symbol" == $9f5a6a0cb29ddb10$var$_typeof(i) ? i : String(i);
}
function $9f5a6a0cb29ddb10$var$_toPrimitive(t, r) {
    if ("object" != $9f5a6a0cb29ddb10$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9f5a6a0cb29ddb10$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9f5a6a0cb29ddb10$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "refinement-list"
});
var $9f5a6a0cb29ddb10$var$suit = (0, $23fceae7dc9dc95c$export$d8556a2a8f973135)("RefinementList");
var $9f5a6a0cb29ddb10$var$searchBoxSuit = (0, $23fceae7dc9dc95c$export$d8556a2a8f973135)("SearchBox");
var $9f5a6a0cb29ddb10$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses, templates = _ref.templates, searchBoxTemplates = _ref.searchBoxTemplates, renderState = _ref.renderState, showMore = _ref.showMore, searchable = _ref.searchable, searchablePlaceholder = _ref.searchablePlaceholder, searchableIsAlwaysActive = _ref.searchableIsAlwaysActive;
    return function(_ref2, isFirstRendering) {
        var refine = _ref2.refine, items = _ref2.items, createURL = _ref2.createURL, searchForItems = _ref2.searchForItems, isFromSearch = _ref2.isFromSearch, instantSearchInstance = _ref2.instantSearchInstance, toggleShowMore = _ref2.toggleShowMore, isShowingMore = _ref2.isShowingMore, hasExhaustiveItems = _ref2.hasExhaustiveItems, canToggleShowMore = _ref2.canToggleShowMore;
        if (isFirstRendering) {
            renderState.templateProps = (0, $4a70ab09dd697263$export$2938ff6a58d41f25)({
                defaultTemplates: (0, $6e2293976e6c1cb0$export$2e2bcd8739ae039),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            renderState.searchBoxTemplateProps = (0, $4a70ab09dd697263$export$2938ff6a58d41f25)({
                defaultTemplates: (0, $ecd69f3ae59539f0$export$2e2bcd8739ae039),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: searchBoxTemplates
            });
            return;
        }
        (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)((0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $d4b5e5eac5306500$export$2e2bcd8739ae039), {
            createURL: createURL,
            cssClasses: cssClasses,
            facetValues: items,
            templateProps: renderState.templateProps,
            searchBoxTemplateProps: renderState.searchBoxTemplateProps,
            toggleRefinement: refine,
            searchFacetValues: searchable ? searchForItems : undefined,
            searchPlaceholder: searchablePlaceholder,
            searchIsAlwaysActive: searchableIsAlwaysActive,
            isFromSearch: isFromSearch,
            showMore: showMore && !isFromSearch && items.length > 0,
            toggleShowMore: toggleShowMore,
            isShowingMore: isShowingMore,
            hasExhaustiveItems: hasExhaustiveItems,
            canToggleShowMore: canToggleShowMore
        }), containerNode);
    };
};
/**
 * The refinement list widget is one of the most common widget that you can find
 * in a search UI. With this widget, the user can filter the dataset based on facets.
 *
 * The refinement list displays only the most relevant facets for the current search
 * context. The sort option only affects the facet that are returned by the engine,
 * not which facets are returned.
 *
 * This widget also implements search for facet values, which is a mini search inside the
 * values of the facets. This makes easy to deal with uncommon facet values.
 *
 * @requirements
 *
 * The attribute passed to `attribute` must be declared as an
 * [attribute for faceting](https://www.algolia.com/doc/guides/searching/faceting/#declaring-attributes-for-faceting)
 * in your Algolia settings.
 *
 * If you also want to use search for facet values on this attribute, you need to make it searchable using the [dashboard](https://www.algolia.com/explorer/display/) or using the [API](https://www.algolia.com/doc/guides/searching/faceting/#search-for-facet-values).
 */ var $9f5a6a0cb29ddb10$var$refinementList = function refinementList(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, attribute = _ref3.attribute, operator = _ref3.operator, sortBy = _ref3.sortBy, limit = _ref3.limit, showMore = _ref3.showMore, showMoreLimit = _ref3.showMoreLimit, _ref3$searchable = _ref3.searchable, searchable = _ref3$searchable === void 0 ? false : _ref3$searchable, _ref3$searchablePlace = _ref3.searchablePlaceholder, searchablePlaceholder = _ref3$searchablePlace === void 0 ? "Search..." : _ref3$searchablePlace, _ref3$searchableEscap = _ref3.searchableEscapeFacetValues, searchableEscapeFacetValues = _ref3$searchableEscap === void 0 ? true : _ref3$searchableEscap, _ref3$searchableIsAlw = _ref3.searchableIsAlwaysActive, searchableIsAlwaysActive = _ref3$searchableIsAlw === void 0 ? true : _ref3$searchableIsAlw, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$templates = _ref3.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, transformItems = _ref3.transformItems;
    if (!container) throw new Error($9f5a6a0cb29ddb10$var$withUsage("The `container` option is required."));
    var escapeFacetValues = searchable ? Boolean(searchableEscapeFacetValues) : false;
    var containerNode = (0, $b8c98bbd5148a964$export$ffb2c7b8d67c359a)(container);
    var cssClasses = {
        root: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit(), userCssClasses.root),
        noRefinementRoot: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit({
            modifierName: "noRefinement"
        }), userCssClasses.noRefinementRoot),
        list: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit({
            descendantName: "list"
        }), userCssClasses.list),
        item: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit({
            descendantName: "item"
        }), userCssClasses.item),
        selectedItem: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit({
            descendantName: "item",
            modifierName: "selected"
        }), userCssClasses.selectedItem),
        searchBox: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit({
            descendantName: "searchBox"
        }), userCssClasses.searchBox),
        label: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit({
            descendantName: "label"
        }), userCssClasses.label),
        checkbox: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit({
            descendantName: "checkbox"
        }), userCssClasses.checkbox),
        labelText: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit({
            descendantName: "labelText"
        }), userCssClasses.labelText),
        count: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit({
            descendantName: "count"
        }), userCssClasses.count),
        noResults: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit({
            descendantName: "noResults"
        }), userCssClasses.noResults),
        showMore: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit({
            descendantName: "showMore"
        }), userCssClasses.showMore),
        disabledShowMore: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$suit({
            descendantName: "showMore",
            modifierName: "disabled"
        }), userCssClasses.disabledShowMore),
        searchable: {
            root: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$searchBoxSuit(), userCssClasses.searchableRoot),
            form: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$searchBoxSuit({
                descendantName: "form"
            }), userCssClasses.searchableForm),
            input: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$searchBoxSuit({
                descendantName: "input"
            }), userCssClasses.searchableInput),
            submit: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$searchBoxSuit({
                descendantName: "submit"
            }), userCssClasses.searchableSubmit),
            submitIcon: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$searchBoxSuit({
                descendantName: "submitIcon"
            }), userCssClasses.searchableSubmitIcon),
            reset: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$searchBoxSuit({
                descendantName: "reset"
            }), userCssClasses.searchableReset),
            resetIcon: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$searchBoxSuit({
                descendantName: "resetIcon"
            }), userCssClasses.searchableResetIcon),
            loadingIndicator: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$searchBoxSuit({
                descendantName: "loadingIndicator"
            }), userCssClasses.searchableLoadingIndicator),
            loadingIcon: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f5a6a0cb29ddb10$var$searchBoxSuit({
                descendantName: "loadingIcon"
            }), userCssClasses.searchableLoadingIcon)
        }
    };
    var specializedRenderer = $9f5a6a0cb29ddb10$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        templates: templates,
        searchBoxTemplates: {
            submit: templates.searchableSubmit,
            reset: templates.searchableReset,
            loadingIndicator: templates.searchableLoadingIndicator
        },
        renderState: {},
        searchable: searchable,
        searchablePlaceholder: searchablePlaceholder,
        searchableIsAlwaysActive: searchableIsAlwaysActive,
        showMore: showMore
    });
    var makeWidget = (0, $235c9714ec9d3c87$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $9f5a6a0cb29ddb10$var$_objectSpread($9f5a6a0cb29ddb10$var$_objectSpread({}, makeWidget({
        attribute: attribute,
        operator: operator,
        limit: limit,
        showMore: showMore,
        showMoreLimit: showMoreLimit,
        sortBy: sortBy,
        escapeFacetValues: escapeFacetValues,
        transformItems: transformItems
    })), {}, {
        $$widgetType: "ais.refinementList"
    });
};
var $9f5a6a0cb29ddb10$export$2e2bcd8739ae039 = $9f5a6a0cb29ddb10$var$refinementList;


const $c693740ce5243d42$export$21cca13ffe0ab3b8 = ({ collapsed: collapsed }, { html: html })=>{
    if (collapsed) return html`<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13">
      <path
        fill="#21243d"
        d="M6 6V0h1v6h6v1H7v6H6V7H0V6h6z"
        fill-rule="evenodd"
      />
    </svg>`;
    return html`<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13">
    <path fill="#21243d" d="M0 6h13v1H0z" fill-rule="evenodd" />
  </svg>`;
};


const $f9be2d1c40fa0922$var$artistsRefinementList = (0, $99926ac7ef17db44$export$2e2bcd8739ae039)({
    templates: {
        header () {
            return "Artistes";
        },
        collapseButtonText: $c693740ce5243d42$export$21cca13ffe0ab3b8
    },
    collapsed: ()=>false
})((0, $9f5a6a0cb29ddb10$export$2e2bcd8739ae039));
const $f9be2d1c40fa0922$export$159753545da00930 = $f9be2d1c40fa0922$var$artistsRefinementList({
    container: '[data-widget="artists"]',
    attribute: "artiste",
    limit: 5,
    showMore: true,
    searchable: true,
    searchablePlaceholder: "Rechercher des artistes...",
    templates: {
        searchableSubmit: (_, { html: html })=>{
            return html`
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 14 14"
                >
                <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#21243D"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.33"
                    transform="translate(1 1)"
                >
                    <circle cx="5.333" cy="5.333" r="5.333" />
                    <path d="M12 12L9.1 9.1" />
                </g>
                </svg>
            `;
        },
        showMoreText: ({ isShowingMore: isShowingMore }, { html: html })=>{
            return isShowingMore ? html`Voir moins...` : html`Voir plus...`;
        }
    }
});







function $934c4dac7fa75ff4$var$_extends() {
    $934c4dac7fa75ff4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $934c4dac7fa75ff4$var$_extends.apply(this, arguments);
}
var $934c4dac7fa75ff4$var$ClearRefinements = function ClearRefinements(_ref) {
    var hasRefinements = _ref.hasRefinements, refine = _ref.refine, cssClasses = _ref.cssClasses, templateProps = _ref.templateProps;
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("div", {
        className: cssClasses.root
    }, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), $934c4dac7fa75ff4$var$_extends({}, templateProps, {
        templateKey: "resetLabel",
        rootTagName: "button",
        rootProps: {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(cssClasses.button, !hasRefinements && cssClasses.disabledButton),
            onClick: refine,
            disabled: !hasRefinements
        },
        data: {
            hasRefinements: hasRefinements
        }
    })));
};
var $934c4dac7fa75ff4$export$2e2bcd8739ae039 = $934c4dac7fa75ff4$var$ClearRefinements;


/**
 * Clears the refinements of a SearchParameters object based on rules provided.
 * The included attributes list is applied before the excluded attributes list. If the list
 * is not provided, this list of all the currently refined attributes is used as included attributes.
 * @returns search parameters with refinements cleared
 */ function $5da3c6d65fd650b3$export$c8b9db57471d846b(_ref) {
    var helper = _ref.helper, _ref$attributesToClea = _ref.attributesToClear, attributesToClear = _ref$attributesToClea === void 0 ? [] : _ref$attributesToClea;
    var finalState = helper.state.setPage(0);
    finalState = attributesToClear.reduce(function(state, attribute) {
        if (finalState.isNumericRefined(attribute)) return state.removeNumericRefinement(attribute);
        if (finalState.isHierarchicalFacet(attribute)) return state.removeHierarchicalFacetRefinement(attribute);
        if (finalState.isDisjunctiveFacet(attribute)) return state.removeDisjunctiveFacetRefinement(attribute);
        if (finalState.isConjunctiveFacet(attribute)) return state.removeFacetRefinement(attribute);
        return state;
    }, finalState);
    if (attributesToClear.indexOf("query") !== -1) finalState = finalState.setQuery("");
    return finalState;
}

function $f7bad1f48014f9ef$export$ad628980c7383a99(value) {
    if (typeof value === "string") return value.replace(/^\\-/, "-");
    return value;
}
function $f7bad1f48014f9ef$export$40415fcf01f0c9e8(value) {
    if (typeof value === "number" && value < 0 || typeof value === "string") return String(value).replace(/^-/, "\\-");
    return value;
}



function $c3ac91646036dced$var$getRefinement(state, type, attribute, name) {
    var resultsFacets = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var res = {
        type: type,
        attribute: attribute,
        name: name,
        escapedValue: (0, $f7bad1f48014f9ef$export$40415fcf01f0c9e8)(name)
    };
    var facet = (0, $6233c69c2fe30ad7$export$71aa6c912b956294)(resultsFacets, function(resultsFacet) {
        return resultsFacet.name === attribute;
    });
    var count;
    if (type === "hierarchical") {
        var facetDeclaration = state.getHierarchicalFacetByName(attribute);
        var nameParts = name.split(facetDeclaration.separator);
        var getFacetRefinement = function getFacetRefinement(facetData) {
            return function(refinementKey) {
                return facetData[refinementKey];
            };
        };
        var _loop = function _loop(i) {
            facet = facet && facet.data && (0, $6233c69c2fe30ad7$export$71aa6c912b956294)(Object.keys(facet.data).map(getFacetRefinement(facet.data)), function(refinement) {
                return refinement.name === nameParts[i];
            });
        };
        for(var i = 0; facet !== undefined && i < nameParts.length; ++i)_loop(i);
        count = facet && facet.count;
    } else count = facet && facet.data && facet.data[res.name];
    if (count !== undefined) res.count = count;
    if (facet && facet.exhaustive !== undefined) res.exhaustive = facet.exhaustive;
    return res;
}
function $c3ac91646036dced$export$d9f33760e70a0a(_results, state) {
    var includesQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var results = _results || {};
    var refinements = [];
    var _state$facetsRefineme = state.facetsRefinements, facetsRefinements = _state$facetsRefineme === void 0 ? {} : _state$facetsRefineme, _state$facetsExcludes = state.facetsExcludes, facetsExcludes = _state$facetsExcludes === void 0 ? {} : _state$facetsExcludes, _state$disjunctiveFac = state.disjunctiveFacetsRefinements, disjunctiveFacetsRefinements = _state$disjunctiveFac === void 0 ? {} : _state$disjunctiveFac, _state$hierarchicalFa = state.hierarchicalFacetsRefinements, hierarchicalFacetsRefinements = _state$hierarchicalFa === void 0 ? {} : _state$hierarchicalFa, _state$numericRefinem = state.numericRefinements, numericRefinements = _state$numericRefinem === void 0 ? {} : _state$numericRefinem, _state$tagRefinements = state.tagRefinements, tagRefinements = _state$tagRefinements === void 0 ? [] : _state$tagRefinements;
    Object.keys(facetsRefinements).forEach(function(attribute) {
        var refinementNames = facetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($c3ac91646036dced$var$getRefinement(state, "facet", attribute, refinementName, results.facets));
        });
    });
    Object.keys(facetsExcludes).forEach(function(attribute) {
        var refinementNames = facetsExcludes[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push({
                type: "exclude",
                attribute: attribute,
                name: refinementName,
                exclude: true
            });
        });
    });
    Object.keys(disjunctiveFacetsRefinements).forEach(function(attribute) {
        var refinementNames = disjunctiveFacetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($c3ac91646036dced$var$getRefinement(state, "disjunctive", attribute, // We unescape any disjunctive refined values with `unescapeFacetValue` because
            // they can be escaped on negative numeric values with `escapeFacetValue`.
            (0, $f7bad1f48014f9ef$export$ad628980c7383a99)(refinementName), results.disjunctiveFacets));
        });
    });
    Object.keys(hierarchicalFacetsRefinements).forEach(function(attribute) {
        var refinementNames = hierarchicalFacetsRefinements[attribute];
        refinementNames.forEach(function(refinement) {
            refinements.push($c3ac91646036dced$var$getRefinement(state, "hierarchical", attribute, refinement, results.hierarchicalFacets));
        });
    });
    Object.keys(numericRefinements).forEach(function(attribute) {
        var operators = numericRefinements[attribute];
        Object.keys(operators).forEach(function(operatorOriginal) {
            var operator = operatorOriginal;
            var valueOrValues = operators[operator];
            var refinementNames = Array.isArray(valueOrValues) ? valueOrValues : [
                valueOrValues
            ];
            refinementNames.forEach(function(refinementName) {
                refinements.push({
                    type: "numeric",
                    attribute: attribute,
                    name: "".concat(refinementName),
                    numericValue: refinementName,
                    operator: operator
                });
            });
        });
    });
    tagRefinements.forEach(function(refinementName) {
        refinements.push({
            type: "tag",
            attribute: "_tags",
            name: refinementName
        });
    });
    if (includesQuery && state.query && state.query.trim()) refinements.push({
        attribute: "query",
        type: "query",
        name: state.query,
        query: state.query
    });
    return refinements;
}


function $f13f036027abcf7c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f13f036027abcf7c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f13f036027abcf7c$var$_typeof(o);
}
function $f13f036027abcf7c$var$_toConsumableArray(arr) {
    return $f13f036027abcf7c$var$_arrayWithoutHoles(arr) || $f13f036027abcf7c$var$_iterableToArray(arr) || $f13f036027abcf7c$var$_unsupportedIterableToArray(arr) || $f13f036027abcf7c$var$_nonIterableSpread();
}
function $f13f036027abcf7c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f13f036027abcf7c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f13f036027abcf7c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f13f036027abcf7c$var$_arrayLikeToArray(o, minLen);
}
function $f13f036027abcf7c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f13f036027abcf7c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f13f036027abcf7c$var$_arrayLikeToArray(arr);
}
function $f13f036027abcf7c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f13f036027abcf7c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f13f036027abcf7c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f13f036027abcf7c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f13f036027abcf7c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f13f036027abcf7c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f13f036027abcf7c$var$_defineProperty(obj, key, value) {
    key = $f13f036027abcf7c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f13f036027abcf7c$var$_toPropertyKey(t) {
    var i = $f13f036027abcf7c$var$_toPrimitive(t, "string");
    return "symbol" == $f13f036027abcf7c$var$_typeof(i) ? i : String(i);
}
function $f13f036027abcf7c$var$_toPrimitive(t, r) {
    if ("object" != $f13f036027abcf7c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f13f036027abcf7c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f13f036027abcf7c$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "clear-refinements",
    connector: true
});
var $f13f036027abcf7c$var$connectClearRefinements = function connectClearRefinements(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $846d3432ff405e8b$export$8793edee2d425525);
    (0, $300f63447e4459ed$export$adc2a8e09aa583ee)(renderFn, $f13f036027abcf7c$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$includedAttribut = _ref.includedAttributes, includedAttributes = _ref$includedAttribut === void 0 ? [] : _ref$includedAttribut, _ref$excludedAttribut = _ref.excludedAttributes, excludedAttributes = _ref$excludedAttribut === void 0 ? [
            "query"
        ] : _ref$excludedAttribut, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (widgetParams && widgetParams.includedAttributes && widgetParams.excludedAttributes) throw new Error($f13f036027abcf7c$var$withUsage("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
        var connectorState = {
            refine: (0, $846d3432ff405e8b$export$8793edee2d425525),
            createURL: function createURL() {
                return "";
            },
            attributesToClear: []
        };
        var cachedRefine = function cachedRefine() {
            return connectorState.refine();
        };
        var cachedCreateURL = function cachedCreateURL() {
            return connectorState.createURL();
        };
        return {
            $$type: "ais.clearRefinements",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($f13f036027abcf7c$var$_objectSpread($f13f036027abcf7c$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($f13f036027abcf7c$var$_objectSpread($f13f036027abcf7c$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $f13f036027abcf7c$var$_objectSpread($f13f036027abcf7c$var$_objectSpread({}, renderState), {}, {
                    clearRefinements: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var createURL = _ref2.createURL, scopedResults = _ref2.scopedResults, results = _ref2.results;
                connectorState.attributesToClear = scopedResults.reduce(function(attributesToClear, scopedResult) {
                    return attributesToClear.concat($f13f036027abcf7c$var$getAttributesToClear({
                        scopedResult: scopedResult,
                        includedAttributes: includedAttributes,
                        excludedAttributes: excludedAttributes,
                        transformItems: transformItems,
                        results: results
                    }));
                }, []);
                connectorState.refine = function() {
                    connectorState.attributesToClear.forEach(function(_ref3) {
                        var indexHelper = _ref3.helper, items = _ref3.items;
                        indexHelper.setState((0, $5da3c6d65fd650b3$export$c8b9db57471d846b)({
                            helper: indexHelper,
                            attributesToClear: items
                        })).search();
                    });
                };
                connectorState.createURL = function() {
                    return createURL((0, $24da987d0ad66cbb$export$8049d91f25899769).apply(void 0, $f13f036027abcf7c$var$_toConsumableArray(connectorState.attributesToClear.map(function(_ref4) {
                        var indexHelper = _ref4.helper, items = _ref4.items;
                        return (0, $5da3c6d65fd650b3$export$c8b9db57471d846b)({
                            helper: indexHelper,
                            attributesToClear: items
                        });
                    }))));
                };
                var canRefine = connectorState.attributesToClear.some(function(attributeToClear) {
                    return attributeToClear.items.length > 0;
                });
                return {
                    canRefine: canRefine,
                    hasRefinements: canRefine,
                    refine: cachedRefine,
                    createURL: cachedCreateURL,
                    widgetParams: widgetParams
                };
            }
        };
    };
};
function $f13f036027abcf7c$var$getAttributesToClear(_ref5) {
    var scopedResult = _ref5.scopedResult, includedAttributes = _ref5.includedAttributes, excludedAttributes = _ref5.excludedAttributes, transformItems = _ref5.transformItems, results = _ref5.results;
    var includesQuery = includedAttributes.indexOf("query") !== -1 || excludedAttributes.indexOf("query") === -1;
    return {
        helper: scopedResult.helper,
        items: transformItems((0, $57b7a6525254cbcf$export$f70730c3d1fc524e)((0, $c3ac91646036dced$export$d9f33760e70a0a)(scopedResult.results, scopedResult.helper.state, includesQuery).map(function(refinement) {
            return refinement.attribute;
        }).filter(function(attribute) {
            return(// If the array is empty (default case), we keep all the attributes
            includedAttributes.length === 0 || // Otherwise, only add the specified attributes
            includedAttributes.indexOf(attribute) !== -1);
        }).filter(function(attribute) {
            return(// If the query is included, we ignore the default `excludedAttributes = ['query']`
            attribute === "query" && includesQuery || // Otherwise, ignore the excluded attributes
            excludedAttributes.indexOf(attribute) === -1);
        })), {
            results: results
        })
    };
}
var $f13f036027abcf7c$export$2e2bcd8739ae039 = $f13f036027abcf7c$var$connectClearRefinements;





var $b158d065a1c37346$var$defaultTemplates = {
    resetLabel: function resetLabel() {
        return "Clear refinements";
    }
};
var $b158d065a1c37346$export$2e2bcd8739ae039 = $b158d065a1c37346$var$defaultTemplates;


function $b633a7eab5a42a6f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b633a7eab5a42a6f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b633a7eab5a42a6f$var$_typeof(o);
}
function $b633a7eab5a42a6f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b633a7eab5a42a6f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b633a7eab5a42a6f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b633a7eab5a42a6f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b633a7eab5a42a6f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b633a7eab5a42a6f$var$_defineProperty(obj, key, value) {
    key = $b633a7eab5a42a6f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b633a7eab5a42a6f$var$_toPropertyKey(t) {
    var i = $b633a7eab5a42a6f$var$_toPrimitive(t, "string");
    return "symbol" == $b633a7eab5a42a6f$var$_typeof(i) ? i : String(i);
}
function $b633a7eab5a42a6f$var$_toPrimitive(t, r) {
    if ("object" != $b633a7eab5a42a6f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b633a7eab5a42a6f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b633a7eab5a42a6f$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "clear-refinements"
});
var $b633a7eab5a42a6f$var$suit = (0, $23fceae7dc9dc95c$export$d8556a2a8f973135)("ClearRefinements");
var $b633a7eab5a42a6f$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses, renderState = _ref.renderState, templates = _ref.templates;
    return function(_ref2, isFirstRendering) {
        var refine = _ref2.refine, canRefine = _ref2.canRefine, instantSearchInstance = _ref2.instantSearchInstance;
        if (isFirstRendering) {
            renderState.templateProps = (0, $4a70ab09dd697263$export$2938ff6a58d41f25)({
                defaultTemplates: (0, $b158d065a1c37346$export$2e2bcd8739ae039),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            return;
        }
        (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)((0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $934c4dac7fa75ff4$export$2e2bcd8739ae039), {
            refine: refine,
            cssClasses: cssClasses,
            hasRefinements: canRefine,
            templateProps: renderState.templateProps
        }), containerNode);
    };
};
var $b633a7eab5a42a6f$var$clearRefinements = function clearRefinements(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, _ref3$templates = _ref3.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, includedAttributes = _ref3.includedAttributes, excludedAttributes = _ref3.excludedAttributes, transformItems = _ref3.transformItems, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses;
    if (!container) throw new Error($b633a7eab5a42a6f$var$withUsage("The `container` option is required."));
    var containerNode = (0, $b8c98bbd5148a964$export$ffb2c7b8d67c359a)(container);
    var cssClasses = {
        root: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($b633a7eab5a42a6f$var$suit(), userCssClasses.root),
        button: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($b633a7eab5a42a6f$var$suit({
            descendantName: "button"
        }), userCssClasses.button),
        disabledButton: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($b633a7eab5a42a6f$var$suit({
            descendantName: "button",
            modifierName: "disabled"
        }), userCssClasses.disabledButton)
    };
    var specializedRenderer = $b633a7eab5a42a6f$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        renderState: {},
        templates: templates
    });
    var makeWidget = (0, $f13f036027abcf7c$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $b633a7eab5a42a6f$var$_objectSpread($b633a7eab5a42a6f$var$_objectSpread({}, makeWidget({
        includedAttributes: includedAttributes,
        excludedAttributes: excludedAttributes,
        transformItems: transformItems
    })), {}, {
        $$widgetType: "ais.clearRefinements"
    });
};
var $b633a7eab5a42a6f$export$2e2bcd8739ae039 = $b633a7eab5a42a6f$var$clearRefinements;


const $ea1125e4c972aea4$export$d0e6b6bfede2a57 = (0, $b633a7eab5a42a6f$export$2e2bcd8739ae039)({
    container: '[data-widget="clear-filters"]',
    templates: {
        resetLabel (_, { html: html }) {
            return html`
        <div class="clear-filters">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="11"
            viewBox="0 0 11 11"
          >
            <g fill="none" fill-rule="evenodd" opacity=".4">
              <path d="M0 0h11v11H0z" />
              <path
                fill="#000"
                fill-rule="nonzero"
                d="M8.26 2.75a3.896 3.896 0 1 0 1.102 3.262l.007-.056a.49.49 0 0 1 .485-.456c.253 0 .451.206.437.457 0 0 .012-.109-.006.061a4.813 4.813 0 1 1-1.348-3.887v-.987a.458.458 0 1 1 .917.002v2.062a.459.459 0 0 1-.459.459H7.334a.458.458 0 1 1-.002-.917h.928z"
              />
            </g>
          </svg>

          Réinitialiser les filtres
        </div>
      `;
        }
    }
});



const $257ef55429b8bd37$var$clearFilters = (0, $99926ac7ef17db44$export$2e2bcd8739ae039)({
    hidden ({ results: results }) {
        return Boolean(results && results.nbHits > 0);
    }
})((0, $b633a7eab5a42a6f$export$2e2bcd8739ae039));
const $257ef55429b8bd37$export$cdb826049ff99b14 = $257ef55429b8bd37$var$clearFilters({
    container: '[data-widget="clear-filters-empty-state"]',
    templates: {
        resetLabel: (_, { html: html })=>{
            return html`
        <div class="clear-filters">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="11"
            viewBox="0 0 11 11"
          >
            <g fill="none" fill-rule="evenodd">
              <path d="M0 0h11v11H0z" />
              <path
                fill="#000"
                fill-rule="nonzero"
                d="M8.26 2.75a3.896 3.896 0 1 0 1.102 3.262l.007-.056a.49.49 0 0 1 .485-.456c.253 0 .451.206.437.457 0 0 .012-.109-.006.061a4.813 4.813 0 1 1-1.348-3.887v-.987a.458.458 0 1 1 .917.002v2.062a.459.459 0 0 1-.459.459H7.334a.458.458 0 1 1-.002-.917h.928z"
              />
            </g>
          </svg>

          Réinitialiser les filtres
        </div>
      `;
        }
    }
});



const $04db2a6f6470b76f$var$resultsContainer = document.querySelector(".container-results");
const $04db2a6f6470b76f$var$clearRefinements = (0, $f13f036027abcf7c$export$2e2bcd8739ae039)(({ refine: refine, widgetParams: widgetParams }, isFirstRender)=>{
    const { container: container } = widgetParams;
    const containerNode = document.querySelector(container);
    if (isFirstRender) {
        const wrapper = document.createElement("div");
        wrapper.classList.add("ais-ClearRefinements");
        const button = document.createElement("button");
        button.classList.add("ais-ClearRefinements-button");
        button.textContent = "R\xe9initialiser";
        button.addEventListener("click", ()=>{
            refine();
            document.body.classList.remove("filtering");
            $04db2a6f6470b76f$var$resultsContainer.scrollIntoView();
        });
        wrapper.appendChild(button);
        containerNode.appendChild(wrapper);
    }
});
const $04db2a6f6470b76f$export$c7331590acc5e7ca = $04db2a6f6470b76f$var$clearRefinements({
    container: '[data-widget="clear-filters-mobile"]'
});




function $fb7473671fcf0599$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fb7473671fcf0599$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fb7473671fcf0599$var$_typeof(o);
}
function $fb7473671fcf0599$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb7473671fcf0599$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb7473671fcf0599$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fb7473671fcf0599$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb7473671fcf0599$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fb7473671fcf0599$var$_defineProperty(obj, key, value) {
    key = $fb7473671fcf0599$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fb7473671fcf0599$var$_toPropertyKey(t) {
    var i = $fb7473671fcf0599$var$_toPrimitive(t, "string");
    return "symbol" == $fb7473671fcf0599$var$_typeof(i) ? i : String(i);
}
function $fb7473671fcf0599$var$_toPrimitive(t, r) {
    if ("object" != $fb7473671fcf0599$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fb7473671fcf0599$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * Refine the given search parameters.
 */ var $fb7473671fcf0599$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "configure",
    connector: true
});
function $fb7473671fcf0599$var$getInitialSearchParameters(state, widgetParams) {
    // We leverage the helper internals to remove the `widgetParams` from
    // the state. The function `setQueryParameters` omits the values that
    // are `undefined` on the next state.
    return state.setQueryParameters(Object.keys(widgetParams.searchParameters).reduce(function(acc, key) {
        return $fb7473671fcf0599$var$_objectSpread($fb7473671fcf0599$var$_objectSpread({}, acc), {}, $fb7473671fcf0599$var$_defineProperty({}, key, undefined));
    }, {}));
}
var $fb7473671fcf0599$var$connectConfigure = function connectConfigure() {
    var renderFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $846d3432ff405e8b$export$8793edee2d425525);
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $846d3432ff405e8b$export$8793edee2d425525);
    return function(widgetParams) {
        if (!widgetParams || !(0, $2024d8874034c7cb$export$53b83ca8eaab0383)(widgetParams.searchParameters)) throw new Error($fb7473671fcf0599$var$withUsage("The `searchParameters` option expects an object."));
        var connectorState = {};
        function refine(helper) {
            return function(searchParameters) {
                // Merge new `searchParameters` with the ones set from other widgets
                var actualState = $fb7473671fcf0599$var$getInitialSearchParameters(helper.state, widgetParams);
                var nextSearchParameters = (0, $24da987d0ad66cbb$export$8049d91f25899769)(actualState, new (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports))).SearchParameters(searchParameters));
                // Update original `widgetParams.searchParameters` to the new refined one
                widgetParams.searchParameters = searchParameters;
                // Trigger a search with the resolved search parameters
                helper.setState(nextSearchParameters).search();
            };
        }
        return {
            $$type: "ais.configure",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($fb7473671fcf0599$var$_objectSpread($fb7473671fcf0599$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($fb7473671fcf0599$var$_objectSpread($fb7473671fcf0599$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref) {
                var state = _ref.state;
                unmountFn();
                return $fb7473671fcf0599$var$getInitialSearchParameters(state, widgetParams);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                var _renderState$configur;
                var widgetRenderState = this.getWidgetRenderState(renderOptions);
                return $fb7473671fcf0599$var$_objectSpread($fb7473671fcf0599$var$_objectSpread({}, renderState), {}, {
                    configure: $fb7473671fcf0599$var$_objectSpread($fb7473671fcf0599$var$_objectSpread({}, widgetRenderState), {}, {
                        widgetParams: $fb7473671fcf0599$var$_objectSpread($fb7473671fcf0599$var$_objectSpread({}, widgetRenderState.widgetParams), {}, {
                            searchParameters: (0, $24da987d0ad66cbb$export$8049d91f25899769)(new (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports))).SearchParameters((_renderState$configur = renderState.configure) === null || _renderState$configur === void 0 ? void 0 : _renderState$configur.widgetParams.searchParameters), new (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports))).SearchParameters(widgetRenderState.widgetParams.searchParameters)).getQueryParams()
                        })
                    })
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var helper = _ref2.helper;
                if (!connectorState.refine) connectorState.refine = refine(helper);
                return {
                    refine: connectorState.refine,
                    widgetParams: widgetParams
                };
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _ref3) {
                var uiState = _ref3.uiState;
                return (0, $24da987d0ad66cbb$export$8049d91f25899769)(state, new (0, (/*@__PURE__*/$parcel$interopDefault($74e7126a05d3520a$exports))).SearchParameters($fb7473671fcf0599$var$_objectSpread($fb7473671fcf0599$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)));
            },
            getWidgetUiState: function getWidgetUiState(uiState) {
                return $fb7473671fcf0599$var$_objectSpread($fb7473671fcf0599$var$_objectSpread({}, uiState), {}, {
                    configure: $fb7473671fcf0599$var$_objectSpread($fb7473671fcf0599$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)
                });
            }
        };
    };
};
var $fb7473671fcf0599$export$2e2bcd8739ae039 = $fb7473671fcf0599$var$connectConfigure;



function $e4b1c5399ad737e3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e4b1c5399ad737e3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e4b1c5399ad737e3$var$_typeof(o);
}
function $e4b1c5399ad737e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e4b1c5399ad737e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e4b1c5399ad737e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e4b1c5399ad737e3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e4b1c5399ad737e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e4b1c5399ad737e3$var$_defineProperty(obj, key, value) {
    key = $e4b1c5399ad737e3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e4b1c5399ad737e3$var$_toPropertyKey(t) {
    var i = $e4b1c5399ad737e3$var$_toPrimitive(t, "string");
    return "symbol" == $e4b1c5399ad737e3$var$_typeof(i) ? i : String(i);
}
function $e4b1c5399ad737e3$var$_toPrimitive(t, r) {
    if ("object" != $e4b1c5399ad737e3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e4b1c5399ad737e3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * A list of [search parameters](https://www.algolia.com/doc/api-reference/search-api-parameters/)
 * to enable when the widget mounts.
 */ var $e4b1c5399ad737e3$var$configure = function configure(widgetParams) {
    // This is a renderless widget that falls back to the connector's
    // noop render and unmount functions.
    var makeWidget = (0, $fb7473671fcf0599$export$2e2bcd8739ae039)((0, $846d3432ff405e8b$export$8793edee2d425525));
    return $e4b1c5399ad737e3$var$_objectSpread($e4b1c5399ad737e3$var$_objectSpread({}, makeWidget({
        searchParameters: widgetParams
    })), {}, {
        $$widgetType: "ais.configure"
    });
};
var $e4b1c5399ad737e3$export$2e2bcd8739ae039 = $e4b1c5399ad737e3$var$configure;


const $5fdb0c2fe0f84a0b$export$1670bf621bbc68f3 = (0, $e4b1c5399ad737e3$export$2e2bcd8739ae039)({
    attributesToSnippet: [
        "description:10"
    ],
    snippetEllipsisText: "\u2026",
    removeWordsIfNoResults: "allOptional"
});




const $268f8fc6e91c0741$var$datesRefinementList = (0, $99926ac7ef17db44$export$2e2bcd8739ae039)({
    templates: {
        header () {
            return "P\xe9riode";
        },
        collapseButtonText: $c693740ce5243d42$export$21cca13ffe0ab3b8
    },
    collapsed: ()=>false
})((0, $9f5a6a0cb29ddb10$export$2e2bcd8739ae039));
const $268f8fc6e91c0741$export$116e10bb000c6f7f = $268f8fc6e91c0741$var$datesRefinementList({
    container: '[data-widget="dates"]',
    attribute: "date_web",
    limit: 5,
    showMore: true,
    searchable: true,
    searchablePlaceholder: "Rechercher des p\xe9riodes...",
    templates: {
        searchableSubmit: (_, { html: html })=>{
            return html`
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 14 14"
                >
                <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#21243D"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.33"
                    transform="translate(1 1)"
                >
                    <circle cx="5.333" cy="5.333" r="5.333" />
                    <path d="M12 12L9.1 9.1" />
                </g>
                </svg>
            `;
        },
        showMoreText: ({ isShowingMore: isShowingMore }, { html: html })=>{
            return isShowingMore ? html`Voir moins...` : html`Voir plus...`;
        }
    }
});






function $1faa477fd073ce0a$var$Selector(_ref) {
    var currentValue = _ref.currentValue, options = _ref.options, cssClasses = _ref.cssClasses, setValue = _ref.setValue, ariaLabel = _ref.ariaLabel;
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("select", {
        className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(cssClasses.select),
        onChange: function onChange(event) {
            return setValue(event.target.value);
        },
        value: "".concat(currentValue),
        "aria-label": ariaLabel
    }, options.map(function(option) {
        return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("option", {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(cssClasses.option),
            key: option.label + option.value,
            value: "".concat(option.value)
        }, option.label);
    }));
}
var $1faa477fd073ce0a$export$2e2bcd8739ae039 = $1faa477fd073ce0a$var$Selector;



function $7b03dc2fe0d21787$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7b03dc2fe0d21787$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7b03dc2fe0d21787$var$_typeof(o);
}
function $7b03dc2fe0d21787$var$_toConsumableArray(arr) {
    return $7b03dc2fe0d21787$var$_arrayWithoutHoles(arr) || $7b03dc2fe0d21787$var$_iterableToArray(arr) || $7b03dc2fe0d21787$var$_unsupportedIterableToArray(arr) || $7b03dc2fe0d21787$var$_nonIterableSpread();
}
function $7b03dc2fe0d21787$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7b03dc2fe0d21787$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7b03dc2fe0d21787$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7b03dc2fe0d21787$var$_arrayLikeToArray(o, minLen);
}
function $7b03dc2fe0d21787$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $7b03dc2fe0d21787$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $7b03dc2fe0d21787$var$_arrayLikeToArray(arr);
}
function $7b03dc2fe0d21787$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7b03dc2fe0d21787$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7b03dc2fe0d21787$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7b03dc2fe0d21787$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7b03dc2fe0d21787$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7b03dc2fe0d21787$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7b03dc2fe0d21787$var$_defineProperty(obj, key, value) {
    key = $7b03dc2fe0d21787$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7b03dc2fe0d21787$var$_toPropertyKey(t) {
    var i = $7b03dc2fe0d21787$var$_toPrimitive(t, "string");
    return "symbol" == $7b03dc2fe0d21787$var$_typeof(i) ? i : String(i);
}
function $7b03dc2fe0d21787$var$_toPrimitive(t, r) {
    if ("object" != $7b03dc2fe0d21787$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7b03dc2fe0d21787$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7b03dc2fe0d21787$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "hits-per-page",
    connector: true
});
var $7b03dc2fe0d21787$var$connectHitsPerPage = function connectHitsPerPage(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $846d3432ff405e8b$export$8793edee2d425525);
    (0, $300f63447e4459ed$export$adc2a8e09aa583ee)(renderFn, $7b03dc2fe0d21787$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, userItems = _ref.items, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (!Array.isArray(userItems)) throw new Error($7b03dc2fe0d21787$var$withUsage("The `items` option expects an array of objects."));
        var items = userItems;
        var defaultItems = items.filter(function(item) {
            return item.default === true;
        });
        if (defaultItems.length === 0) throw new Error($7b03dc2fe0d21787$var$withUsage("A default value must be specified in `items`."));
        if (defaultItems.length > 1) throw new Error($7b03dc2fe0d21787$var$withUsage("More than one default value is specified in `items`."));
        var defaultItem = defaultItems[0];
        var normalizeItems = function normalizeItems(_ref2) {
            var hitsPerPage = _ref2.hitsPerPage;
            return items.map(function(item) {
                return $7b03dc2fe0d21787$var$_objectSpread($7b03dc2fe0d21787$var$_objectSpread({}, item), {}, {
                    isRefined: Number(item.value) === Number(hitsPerPage)
                });
            });
        };
        var connectorState = {
            getRefine: function getRefine(helper) {
                return function(value) {
                    return !value && value !== 0 ? helper.setQueryParameter("hitsPerPage", undefined).search() : helper.setQueryParameter("hitsPerPage", value).search();
                };
            },
            createURLFactory: function createURLFactory(_ref3) {
                var state = _ref3.state, createURL = _ref3.createURL, getWidgetUiState = _ref3.getWidgetUiState, helper = _ref3.helper;
                return function(value) {
                    return createURL(function(uiState) {
                        return getWidgetUiState(uiState, {
                            searchParameters: state.resetPage().setQueryParameter("hitsPerPage", !value && value !== 0 ? undefined : value),
                            helper: helper
                        });
                    });
                };
            }
        };
        return {
            $$type: "ais.hitsPerPage",
            init: function init(initOptions) {
                var state = initOptions.state, instantSearchInstance = initOptions.instantSearchInstance;
                var isCurrentInOptions = items.some(function(item) {
                    return Number(state.hitsPerPage) === Number(item.value);
                });
                if (!isCurrentInOptions) items = [
                    // The helper will convert the empty string to `undefined`.
                    {
                        value: "",
                        label: ""
                    }
                ].concat($7b03dc2fe0d21787$var$_toConsumableArray(items));
                renderFn($7b03dc2fe0d21787$var$_objectSpread($7b03dc2fe0d21787$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($7b03dc2fe0d21787$var$_objectSpread($7b03dc2fe0d21787$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref4) {
                var state = _ref4.state;
                unmountFn();
                return state.setQueryParameter("hitsPerPage", undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $7b03dc2fe0d21787$var$_objectSpread($7b03dc2fe0d21787$var$_objectSpread({}, renderState), {}, {
                    hitsPerPage: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref5) {
                var state = _ref5.state, results = _ref5.results, createURL = _ref5.createURL, helper = _ref5.helper;
                var canRefine = results ? results.nbHits > 0 : false;
                return {
                    items: transformItems(normalizeItems(state), {
                        results: results
                    }),
                    refine: connectorState.getRefine(helper),
                    createURL: connectorState.createURLFactory({
                        state: state,
                        createURL: createURL,
                        getWidgetUiState: this.getWidgetUiState,
                        helper: helper
                    }),
                    hasNoResults: !canRefine,
                    canRefine: canRefine,
                    widgetParams: widgetParams
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref6) {
                var searchParameters = _ref6.searchParameters;
                var hitsPerPage = searchParameters.hitsPerPage;
                if (hitsPerPage === undefined || hitsPerPage === defaultItem.value) return uiState;
                return $7b03dc2fe0d21787$var$_objectSpread($7b03dc2fe0d21787$var$_objectSpread({}, uiState), {}, {
                    hitsPerPage: hitsPerPage
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref7) {
                var uiState = _ref7.uiState;
                return searchParameters.setQueryParameters({
                    hitsPerPage: uiState.hitsPerPage || defaultItem.value
                });
            }
        };
    };
};
var $7b03dc2fe0d21787$export$2e2bcd8739ae039 = $7b03dc2fe0d21787$var$connectHitsPerPage;




function $9f2336e44a1eee76$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9f2336e44a1eee76$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9f2336e44a1eee76$var$_typeof(o);
}
function $9f2336e44a1eee76$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f2336e44a1eee76$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f2336e44a1eee76$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9f2336e44a1eee76$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f2336e44a1eee76$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9f2336e44a1eee76$var$_defineProperty(obj, key, value) {
    key = $9f2336e44a1eee76$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9f2336e44a1eee76$var$_toPropertyKey(t) {
    var i = $9f2336e44a1eee76$var$_toPrimitive(t, "string");
    return "symbol" == $9f2336e44a1eee76$var$_typeof(i) ? i : String(i);
}
function $9f2336e44a1eee76$var$_toPrimitive(t, r) {
    if ("object" != $9f2336e44a1eee76$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9f2336e44a1eee76$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9f2336e44a1eee76$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "hits-per-page"
});
var $9f2336e44a1eee76$var$suit = (0, $23fceae7dc9dc95c$export$d8556a2a8f973135)("HitsPerPage");
var $9f2336e44a1eee76$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses;
    return function(_ref2, isFirstRendering) {
        var items = _ref2.items, refine = _ref2.refine;
        if (isFirstRendering) return;
        var _ref3 = (0, $6233c69c2fe30ad7$export$71aa6c912b956294)(items, function(_ref4) {
            var isRefined = _ref4.isRefined;
            return isRefined;
        }) || {}, currentValue = _ref3.value;
        (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)((0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("div", {
            className: cssClasses.root
        }, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $1faa477fd073ce0a$export$2e2bcd8739ae039), {
            cssClasses: cssClasses,
            currentValue: currentValue,
            options: items,
            setValue: refine
        })), containerNode);
    };
};
var $9f2336e44a1eee76$var$hitsPerPage = function hitsPerPage(widgetParams) {
    var _ref5 = widgetParams || {}, container = _ref5.container, items = _ref5.items, _ref5$cssClasses = _ref5.cssClasses, userCssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses, transformItems = _ref5.transformItems;
    if (!container) throw new Error($9f2336e44a1eee76$var$withUsage("The `container` option is required."));
    var containerNode = (0, $b8c98bbd5148a964$export$ffb2c7b8d67c359a)(container);
    var cssClasses = {
        root: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f2336e44a1eee76$var$suit(), userCssClasses.root),
        select: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f2336e44a1eee76$var$suit({
            descendantName: "select"
        }), userCssClasses.select),
        option: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($9f2336e44a1eee76$var$suit({
            descendantName: "option"
        }), userCssClasses.option)
    };
    var specializedRenderer = $9f2336e44a1eee76$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses
    });
    var makeWidget = (0, $7b03dc2fe0d21787$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $9f2336e44a1eee76$var$_objectSpread($9f2336e44a1eee76$var$_objectSpread({}, makeWidget({
        items: items,
        transformItems: transformItems
    })), {}, {
        $$widgetType: "ais.hitsPerPage"
    });
};
var $9f2336e44a1eee76$export$2e2bcd8739ae039 = $9f2336e44a1eee76$var$hitsPerPage;


const $13785c5fb5455682$var$items = [
    {
        label: "32 r\xe9sultats par page",
        value: 32,
        default: true
    },
    {
        label: "64 r\xe9sultats par page",
        value: 64
    },
    {
        label: "96 r\xe9sultats par page",
        value: 96
    }
];
const $13785c5fb5455682$export$640d434f5a401408 = (0, $9f2336e44a1eee76$export$2e2bcd8739ae039)({
    container: '[data-widget="hits-per-page"]',
    items: $13785c5fb5455682$var$items
});
function $13785c5fb5455682$export$d95bb141aa94dd5d(hitsPerPageValue) {
    if ($13785c5fb5455682$var$items.map((item)=>item.value).indexOf(Number(hitsPerPageValue)) !== -1) return hitsPerPageValue;
    return undefined;
}




const $f8fe226bdf859eba$var$ownersRefinementList = (0, $99926ac7ef17db44$export$2e2bcd8739ae039)({
    templates: {
        header () {
            return "Propri\xe9taire";
        },
        collapseButtonText: $c693740ce5243d42$export$21cca13ffe0ab3b8
    },
    collapsed: ()=>false
})((0, $9f5a6a0cb29ddb10$export$2e2bcd8739ae039));
const $f8fe226bdf859eba$export$45e6fc4a87827098 = $f8fe226bdf859eba$var$ownersRefinementList({
    container: '[data-widget="owners"]',
    attribute: "proprietaire",
    limit: 5,
    showMore: true,
    searchable: true,
    searchablePlaceholder: "Rechercher des propri\xe9taires...",
    templates: {
        searchableSubmit: (_, { html: html })=>{
            return html`
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 14 14"
                >
                <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#21243D"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.33"
                    transform="translate(1 1)"
                >
                    <circle cx="5.333" cy="5.333" r="5.333" />
                    <path d="M12 12L9.1 9.1" />
                </g>
                </svg>
            `;
        },
        showMoreText: ({ isShowingMore: isShowingMore }, { html: html })=>{
            return isShowingMore ? html`Voir moins...` : html`Voir plus...`;
        }
    }
});








function $0b66e31c767976bf$var$Pagination(props) {
    function createClickHandler(pageNumber) {
        return function(event) {
            if ((0, $d3ddefa5c7b3300b$export$5b1771037ab7c451)(event)) // do not alter the default browser behavior
            // if one special key is down
            return;
            event.preventDefault();
            props.setCurrentPage(pageNumber);
        };
    }
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("div", {
        className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(props.cssClasses.root, props.nbPages <= 1 && props.cssClasses.noRefinementRoot)
    }, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("ul", {
        className: props.cssClasses.list
    }, props.showFirst && (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)($0b66e31c767976bf$var$PaginationLink, {
        ariaLabel: "First Page",
        className: props.cssClasses.firstPageItem,
        isDisabled: props.isFirstPage,
        templates: props.templates,
        templateKey: "first",
        pageNumber: 0,
        createURL: props.createURL,
        cssClasses: props.cssClasses,
        createClickHandler: createClickHandler
    }), props.showPrevious && (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)($0b66e31c767976bf$var$PaginationLink, {
        ariaLabel: "Previous Page",
        className: props.cssClasses.previousPageItem,
        isDisabled: props.isFirstPage,
        templates: props.templates,
        templateKey: "previous",
        pageNumber: props.currentPage - 1,
        createURL: props.createURL,
        cssClasses: props.cssClasses,
        createClickHandler: createClickHandler
    }), props.pages.map(function(pageNumber) {
        return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)($0b66e31c767976bf$var$PaginationLink, {
            key: pageNumber,
            ariaLabel: "Page ".concat(pageNumber + 1),
            className: props.cssClasses.pageItem,
            isSelected: pageNumber === props.currentPage,
            templates: props.templates,
            templateKey: "page",
            pageNumber: pageNumber,
            createURL: props.createURL,
            cssClasses: props.cssClasses,
            createClickHandler: createClickHandler
        });
    }), props.showNext && (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)($0b66e31c767976bf$var$PaginationLink, {
        ariaLabel: "Next Page",
        className: props.cssClasses.nextPageItem,
        isDisabled: props.isLastPage,
        templates: props.templates,
        templateKey: "next",
        pageNumber: props.currentPage + 1,
        createURL: props.createURL,
        cssClasses: props.cssClasses,
        createClickHandler: createClickHandler
    }), props.showLast && (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)($0b66e31c767976bf$var$PaginationLink, {
        ariaLabel: "Last Page, Page ".concat(props.nbPages),
        className: props.cssClasses.lastPageItem,
        isDisabled: props.isLastPage,
        templates: props.templates,
        templateKey: "last",
        pageNumber: props.nbPages - 1,
        createURL: props.createURL,
        cssClasses: props.cssClasses,
        createClickHandler: createClickHandler
    })));
}
function $0b66e31c767976bf$var$PaginationLink(_ref) {
    var templates = _ref.templates, templateKey = _ref.templateKey, ariaLabel = _ref.ariaLabel, pageNumber = _ref.pageNumber, className = _ref.className, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, cssClasses = _ref.cssClasses, createURL = _ref.createURL, createClickHandler = _ref.createClickHandler;
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("li", {
        className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(cssClasses.item, isDisabled && cssClasses.disabledItem, className, isSelected && cssClasses.selectedItem)
    }, isDisabled ? (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), {
        rootTagName: "span",
        rootProps: {
            className: cssClasses.link,
            "aria-label": ariaLabel
        },
        templateKey: templateKey,
        templates: templates,
        data: {
            page: pageNumber + 1
        }
    }) : (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), {
        rootTagName: "a",
        rootProps: {
            className: cssClasses.link,
            "aria-label": ariaLabel,
            href: createURL(pageNumber),
            onClick: createClickHandler(pageNumber)
        },
        templateKey: templateKey,
        templates: templates,
        data: {
            page: pageNumber + 1
        }
    }));
}
var $0b66e31c767976bf$export$2e2bcd8739ae039 = $0b66e31c767976bf$var$Pagination;



function $3a27e3850682efea$var$_toConsumableArray(arr) {
    return $3a27e3850682efea$var$_arrayWithoutHoles(arr) || $3a27e3850682efea$var$_iterableToArray(arr) || $3a27e3850682efea$var$_unsupportedIterableToArray(arr) || $3a27e3850682efea$var$_nonIterableSpread();
}
function $3a27e3850682efea$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3a27e3850682efea$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3a27e3850682efea$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3a27e3850682efea$var$_arrayLikeToArray(o, minLen);
}
function $3a27e3850682efea$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3a27e3850682efea$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3a27e3850682efea$var$_arrayLikeToArray(arr);
}
function $3a27e3850682efea$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3a27e3850682efea$export$d02631cccf789723(_ref) {
    var _ref$start = _ref.start, start = _ref$start === void 0 ? 0 : _ref$start, end = _ref.end, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step;
    // We can't divide by 0 so we re-assign the step to 1 if it happens.
    var limitStep = step === 0 ? 1 : step;
    // In some cases the array to create has a decimal length.
    // We therefore need to round the value.
    // Example:
    //   { start: 1, end: 5000, step: 500 }
    //   => Array length = (5000 - 1) / 500 = 9.998
    var arrayLength = Math.round((end - start) / limitStep);
    return $3a27e3850682efea$var$_toConsumableArray(Array(arrayLength)).map(function(_, current) {
        return start + current * limitStep;
    });
}


function $4c976f837cc47819$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4c976f837cc47819$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4c976f837cc47819$var$_typeof(o);
}
function $4c976f837cc47819$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4c976f837cc47819$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4c976f837cc47819$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4c976f837cc47819$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4c976f837cc47819$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4c976f837cc47819$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4c976f837cc47819$var$_defineProperty(obj, key, value) {
    key = $4c976f837cc47819$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4c976f837cc47819$var$_toPropertyKey(t) {
    var i = $4c976f837cc47819$var$_toPrimitive(t, "string");
    return "symbol" == $4c976f837cc47819$var$_typeof(i) ? i : String(i);
}
function $4c976f837cc47819$var$_toPrimitive(t, r) {
    if ("object" != $4c976f837cc47819$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4c976f837cc47819$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4c976f837cc47819$var$Paginator = /*#__PURE__*/ function() {
    function Paginator(params) {
        $4c976f837cc47819$var$_classCallCheck(this, Paginator);
        $4c976f837cc47819$var$_defineProperty(this, "currentPage", void 0);
        $4c976f837cc47819$var$_defineProperty(this, "total", void 0);
        $4c976f837cc47819$var$_defineProperty(this, "padding", void 0);
        this.currentPage = params.currentPage;
        this.total = params.total;
        this.padding = params.padding;
    }
    $4c976f837cc47819$var$_createClass(Paginator, [
        {
            key: "pages",
            value: function pages() {
                var total = this.total, currentPage = this.currentPage, padding = this.padding;
                if (total === 0) return [
                    0
                ];
                var totalDisplayedPages = this.nbPagesDisplayed(padding, total);
                if (totalDisplayedPages === total) return (0, $3a27e3850682efea$export$d02631cccf789723)({
                    end: total
                });
                var paddingLeft = this.calculatePaddingLeft(currentPage, padding, total, totalDisplayedPages);
                var paddingRight = totalDisplayedPages - paddingLeft;
                var first = currentPage - paddingLeft;
                var last = currentPage + paddingRight;
                return (0, $3a27e3850682efea$export$d02631cccf789723)({
                    start: first,
                    end: last
                });
            }
        },
        {
            key: "nbPagesDisplayed",
            value: function nbPagesDisplayed(padding, total) {
                return Math.min(2 * padding + 1, total);
            }
        },
        {
            key: "calculatePaddingLeft",
            value: function calculatePaddingLeft(current, padding, total, totalDisplayedPages) {
                if (current <= padding) return current;
                if (current >= total - padding) return totalDisplayedPages - (total - current);
                return padding;
            }
        },
        {
            key: "isLastPage",
            value: function isLastPage() {
                return this.currentPage >= this.total - 1;
            }
        },
        {
            key: "isFirstPage",
            value: function isFirstPage() {
                return this.currentPage <= 0;
            }
        }
    ]);
    return Paginator;
}();
var $4c976f837cc47819$export$2e2bcd8739ae039 = $4c976f837cc47819$var$Paginator;


function $d5be5d98982ac0ca$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d5be5d98982ac0ca$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d5be5d98982ac0ca$var$_typeof(o);
}
function $d5be5d98982ac0ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5be5d98982ac0ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5be5d98982ac0ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d5be5d98982ac0ca$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5be5d98982ac0ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d5be5d98982ac0ca$var$_defineProperty(obj, key, value) {
    key = $d5be5d98982ac0ca$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d5be5d98982ac0ca$var$_toPropertyKey(t) {
    var i = $d5be5d98982ac0ca$var$_toPrimitive(t, "string");
    return "symbol" == $d5be5d98982ac0ca$var$_typeof(i) ? i : String(i);
}
function $d5be5d98982ac0ca$var$_toPrimitive(t, r) {
    if ("object" != $d5be5d98982ac0ca$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d5be5d98982ac0ca$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d5be5d98982ac0ca$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "pagination",
    connector: true
});
/**
 * **Pagination** connector provides the logic to build a widget that will let the user
 * choose the current page of the results.
 *
 * When using the pagination with Algolia, you should be aware that the engine won't provide you pages
 * beyond the 1000th hits by default. You can find more information on the [Algolia documentation](https://www.algolia.com/doc/guides/searching/pagination/#pagination-limitations).
 */ var $d5be5d98982ac0ca$var$connectPagination = function connectPagination(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $846d3432ff405e8b$export$8793edee2d425525);
    (0, $300f63447e4459ed$export$adc2a8e09aa583ee)(renderFn, $d5be5d98982ac0ca$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, totalPages = _ref.totalPages, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? 3 : _ref$padding;
        var pager = new (0, $4c976f837cc47819$export$2e2bcd8739ae039)({
            currentPage: 0,
            total: 0,
            padding: padding
        });
        var connectorState = {};
        function getMaxPage(_ref2) {
            var nbPages = _ref2.nbPages;
            return totalPages !== undefined ? Math.min(totalPages, nbPages) : nbPages;
        }
        return {
            $$type: "ais.pagination",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($d5be5d98982ac0ca$var$_objectSpread($d5be5d98982ac0ca$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($d5be5d98982ac0ca$var$_objectSpread($d5be5d98982ac0ca$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                return state.setQueryParameter("page", undefined);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var page = searchParameters.page || 0;
                if (!page) return uiState;
                return $d5be5d98982ac0ca$var$_objectSpread($d5be5d98982ac0ca$var$_objectSpread({}, uiState), {}, {
                    page: page + 1
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                var page = uiState.page ? uiState.page - 1 : 0;
                return searchParameters.setQueryParameter("page", page);
            },
            getWidgetRenderState: function getWidgetRenderState(_ref6) {
                var results = _ref6.results, helper = _ref6.helper, state = _ref6.state, createURL = _ref6.createURL;
                if (!connectorState.refine) connectorState.refine = function(page) {
                    helper.setPage(page);
                    helper.search();
                };
                if (!connectorState.createURL) connectorState.createURL = function(page) {
                    return createURL(function(uiState) {
                        return $d5be5d98982ac0ca$var$_objectSpread($d5be5d98982ac0ca$var$_objectSpread({}, uiState), {}, {
                            page: page + 1
                        });
                    });
                };
                var page = state.page || 0;
                var nbPages = getMaxPage(results || {
                    nbPages: 0
                });
                pager.currentPage = page;
                pager.total = nbPages;
                return {
                    createURL: connectorState.createURL,
                    refine: connectorState.refine,
                    canRefine: nbPages > 1,
                    currentRefinement: page,
                    nbHits: (results === null || results === void 0 ? void 0 : results.nbHits) || 0,
                    nbPages: nbPages,
                    pages: results ? pager.pages() : [],
                    isFirstPage: pager.isFirstPage(),
                    isLastPage: pager.isLastPage(),
                    widgetParams: widgetParams
                };
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $d5be5d98982ac0ca$var$_objectSpread($d5be5d98982ac0ca$var$_objectSpread({}, renderState), {}, {
                    pagination: this.getWidgetRenderState(renderOptions)
                });
            }
        };
    };
};
var $d5be5d98982ac0ca$export$2e2bcd8739ae039 = $d5be5d98982ac0ca$var$connectPagination;




function $dc783a0ea3319147$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dc783a0ea3319147$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dc783a0ea3319147$var$_typeof(o);
}
function $dc783a0ea3319147$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dc783a0ea3319147$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dc783a0ea3319147$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dc783a0ea3319147$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dc783a0ea3319147$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dc783a0ea3319147$var$_defineProperty(obj, key, value) {
    key = $dc783a0ea3319147$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc783a0ea3319147$var$_toPropertyKey(t) {
    var i = $dc783a0ea3319147$var$_toPrimitive(t, "string");
    return "symbol" == $dc783a0ea3319147$var$_typeof(i) ? i : String(i);
}
function $dc783a0ea3319147$var$_toPrimitive(t, r) {
    if ("object" != $dc783a0ea3319147$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dc783a0ea3319147$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $dc783a0ea3319147$var$suit = (0, $23fceae7dc9dc95c$export$d8556a2a8f973135)("Pagination");
var $dc783a0ea3319147$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "pagination"
});
var $dc783a0ea3319147$var$defaultTemplates = {
    previous: function previous() {
        return "\u2039";
    },
    next: function next() {
        return "\u203A";
    },
    page: function page(_ref) {
        var _page = _ref.page;
        return "".concat(_page);
    },
    first: function first() {
        return "\xab";
    },
    last: function last() {
        return "\xbb";
    }
};
var $dc783a0ea3319147$var$renderer = function renderer(_ref2) {
    var containerNode = _ref2.containerNode, cssClasses = _ref2.cssClasses, templates = _ref2.templates, showFirst = _ref2.showFirst, showLast = _ref2.showLast, showPrevious = _ref2.showPrevious, showNext = _ref2.showNext, scrollToNode = _ref2.scrollToNode;
    return function(_ref3, isFirstRendering) {
        var createURL = _ref3.createURL, currentRefinement = _ref3.currentRefinement, nbPages = _ref3.nbPages, pages = _ref3.pages, isFirstPage = _ref3.isFirstPage, isLastPage = _ref3.isLastPage, refine = _ref3.refine;
        if (isFirstRendering) return;
        var setCurrentPage = function setCurrentPage(pageNumber) {
            refine(pageNumber);
            if (scrollToNode !== false) scrollToNode.scrollIntoView();
        };
        (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)((0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $0b66e31c767976bf$export$2e2bcd8739ae039), {
            createURL: createURL,
            cssClasses: cssClasses,
            currentPage: currentRefinement,
            templates: templates,
            nbPages: nbPages,
            pages: pages,
            isFirstPage: isFirstPage,
            isLastPage: isLastPage,
            setCurrentPage: setCurrentPage,
            showFirst: showFirst,
            showLast: showLast,
            showPrevious: showPrevious,
            showNext: showNext
        }), containerNode);
    };
};
var $dc783a0ea3319147$var$pagination = function pagination(widgetParams) {
    var _ref4 = widgetParams || {}, container = _ref4.container, _ref4$templates = _ref4.templates, userTemplates = _ref4$templates === void 0 ? {} : _ref4$templates, _ref4$cssClasses = _ref4.cssClasses, userCssClasses = _ref4$cssClasses === void 0 ? {} : _ref4$cssClasses, totalPages = _ref4.totalPages, padding = _ref4.padding, _ref4$showFirst = _ref4.showFirst, showFirst = _ref4$showFirst === void 0 ? true : _ref4$showFirst, _ref4$showLast = _ref4.showLast, showLast = _ref4$showLast === void 0 ? true : _ref4$showLast, _ref4$showPrevious = _ref4.showPrevious, showPrevious = _ref4$showPrevious === void 0 ? true : _ref4$showPrevious, _ref4$showNext = _ref4.showNext, showNext = _ref4$showNext === void 0 ? true : _ref4$showNext, _ref4$scrollTo = _ref4.scrollTo, userScrollTo = _ref4$scrollTo === void 0 ? "body" : _ref4$scrollTo;
    if (!container) throw new Error($dc783a0ea3319147$var$withUsage("The `container` option is required."));
    var containerNode = (0, $b8c98bbd5148a964$export$ffb2c7b8d67c359a)(container);
    var scrollTo = userScrollTo === true ? "body" : userScrollTo;
    var scrollToNode = scrollTo !== false ? (0, $b8c98bbd5148a964$export$ffb2c7b8d67c359a)(scrollTo) : false;
    var cssClasses = {
        root: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($dc783a0ea3319147$var$suit(), userCssClasses.root),
        noRefinementRoot: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($dc783a0ea3319147$var$suit({
            modifierName: "noRefinement"
        }), userCssClasses.noRefinementRoot),
        list: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($dc783a0ea3319147$var$suit({
            descendantName: "list"
        }), userCssClasses.list),
        item: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($dc783a0ea3319147$var$suit({
            descendantName: "item"
        }), userCssClasses.item),
        firstPageItem: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($dc783a0ea3319147$var$suit({
            descendantName: "item",
            modifierName: "firstPage"
        }), userCssClasses.firstPageItem),
        lastPageItem: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($dc783a0ea3319147$var$suit({
            descendantName: "item",
            modifierName: "lastPage"
        }), userCssClasses.lastPageItem),
        previousPageItem: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($dc783a0ea3319147$var$suit({
            descendantName: "item",
            modifierName: "previousPage"
        }), userCssClasses.previousPageItem),
        nextPageItem: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($dc783a0ea3319147$var$suit({
            descendantName: "item",
            modifierName: "nextPage"
        }), userCssClasses.nextPageItem),
        pageItem: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($dc783a0ea3319147$var$suit({
            descendantName: "item",
            modifierName: "page"
        }), userCssClasses.pageItem),
        selectedItem: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($dc783a0ea3319147$var$suit({
            descendantName: "item",
            modifierName: "selected"
        }), userCssClasses.selectedItem),
        disabledItem: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($dc783a0ea3319147$var$suit({
            descendantName: "item",
            modifierName: "disabled"
        }), userCssClasses.disabledItem),
        link: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($dc783a0ea3319147$var$suit({
            descendantName: "link"
        }), userCssClasses.link)
    };
    var templates = $dc783a0ea3319147$var$_objectSpread($dc783a0ea3319147$var$_objectSpread({}, $dc783a0ea3319147$var$defaultTemplates), userTemplates);
    var specializedRenderer = $dc783a0ea3319147$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        templates: templates,
        showFirst: showFirst,
        showLast: showLast,
        showPrevious: showPrevious,
        showNext: showNext,
        scrollToNode: scrollToNode
    });
    var makeWidget = (0, $d5be5d98982ac0ca$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $dc783a0ea3319147$var$_objectSpread($dc783a0ea3319147$var$_objectSpread({}, makeWidget({
        totalPages: totalPages,
        padding: padding
    })), {}, {
        $$widgetType: "ais.pagination"
    });
};
var $dc783a0ea3319147$export$2e2bcd8739ae039 = $dc783a0ea3319147$var$pagination;


const $d0018dc2ac8d2ba0$var$paginationWithMultiplePages = (0, $99926ac7ef17db44$export$2e2bcd8739ae039)({
    hidden ({ results: results }) {
        return Boolean(results && results.nbPages <= 1);
    }
})((0, $dc783a0ea3319147$export$2e2bcd8739ae039));
const $d0018dc2ac8d2ba0$export$22fa394f3ba39578 = $d0018dc2ac8d2ba0$var$paginationWithMultiplePages({
    container: '[data-widget="pagination"]',
    scrollTo: ".container",
    padding: 2,
    showFirst: false,
    showLast: false,
    templates: {
        previous: (_, { html: html })=>{
            return html`
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke="#000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.143"
          >
            <path d="M9 5H1M5 9L1 5l4-4" />
          </g>
        </svg>
      `;
        },
        next: (_, { html: html })=>{
            return html`
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke="#000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.143"
          >
            <path d="M1 5h8M5 9l4-4-4-4" />
          </g>
        </svg>
      `;
        }
    }
});





var $e0f3c2b2df78bd02$var$_excluded = [
    "classNames",
    "hits",
    "itemComponent",
    "sendEvent",
    "emptyComponent",
    "banner",
    "bannerComponent"
];
// Should be imported from a shared package in the future
function $e0f3c2b2df78bd02$var$createDefaultBannerComponent(_ref) {
    var createElement = _ref.createElement;
    return function DefaultBanner(_ref2) {
        var classNames = _ref2.classNames, banner = _ref2.banner;
        if (!banner.image.urls[0].url) return null;
        return createElement("aside", {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Hits-banner", classNames.bannerRoot)
        }, banner.link ? createElement("a", {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Hits-banner-link", classNames.bannerLink),
            href: banner.link.url,
            target: banner.link.target
        }, createElement("img", {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Hits-banner-image", classNames.bannerImage),
            src: banner.image.urls[0].url,
            alt: banner.image.title
        })) : createElement("img", {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Hits-banner-image", classNames.bannerImage),
            src: banner.image.urls[0].url,
            alt: banner.image.title
        }));
    };
}
function $e0f3c2b2df78bd02$export$abc871145e3e685(_ref3) {
    var createElement = _ref3.createElement, Fragment = _ref3.Fragment;
    var DefaultBannerComponent = $e0f3c2b2df78bd02$var$createDefaultBannerComponent({
        createElement: createElement,
        Fragment: Fragment
    });
    return function Hits(userProps) {
        var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, hits = userProps.hits, ItemComponent = userProps.itemComponent, sendEvent = userProps.sendEvent, EmptyComponent = userProps.emptyComponent, banner = userProps.banner, BannerComponent = userProps.bannerComponent, props = (0, $e873bb60d4749aff$export$2e2bcd8739ae039)(userProps, $e0f3c2b2df78bd02$var$_excluded);
        return createElement("div", (0, $3f4dad95783025c7$export$2e2bcd8739ae039)({}, props, {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Hits", classNames.root, hits.length === 0 && (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Hits--empty", classNames.emptyRoot), props.className)
        }), banner && (BannerComponent ? createElement(BannerComponent, {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Hits-banner", classNames.bannerRoot),
            banner: banner
        }) : createElement(DefaultBannerComponent, {
            classNames: classNames,
            banner: banner
        })), hits.length === 0 && EmptyComponent ? createElement(EmptyComponent, null) : createElement("ol", {
            className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Hits-list", classNames.list)
        }, hits.map(function(hit, index) {
            return createElement(ItemComponent, {
                key: hit.objectID,
                hit: hit,
                index: index,
                className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)("ais-Hits-item", classNames.item),
                onClick: function onClick() {
                    sendEvent("click:internal", hit, "Hit Clicked");
                },
                onAuxClick: function onAuxClick() {
                    sendEvent("click:internal", hit, "Hit Clicked");
                }
            });
        })));
    };
}




function $dd6647243d3b5891$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dd6647243d3b5891$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dd6647243d3b5891$var$_typeof(o);
}
function $dd6647243d3b5891$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd6647243d3b5891$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd6647243d3b5891$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dd6647243d3b5891$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd6647243d3b5891$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dd6647243d3b5891$var$_defineProperty(obj, key, value) {
    key = $dd6647243d3b5891$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dd6647243d3b5891$var$_toPropertyKey(t) {
    var i = $dd6647243d3b5891$var$_toPrimitive(t, "string");
    return "symbol" == $dd6647243d3b5891$var$_typeof(i) ? i : String(i);
}
function $dd6647243d3b5891$var$_toPrimitive(t, r) {
    if ("object" != $dd6647243d3b5891$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dd6647243d3b5891$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $dd6647243d3b5891$export$33d742d8ee5a4609(hits, page, hitsPerPage) {
    return hits.map(function(hit, idx) {
        return $dd6647243d3b5891$var$_objectSpread($dd6647243d3b5891$var$_objectSpread({}, hit), {}, {
            __position: hitsPerPage * page + idx + 1
        });
    });
}

function $8e44a9d176e4c854$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8e44a9d176e4c854$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8e44a9d176e4c854$var$_typeof(o);
}
function $8e44a9d176e4c854$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e44a9d176e4c854$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e44a9d176e4c854$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8e44a9d176e4c854$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e44a9d176e4c854$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8e44a9d176e4c854$var$_defineProperty(obj, key, value) {
    key = $8e44a9d176e4c854$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8e44a9d176e4c854$var$_toPropertyKey(t) {
    var i = $8e44a9d176e4c854$var$_toPrimitive(t, "string");
    return "symbol" == $8e44a9d176e4c854$var$_typeof(i) ? i : String(i);
}
function $8e44a9d176e4c854$var$_toPrimitive(t, r) {
    if ("object" != $8e44a9d176e4c854$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8e44a9d176e4c854$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8e44a9d176e4c854$export$b8f834386ea30952(hits, queryID) {
    if (!queryID) return hits;
    return hits.map(function(hit) {
        return $8e44a9d176e4c854$var$_objectSpread($8e44a9d176e4c854$var$_objectSpread({}, hit), {}, {
            __queryID: queryID
        });
    });
}


function $cce5ac6f4caf08a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cce5ac6f4caf08a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cce5ac6f4caf08a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cce5ac6f4caf08a3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cce5ac6f4caf08a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cce5ac6f4caf08a3$var$_defineProperty(obj, key, value) {
    key = $cce5ac6f4caf08a3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cce5ac6f4caf08a3$var$_toPropertyKey(t) {
    var i = $cce5ac6f4caf08a3$var$_toPrimitive(t, "string");
    return "symbol" == $cce5ac6f4caf08a3$var$_typeof(i) ? i : String(i);
}
function $cce5ac6f4caf08a3$var$_toPrimitive(t, r) {
    if ("object" != $cce5ac6f4caf08a3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cce5ac6f4caf08a3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cce5ac6f4caf08a3$var$_slicedToArray(arr, i) {
    return $cce5ac6f4caf08a3$var$_arrayWithHoles(arr) || $cce5ac6f4caf08a3$var$_iterableToArrayLimit(arr, i) || $cce5ac6f4caf08a3$var$_unsupportedIterableToArray(arr, i) || $cce5ac6f4caf08a3$var$_nonIterableRest();
}
function $cce5ac6f4caf08a3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cce5ac6f4caf08a3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cce5ac6f4caf08a3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cce5ac6f4caf08a3$var$_arrayLikeToArray(o, minLen);
}
function $cce5ac6f4caf08a3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cce5ac6f4caf08a3$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $cce5ac6f4caf08a3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $cce5ac6f4caf08a3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cce5ac6f4caf08a3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cce5ac6f4caf08a3$var$_typeof(o);
}
function $cce5ac6f4caf08a3$var$chunk(arr) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < Math.ceil(arr.length / chunkSize); i++)chunks.push(arr.slice(i * chunkSize, (i + 1) * chunkSize));
    return chunks;
}
function $cce5ac6f4caf08a3$export$2f82a8f6391c6db9(_ref) {
    var getIndex = _ref.getIndex, widgetType = _ref.widgetType, methodName = _ref.methodName, args = _ref.args, instantSearchInstance = _ref.instantSearchInstance;
    // when there's only one argument, that means it's custom
    if (args.length === 1 && $cce5ac6f4caf08a3$var$_typeof(args[0]) === "object") return [
        args[0]
    ];
    var _args$0$split = args[0].split(":"), _args$0$split2 = $cce5ac6f4caf08a3$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
    var hits = args[1];
    var eventName = args[2];
    var additionalData = args[3] || {};
    if (!hits) return [];
    if ((eventType === "click" || eventType === "conversion") && !eventName) return [];
    var hitsArray = Array.isArray(hits) ? hits : [
        hits
    ];
    if (hitsArray.length === 0) return [];
    var queryID = hitsArray[0].__queryID;
    var hitsChunks = $cce5ac6f4caf08a3$var$chunk(hitsArray);
    var objectIDsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.objectID;
        });
    });
    var positionsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.__position;
        });
    });
    if (eventType === "view") {
        if (instantSearchInstance.status !== "idle") return [];
        return hitsChunks.map(function(batch, i) {
            return {
                insightsMethod: "viewedObjectIDs",
                widgetType: widgetType,
                eventType: eventType,
                payload: $cce5ac6f4caf08a3$var$_objectSpread({
                    eventName: eventName || "Hits Viewed",
                    index: getIndex(),
                    objectIDs: objectIDsByChunk[i]
                }, additionalData),
                hits: batch,
                eventModifier: eventModifier
            };
        });
    } else if (eventType === "click") return hitsChunks.map(function(batch, i) {
        return {
            insightsMethod: "clickedObjectIDsAfterSearch",
            widgetType: widgetType,
            eventType: eventType,
            payload: $cce5ac6f4caf08a3$var$_objectSpread({
                eventName: eventName || "Hit Clicked",
                index: getIndex(),
                queryID: queryID,
                objectIDs: objectIDsByChunk[i],
                positions: positionsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else if (eventType === "conversion") return hitsChunks.map(function(batch, i) {
        return {
            insightsMethod: "convertedObjectIDsAfterSearch",
            widgetType: widgetType,
            eventType: eventType,
            payload: $cce5ac6f4caf08a3$var$_objectSpread({
                eventName: eventName || "Hit Converted",
                index: getIndex(),
                queryID: queryID,
                objectIDs: objectIDsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else return [];
}
function $cce5ac6f4caf08a3$export$4139f3a7130239e3(_ref2) {
    var instantSearchInstance = _ref2.instantSearchInstance, getIndex = _ref2.getIndex, widgetType = _ref2.widgetType;
    var sentEvents = {};
    var timer = undefined;
    var sendEventForHits = function sendEventForHits() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var payloads = $cce5ac6f4caf08a3$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            getIndex: getIndex,
            methodName: "sendEvent",
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        payloads.forEach(function(payload) {
            if (payload.eventType === "click" && payload.eventModifier === "internal" && sentEvents[payload.eventType]) return;
            sentEvents[payload.eventType] = true;
            instantSearchInstance.sendEventToInsights(payload);
        });
        clearTimeout(timer);
        timer = setTimeout(function() {
            sentEvents = {};
        }, 0);
    };
    return sendEventForHits;
}
function $cce5ac6f4caf08a3$export$5a3d9973824d9b76(_ref3) {
    var getIndex = _ref3.getIndex, widgetType = _ref3.widgetType, instantSearchInstance = _ref3.instantSearchInstance;
    var bindEventForHits = function bindEventForHits() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var payloads = $cce5ac6f4caf08a3$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            getIndex: getIndex,
            methodName: "bindEvent",
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        return payloads.length ? "data-insights-event=".concat((0, $9e862a34ed7cbcee$export$44b4521aa38272f2)(payloads)) : "";
    };
    return bindEventForHits;
}


function $638c8fc48faa4466$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $638c8fc48faa4466$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $638c8fc48faa4466$var$_typeof(o);
}
function $638c8fc48faa4466$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $638c8fc48faa4466$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $638c8fc48faa4466$var$ownKeys(Object(t), !0).forEach(function(r) {
            $638c8fc48faa4466$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $638c8fc48faa4466$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $638c8fc48faa4466$var$_defineProperty(obj, key, value) {
    key = $638c8fc48faa4466$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $638c8fc48faa4466$var$_toPropertyKey(t) {
    var i = $638c8fc48faa4466$var$_toPrimitive(t, "string");
    return "symbol" == $638c8fc48faa4466$var$_typeof(i) ? i : String(i);
}
function $638c8fc48faa4466$var$_toPrimitive(t, r) {
    if ("object" != $638c8fc48faa4466$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $638c8fc48faa4466$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $638c8fc48faa4466$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "hits",
    connector: true
});
var $638c8fc48faa4466$export$2e2bcd8739ae039 = function connectHits(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $846d3432ff405e8b$export$8793edee2d425525);
    (0, $300f63447e4459ed$export$adc2a8e09aa583ee)(renderFn, $638c8fc48faa4466$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$escapeHTML = _ref.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        var sendEvent;
        var bindEvent;
        return {
            $$type: "ais.hits",
            init: function init(initOptions) {
                renderFn($638c8fc48faa4466$var$_objectSpread($638c8fc48faa4466$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var renderState = this.getWidgetRenderState(renderOptions);
                renderFn($638c8fc48faa4466$var$_objectSpread($638c8fc48faa4466$var$_objectSpread({}, renderState), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
                renderState.sendEvent("view:internal", renderState.items);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $638c8fc48faa4466$var$_objectSpread($638c8fc48faa4466$var$_objectSpread({}, renderState), {}, {
                    hits: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var _results$renderingCon, _results$renderingCon2, _results$renderingCon3;
                var results = _ref2.results, helper = _ref2.helper, instantSearchInstance = _ref2.instantSearchInstance;
                if (!sendEvent) sendEvent = (0, $cce5ac6f4caf08a3$export$4139f3a7130239e3)({
                    instantSearchInstance: instantSearchInstance,
                    getIndex: function getIndex() {
                        return helper.getIndex();
                    },
                    widgetType: this.$$type
                });
                if (!bindEvent) bindEvent = (0, $cce5ac6f4caf08a3$export$5a3d9973824d9b76)({
                    getIndex: function getIndex() {
                        return helper.getIndex();
                    },
                    widgetType: this.$$type,
                    instantSearchInstance: instantSearchInstance
                });
                if (!results) return {
                    hits: [],
                    items: [],
                    results: undefined,
                    banner: undefined,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
                if (escapeHTML && results.hits.length > 0) results.hits = (0, $ffe8c7f6cc3688f1$export$9adb036445aab889)(results.hits);
                var hitsWithAbsolutePosition = (0, $dd6647243d3b5891$export$33d742d8ee5a4609)(results.hits, results.page, results.hitsPerPage);
                var hitsWithAbsolutePositionAndQueryID = (0, $8e44a9d176e4c854$export$b8f834386ea30952)(hitsWithAbsolutePosition, results.queryID);
                var items = transformItems(hitsWithAbsolutePositionAndQueryID, {
                    results: results
                });
                var banner = (_results$renderingCon = results.renderingContent) === null || _results$renderingCon === void 0 ? void 0 : (_results$renderingCon2 = _results$renderingCon.widgets) === null || _results$renderingCon2 === void 0 ? void 0 : (_results$renderingCon3 = _results$renderingCon2.banners) === null || _results$renderingCon3 === void 0 ? void 0 : _results$renderingCon3[0];
                return {
                    hits: items,
                    items: items,
                    results: results,
                    banner: banner,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                if (!escapeHTML) return state;
                return state.setQueryParameters(Object.keys((0, $ffe8c7f6cc3688f1$export$1e7338a8952eaf35)).reduce(function(acc, key) {
                    return $638c8fc48faa4466$var$_objectSpread($638c8fc48faa4466$var$_objectSpread({}, acc), {}, $638c8fc48faa4466$var$_defineProperty({}, key, undefined));
                }, {}));
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _uiState) {
                if (!escapeHTML) return state;
                // @MAJOR: set this globally, not in the Hits widget to allow Hits to be conditionally used
                return state.setQueryParameters((0, $ffe8c7f6cc3688f1$export$1e7338a8952eaf35));
            }
        };
    };
};



function $fb985a5085cbb52d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fb985a5085cbb52d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fb985a5085cbb52d$var$_typeof(o);
}
function $fb985a5085cbb52d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb985a5085cbb52d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb985a5085cbb52d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fb985a5085cbb52d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb985a5085cbb52d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fb985a5085cbb52d$var$_defineProperty(obj, key, value) {
    key = $fb985a5085cbb52d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fb985a5085cbb52d$var$_toPropertyKey(t) {
    var i = $fb985a5085cbb52d$var$_toPrimitive(t, "string");
    return "symbol" == $fb985a5085cbb52d$var$_typeof(i) ? i : String(i);
}
function $fb985a5085cbb52d$var$_toPrimitive(t, r) {
    if ("object" != $fb985a5085cbb52d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fb985a5085cbb52d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fb985a5085cbb52d$var$getSelectedHits = function getSelectedHits(hits, selectedObjectIDs) {
    return selectedObjectIDs.map(function(objectID) {
        var hit = (0, $6233c69c2fe30ad7$export$71aa6c912b956294)(hits, function(h) {
            return h.objectID === objectID;
        });
        if (typeof hit === "undefined") throw new Error('Could not find objectID "'.concat(objectID, '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'));
        return hit;
    });
};
var $fb985a5085cbb52d$var$getQueryID = function getQueryID(selectedHits) {
    var queryIDs = (0, $57b7a6525254cbcf$export$f70730c3d1fc524e)(selectedHits.map(function(hit) {
        return hit.__queryID;
    }));
    if (queryIDs.length > 1) throw new Error("Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.");
    var queryID = queryIDs[0];
    if (typeof queryID !== "string") throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
    return queryID;
};
var $fb985a5085cbb52d$var$getPositions = function getPositions(selectedHits) {
    return selectedHits.map(function(hit) {
        return hit.__position;
    });
};
var $fb985a5085cbb52d$export$24bd91850d68b36c = function inferPayload(_ref) {
    var method = _ref.method, results = _ref.results, hits = _ref.hits, objectIDs = _ref.objectIDs;
    var index = results.index;
    var selectedHits = $fb985a5085cbb52d$var$getSelectedHits(hits, objectIDs);
    var queryID = $fb985a5085cbb52d$var$getQueryID(selectedHits);
    switch(method){
        case "clickedObjectIDsAfterSearch":
            var positions = $fb985a5085cbb52d$var$getPositions(selectedHits);
            return {
                index: index,
                queryID: queryID,
                objectIDs: objectIDs,
                positions: positions
            };
        case "convertedObjectIDsAfterSearch":
            return {
                index: index,
                queryID: queryID,
                objectIDs: objectIDs
            };
        default:
            throw new Error('Unsupported method passed to insights: "'.concat(method, '".'));
    }
};
var $fb985a5085cbb52d$var$wrapInsightsClient = function wrapInsightsClient(aa, results, hits) {
    return function(method) {
        for(var _len = arguments.length, payloads = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)payloads[_key - 1] = arguments[_key];
        var payload = payloads[0];
        if (!aa) {
            var withInstantSearchUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
                name: "instantsearch"
            });
            throw new Error(withInstantSearchUsage("The `insightsClient` option has not been provided to `instantsearch`."));
        }
        if (!Array.isArray(payload.objectIDs)) throw new TypeError("Expected `objectIDs` to be an array.");
        var inferredPayload = $fb985a5085cbb52d$export$24bd91850d68b36c({
            method: method,
            results: results,
            hits: hits,
            objectIDs: payload.objectIDs
        });
        aa(method, $fb985a5085cbb52d$var$_objectSpread($fb985a5085cbb52d$var$_objectSpread({}, inferredPayload), payload));
    };
};
function $fb985a5085cbb52d$export$2e2bcd8739ae039(connector) {
    return function(renderFn, unmountFn) {
        return connector(function(renderOptions, isFirstRender) {
            var results = renderOptions.results, hits = renderOptions.hits, instantSearchInstance = renderOptions.instantSearchInstance;
            if (results && hits && instantSearchInstance) {
                var insights = $fb985a5085cbb52d$var$wrapInsightsClient(instantSearchInstance.insightsClient, results, hits);
                return renderFn($fb985a5085cbb52d$var$_objectSpread($fb985a5085cbb52d$var$_objectSpread({}, renderOptions), {}, {
                    insights: insights
                }), isFirstRender);
            }
            return renderFn(renderOptions, isFirstRender);
        }, unmountFn);
    };
}





var $feed5bb9cd146549$export$71d036cfbce90975 = function createInsightsEventHandler(_ref) {
    var insights = _ref.insights, sendEvent = _ref.sendEvent;
    return function(event) {
        // new way, e.g. bindEvent("click", hit, "Hit clicked")
        var insightsThroughSendEvent = $feed5bb9cd146549$var$findInsightsTarget(event.target, event.currentTarget, function(element) {
            return element.hasAttribute("data-insights-event");
        });
        if (insightsThroughSendEvent) {
            var payload = $feed5bb9cd146549$var$parseInsightsEvent(insightsThroughSendEvent);
            payload.forEach(function(single) {
                return sendEvent(single);
            });
        }
        // old way, e.g. instantsearch.insights("clickedObjectIDsAfterSearch", { .. })
        var insightsThroughFunction = $feed5bb9cd146549$var$findInsightsTarget(event.target, event.currentTarget, function(element) {
            return element.hasAttribute("data-insights-method") && element.hasAttribute("data-insights-payload");
        });
        if (insightsThroughFunction) {
            var _readDataAttributes = (0, $0960a378c85a0fdc$export$cbcfede36ce7ab2e)(insightsThroughFunction), method = _readDataAttributes.method, _payload = _readDataAttributes.payload;
            insights(method, _payload);
        }
    };
};
function $feed5bb9cd146549$var$findInsightsTarget(startElement, endElement, validator) {
    var element = startElement;
    while(element && !validator(element)){
        if (element === endElement) return null;
        element = element.parentElement;
    }
    return element;
}
function $feed5bb9cd146549$var$parseInsightsEvent(element) {
    var serializedPayload = element.getAttribute("data-insights-event");
    if (typeof serializedPayload !== "string") throw new Error("The insights middleware expects `data-insights-event` to be a base64-encoded JSON string.");
    try {
        return (0, $9e862a34ed7cbcee$export$706ea24b0964bee9)(serializedPayload);
    } catch (error) {
        throw new Error("The insights middleware was unable to parse `data-insights-event`.");
    }
}
function $feed5bb9cd146549$export$2e2bcd8739ae039(BaseComponent) {
    return function WithInsightsListener(props) {
        var handleClick = $feed5bb9cd146549$export$71d036cfbce90975(props);
        return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("div", {
            onClick: handleClick
        }, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)(BaseComponent, props));
    };
}




/**
 * Creates a new object with the same keys as the original object, but without the excluded keys.
 * @param source original object
 * @param excluded keys to remove from the original object
 * @returns the new object
 */ function $0506a39e60fac91a$export$30a06c8d3562193f(source, excluded) {
    if (source === null || source === undefined) return source;
    return Object.keys(source).reduce(function(target, key) {
        if (excluded.indexOf(key) >= 0) return target;
        var validKey = key;
        target[validKey] = source[validKey];
        return target;
    }, {});
}


// false positive lint error
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
var $8a06762bb97e5be2$var$defaultTemplates = {
    empty: function empty() {
        return "No results";
    },
    item: function item(data) {
        return JSON.stringify((0, $0506a39e60fac91a$export$30a06c8d3562193f)(data, [
            "__hitIndex"
        ]), null, 2);
    }
};
var $8a06762bb97e5be2$export$2e2bcd8739ae039 = $8a06762bb97e5be2$var$defaultTemplates;


function $c612e53fbc8ced00$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c612e53fbc8ced00$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c612e53fbc8ced00$var$_typeof(o);
}
var $c612e53fbc8ced00$var$_excluded = [
    "hit",
    "index"
];
function $c612e53fbc8ced00$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c612e53fbc8ced00$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c612e53fbc8ced00$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c612e53fbc8ced00$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c612e53fbc8ced00$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c612e53fbc8ced00$var$_defineProperty(obj, key, value) {
    key = $c612e53fbc8ced00$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c612e53fbc8ced00$var$_toPropertyKey(t) {
    var i = $c612e53fbc8ced00$var$_toPrimitive(t, "string");
    return "symbol" == $c612e53fbc8ced00$var$_typeof(i) ? i : String(i);
}
function $c612e53fbc8ced00$var$_toPrimitive(t, r) {
    if ("object" != $c612e53fbc8ced00$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c612e53fbc8ced00$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c612e53fbc8ced00$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c612e53fbc8ced00$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c612e53fbc8ced00$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c612e53fbc8ced00$var$_objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $c612e53fbc8ced00$var$_extends() {
    $c612e53fbc8ced00$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c612e53fbc8ced00$var$_extends.apply(this, arguments);
}
var $c612e53fbc8ced00$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "hits"
});
var $c612e53fbc8ced00$var$Hits = (0, $e0f3c2b2df78bd02$export$abc871145e3e685)({
    createElement: (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d),
    Fragment: (0, $fd5c1591a458e61e$export$ffb0004e005737fa)
});
var $c612e53fbc8ced00$var$renderer = function renderer(_ref) {
    var renderState = _ref.renderState, cssClasses = _ref.cssClasses, containerNode = _ref.containerNode, templates = _ref.templates;
    return function(_ref2, isFirstRendering) {
        var items = _ref2.items, results = _ref2.results, instantSearchInstance = _ref2.instantSearchInstance, insights = _ref2.insights, bindEvent = _ref2.bindEvent, sendEvent = _ref2.sendEvent, banner = _ref2.banner;
        if (isFirstRendering) {
            renderState.templateProps = (0, $4a70ab09dd697263$export$2938ff6a58d41f25)({
                defaultTemplates: (0, $8a06762bb97e5be2$export$2e2bcd8739ae039),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            return;
        }
        var handleInsightsClick = (0, $feed5bb9cd146549$export$71d036cfbce90975)({
            insights: insights,
            sendEvent: sendEvent
        });
        var emptyComponent = function emptyComponent(_ref3) {
            var rootProps = $c612e53fbc8ced00$var$_extends({}, ($c612e53fbc8ced00$var$_objectDestructuringEmpty(_ref3), _ref3));
            return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), $c612e53fbc8ced00$var$_extends({}, renderState.templateProps, {
                rootProps: rootProps,
                templateKey: "empty",
                data: results,
                rootTagName: "fragment"
            }));
        };
        // @MAJOR: Move default hit component back to the UI library
        // once flavour specificities are erased
        var itemComponent = function itemComponent(_ref4) {
            var hit = _ref4.hit, index = _ref4.index, rootProps = $c612e53fbc8ced00$var$_objectWithoutProperties(_ref4, $c612e53fbc8ced00$var$_excluded);
            return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), $c612e53fbc8ced00$var$_extends({}, renderState.templateProps, {
                templateKey: "item",
                rootTagName: "li",
                rootProps: $c612e53fbc8ced00$var$_objectSpread($c612e53fbc8ced00$var$_objectSpread({}, rootProps), {}, {
                    onClick: function onClick(event) {
                        handleInsightsClick(event);
                        rootProps.onClick();
                    },
                    onAuxClick: function onAuxClick(event) {
                        handleInsightsClick(event);
                        rootProps.onAuxClick();
                    }
                }),
                data: $c612e53fbc8ced00$var$_objectSpread($c612e53fbc8ced00$var$_objectSpread({}, hit), {}, {
                    get __hitIndex () {
                        return index;
                    }
                }),
                bindEvent: bindEvent,
                sendEvent: sendEvent
            }));
        };
        var bannerComponent = function bannerComponent(props) {
            return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), $c612e53fbc8ced00$var$_extends({}, renderState.templateProps, {
                templateKey: "banner",
                data: props,
                rootTagName: "fragment"
            }));
        };
        (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)((0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)($c612e53fbc8ced00$var$Hits, {
            hits: items,
            itemComponent: itemComponent,
            sendEvent: sendEvent,
            classNames: cssClasses,
            emptyComponent: emptyComponent,
            banner: banner,
            bannerComponent: templates.banner ? bannerComponent : undefined
        }), containerNode);
    };
};
var $c612e53fbc8ced00$export$2e2bcd8739ae039 = function hits(widgetParams) {
    var _ref5 = widgetParams || {}, container = _ref5.container, escapeHTML = _ref5.escapeHTML, transformItems = _ref5.transformItems, _ref5$templates = _ref5.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates, _ref5$cssClasses = _ref5.cssClasses, cssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses;
    if (!container) throw new Error($c612e53fbc8ced00$var$withUsage("The `container` option is required."));
    var containerNode = (0, $b8c98bbd5148a964$export$ffb2c7b8d67c359a)(container);
    var specializedRenderer = $c612e53fbc8ced00$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        renderState: {},
        templates: templates
    });
    var makeWidget = (0, $fb985a5085cbb52d$export$2e2bcd8739ae039)((0, $638c8fc48faa4466$export$2e2bcd8739ae039))(specializedRenderer, function() {
        return (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $c612e53fbc8ced00$var$_objectSpread($c612e53fbc8ced00$var$_objectSpread({}, makeWidget({
        escapeHTML: escapeHTML,
        transformItems: transformItems
    })), {}, {
        $$widgetType: "ais.hits"
    });
};


var $11b8d3d3f114177d$exports = {};
$11b8d3d3f114177d$exports = new URL("nophoto.1a264842.jpg", import.meta.url).toString();


const $fa58e233f6d221e9$var$IMG_PATH = "https://files.bpun.ch/images/images_exlibris/";
const $fa58e233f6d221e9$export$b6aad051bad07f12 = (0, $c612e53fbc8ced00$export$2e2bcd8739ae039)({
    container: '[data-widget="hits"]',
    templates: {
        item (hit, { html: html, components: components }) {
            var imageUrl = "";
            if (hit.image == "BPUN_renvoi" || hit.image == "BPUN_exlibris.jpg") imageUrl = (0, (/*@__PURE__*/$parcel$interopDefault($11b8d3d3f114177d$exports)));
            else imageUrl = `${$fa58e233f6d221e9$var$IMG_PATH}${hit.image}`;
            return html`
        <article class="hit">
          <header class="hit-image-container">
            <img src="${imageUrl}" alt="${hit.image}" class="hit-image" />
          </header>

          <div class="hit-info-container">
            <p class="hit-category">${hit.type_doc}</p>
            <h1>${components.Highlight({
                hit: hit,
                attribute: "proprietaire"
            })}</h1>
            <p class="hit-description">
              ${components.Highlight({
                attribute: "lieu",
                hit: hit
            })}
            </p>
            <p class="hit-description">
              ${components.Highlight({
                attribute: "profession",
                hit: hit
            })}
            </p>
            <p class="hit-description">
              ${components.Highlight({
                attribute: "reference",
                hit: hit
            })}
            </p>
            <p class="hit-description">
              ${components.Highlight({
                attribute: "date",
                hit: hit
            })}
            </p>
            <p class="hit-description">
              ${components.Highlight({
                attribute: "technique",
                hit: hit
            })}
            </p>
            <p class="hit-description">
              ${components.Highlight({
                attribute: "dimension",
                hit: hit
            })}
            </p>
            <p class="hit-description">
              ${components.Highlight({
                attribute: "artiste",
                hit: hit
            })}
            </p>
            <p class="hit-description">
              ${components.Highlight({
                attribute: "devise",
                hit: hit
            })}
            </p>
          </div>
        </article>
      `;
        },
        empty (results, { html: html }) {
            const hasRefinements = results.getRefinements().length > 0;
            const description = hasRefinements ? "Try to reset your applied filters." : "Please try another query.";
            return html`
        <div class="hits-empty-state">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="138"
            height="138"
            class="hits-empty-state-image"
          >
            <defs>
              <linearGradient id="c" x1="50%" x2="50%" y1="100%" y2="0%">
                <stop offset="0%" stop-color="#F5F5FA" />
                <stop offset="100%" stop-color="#FFF" />
              </linearGradient>
              <path
                id="b"
                d="M68.71 114.25a45.54 45.54 0 1 1 0-91.08 45.54 45.54 0 0 1 0 91.08z"
              />
              <filter
                id="a"
                width="140.6%"
                height="140.6%"
                x="-20.3%"
                y="-15.9%"
                filterUnits="objectBoundingBox"
              >
                <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur
                  in="shadowOffsetOuter1"
                  result="shadowBlurOuter1"
                  stdDeviation="5.5"
                />
                <feColorMatrix
                  in="shadowBlurOuter1"
                  result="shadowMatrixOuter1"
                  values="0 0 0 0 0.145098039 0 0 0 0 0.17254902 0 0 0 0 0.380392157 0 0 0 0.15 0"
                />
                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter2" />
                <feGaussianBlur
                  in="shadowOffsetOuter2"
                  result="shadowBlurOuter2"
                  stdDeviation="1.5"
                />
                <feColorMatrix
                  in="shadowBlurOuter2"
                  result="shadowMatrixOuter2"
                  values="0 0 0 0 0.364705882 0 0 0 0 0.392156863 0 0 0 0 0.580392157 0 0 0 0.2 0"
                />
                <feMerge>
                  <feMergeNode in="shadowMatrixOuter1" />
                  <feMergeNode in="shadowMatrixOuter2" />
                </feMerge>
              </filter>
            </defs>
            <g fill="none" fill-rule="evenodd">
              <circle
                cx="68.85"
                cy="68.85"
                r="68.85"
                fill="#5468FF"
                opacity=".07"
              />
              <circle
                cx="68.85"
                cy="68.85"
                r="52.95"
                fill="#5468FF"
                opacity=".08"
              />
              <use fill="#000" filter="url(#a)" xlink:href="#b" />
              <use fill="url(#c)" xlink:href="#b" />
              <path
                d="M76.01 75.44c5-5 5.03-13.06.07-18.01a12.73 12.73 0 0 0-18 .07c-5 4.99-5.03 13.05-.07 18a12.73 12.73 0 0 0 18-.06zm2.5 2.5a16.28 16.28 0 0 1-23.02.09A16.29 16.29 0 0 1 55.57 55a16.28 16.28 0 0 1 23.03-.1 16.28 16.28 0 0 1-.08 23.04zm1.08-1.08l-2.15 2.16 8.6 8.6 2.16-2.15-8.6-8.6z"
                fill="#5369FF"
              />
            </g>
          </svg>

          <p class="hits-empty-state-title">
            Sorry, we can't find any matches to your query!
          </p>
          <p class="hits-empty-state-description">${description}</p>
        </div>
      `;
        }
    }
});




const $22a09601bfd3c5ea$var$provenancesRefinementList = (0, $99926ac7ef17db44$export$2e2bcd8739ae039)({
    templates: {
        header () {
            return "Provenances";
        },
        collapseButtonText: $c693740ce5243d42$export$21cca13ffe0ab3b8
    },
    collapsed: ()=>false
})((0, $9f5a6a0cb29ddb10$export$2e2bcd8739ae039));
const $22a09601bfd3c5ea$export$5012d0d85f409970 = $22a09601bfd3c5ea$var$provenancesRefinementList({
    container: '[data-widget="provenances"]',
    attribute: "provenance",
    limit: 5,
    showMore: true,
    searchable: true,
    searchablePlaceholder: "Rechercher des provenances...",
    templates: {
        searchableSubmit: (_, { html: html })=>{
            return html`
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 14 14"
                >
                <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#21243D"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.33"
                    transform="translate(1 1)"
                >
                    <circle cx="5.333" cy="5.333" r="5.333" />
                    <path d="M12 12L9.1 9.1" />
                </g>
                </svg>
            `;
        },
        showMoreText: ({ isShowingMore: isShowingMore }, { html: html })=>{
            return isShowingMore ? html`Voir moins...` : html`Voir plus...`;
        }
    }
});




const $a0fdaf0ca4161619$var$referencesRefinementList = (0, $99926ac7ef17db44$export$2e2bcd8739ae039)({
    templates: {
        header () {
            return "R\xe9f\xe9rence";
        },
        collapseButtonText: $c693740ce5243d42$export$21cca13ffe0ab3b8
    },
    collapsed: ()=>false
})((0, $9f5a6a0cb29ddb10$export$2e2bcd8739ae039)); // export const references = referencesRefinementList({
 //     container: '[data-widget="reference"]',
 //     attribute: 'reference',
 //     limit: 5,
 //     showMore: true,
 //     searchable: true,
 //     searchablePlaceholder: 'Rechercher des références...',
 //     templates: {
 //         searchableSubmit: (_, { html }) => {
 //             return html`
 //                 <svg
 //                 xmlns="http://www.w3.org/2000/svg"
 //                 width="12"
 //                 height="12"
 //                 viewBox="0 0 14 14"
 //                 >
 //                 <g
 //                     fill="none"
 //                     fill-rule="evenodd"
 //                     stroke="#21243D"
 //                     stroke-linecap="round"
 //                     stroke-linejoin="round"
 //                     stroke-width="1.33"
 //                     transform="translate(1 1)"
 //                 >
 //                     <circle cx="5.333" cy="5.333" r="5.333" />
 //                     <path d="M12 12L9.1 9.1" />
 //                 </g>
 //                 </svg>
 //             `;
 //         },
 //         showMoreText: ({ isShowingMore }, { html }) => {
 //             return isShowingMore ? html `Voir moins...` : html `Voir plus...`;
 //         },
 //     },
 // })







function $626e5607e24b1084$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $626e5607e24b1084$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $626e5607e24b1084$var$_typeof(o);
}
var $626e5607e24b1084$var$_excluded = [
    "nbHits",
    "nbSortedHits",
    "cssClasses",
    "templateProps"
];
function $626e5607e24b1084$var$_extends() {
    $626e5607e24b1084$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $626e5607e24b1084$var$_extends.apply(this, arguments);
}
function $626e5607e24b1084$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $626e5607e24b1084$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $626e5607e24b1084$var$ownKeys(Object(t), !0).forEach(function(r) {
            $626e5607e24b1084$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $626e5607e24b1084$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $626e5607e24b1084$var$_defineProperty(obj, key, value) {
    key = $626e5607e24b1084$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $626e5607e24b1084$var$_toPropertyKey(t) {
    var i = $626e5607e24b1084$var$_toPrimitive(t, "string");
    return "symbol" == $626e5607e24b1084$var$_typeof(i) ? i : String(i);
}
function $626e5607e24b1084$var$_toPrimitive(t, r) {
    if ("object" != $626e5607e24b1084$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $626e5607e24b1084$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $626e5607e24b1084$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $626e5607e24b1084$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $626e5607e24b1084$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $626e5607e24b1084$var$Stats = function Stats(_ref) {
    var nbHits = _ref.nbHits, nbSortedHits = _ref.nbSortedHits, cssClasses = _ref.cssClasses, templateProps = _ref.templateProps, rest = $626e5607e24b1084$var$_objectWithoutProperties(_ref, $626e5607e24b1084$var$_excluded);
    return (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)("div", {
        className: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)(cssClasses.root)
    }, (0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $3d665ba039c115b1$export$2e2bcd8739ae039), $626e5607e24b1084$var$_extends({}, templateProps, {
        templateKey: "text",
        rootTagName: "span",
        rootProps: {
            className: cssClasses.text
        },
        data: $626e5607e24b1084$var$_objectSpread({
            hasManySortedResults: nbSortedHits && nbSortedHits > 1,
            hasNoSortedResults: nbSortedHits === 0,
            hasOneSortedResults: nbSortedHits === 1,
            hasManyResults: nbHits > 1,
            hasNoResults: nbHits === 0,
            hasOneResult: nbHits === 1,
            nbHits: nbHits,
            nbSortedHits: nbSortedHits,
            cssClasses: cssClasses
        }, rest)
    })));
};
var $626e5607e24b1084$export$2e2bcd8739ae039 = $626e5607e24b1084$var$Stats;



function $cafe417e6d5f3b58$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cafe417e6d5f3b58$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cafe417e6d5f3b58$var$_typeof(o);
}
function $cafe417e6d5f3b58$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cafe417e6d5f3b58$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cafe417e6d5f3b58$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cafe417e6d5f3b58$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cafe417e6d5f3b58$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cafe417e6d5f3b58$var$_defineProperty(obj, key, value) {
    key = $cafe417e6d5f3b58$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cafe417e6d5f3b58$var$_toPropertyKey(t) {
    var i = $cafe417e6d5f3b58$var$_toPrimitive(t, "string");
    return "symbol" == $cafe417e6d5f3b58$var$_typeof(i) ? i : String(i);
}
function $cafe417e6d5f3b58$var$_toPrimitive(t, r) {
    if ("object" != $cafe417e6d5f3b58$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cafe417e6d5f3b58$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $cafe417e6d5f3b58$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "stats",
    connector: true
});
/**
 * **Stats** connector provides the logic to build a custom widget that will displays
 * search statistics (hits number and processing time).
 */ var $cafe417e6d5f3b58$var$connectStats = function connectStats(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $846d3432ff405e8b$export$8793edee2d425525);
    (0, $300f63447e4459ed$export$adc2a8e09aa583ee)(renderFn, $cafe417e6d5f3b58$var$withUsage());
    return function(widgetParams) {
        return {
            $$type: "ais.stats",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($cafe417e6d5f3b58$var$_objectSpread($cafe417e6d5f3b58$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($cafe417e6d5f3b58$var$_objectSpread($cafe417e6d5f3b58$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $cafe417e6d5f3b58$var$_objectSpread($cafe417e6d5f3b58$var$_objectSpread({}, renderState), {}, {
                    stats: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref) {
                var results = _ref.results, state = _ref.state;
                if (!results) return {
                    hitsPerPage: state.hitsPerPage,
                    nbHits: 0,
                    nbSortedHits: undefined,
                    areHitsSorted: false,
                    nbPages: 0,
                    page: state.page || 0,
                    processingTimeMS: -1,
                    query: state.query || "",
                    widgetParams: widgetParams
                };
                return {
                    hitsPerPage: results.hitsPerPage,
                    nbHits: results.nbHits,
                    nbSortedHits: results.nbSortedHits,
                    areHitsSorted: typeof results.appliedRelevancyStrictness !== "undefined" && results.appliedRelevancyStrictness > 0 && results.nbSortedHits !== results.nbHits,
                    nbPages: results.nbPages,
                    page: results.page,
                    processingTimeMS: results.processingTimeMS,
                    query: results.query,
                    widgetParams: widgetParams
                };
            }
        };
    };
};
var $cafe417e6d5f3b58$export$2e2bcd8739ae039 = $cafe417e6d5f3b58$var$connectStats;






function $1d270fba529e2be6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1d270fba529e2be6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1d270fba529e2be6$var$_typeof(o);
}
function $1d270fba529e2be6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d270fba529e2be6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d270fba529e2be6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1d270fba529e2be6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d270fba529e2be6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1d270fba529e2be6$var$_defineProperty(obj, key, value) {
    key = $1d270fba529e2be6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1d270fba529e2be6$var$_toPropertyKey(t) {
    var i = $1d270fba529e2be6$var$_toPrimitive(t, "string");
    return "symbol" == $1d270fba529e2be6$var$_typeof(i) ? i : String(i);
}
function $1d270fba529e2be6$var$_toPrimitive(t, r) {
    if ("object" != $1d270fba529e2be6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1d270fba529e2be6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1d270fba529e2be6$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "stats"
});
var $1d270fba529e2be6$var$suit = (0, $23fceae7dc9dc95c$export$d8556a2a8f973135)("Stats");
var $1d270fba529e2be6$export$952bbd6b1defadc7 = {
    text: function text(props) {
        return "".concat(props.areHitsSorted ? $1d270fba529e2be6$var$getSortedResultsSentence(props) : $1d270fba529e2be6$var$getResultsSentence(props), " found in ").concat(props.processingTimeMS, "ms");
    }
};
function $1d270fba529e2be6$var$getSortedResultsSentence(_ref) {
    var nbHits = _ref.nbHits, hasNoSortedResults = _ref.hasNoSortedResults, hasOneSortedResults = _ref.hasOneSortedResults, hasManySortedResults = _ref.hasManySortedResults, nbSortedHits = _ref.nbSortedHits;
    var suffix = "sorted out of ".concat((0, $65b35437084c827d$export$f5dd818bff069720)(nbHits));
    if (hasNoSortedResults) return "No relevant results ".concat(suffix);
    if (hasOneSortedResults) return "1 relevant result ".concat(suffix);
    if (hasManySortedResults) return "".concat((0, $65b35437084c827d$export$f5dd818bff069720)(nbSortedHits || 0), " relevant results ").concat(suffix);
    return "";
}
function $1d270fba529e2be6$var$getResultsSentence(_ref2) {
    var nbHits = _ref2.nbHits, hasNoResults = _ref2.hasNoResults, hasOneResult = _ref2.hasOneResult, hasManyResults = _ref2.hasManyResults;
    if (hasNoResults) return "No results";
    if (hasOneResult) return "1 result";
    if (hasManyResults) return "".concat((0, $65b35437084c827d$export$f5dd818bff069720)(nbHits), " results");
    return "";
}
var $1d270fba529e2be6$var$renderer = function renderer(_ref3) {
    var renderState = _ref3.renderState, cssClasses = _ref3.cssClasses, containerNode = _ref3.containerNode, templates = _ref3.templates;
    return function(_ref4, isFirstRendering) {
        var hitsPerPage = _ref4.hitsPerPage, nbHits = _ref4.nbHits, nbSortedHits = _ref4.nbSortedHits, areHitsSorted = _ref4.areHitsSorted, nbPages = _ref4.nbPages, page = _ref4.page, processingTimeMS = _ref4.processingTimeMS, query = _ref4.query, instantSearchInstance = _ref4.instantSearchInstance;
        if (isFirstRendering) {
            renderState.templateProps = (0, $4a70ab09dd697263$export$2938ff6a58d41f25)({
                defaultTemplates: $1d270fba529e2be6$export$952bbd6b1defadc7,
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            return;
        }
        (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)((0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $626e5607e24b1084$export$2e2bcd8739ae039), {
            cssClasses: cssClasses,
            hitsPerPage: hitsPerPage,
            nbHits: nbHits,
            nbSortedHits: nbSortedHits,
            areHitsSorted: areHitsSorted,
            nbPages: nbPages,
            page: page,
            processingTimeMS: processingTimeMS,
            query: query,
            templateProps: renderState.templateProps
        }), containerNode);
    };
};
/**
 * The `stats` widget is used to display useful insights about the current results.
 *
 * By default, it will display the **number of hits** and the time taken to compute the
 * results inside the engine.
 */ var $1d270fba529e2be6$var$stats = function stats(widgetParams) {
    var _ref5 = widgetParams || {}, container = _ref5.container, _ref5$cssClasses = _ref5.cssClasses, userCssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses, _ref5$templates = _ref5.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates;
    if (!container) throw new Error($1d270fba529e2be6$var$withUsage("The `container` option is required."));
    var containerNode = (0, $b8c98bbd5148a964$export$ffb2c7b8d67c359a)(container);
    var cssClasses = {
        root: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($1d270fba529e2be6$var$suit(), userCssClasses.root),
        text: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($1d270fba529e2be6$var$suit({
            descendantName: "text"
        }), userCssClasses.text)
    };
    var specializedRenderer = $1d270fba529e2be6$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        templates: templates,
        renderState: {}
    });
    var makeWidget = (0, $cafe417e6d5f3b58$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $1d270fba529e2be6$var$_objectSpread($1d270fba529e2be6$var$_objectSpread({}, makeWidget({})), {}, {
        $$widgetType: "ais.stats"
    });
};
var $1d270fba529e2be6$export$2e2bcd8739ae039 = $1d270fba529e2be6$var$stats;


const $41b570eac772c9a5$export$2d34c683630d7660 = (0, $1d270fba529e2be6$export$2e2bcd8739ae039)({
    container: '[data-widget="results-number-mobile"]',
    templates: {
        text ({ nbHits: nbHits }, { html: html }) {
            return html`<strong>${nbHits.toLocaleString()}</strong> résultats`;
        }
    }
});



const $7bcaae30ade83170$export$fd2b70043bf5186a = (0, $1d270fba529e2be6$export$2e2bcd8739ae039)({
    container: '[data-widget="save-filters-mobile"]',
    templates: {
        text ({ nbHits: nbHits }, { html: html }) {
            return html`
        <button class="button button-primary">
          Voir ${nbHits.toLocaleString()} résultats
        </button>
      `;
        }
    }
});






function $9fd10447e2eff7cb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9fd10447e2eff7cb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9fd10447e2eff7cb$var$_typeof(o);
}
function $9fd10447e2eff7cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9fd10447e2eff7cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9fd10447e2eff7cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9fd10447e2eff7cb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9fd10447e2eff7cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9fd10447e2eff7cb$var$_defineProperty(obj, key, value) {
    key = $9fd10447e2eff7cb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9fd10447e2eff7cb$var$_toPropertyKey(t) {
    var i = $9fd10447e2eff7cb$var$_toPrimitive(t, "string");
    return "symbol" == $9fd10447e2eff7cb$var$_typeof(i) ? i : String(i);
}
function $9fd10447e2eff7cb$var$_toPrimitive(t, r) {
    if ("object" != $9fd10447e2eff7cb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9fd10447e2eff7cb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9fd10447e2eff7cb$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "search-box",
    connector: true
});
/**
 * @typedef {Object} CustomSearchBoxWidgetParams
 * @property {function(string, function(string))} [queryHook = undefined] A function that will be called every time
 * a new value for the query is set. The first parameter is the query and the second is a
 * function to actually trigger the search. The function takes the query as the parameter.
 *
 * This queryHook can be used to debounce the number of searches done from the searchBox.
 */ var $9fd10447e2eff7cb$var$defaultQueryHook = function defaultQueryHook(query, hook) {
    return hook(query);
};
/**
 * **SearchBox** connector provides the logic to build a widget that will let the user search for a query.
 *
 * The connector provides to the rendering: `refine()` to set the query. The behaviour of this function
 * may be impacted by the `queryHook` widget parameter.
 */ var $9fd10447e2eff7cb$var$connectSearchBox = function connectSearchBox(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $846d3432ff405e8b$export$8793edee2d425525);
    (0, $300f63447e4459ed$export$adc2a8e09aa583ee)(renderFn, $9fd10447e2eff7cb$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$queryHook = _ref.queryHook, queryHook = _ref$queryHook === void 0 ? $9fd10447e2eff7cb$var$defaultQueryHook : _ref$queryHook;
        var _refine;
        var _clear;
        return {
            $$type: "ais.searchBox",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($9fd10447e2eff7cb$var$_objectSpread($9fd10447e2eff7cb$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($9fd10447e2eff7cb$var$_objectSpread($9fd10447e2eff7cb$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return state.setQueryParameter("query", undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $9fd10447e2eff7cb$var$_objectSpread($9fd10447e2eff7cb$var$_objectSpread({}, renderState), {}, {
                    searchBox: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref3) {
                var helper = _ref3.helper, instantSearchInstance = _ref3.instantSearchInstance, state = _ref3.state;
                if (!_refine) {
                    _refine = function _refine(query) {
                        queryHook(query, function(q) {
                            return helper.setQuery(q).search();
                        });
                    };
                    _clear = function _clear() {
                        helper.setQuery("").search();
                    };
                }
                return {
                    query: state.query || "",
                    refine: _refine,
                    clear: _clear,
                    widgetParams: widgetParams,
                    isSearchStalled: instantSearchInstance.status === "stalled"
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var query = searchParameters.query || "";
                if (query === "" || uiState && uiState.query === query) return uiState;
                return $9fd10447e2eff7cb$var$_objectSpread($9fd10447e2eff7cb$var$_objectSpread({}, uiState), {}, {
                    query: query
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                return searchParameters.setQueryParameter("query", uiState.query || "");
            }
        };
    };
};
var $9fd10447e2eff7cb$export$2e2bcd8739ae039 = $9fd10447e2eff7cb$var$connectSearchBox;





function $f5bdc517e4bf45a7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f5bdc517e4bf45a7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f5bdc517e4bf45a7$var$_typeof(o);
}
function $f5bdc517e4bf45a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f5bdc517e4bf45a7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f5bdc517e4bf45a7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f5bdc517e4bf45a7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f5bdc517e4bf45a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f5bdc517e4bf45a7$var$_defineProperty(obj, key, value) {
    key = $f5bdc517e4bf45a7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f5bdc517e4bf45a7$var$_toPropertyKey(t) {
    var i = $f5bdc517e4bf45a7$var$_toPrimitive(t, "string");
    return "symbol" == $f5bdc517e4bf45a7$var$_typeof(i) ? i : String(i);
}
function $f5bdc517e4bf45a7$var$_toPrimitive(t, r) {
    if ("object" != $f5bdc517e4bf45a7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f5bdc517e4bf45a7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f5bdc517e4bf45a7$var$withUsage = (0, $c5ac68b3400622d0$export$2fde5bffc340821e)({
    name: "search-box"
});
var $f5bdc517e4bf45a7$var$suit = (0, $23fceae7dc9dc95c$export$d8556a2a8f973135)("SearchBox");
var $f5bdc517e4bf45a7$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses, placeholder = _ref.placeholder, templates = _ref.templates, autofocus = _ref.autofocus, searchAsYouType = _ref.searchAsYouType, ignoreCompositionEvents = _ref.ignoreCompositionEvents, showReset = _ref.showReset, showSubmit = _ref.showSubmit, showLoadingIndicator = _ref.showLoadingIndicator;
    return function(_ref2) {
        var refine = _ref2.refine, query = _ref2.query, isSearchStalled = _ref2.isSearchStalled;
        (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)((0, $fd5c1591a458e61e$export$c8a8987d4410bf2d)((0, $32b2f46ed1cf6dbc$export$2e2bcd8739ae039), {
            query: query,
            placeholder: placeholder,
            autofocus: autofocus,
            refine: refine,
            searchAsYouType: searchAsYouType,
            ignoreCompositionEvents: ignoreCompositionEvents,
            templates: templates,
            showSubmit: showSubmit,
            showReset: showReset,
            showLoadingIndicator: showLoadingIndicator,
            isSearchStalled: isSearchStalled,
            cssClasses: cssClasses
        }), containerNode);
    };
};
/**
 * The searchbox widget is used to let the user set a text based query.
 *
 * This is usually the  main entry point to start the search in an instantsearch context. For that
 * reason is usually placed on top, and not hidden so that the user can start searching right
 * away.
 *
 */ var $f5bdc517e4bf45a7$var$searchBox = function searchBox(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, _ref3$placeholder = _ref3.placeholder, placeholder = _ref3$placeholder === void 0 ? "" : _ref3$placeholder, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$autofocus = _ref3.autofocus, autofocus = _ref3$autofocus === void 0 ? false : _ref3$autofocus, _ref3$searchAsYouType = _ref3.searchAsYouType, searchAsYouType = _ref3$searchAsYouType === void 0 ? true : _ref3$searchAsYouType, _ref3$ignoreCompositi = _ref3.ignoreCompositionEvents, ignoreCompositionEvents = _ref3$ignoreCompositi === void 0 ? false : _ref3$ignoreCompositi, _ref3$showReset = _ref3.showReset, showReset = _ref3$showReset === void 0 ? true : _ref3$showReset, _ref3$showSubmit = _ref3.showSubmit, showSubmit = _ref3$showSubmit === void 0 ? true : _ref3$showSubmit, _ref3$showLoadingIndi = _ref3.showLoadingIndicator, showLoadingIndicator = _ref3$showLoadingIndi === void 0 ? true : _ref3$showLoadingIndi, queryHook = _ref3.queryHook, _ref3$templates = _ref3.templates, userTemplates = _ref3$templates === void 0 ? {} : _ref3$templates;
    if (!container) throw new Error($f5bdc517e4bf45a7$var$withUsage("The `container` option is required."));
    var containerNode = (0, $b8c98bbd5148a964$export$ffb2c7b8d67c359a)(container);
    var cssClasses = {
        root: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($f5bdc517e4bf45a7$var$suit(), userCssClasses.root),
        form: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($f5bdc517e4bf45a7$var$suit({
            descendantName: "form"
        }), userCssClasses.form),
        input: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($f5bdc517e4bf45a7$var$suit({
            descendantName: "input"
        }), userCssClasses.input),
        submit: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($f5bdc517e4bf45a7$var$suit({
            descendantName: "submit"
        }), userCssClasses.submit),
        submitIcon: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($f5bdc517e4bf45a7$var$suit({
            descendantName: "submitIcon"
        }), userCssClasses.submitIcon),
        reset: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($f5bdc517e4bf45a7$var$suit({
            descendantName: "reset"
        }), userCssClasses.reset),
        resetIcon: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($f5bdc517e4bf45a7$var$suit({
            descendantName: "resetIcon"
        }), userCssClasses.resetIcon),
        loadingIndicator: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($f5bdc517e4bf45a7$var$suit({
            descendantName: "loadingIndicator"
        }), userCssClasses.loadingIndicator),
        loadingIcon: (0, $6d13b29dffb7bdff$export$a274e22fb40f762e)($f5bdc517e4bf45a7$var$suit({
            descendantName: "loadingIcon"
        }), userCssClasses.loadingIcon)
    };
    var templates = $f5bdc517e4bf45a7$var$_objectSpread($f5bdc517e4bf45a7$var$_objectSpread({}, (0, $ecd69f3ae59539f0$export$2e2bcd8739ae039)), userTemplates);
    var specializedRenderer = $f5bdc517e4bf45a7$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        placeholder: placeholder,
        templates: templates,
        autofocus: autofocus,
        searchAsYouType: searchAsYouType,
        ignoreCompositionEvents: ignoreCompositionEvents,
        showReset: showReset,
        showSubmit: showSubmit,
        showLoadingIndicator: showLoadingIndicator
    });
    var makeWidget = (0, $9fd10447e2eff7cb$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $fd5c1591a458e61e$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $f5bdc517e4bf45a7$var$_objectSpread($f5bdc517e4bf45a7$var$_objectSpread({}, makeWidget({
        queryHook: queryHook
    })), {}, {
        $$widgetType: "ais.searchBox"
    });
};
var $f5bdc517e4bf45a7$export$2e2bcd8739ae039 = $f5bdc517e4bf45a7$var$searchBox;


const $7cb158790fe03f60$export$70de536d1e66dd02 = (0, $f5bdc517e4bf45a7$export$2e2bcd8739ae039)({
    container: '[data-widget="searchbox"]',
    placeholder: "Rechercher des menus...",
    templates: {
        submit (_, { html: html }) {
            return html`
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 18 18"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke="#f56603"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.67"
            transform="translate(1 1)"
          >
            <circle cx="7.11" cy="7.11" r="7.11" />
            <path d="M16 16l-3.87-3.87" />
          </g>
        </svg>
      `;
        }
    }
});


const $ff3fd7049a63a0f5$var$items = [
    {
        label: "Featured",
        value: "instant_search"
    },
    {
        label: "Price ascending",
        value: "instant_search_price_asc"
    },
    {
        label: "Price descending",
        value: "instant_search_price_desc"
    }
];
function $ff3fd7049a63a0f5$export$23e0346ad943066e(sortByValue) {
    if ($ff3fd7049a63a0f5$var$items.map((item)=>item.value).indexOf(sortByValue) !== -1) return sortByValue;
    return undefined;
}




const $b3d9467e69c7983b$var$techniquesRefinementList = (0, $99926ac7ef17db44$export$2e2bcd8739ae039)({
    templates: {
        header () {
            return "Techniques";
        },
        collapseButtonText: $c693740ce5243d42$export$21cca13ffe0ab3b8
    },
    collapsed: ()=>false
})((0, $9f5a6a0cb29ddb10$export$2e2bcd8739ae039));
const $b3d9467e69c7983b$export$c1839531561c6367 = $b3d9467e69c7983b$var$techniquesRefinementList({
    container: '[data-widget="techniques"]',
    attribute: "technique",
    limit: 5,
    showMore: true,
    searchable: true,
    searchablePlaceholder: "Rechercher des techniques...",
    templates: {
        searchableSubmit: (_, { html: html })=>{
            return html`
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 14 14"
                >
                <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#21243D"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.33"
                    transform="translate(1 1)"
                >
                    <circle cx="5.333" cy="5.333" r="5.333" />
                    <path d="M12 12L9.1 9.1" />
                </g>
                </svg>
            `;
        },
        showMoreText: ({ isShowingMore: isShowingMore }, { html: html })=>{
            return isShowingMore ? html`Voir moins...` : html`Voir plus...`;
        }
    }
});




const $ad5d124a635a5eeb$var$typesRefinementList = (0, $99926ac7ef17db44$export$2e2bcd8739ae039)({
    templates: {
        header () {
            return "Types";
        },
        collapseButtonText: $c693740ce5243d42$export$21cca13ffe0ab3b8
    },
    collapsed: ()=>false
})((0, $9f5a6a0cb29ddb10$export$2e2bcd8739ae039));
const $ad5d124a635a5eeb$export$b14ad400b1d09e0f = $ad5d124a635a5eeb$var$typesRefinementList({
    container: '[data-widget="types"]',
    attribute: "type_doc",
    limit: 5,
    showMore: true,
    searchable: true,
    searchablePlaceholder: "Rechercher des types...",
    templates: {
        searchableSubmit: (_, { html: html })=>{
            return html`
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 14 14"
                >
                <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke="#21243D"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.33"
                    transform="translate(1 1)"
                >
                    <circle cx="5.333" cy="5.333" r="5.333" />
                    <path d="M12 12L9.1 9.1" />
                </g>
                </svg>
            `;
        },
        showMoreText: ({ isShowingMore: isShowingMore }, { html: html })=>{
            return isShowingMore ? html`Voir moins...` : html`Voir plus...`;
        }
    }
});




const $02675bbfbaadcdd4$var$searchClient = (0, $ef6ec48844ba4a28$export$f33d1b811c3510b4)("QFUNBU0BK9", "7ea3ccbba8c38776262aa0dcda35df37");
const $02675bbfbaadcdd4$var$search = (0, $48737dfc970c14bb$export$2e2bcd8739ae039)({
    searchClient: $02675bbfbaadcdd4$var$searchClient,
    indexName: "t_ex_libris",
    // routing: getRouting({ indexName: 'instant_search' }),
    insights: true
});
$02675bbfbaadcdd4$var$search.addWidgets([
    (0, $f9be2d1c40fa0922$export$159753545da00930),
    (0, $ea1125e4c972aea4$export$d0e6b6bfede2a57),
    (0, $257ef55429b8bd37$export$cdb826049ff99b14),
    (0, $04db2a6f6470b76f$export$c7331590acc5e7ca),
    (0, $5fdb0c2fe0f84a0b$export$1670bf621bbc68f3),
    (0, $268f8fc6e91c0741$export$116e10bb000c6f7f),
    (0, $13785c5fb5455682$export$640d434f5a401408),
    (0, $f8fe226bdf859eba$export$45e6fc4a87827098),
    (0, $d0018dc2ac8d2ba0$export$22fa394f3ba39578),
    (0, $fa58e233f6d221e9$export$b6aad051bad07f12),
    (0, $22a09601bfd3c5ea$export$5012d0d85f409970),
    (0, $41b570eac772c9a5$export$2d34c683630d7660),
    (0, $7bcaae30ade83170$export$fd2b70043bf5186a),
    (0, $7cb158790fe03f60$export$70de536d1e66dd02),
    (0, $b3d9467e69c7983b$export$c1839531561c6367),
    (0, $ad5d124a635a5eeb$export$b14ad400b1d09e0f)
]);
var $02675bbfbaadcdd4$export$2e2bcd8739ae039 = $02675bbfbaadcdd4$var$search;


const $52eb1f57027d4931$var$filtersButtons = Array.prototype.slice.call(document.querySelectorAll('[data-action="open-overlay"]'));
const $52eb1f57027d4931$var$closeOverlayButtons = Array.prototype.slice.call(document.querySelectorAll('[data-action="close-overlay"]'));
const $52eb1f57027d4931$var$header = document.querySelector("#header");
const $52eb1f57027d4931$var$resultsContainer = document.querySelector(".container-results");
function $52eb1f57027d4931$var$openFilters() {
    document.body.classList.add("filtering");
    window.scrollTo(0, 0);
    window.addEventListener("keyup", $52eb1f57027d4931$var$onKeyUp);
    window.addEventListener("click", $52eb1f57027d4931$var$onClick);
}
function $52eb1f57027d4931$var$closeFilters() {
    document.body.classList.remove("filtering");
    $52eb1f57027d4931$var$resultsContainer.scrollIntoView();
    window.removeEventListener("keyup", $52eb1f57027d4931$var$onKeyUp);
    window.removeEventListener("click", $52eb1f57027d4931$var$onClick);
}
function $52eb1f57027d4931$var$onKeyUp(event) {
    if (event.key !== "Escape") return;
    $52eb1f57027d4931$var$closeFilters();
}
function $52eb1f57027d4931$var$onClick(event) {
    if (event.target !== $52eb1f57027d4931$var$header) return;
    $52eb1f57027d4931$var$closeFilters();
}
function $52eb1f57027d4931$export$925a5e3cf7a5ad5b() {
    $52eb1f57027d4931$var$filtersButtons.forEach((button)=>{
        button.addEventListener("click", $52eb1f57027d4931$var$openFilters);
    });
    $52eb1f57027d4931$var$closeOverlayButtons.forEach((button)=>{
        button.addEventListener("click", $52eb1f57027d4931$var$closeFilters);
    });
}



(0, $02675bbfbaadcdd4$export$2e2bcd8739ae039).start();
(0, $52eb1f57027d4931$export$925a5e3cf7a5ad5b)();


//# sourceMappingURL=index.bc2dab46.js.map
